import { wktToGeoJSON as e } from "@terraformer/wkt";
import { jwtDecode as t } from "jwt-decode";
import { nanoid as n } from "nanoid";
//#region \0rolldown/runtime.js
var r = Object.create, i = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = Object.getOwnPropertyNames, s = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), u = (e, t) => {
	let n = {};
	for (var r in e) i(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || i(n, Symbol.toStringTag, { value: "Module" }), n;
}, d = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var s = o(t), l = 0, u = s.length, d; l < u; l++) d = s[l], !c.call(e, d) && d !== n && i(e, d, {
		get: ((e) => t[e]).bind(null, d),
		enumerable: !(r = a(t, d)) || r.enumerable
	});
	return e;
}, f = (e, t, n) => (n = e == null ? {} : r(s(e)), d(t || !e || !e.__esModule ? i(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), p = /* @__PURE__ */ function(e) {
	return e.String = "string", e.Number = "number", e.Boolean = "boolean", e.Date = "date", e.Array = "array", e.Geography = "geography", e.ArrayNumbers = "array_numbers", e.ArrayStrings = "array_strings", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.FirebaseToken = "firebase_token", e.Audit = "audit", e.SharedPlan = "share_plan", e.Auth0 = "auth0", e.CustomGeoboundaries = "custom_geoboundaries", e.SignedUrls = "signed_urls", e.Geocoding = "geocoding", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Share = "share", e.Assets = "load_assets", e.AssetsPagination = "load_assets_pagination", e.Plan = "load_plan", e.Geoboundary = "geoboundary_geometries", e.Asset = "asset_details", e.PasswordRequired = "password_required", e.AllMediaTypeOptions = "all_media_type_options", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Development = "dev", e.Production = "pro", e.Staging = "stg", e.Local = "local", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.PowerUser = "power_user", e.Admin = "admin", e.User = "user", e.Unknown = "unknown", e.Anonymous = "anonymous", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Purchase = "Purchase", e;
}({}), _ = /* @__PURE__ */ l(((e, t) => {
	var n = typeof self < "u" ? self : e, r = (function() {
		function e() {
			this.fetch = !1, this.DOMException = n.DOMException;
		}
		return e.prototype = n, new e();
	})();
	(function(e) {
		(function(t) {
			var n = {
				searchParams: "URLSearchParams" in e,
				iterable: "Symbol" in e && "iterator" in Symbol,
				blob: "FileReader" in e && "Blob" in e && (function() {
					try {
						return new Blob(), !0;
					} catch {
						return !1;
					}
				})(),
				formData: "FormData" in e,
				arrayBuffer: "ArrayBuffer" in e
			};
			function r(e) {
				return e && DataView.prototype.isPrototypeOf(e);
			}
			if (n.arrayBuffer) var i = [
				"[object Int8Array]",
				"[object Uint8Array]",
				"[object Uint8ClampedArray]",
				"[object Int16Array]",
				"[object Uint16Array]",
				"[object Int32Array]",
				"[object Uint32Array]",
				"[object Float32Array]",
				"[object Float64Array]"
			], a = ArrayBuffer.isView || function(e) {
				return e && i.indexOf(Object.prototype.toString.call(e)) > -1;
			};
			function o(e) {
				if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw TypeError("Invalid character in header field name");
				return e.toLowerCase();
			}
			function s(e) {
				return typeof e != "string" && (e = String(e)), e;
			}
			function c(e) {
				var t = { next: function() {
					var t = e.shift();
					return {
						done: t === void 0,
						value: t
					};
				} };
				return n.iterable && (t[Symbol.iterator] = function() {
					return t;
				}), t;
			}
			function l(e) {
				this.map = {}, e instanceof l ? e.forEach(function(e, t) {
					this.append(t, e);
				}, this) : Array.isArray(e) ? e.forEach(function(e) {
					this.append(e[0], e[1]);
				}, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
					this.append(t, e[t]);
				}, this);
			}
			l.prototype.append = function(e, t) {
				e = o(e), t = s(t);
				var n = this.map[e];
				this.map[e] = n ? n + ", " + t : t;
			}, l.prototype.delete = function(e) {
				delete this.map[o(e)];
			}, l.prototype.get = function(e) {
				return e = o(e), this.has(e) ? this.map[e] : null;
			}, l.prototype.has = function(e) {
				return this.map.hasOwnProperty(o(e));
			}, l.prototype.set = function(e, t) {
				this.map[o(e)] = s(t);
			}, l.prototype.forEach = function(e, t) {
				for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
			}, l.prototype.keys = function() {
				var e = [];
				return this.forEach(function(t, n) {
					e.push(n);
				}), c(e);
			}, l.prototype.values = function() {
				var e = [];
				return this.forEach(function(t) {
					e.push(t);
				}), c(e);
			}, l.prototype.entries = function() {
				var e = [];
				return this.forEach(function(t, n) {
					e.push([n, t]);
				}), c(e);
			}, n.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
			function u(e) {
				if (e.bodyUsed) return Promise.reject(/* @__PURE__ */ TypeError("Already read"));
				e.bodyUsed = !0;
			}
			function d(e) {
				return new Promise(function(t, n) {
					e.onload = function() {
						t(e.result);
					}, e.onerror = function() {
						n(e.error);
					};
				});
			}
			function f(e) {
				var t = new FileReader(), n = d(t);
				return t.readAsArrayBuffer(e), n;
			}
			function p(e) {
				var t = new FileReader(), n = d(t);
				return t.readAsText(e), n;
			}
			function m(e) {
				for (var t = new Uint8Array(e), n = Array(t.length), r = 0; r < t.length; r++) n[r] = String.fromCharCode(t[r]);
				return n.join("");
			}
			function h(e) {
				if (e.slice) return e.slice(0);
				var t = new Uint8Array(e.byteLength);
				return t.set(new Uint8Array(e)), t.buffer;
			}
			function g() {
				return this.bodyUsed = !1, this._initBody = function(e) {
					this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : n.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : n.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : n.arrayBuffer && n.blob && r(e) ? (this._bodyArrayBuffer = h(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || a(e)) ? this._bodyArrayBuffer = h(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
				}, n.blob && (this.blob = function() {
					var e = u(this);
					if (e) return e;
					if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
					if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
					if (this._bodyFormData) throw Error("could not read FormData body as blob");
					return Promise.resolve(new Blob([this._bodyText]));
				}, this.arrayBuffer = function() {
					return this._bodyArrayBuffer ? u(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(f);
				}), this.text = function() {
					var e = u(this);
					if (e) return e;
					if (this._bodyBlob) return p(this._bodyBlob);
					if (this._bodyArrayBuffer) return Promise.resolve(m(this._bodyArrayBuffer));
					if (this._bodyFormData) throw Error("could not read FormData body as text");
					return Promise.resolve(this._bodyText);
				}, n.formData && (this.formData = function() {
					return this.text().then(ne);
				}), this.json = function() {
					return this.text().then(JSON.parse);
				}, this;
			}
			var ee = [
				"DELETE",
				"GET",
				"HEAD",
				"OPTIONS",
				"POST",
				"PUT"
			];
			function te(e) {
				var t = e.toUpperCase();
				return ee.indexOf(t) > -1 ? t : e;
			}
			function _(e, t) {
				t ||= {};
				var n = t.body;
				if (e instanceof _) {
					if (e.bodyUsed) throw TypeError("Already read");
					this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new l(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, !n && e._bodyInit != null && (n = e._bodyInit, e.bodyUsed = !0);
				} else this.url = String(e);
				if (this.credentials = t.credentials || this.credentials || "same-origin", (t.headers || !this.headers) && (this.headers = new l(t.headers)), this.method = te(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && n) throw TypeError("Body not allowed for GET or HEAD requests");
				this._initBody(n);
			}
			_.prototype.clone = function() {
				return new _(this, { body: this._bodyInit });
			};
			function ne(e) {
				var t = new FormData();
				return e.trim().split("&").forEach(function(e) {
					if (e) {
						var n = e.split("="), r = n.shift().replace(/\+/g, " "), i = n.join("=").replace(/\+/g, " ");
						t.append(decodeURIComponent(r), decodeURIComponent(i));
					}
				}), t;
			}
			function re(e) {
				var t = new l();
				return e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e) {
					var n = e.split(":"), r = n.shift().trim();
					if (r) {
						var i = n.join(":").trim();
						t.append(r, i);
					}
				}), t;
			}
			g.call(_.prototype);
			function v(e, t) {
				t ||= {}, this.type = "default", this.status = t.status === void 0 ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new l(t.headers), this.url = t.url || "", this._initBody(e);
			}
			g.call(v.prototype), v.prototype.clone = function() {
				return new v(this._bodyInit, {
					status: this.status,
					statusText: this.statusText,
					headers: new l(this.headers),
					url: this.url
				});
			}, v.error = function() {
				var e = new v(null, {
					status: 0,
					statusText: ""
				});
				return e.type = "error", e;
			};
			var ie = [
				301,
				302,
				303,
				307,
				308
			];
			v.redirect = function(e, t) {
				if (ie.indexOf(t) === -1) throw RangeError("Invalid status code");
				return new v(null, {
					status: t,
					headers: { location: e }
				});
			}, t.DOMException = e.DOMException;
			try {
				new t.DOMException();
			} catch {
				t.DOMException = function(e, t) {
					this.message = e, this.name = t;
					var n = Error(e);
					this.stack = n.stack;
				}, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
			}
			function ae(e, r) {
				return new Promise(function(i, a) {
					var o = new _(e, r);
					if (o.signal && o.signal.aborted) return a(new t.DOMException("Aborted", "AbortError"));
					var s = new XMLHttpRequest();
					function c() {
						s.abort();
					}
					s.onload = function() {
						var e = {
							status: s.status,
							statusText: s.statusText,
							headers: re(s.getAllResponseHeaders() || "")
						};
						e.url = "responseURL" in s ? s.responseURL : e.headers.get("X-Request-URL"), i(new v("response" in s ? s.response : s.responseText, e));
					}, s.onerror = function() {
						a(/* @__PURE__ */ TypeError("Network request failed"));
					}, s.ontimeout = function() {
						a(/* @__PURE__ */ TypeError("Network request failed"));
					}, s.onabort = function() {
						a(new t.DOMException("Aborted", "AbortError"));
					}, s.open(o.method, o.url, !0), o.credentials === "include" ? s.withCredentials = !0 : o.credentials === "omit" && (s.withCredentials = !1), "responseType" in s && n.blob && (s.responseType = "blob"), o.headers.forEach(function(e, t) {
						s.setRequestHeader(t, e);
					}), o.signal && (o.signal.addEventListener("abort", c), s.onreadystatechange = function() {
						s.readyState === 4 && o.signal.removeEventListener("abort", c);
					}), s.send(o._bodyInit === void 0 ? null : o._bodyInit);
				});
			}
			return ae.polyfill = !0, e.fetch || (e.fetch = ae, e.Headers = l, e.Request = _, e.Response = v), t.Headers = l, t.Request = _, t.Response = v, t.fetch = ae, Object.defineProperty(t, "__esModule", { value: !0 }), t;
		})({});
	})(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
	var i = r;
	e = i.fetch, e.default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, t.exports = e;
})), ne = /* @__PURE__ */ l(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return e.propertyIsEnumerable(t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (p(e, i) && n.isMergeableObject(t[i]) ? r[i] = u(i, n)(e[i], t[i], n) : r[i] = c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
})), re = /* @__PURE__ */ f(_(), 1), v = /* @__PURE__ */ f(ne(), 1), ie = /* @__PURE__ */ ((e) => (e.Get = "GET", e.Post = "POST", e.Put = "PUT", e.Patch = "PATCH", e.Delete = "DELETE", e))(ie || {});
function ae(e, t) {
	return Array.isArray(t) ? t.map((t) => ae(e, t)).join("&") : t == null || t === "" ? "" : typeof t == "object" ? `${e}=${encodeURIComponent(JSON.stringify(t))}` : `${e}=${encodeURIComponent(t)}`;
}
function oe({ params: e, url: t }) {
	return e ? `${t}?${Object.entries(e).map(([e, t]) => ae(e, t)).filter(Boolean).join("&")}` : t;
}
function se(e) {
	return (0, v.default)({
		method: ie.Get,
		headers: { Accept: "application/json" }
	}, e);
}
function ce(e, t) {
	return (0, v.default)({
		method: ie.Post,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json"
		},
		body: JSON.stringify(t)
	}, e);
}
var le = {
	GET: se,
	POST: ce,
	PUT: ce,
	PATCH: ce,
	DELETE: se
};
function ue({ body: e, credentials: t, method: n, other: r = {} }) {
	let i = t?.accessToken;
	return i && i.indexOf("Bearer") === -1 && (i = "Bearer " + i), le[n]((0, v.default)({
		method: n,
		headers: { ...!!i && { authorization: i } }
	}, r), e);
}
var de = 6144;
async function fe({ abortController: e, body: t, credentials: n, method: r = ie.Get, params: i, url: a, requestOptions: { getMaxUrlLength: o } = { getMaxUrlLength: de }, ...s }) {
	let c = oe({
		url: a,
		params: i
	}), l = t, u = r;
	r === ie.Get && c.length > o && (l = i, u = ie.Post, c = a);
	let d = ue({
		body: l,
		credentials: n,
		method: u,
		...s
	});
	e && (d.signal = e);
	let f = await (0, re.default)(c, d);
	if (!f.ok) {
		let e = await f.text();
		return Promise.reject(e);
	}
	return f.status === 204 ? Promise.resolve() : await f.json();
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/typeof.js
function pe(e) {
	"@babel/helpers - typeof";
	return pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, pe(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/toPrimitive.js
function me(e, t) {
	if (pe(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (pe(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/toPropertyKey.js
function he(e) {
	var t = me(e, "string");
	return pe(t) == "symbol" ? t : t + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/defineProperty.js
function ge(e, t, n) {
	return (t = he(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region src/auth/auth.manager.ts
var _e = class e {
	constructor() {
		ge(this, "cartoAuthorizer", null);
	}
	async init(e) {
		this.cartoAuthorizer = e;
	}
	static getInstance() {
		return e.instance ||= new e(), e.instance;
	}
	getToken() {
		if (this.cartoAuthorizer === null) throw Error("AuthManager not initialized");
		return this.cartoAuthorizer.getToken();
	}
};
ge(_e, "instance", void 0);
//#endregion
//#region src/common/geometry.helper.ts
function ve(t) {
	try {
		return e(t);
	} catch (e) {
		return console.error("❌ Could not convert field", e), null;
	}
}
function ye(e, t) {
	let n = e;
	return t.filter((e) => e in n);
}
function y(e, t) {
	return e.map((e) => {
		let n = { ...e };
		for (let e of t) {
			let t = n[e], r = ve(t);
			r && (n[e] = r);
		}
		return n;
	});
}
function be(e, t) {
	let n = e[0];
	if (!n) return e;
	let r = ye(n, t);
	return r.length === 0 ? e : (console.debug(`Rows to convert to geom: rows.length = ${e.length}`), y(e, r));
}
//#endregion
//#region src/common/sql.service.ts
var xe = "radarview-fi", Se = ["geom", "geometry"], Ce = 5, we = "wrapped_data";
function Te(e) {
	return e.trim().replace(/;\s*$/, "");
}
function Ee(e, t) {
	return `
    WITH source_array AS (
      SELECT ARRAY(SELECT t FROM (${Te(e)}) AS t) as arr
    ),
    numbered_data AS (
      SELECT
        t,
        offset as row_idx,
        ARRAY_LENGTH(arr) as total_rows
      FROM source_array, UNNEST(arr) as t WITH OFFSET as offset
    ),
    bucketed_data AS (
      SELECT
        t,
        row_idx,
        TRUNC(row_idx * ${t} / GREATEST(total_rows, 1)) as bucket_id
      FROM numbered_data
    )
    SELECT
      ARRAY_AGG(t ORDER BY row_idx) AS ${we}
    FROM bucketed_data
    GROUP BY bucket_id
    ORDER BY bucket_id
  `;
}
async function De(e) {
	let t = {
		type: "query",
		client: e.client ?? xe,
		source: e.query.query,
		params: {
			column: e.query.columns,
			limit: e.query.limit,
			offset: e.query.offset
		},
		filters: {},
		spatialDataType: "geo",
		spatialDataColumn: "geom_alt126"
	}, n = `${e.apiBaseUrl}/v3/sql/${e.connection}/model/table`, r = e.avoidCache ?? !1;
	return await fe({
		abortController: e.abortController ?? new AbortController().signal,
		method: r ? ie.Post : ie.Get,
		url: n,
		credentials: { accessToken: e.token },
		...r ? { body: t } : { params: t }
	});
}
async function Oe({ credentials: e, connection: t, client: n, query: r, params: i, fetcherOptions: a, geometryFields: o = Se, buckets: s = Ce }) {
	let c = await De({
		query: {
			query: Ee(r, s),
			columns: [we],
			limit: s,
			offset: 0
		},
		token: e.accessToken,
		apiBaseUrl: e.apiBaseUrl,
		connection: t,
		client: n,
		avoidCache: i?.avoidCache ?? !1,
		abortController: a?.abortController
	}), l = be(c.rows.flatMap((e) => e[we] ?? []), o);
	return {
		...c,
		rows: l
	};
}
//#endregion
//#region src/helpers/query-executor.helper.ts
var ke = "_test", Ae = "_live", je = "default";
function Me(e, t, n = je) {
	return `${He(e, t)}${t.isTesting() ? ke : Ae}_${n}`;
}
async function b(e, t, n, r = !1) {
	let i = _e.getInstance().getToken(), { apiBaseUrl: a, cartoConnection: o } = S(t, n);
	return (await Oe({
		credentials: {
			accessToken: i,
			apiBaseUrl: a
		},
		connection: o,
		client: Me(t, n),
		query: e,
		params: { avoidCache: r },
		fetcherOptions: { abortController: new AbortController().signal }
	})).rows;
}
//#endregion
//#region src/cache.service.ts
async function Ne(e, t, n, r) {
	return await b(`
  SELECT
    table_id as table_name,
    FORMAT_TIMESTAMP('%FT%T', TIMESTAMP_MILLIS(last_modified_time), "UTC") AS last_modified
  FROM \`${r}.${n}.__TABLES__\`
  WHERE NOT STARTS_WITH(table_id, 'rollback')
  `, e, t, !0);
}
//#endregion
//#region src/cache/cache.manager.ts
var Pe = class e {
	constructor() {
		ge(this, "cacheInfo", /* @__PURE__ */ new Map()), ge(this, "cacheInfoAsArray", []), ge(this, "environment", null), ge(this, "bigQueryDataset", ""), ge(this, "authManager", null);
	}
	async init(e, t, n, r = !1) {
		if (this.environment = e, this.authManager = t, !r && this.cacheInfoAsArray.length > 0) return;
		let i = this.environment.getEnvironment(), a = this.environment.isTesting();
		this.bigQueryDataset = a ? `${i}_testing` : i, await this.updateCacheInfo(n);
	}
	async updateCacheInfo(e) {
		if (this.authManager === null || this.environment === null) throw Error("CacheManager not initialized");
		let t = Ve(e, this.environment);
		this.cacheInfoAsArray = await Ne(e, this.environment, this.bigQueryDataset, t), this.cacheInfoAsArray.reduce((e, t) => (e.set(t.table_name, t.last_modified), e), this.cacheInfo);
	}
	static getInstance() {
		return e.instance ||= new e(), e.instance;
	}
	getCacheInfo() {
		return this.cacheInfoAsArray;
	}
	getCacheInfoForTable(e) {
		let t = this.cacheInfo.get(e);
		if (!t) throw Error(`Cache info not found for table ${e}`);
		return t;
	}
};
ge(Pe, "instance", void 0);
//#endregion
//#region src/helpers/metadata.helper.ts
function Fe(e) {
	return e.join(", ");
}
var Ie = /* @__PURE__ */ function(e) {
	return e[e.Filterable = 0] = "Filterable", e[e.Autocomplete = 1] = "Autocomplete", e[e.Display = 2] = "Display", e[e.Startup = 3] = "Startup", e[e.Background = 4] = "Background", e;
}({});
function Le(e, t) {
	return e.filter((e) => {
		switch (t) {
			case 0: return e.filterable;
			case 2: return e.display;
			case 1: return "autocomplete" in e ? e.autocomplete : !1;
			case 3: return e.startup;
			case 4: return e.background;
			default: throw Error("Executing getColunmsFromModel: Invalid filter option");
		}
	});
}
function Re(e, t) {
	return Le(e, t).map((e) => e.id);
}
function ze(e, t) {
	return Fe(Re(e, t));
}
function Be(e, t, n) {
	let r = e.getEnvironment();
	return `\`${t}.${e.isTesting() ? `${r}_testing` : r}.${n}\` ${`/*${Pe.getInstance().getCacheInfoForTable(n)}*/`}`;
}
function Ve(e, t) {
	let n = t.getEnvironment(), r = e.bq_project;
	switch (n) {
		case g.Development: return r.dev;
		case g.Staging: return r.staging;
		case g.Production: return r.prod;
	}
	throw Error(`Could not find BQ project for environment ${n}. Check metadata file to verify values are correctly set under bq_project parameter`);
}
function x(e, t, n) {
	return Be(t, Ve(e, t), n.table_name);
}
function S(e, t) {
	return {
		apiBaseUrl: e.base_url,
		cartoConnection: He(e, t)
	};
}
function He(e, t) {
	let n = t.getEnvironment();
	return `${e.connection}_${n}`;
}
function Ue(e) {
	return e.local_storage_keys.firebase_token;
}
function We(e) {
	return e.countries.length > 1;
}
function Ge(e) {
	return e.countries[0].id;
}
function Ke(e, t, n) {
	let r = t.getEnvironment(), i = e.app_config.remote_functions[n];
	if (!i) throw Error(`🛑 Getting remote function. Remote function ${n} not found. Check flavour metadata.`);
	switch (r) {
		case "dev": return i.dev || "";
		case "stg": return i.staging || "";
		case "pro": return i.prod || "";
		default: throw Error(`🛑 Getting remote function. Unrecognized environment value: ${r} . Check .env file to verify VITE_APP_ENV is set.`);
	}
}
function qe(e, t) {
	let n = t.getEnvironment(), r = e.app_config.firebase;
	switch (n) {
		case "dev": return r.dev;
		case "stg": return r.staging;
		case "pro": return r.prod;
		default: throw Error(`🛑 Getting Firebase config. Unrecognized environment value: ${t}. Check .env file to verify VITE_APP_ENV is set.`);
	}
}
function Je(e) {
	return e.carto_events_url;
}
//#endregion
//#region src/helpers/query-construction.helper.ts
var Ye = /* @__PURE__ */ function(e) {
	return e.EQUALS = "=", e.NOT_EQUALS = "<>", e;
}({}), Xe = /* @__PURE__ */ function(e) {
	return e.AND = "AND", e.OR = "OR", e.WHERE = "WHERE", e.NONE = "", e;
}({});
function Ze(e) {
	let { columnName: t, ids: n, equalityOperator: r, logicalOperator: i, normalizedStringSearch: a, returnEmptyIfIdsEmpty: o } = e;
	if (n.length === 0) {
		if (o) return "";
		throw Error("When generating a where clause from ids, the ids array must not be empty");
	}
	let s = a ? `NORMALIZE_AND_CASEFOLD(${t})` : t;
	if (n.length === 1) {
		let e = n[0];
		return typeof n[0] == "string" && (e = `"${n[0]}"`), `${i} ${s} ${r} ${e}`;
	}
	let c = n.join(", ");
	typeof n[0] == "string" && (c = `"${n.join("\", \"")}"`);
	let l = `${i} ${s} `;
	return r === "=" ? l += `IN UNNEST([${c}])` : l += `NOT IN UNNEST([${c}])`, l;
}
//#endregion
//#region src/assets.helper.ts
function Qe(e, t, n) {
	return `SELECT ${ze(e.data_model.assets.columns, Ie.Display)} FROM ${x(e, t, e.data_model.assets)} WHERE id = '${n}'`;
}
function $e(e, t, n) {
	return `SELECT id, internal_panel_id, geom FROM ${x(e, t, e.data_model.assets)} ${Ze({
		columnName: "id",
		ids: n,
		equalityOperator: Ye.EQUALS,
		logicalOperator: Xe.WHERE
	})}`;
}
function et(e, t, n) {
	let r = x(e, t, e.data_model.assets), i = `WITH assets_by_countries AS (SELECT * FROM ${r})`;
	return e.countries.length === 1 || n.countries === void 0 || n.countries.length === 0 ? i : `WITH assets_by_countries AS (
    SELECT
      *
    FROM ${r}
    WHERE
      country_id in (${n.countries.join(",")})
  )`;
}
function tt(e, t, n, r) {
	return `
    ${et(e, t, n)}

    SELECT DISTINCT
      a.business_unit_id,
      a.l1panelclass_id as id,
      a.l1_panel_class as name
    FROM assets_by_countries a
    WHERE a.is_digital = ${r ? "true" : "false"} AND name IS NOT NULL AND id IS NOT NULL`;
}
function nt(e, t, n) {
	return tt(e, t, n, !0);
}
function rt(e, t, n) {
	return tt(e, t, n, !1);
}
//#endregion
//#region src/assets.service.ts
var it = /* @__PURE__ */ u({
	fetchLayerSource: () => _t,
	getAllAssetsWithBackgroundProperties: () => pt,
	getAllAssetsWithStartupProperties: () => ft,
	getAllMediaTypeOptionsForSharedPlan: () => At,
	getAssetById: () => kt,
	getAssetProperties: () => mt,
	getAssetPropertiesQuery: () => at,
	getAssetsCountPerCountry: () => ht,
	getAssetsPointsByIds: () => jt,
	getAssetsSQL: () => gt,
	getAssetsTypeL1: () => bt,
	getAssetsTypeL1DigitalFilter: () => vt,
	getAssetsTypeL1StaticFilter: () => yt,
	getAssetsTypeL2: () => xt,
	getAssetsTypeL3: () => St,
	getAssetsTypeL4: () => Ct,
	getAssetsTypeL5: () => wt,
	getAssetsTypeL6: () => Tt,
	getAssetsTypeL7: () => Et,
	getAssetsTypeL8: () => Dt,
	getAssetsTypeL9: () => Ot
});
function at(e, t, n, r, i) {
	return `SELECT ${ze(e.data_model.assets.columns, Ie.Background)} FROM ${x(e, t, e.data_model.assets)}
  ${n ? Ze({
		columnName: "country_id",
		ids: [n],
		equalityOperator: Ye.EQUALS,
		logicalOperator: Xe.WHERE
	}) : ""}
  ORDER BY id
  LIMIT ${r} OFFSET ${i}`;
}
function ot(e, t) {
	if (typeof e != "string") throw Error(`Executing convertFromStringToProvidedType: Value ${e} is not a string`);
	if (e === "NULL") return null;
	switch (t) {
		case p.String: return e;
		case p.Number: return Number(e);
		case p.Boolean: return e.toLocaleLowerCase() === "true";
		case p.Date: return new Date(e);
		case p.ArrayNumbers: return e.split(";").map((e) => Number(e));
		default: throw Error(`Executing convertFromStringToProvidedType: Type not supported ${t}`);
	}
}
async function st(e, t, n, r, i, a, o) {
	let s = `, '${n}', `, c = x(e, t, e.data_model.assets), l = "";
	r.forEach((e) => e.type === p.ArrayNumbers ? l += `COALESCE(SAFE_CAST((SELECT STRING_AGG(CAST(id AS STRING), ';') FROM UNNEST(${e.id}) id) AS STRING), 'NULL')${s}` : l += `COALESCE(SAFE_CAST(${e.id} AS STRING), 'NULL')${s}`), l = l.slice(0, -s.length);
	let u = i === -1 ? "" : `WHERE country_id = ${i}`;
	return await b(`
  SELECT CONCAT(${l}) as asset
  FROM ${c}
  ${u}
  ORDER BY id
  LIMIT ${a}
  OFFSET ${o}`, e, t);
}
async function ct(e, t, n, r, i, a) {
	let o = [], s = [];
	n.forEach((n) => {
		let c = Math.ceil(n.assets / a);
		for (let l = 0; l < c; l++) {
			let c = l * a;
			o.push(n.country_id), s.push(st(e, t, i, r, n.country_id, a, c));
		}
	});
	let c = await Promise.all(s), l = o.length, u = [], d = [], f = o[0];
	for (let e = 0; e < l; e++) f === o[e] ? d = d.concat(c[e]) : (u.push({
		countryId: f,
		assets: d.map((e) => e.asset)
	}), d = c[e]), f = o[e];
	return u.push({
		countryId: f,
		assets: d.map((e) => e.asset)
	}), u;
}
function lt(e, t, n) {
	return e.map((e) => {
		let r = e.split(n), i = {};
		return r.forEach((e, n) => {
			let r = t[n], a = ot(e, r.type);
			i[r.id] = a;
		}), i;
	});
}
function ut(e) {
	return e.map((e) => ({
		type: "Feature",
		geometry: {
			coordinates: [e.longitude, e.latitude],
			type: "Point"
		},
		properties: e
	}));
}
async function dt(e, t, n, r, i) {
	let a = "%&&%";
	return (await ct(e, t, n, r, a, i)).map((e) => {
		let t = ut(lt(e.assets, r, a));
		return {
			countryId: e.countryId,
			assets: t
		};
	});
}
async function ft(e, t, n, r) {
	return await dt(e, t, n, Le(e.data_model.assets.columns, Ie.Startup), r);
}
async function pt(e, t, n, r) {
	let i = "%&&%", a = Le(e.data_model.assets.columns, Ie.Background);
	return (await ct(e, t, n, a, i, r)).map((e) => {
		let t = lt(e.assets, a, i);
		return {
			countryId: e.countryId,
			assets: t
		};
	});
}
async function mt(e, t, n, r, i) {
	return await b(at(e, t, n, r, i), e, t);
}
async function ht(e, t) {
	let n = x(e, t, e.data_model.assets), r = "country_id";
	We(e) || (r = `${Ge(e).toString()} as country_id`);
	let i = await b(`SELECT
    ${r},
    COUNT(*) as assets
  FROM ${n}

  GROUP BY country_id`, e, t);
	return i.length === 0 && (console.debug("🔥 ----------------------------------------------------- "), console.debug("🔥 There are no assets in the database                   "), console.debug("🔥 Restore the assets table with the last rollback table "), console.debug("🔥 ----------------------------------------------------- ")), i;
}
async function gt(e, t, n) {
	return await b(n, e, t);
}
function _t(e, t, n, r, i) {
	return `SELECT ${ze(e.data_model.assets.columns, Ie.Startup)} FROM ${x(e, t, e.data_model.assets)}
  ${n ? Ze({
		columnName: "country_id",
		ids: [n],
		equalityOperator: Ye.EQUALS,
		logicalOperator: Xe.WHERE
	}) : ""}
  ORDER BY id
  LIMIT ${r} OFFSET ${i}`;
}
async function vt(e, t, n) {
	return await b(nt(e, t, n), e, t);
}
async function yt(e, t, n) {
	return await b(rt(e, t, n), e, t);
}
async function bt(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      NULL as parent_id,
      a.l1panelclass_id as id,
      a.l1panelclass as name
    FROM assets_by_countries a
    WHERE l1panelclass_id IS NOT NULL
    GROUP BY a.country_id, a.l1panelclass_id, a.l1panelclass
    `, e, t);
}
async function xt(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l1panelclass_id as parent_id,
      a.l2product_id as id,
      a.l2product as name
    FROM assets_by_countries a
    WHERE l2product_id IS NOT NULL
    GROUP BY a.country_id, a.l1panelclass_id, a.l2product_id, a.l2product
    `, e, t);
}
async function St(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l2product_id as parent_id,
      a.l3subproduct_id as id,
      a.l3subproduct as name
    FROM assets_by_countries a
    WHERE l3subproduct_id IS NOT NULL
    GROUP BY a.country_id, a.l2product_id, a.l3subproduct_id, a.l3subproduct
    `, e, t);
}
async function Ct(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l3subproduct_id as parent_id,
      a.l4_id as id,
      a.l4 as name
    FROM assets_by_countries a
    WHERE l4_id IS NOT NULL
    GROUP BY a.country_id, a.l3subproduct_id, a.l4_id, a.l4
    `, e, t);
}
async function wt(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l4_id as parent_id,
      a.l5_id as id,
      a.l5 as name
    FROM assets_by_countries a
    WHERE l5_id IS NOT NULL
    GROUP BY a.country_id, a.l4_id, a.l5_id, a.l5
    `, e, t);
}
async function Tt(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l5_id as parent_id,
      a.l6_id as id,
      a.l6 as name
    FROM assets_by_countries a
    WHERE l6_id IS NOT NULL
    GROUP BY a.country_id, a.l5_id, a.l6_id, a.l6
    `, e, t);
}
async function Et(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l6_id as parent_id,
      a.l7_id as id,
      a.l7 as name
    FROM assets_by_countries a
    WHERE l7_id IS NOT NULL
    GROUP BY a.country_id, a.l6_id, a.l7_id, a.l7
    `, e, t);
}
async function Dt(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l7_id as parent_id,
      a.l8_id as id,
      a.l8 as name
    FROM assets_by_countries a
    WHERE l8_id IS NOT NULL
    GROUP BY a.country_id, a.l7_id, a.l8_id, a.l8
    `, e, t);
}
async function Ot(e, t, n) {
	return await b(`
    ${et(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l8_id as parent_id,
      a.l9_id as id,
      a.l9 as name
    FROM assets_by_countries a
    WHERE l9_id IS NOT NULL
    GROUP BY a.country_id, a.l8_id, a.l9_id, a.l9
    `, e, t);
}
async function kt(e, t, n) {
	return await b(Qe(e, t, n), e, t);
}
async function At(e, t, n, r, i) {
	let a = Ke(e, r, m.SharedPlan), o = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, s = new URLSearchParams({
		action: h.AllMediaTypeOptions,
		appVersion: o,
		planId: t,
		activeSubfilterIndex: n.toString()
	});
	return i && s.set("password", i), a += `?${s.toString()}`, await (await fetch(a, {
		method: "POST",
		body: JSON.stringify({ planId: t })
	})).json();
}
async function jt(e, t, n) {
	return await b($e(e, t, n), e, t);
}
//#endregion
//#region ../node_modules/@firebase/util/dist/index.esm2017.js
var Mt = function(e) {
	let t = [], n = 0;
	for (let r = 0; r < e.length; r++) {
		let i = e.charCodeAt(r);
		i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) == 55296 && r + 1 < e.length && (e.charCodeAt(r + 1) & 64512) == 56320 ? (i = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++r) & 1023), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
	}
	return t;
}, Nt = function(e) {
	let t = [], n = 0, r = 0;
	for (; n < e.length;) {
		let i = e[n++];
		if (i < 128) t[r++] = String.fromCharCode(i);
		else if (i > 191 && i < 224) {
			let a = e[n++];
			t[r++] = String.fromCharCode((i & 31) << 6 | a & 63);
		} else if (i > 239 && i < 365) {
			let a = e[n++], o = e[n++], s = e[n++], c = ((i & 7) << 18 | (a & 63) << 12 | (o & 63) << 6 | s & 63) - 65536;
			t[r++] = String.fromCharCode(55296 + (c >> 10)), t[r++] = String.fromCharCode(56320 + (c & 1023));
		} else {
			let a = e[n++], o = e[n++];
			t[r++] = String.fromCharCode((i & 15) << 12 | (a & 63) << 6 | o & 63);
		}
	}
	return t.join("");
}, Pt = {
	byteToCharMap_: null,
	charToByteMap_: null,
	byteToCharMapWebSafe_: null,
	charToByteMapWebSafe_: null,
	ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
	get ENCODED_VALS() {
		return this.ENCODED_VALS_BASE + "+/=";
	},
	get ENCODED_VALS_WEBSAFE() {
		return this.ENCODED_VALS_BASE + "-_.";
	},
	HAS_NATIVE_SUPPORT: typeof atob == "function",
	encodeByteArray(e, t) {
		if (!Array.isArray(e)) throw Error("encodeByteArray takes an array as a parameter");
		this.init_();
		let n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
		for (let t = 0; t < e.length; t += 3) {
			let i = e[t], a = t + 1 < e.length, o = a ? e[t + 1] : 0, s = t + 2 < e.length, c = s ? e[t + 2] : 0, l = i >> 2, u = (i & 3) << 4 | o >> 4, d = (o & 15) << 2 | c >> 6, f = c & 63;
			s || (f = 64, a || (d = 64)), r.push(n[l], n[u], n[d], n[f]);
		}
		return r.join("");
	},
	encodeString(e, t) {
		return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(Mt(e), t);
	},
	decodeString(e, t) {
		return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : Nt(this.decodeStringToByteArray(e, t));
	},
	decodeStringToByteArray(e, t) {
		this.init_();
		let n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
		for (let t = 0; t < e.length;) {
			let i = n[e.charAt(t++)], a = t < e.length ? n[e.charAt(t)] : 0;
			++t;
			let o = t < e.length ? n[e.charAt(t)] : 64;
			++t;
			let s = t < e.length ? n[e.charAt(t)] : 64;
			if (++t, i == null || a == null || o == null || s == null) throw new Ft();
			let c = i << 2 | a >> 4;
			if (r.push(c), o !== 64) {
				let e = a << 4 & 240 | o >> 2;
				if (r.push(e), s !== 64) {
					let e = o << 6 & 192 | s;
					r.push(e);
				}
			}
		}
		return r;
	},
	init_() {
		if (!this.byteToCharMap_) {
			this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
			for (let e = 0; e < this.ENCODED_VALS.length; e++) this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
		}
	}
}, Ft = class extends Error {
	constructor() {
		super(...arguments), this.name = "DecodeBase64StringError";
	}
}, It = function(e) {
	let t = Mt(e);
	return Pt.encodeByteArray(t, !0);
}, Lt = function(e) {
	return It(e).replace(/\./g, "");
}, Rt = function(e) {
	try {
		return Pt.decodeString(e, !0);
	} catch (e) {
		console.error("base64Decode failed: ", e);
	}
	return null;
};
function zt() {
	if (typeof self < "u") return self;
	if (typeof window < "u") return window;
	if (typeof global < "u") return global;
	throw Error("Unable to locate global object.");
}
var Bt = () => zt().__FIREBASE_DEFAULTS__, Vt = () => {
	if (typeof process > "u" || process.env === void 0) return;
	let e = process.env.__FIREBASE_DEFAULTS__;
	if (e) return JSON.parse(e);
}, Ht = () => {
	if (typeof document > "u") return;
	let e;
	try {
		e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
	} catch {
		return;
	}
	let t = e && Rt(e[1]);
	return t && JSON.parse(t);
}, Ut = () => {
	try {
		return Bt() || Vt() || Ht();
	} catch (e) {
		console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
		return;
	}
}, Wt = (e) => Ut()?.emulatorHosts?.[e], Gt = (e) => {
	let t = Wt(e);
	if (!t) return;
	let n = t.lastIndexOf(":");
	if (n <= 0 || n + 1 === t.length) throw Error(`Invalid host ${t} with no separate hostname and port!`);
	let r = parseInt(t.substring(n + 1), 10);
	return t[0] === "[" ? [t.substring(1, n - 1), r] : [t.substring(0, n), r];
}, Kt = () => Ut()?.config, qt = (e) => Ut()?.[`_${e}`], Jt = class {
	constructor() {
		this.reject = () => {}, this.resolve = () => {}, this.promise = new Promise((e, t) => {
			this.resolve = e, this.reject = t;
		});
	}
	wrapCallback(e) {
		return (t, n) => {
			t ? this.reject(t) : this.resolve(n), typeof e == "function" && (this.promise.catch(() => {}), e.length === 1 ? e(t) : e(t, n));
		};
	}
};
function Yt(e, t) {
	if (e.uid) throw Error("The \"uid\" field is no longer supported by mockUserToken. Please use \"sub\" instead for Firebase Auth User ID.");
	let n = {
		alg: "none",
		type: "JWT"
	}, r = t || "demo-project", i = e.iat || 0, a = e.sub || e.user_id;
	if (!a) throw Error("mockUserToken must contain 'sub' or 'user_id' field!");
	let o = Object.assign({
		iss: `https://securetoken.google.com/${r}`,
		aud: r,
		iat: i,
		exp: i + 3600,
		auth_time: i,
		sub: a,
		user_id: a,
		firebase: {
			sign_in_provider: "custom",
			identities: {}
		}
	}, e);
	return [
		Lt(JSON.stringify(n)),
		Lt(JSON.stringify(o)),
		""
	].join(".");
}
function C() {
	return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function Xt() {
	return typeof window < "u" && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(C());
}
function Zt() {
	let e = Ut()?.forceEnvironment;
	if (e === "node") return !0;
	if (e === "browser") return !1;
	try {
		return Object.prototype.toString.call(global.process) === "[object process]";
	} catch {
		return !1;
	}
}
function Qt() {
	return typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers";
}
function $t() {
	let e = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
	return typeof e == "object" && e.id !== void 0;
}
function w() {
	return typeof navigator == "object" && navigator.product === "ReactNative";
}
function en() {
	let e = C();
	return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
}
function tn() {
	return !Zt() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
function nn() {
	try {
		return typeof indexedDB == "object";
	} catch {
		return !1;
	}
}
function rn() {
	return new Promise((e, t) => {
		try {
			let n = !0, r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
			i.onsuccess = () => {
				i.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
			}, i.onupgradeneeded = () => {
				n = !1;
			}, i.onerror = () => {
				t(i.error?.message || "");
			};
		} catch (e) {
			t(e);
		}
	});
}
var an = "FirebaseError", on = class e extends Error {
	constructor(t, n, r) {
		super(n), this.code = t, this.customData = r, this.name = an, Object.setPrototypeOf(this, e.prototype), Error.captureStackTrace && Error.captureStackTrace(this, sn.prototype.create);
	}
}, sn = class {
	constructor(e, t, n) {
		this.service = e, this.serviceName = t, this.errors = n;
	}
	create(e, ...t) {
		let n = t[0] || {}, r = `${this.service}/${e}`, i = this.errors[e], a = i ? cn(i, n) : "Error";
		return new on(r, `${this.serviceName}: ${a} (${r}).`, n);
	}
};
function cn(e, t) {
	return e.replace(ln, (e, n) => {
		let r = t[n];
		return r == null ? `<${n}?>` : String(r);
	});
}
var ln = /\{\$([^}]+)}/g;
function un(e) {
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
	return !0;
}
function dn(e, t) {
	if (e === t) return !0;
	let n = Object.keys(e), r = Object.keys(t);
	for (let i of n) {
		if (!r.includes(i)) return !1;
		let n = e[i], a = t[i];
		if (fn(n) && fn(a)) {
			if (!dn(n, a)) return !1;
		} else if (n !== a) return !1;
	}
	for (let e of r) if (!n.includes(e)) return !1;
	return !0;
}
function fn(e) {
	return typeof e == "object" && !!e;
}
function pn(e) {
	let t = [];
	for (let [n, r] of Object.entries(e)) Array.isArray(r) ? r.forEach((e) => {
		t.push(encodeURIComponent(n) + "=" + encodeURIComponent(e));
	}) : t.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
	return t.length ? "&" + t.join("&") : "";
}
function mn(e) {
	let t = {};
	return e.replace(/^\?/, "").split("&").forEach((e) => {
		if (e) {
			let [n, r] = e.split("=");
			t[decodeURIComponent(n)] = decodeURIComponent(r);
		}
	}), t;
}
function hn(e) {
	let t = e.indexOf("?");
	if (!t) return "";
	let n = e.indexOf("#", t);
	return e.substring(t, n > 0 ? n : void 0);
}
function gn(e, t) {
	let n = new _n(e, t);
	return n.subscribe.bind(n);
}
var _n = class {
	constructor(e, t) {
		this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = t, this.task.then(() => {
			e(this);
		}).catch((e) => {
			this.error(e);
		});
	}
	next(e) {
		this.forEachObserver((t) => {
			t.next(e);
		});
	}
	error(e) {
		this.forEachObserver((t) => {
			t.error(e);
		}), this.close(e);
	}
	complete() {
		this.forEachObserver((e) => {
			e.complete();
		}), this.close();
	}
	subscribe(e, t, n) {
		let r;
		if (e === void 0 && t === void 0 && n === void 0) throw Error("Missing Observer.");
		r = vn(e, [
			"next",
			"error",
			"complete"
		]) ? e : {
			next: e,
			error: t,
			complete: n
		}, r.next === void 0 && (r.next = yn), r.error === void 0 && (r.error = yn), r.complete === void 0 && (r.complete = yn);
		let i = this.unsubscribeOne.bind(this, this.observers.length);
		return this.finalized && this.task.then(() => {
			try {
				this.finalError ? r.error(this.finalError) : r.complete();
			} catch {}
		}), this.observers.push(r), i;
	}
	unsubscribeOne(e) {
		this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], --this.observerCount, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
	}
	forEachObserver(e) {
		if (!this.finalized) for (let t = 0; t < this.observers.length; t++) this.sendOne(t, e);
	}
	sendOne(e, t) {
		this.task.then(() => {
			if (this.observers !== void 0 && this.observers[e] !== void 0) try {
				t(this.observers[e]);
			} catch (e) {
				typeof console < "u" && console.error && console.error(e);
			}
		});
	}
	close(e) {
		this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
			this.observers = void 0, this.onNoObservers = void 0;
		}));
	}
};
function vn(e, t) {
	if (typeof e != "object" || !e) return !1;
	for (let n of t) if (n in e && typeof e[n] == "function") return !0;
	return !1;
}
function yn() {}
function T(e) {
	return e && e._delegate ? e._delegate : e;
}
//#endregion
//#region ../node_modules/@firebase/component/dist/esm/index.esm2017.js
var bn = class {
	constructor(e, t, n) {
		this.name = e, this.instanceFactory = t, this.type = n, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
	}
	setInstantiationMode(e) {
		return this.instantiationMode = e, this;
	}
	setMultipleInstances(e) {
		return this.multipleInstances = e, this;
	}
	setServiceProps(e) {
		return this.serviceProps = e, this;
	}
	setInstanceCreatedCallback(e) {
		return this.onInstanceCreated = e, this;
	}
}, xn = "[DEFAULT]", Sn = class {
	constructor(e, t) {
		this.name = e, this.container = t, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
	}
	get(e) {
		let t = this.normalizeInstanceIdentifier(e);
		if (!this.instancesDeferred.has(t)) {
			let e = new Jt();
			if (this.instancesDeferred.set(t, e), this.isInitialized(t) || this.shouldAutoInitialize()) try {
				let n = this.getOrInitializeService({ instanceIdentifier: t });
				n && e.resolve(n);
			} catch {}
		}
		return this.instancesDeferred.get(t).promise;
	}
	getImmediate(e) {
		let t = this.normalizeInstanceIdentifier(e?.identifier), n = e?.optional ?? !1;
		if (this.isInitialized(t) || this.shouldAutoInitialize()) try {
			return this.getOrInitializeService({ instanceIdentifier: t });
		} catch (e) {
			if (n) return null;
			throw e;
		}
		else if (n) return null;
		else throw Error(`Service ${this.name} is not available`);
	}
	getComponent() {
		return this.component;
	}
	setComponent(e) {
		if (e.name !== this.name) throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
		if (this.component) throw Error(`Component for ${this.name} has already been provided`);
		if (this.component = e, this.shouldAutoInitialize()) {
			if (wn(e)) try {
				this.getOrInitializeService({ instanceIdentifier: xn });
			} catch {}
			for (let [e, t] of this.instancesDeferred.entries()) {
				let n = this.normalizeInstanceIdentifier(e);
				try {
					let e = this.getOrInitializeService({ instanceIdentifier: n });
					t.resolve(e);
				} catch {}
			}
		}
	}
	clearInstance(e = xn) {
		this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
	}
	async delete() {
		let e = Array.from(this.instances.values());
		await Promise.all([...e.filter((e) => "INTERNAL" in e).map((e) => e.INTERNAL.delete()), ...e.filter((e) => "_delete" in e).map((e) => e._delete())]);
	}
	isComponentSet() {
		return this.component != null;
	}
	isInitialized(e = xn) {
		return this.instances.has(e);
	}
	getOptions(e = xn) {
		return this.instancesOptions.get(e) || {};
	}
	initialize(e = {}) {
		let { options: t = {} } = e, n = this.normalizeInstanceIdentifier(e.instanceIdentifier);
		if (this.isInitialized(n)) throw Error(`${this.name}(${n}) has already been initialized`);
		if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
		let r = this.getOrInitializeService({
			instanceIdentifier: n,
			options: t
		});
		for (let [e, t] of this.instancesDeferred.entries()) n === this.normalizeInstanceIdentifier(e) && t.resolve(r);
		return r;
	}
	onInit(e, t) {
		let n = this.normalizeInstanceIdentifier(t), r = this.onInitCallbacks.get(n) ?? /* @__PURE__ */ new Set();
		r.add(e), this.onInitCallbacks.set(n, r);
		let i = this.instances.get(n);
		return i && e(i, n), () => {
			r.delete(e);
		};
	}
	invokeOnInitCallbacks(e, t) {
		let n = this.onInitCallbacks.get(t);
		if (n) for (let r of n) try {
			r(e, t);
		} catch {}
	}
	getOrInitializeService({ instanceIdentifier: e, options: t = {} }) {
		let n = this.instances.get(e);
		if (!n && this.component && (n = this.component.instanceFactory(this.container, {
			instanceIdentifier: Cn(e),
			options: t
		}), this.instances.set(e, n), this.instancesOptions.set(e, t), this.invokeOnInitCallbacks(n, e), this.component.onInstanceCreated)) try {
			this.component.onInstanceCreated(this.container, e, n);
		} catch {}
		return n || null;
	}
	normalizeInstanceIdentifier(e = xn) {
		return this.component ? this.component.multipleInstances ? e : xn : e;
	}
	shouldAutoInitialize() {
		return !!this.component && this.component.instantiationMode !== "EXPLICIT";
	}
};
function Cn(e) {
	return e === xn ? void 0 : e;
}
function wn(e) {
	return e.instantiationMode === "EAGER";
}
var Tn = class {
	constructor(e) {
		this.name = e, this.providers = /* @__PURE__ */ new Map();
	}
	addComponent(e) {
		let t = this.getProvider(e.name);
		if (t.isComponentSet()) throw Error(`Component ${e.name} has already been registered with ${this.name}`);
		t.setComponent(e);
	}
	addOrOverwriteComponent(e) {
		this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
	}
	getProvider(e) {
		if (this.providers.has(e)) return this.providers.get(e);
		let t = new Sn(e, this);
		return this.providers.set(e, t), t;
	}
	getProviders() {
		return Array.from(this.providers.values());
	}
}, En = [], E;
(function(e) {
	e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(E ||= {});
var D = {
	debug: E.DEBUG,
	verbose: E.VERBOSE,
	info: E.INFO,
	warn: E.WARN,
	error: E.ERROR,
	silent: E.SILENT
}, Dn = E.INFO, On = {
	[E.DEBUG]: "log",
	[E.VERBOSE]: "log",
	[E.INFO]: "info",
	[E.WARN]: "warn",
	[E.ERROR]: "error"
}, kn = (e, t, ...n) => {
	if (t < e.logLevel) return;
	let r = (/* @__PURE__ */ new Date()).toISOString(), i = On[t];
	if (i) console[i](`[${r}]  ${e.name}:`, ...n);
	else throw Error(`Attempted to log a message with an invalid logType (value: ${t})`);
}, An = class {
	constructor(e) {
		this.name = e, this._logLevel = Dn, this._logHandler = kn, this._userLogHandler = null, En.push(this);
	}
	get logLevel() {
		return this._logLevel;
	}
	set logLevel(e) {
		if (!(e in E)) throw TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
		this._logLevel = e;
	}
	setLogLevel(e) {
		this._logLevel = typeof e == "string" ? D[e] : e;
	}
	get logHandler() {
		return this._logHandler;
	}
	set logHandler(e) {
		if (typeof e != "function") throw TypeError("Value assigned to `logHandler` must be a function");
		this._logHandler = e;
	}
	get userLogHandler() {
		return this._userLogHandler;
	}
	set userLogHandler(e) {
		this._userLogHandler = e;
	}
	debug(...e) {
		this._userLogHandler && this._userLogHandler(this, E.DEBUG, ...e), this._logHandler(this, E.DEBUG, ...e);
	}
	log(...e) {
		this._userLogHandler && this._userLogHandler(this, E.VERBOSE, ...e), this._logHandler(this, E.VERBOSE, ...e);
	}
	info(...e) {
		this._userLogHandler && this._userLogHandler(this, E.INFO, ...e), this._logHandler(this, E.INFO, ...e);
	}
	warn(...e) {
		this._userLogHandler && this._userLogHandler(this, E.WARN, ...e), this._logHandler(this, E.WARN, ...e);
	}
	error(...e) {
		this._userLogHandler && this._userLogHandler(this, E.ERROR, ...e), this._logHandler(this, E.ERROR, ...e);
	}
}, jn = (e, t) => t.some((t) => e instanceof t), Mn, Nn;
function Pn() {
	return Mn ||= [
		IDBDatabase,
		IDBObjectStore,
		IDBIndex,
		IDBCursor,
		IDBTransaction
	];
}
function Fn() {
	return Nn ||= [
		IDBCursor.prototype.advance,
		IDBCursor.prototype.continue,
		IDBCursor.prototype.continuePrimaryKey
	];
}
var In = /* @__PURE__ */ new WeakMap(), Ln = /* @__PURE__ */ new WeakMap(), Rn = /* @__PURE__ */ new WeakMap(), zn = /* @__PURE__ */ new WeakMap(), Bn = /* @__PURE__ */ new WeakMap();
function Vn(e) {
	let t = new Promise((t, n) => {
		let r = () => {
			e.removeEventListener("success", i), e.removeEventListener("error", a);
		}, i = () => {
			t(qn(e.result)), r();
		}, a = () => {
			n(e.error), r();
		};
		e.addEventListener("success", i), e.addEventListener("error", a);
	});
	return t.then((t) => {
		t instanceof IDBCursor && In.set(t, e);
	}).catch(() => {}), Bn.set(t, e), t;
}
function Hn(e) {
	if (Ln.has(e)) return;
	let t = new Promise((t, n) => {
		let r = () => {
			e.removeEventListener("complete", i), e.removeEventListener("error", a), e.removeEventListener("abort", a);
		}, i = () => {
			t(), r();
		}, a = () => {
			n(e.error || new DOMException("AbortError", "AbortError")), r();
		};
		e.addEventListener("complete", i), e.addEventListener("error", a), e.addEventListener("abort", a);
	});
	Ln.set(e, t);
}
var Un = {
	get(e, t, n) {
		if (e instanceof IDBTransaction) {
			if (t === "done") return Ln.get(e);
			if (t === "objectStoreNames") return e.objectStoreNames || Rn.get(e);
			if (t === "store") return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
		}
		return qn(e[t]);
	},
	set(e, t, n) {
		return e[t] = n, !0;
	},
	has(e, t) {
		return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
	}
};
function Wn(e) {
	Un = e(Un);
}
function Gn(e) {
	return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
		let r = e.call(Jn(this), t, ...n);
		return Rn.set(r, t.sort ? t.sort() : [t]), qn(r);
	} : Fn().includes(e) ? function(...t) {
		return e.apply(Jn(this), t), qn(In.get(this));
	} : function(...t) {
		return qn(e.apply(Jn(this), t));
	};
}
function Kn(e) {
	return typeof e == "function" ? Gn(e) : (e instanceof IDBTransaction && Hn(e), jn(e, Pn()) ? new Proxy(e, Un) : e);
}
function qn(e) {
	if (e instanceof IDBRequest) return Vn(e);
	if (zn.has(e)) return zn.get(e);
	let t = Kn(e);
	return t !== e && (zn.set(e, t), Bn.set(t, e)), t;
}
var Jn = (e) => Bn.get(e);
//#endregion
//#region ../node_modules/idb/build/index.js
function Yn(e, t, { blocked: n, upgrade: r, blocking: i, terminated: a } = {}) {
	let o = indexedDB.open(e, t), s = qn(o);
	return r && o.addEventListener("upgradeneeded", (e) => {
		r(qn(o.result), e.oldVersion, e.newVersion, qn(o.transaction), e);
	}), n && o.addEventListener("blocked", (e) => n(e.oldVersion, e.newVersion, e)), s.then((e) => {
		a && e.addEventListener("close", () => a()), i && e.addEventListener("versionchange", (e) => i(e.oldVersion, e.newVersion, e));
	}).catch(() => {}), s;
}
var Xn = [
	"get",
	"getKey",
	"getAll",
	"getAllKeys",
	"count"
], Zn = [
	"put",
	"add",
	"delete",
	"clear"
], Qn = /* @__PURE__ */ new Map();
function $n(e, t) {
	if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string")) return;
	if (Qn.get(t)) return Qn.get(t);
	let n = t.replace(/FromIndex$/, ""), r = t !== n, i = Zn.includes(n);
	if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || Xn.includes(n))) return;
	let a = async function(e, ...t) {
		let a = this.transaction(e, i ? "readwrite" : "readonly"), o = a.store;
		return r && (o = o.index(t.shift())), (await Promise.all([o[n](...t), i && a.done]))[0];
	};
	return Qn.set(t, a), a;
}
Wn((e) => ({
	...e,
	get: (t, n, r) => $n(t, n) || e.get(t, n, r),
	has: (t, n) => !!$n(t, n) || e.has(t, n)
}));
//#endregion
//#region ../node_modules/@firebase/app/dist/esm/index.esm2017.js
var er = class {
	constructor(e) {
		this.container = e;
	}
	getPlatformInfoString() {
		return this.container.getProviders().map((e) => {
			if (tr(e)) {
				let t = e.getImmediate();
				return `${t.library}/${t.version}`;
			} else return null;
		}).filter((e) => e).join(" ");
	}
};
function tr(e) {
	return e.getComponent()?.type === "VERSION";
}
var nr = "@firebase/app", rr = "0.10.15", ir = new An("@firebase/app"), ar = "@firebase/app-compat", or = "@firebase/analytics-compat", sr = "@firebase/analytics", cr = "@firebase/app-check-compat", lr = "@firebase/app-check", ur = "@firebase/auth", dr = "@firebase/auth-compat", fr = "@firebase/database", pr = "@firebase/data-connect", mr = "@firebase/database-compat", hr = "@firebase/functions", gr = "@firebase/functions-compat", _r = "@firebase/installations", vr = "@firebase/installations-compat", yr = "@firebase/messaging", br = "@firebase/messaging-compat", xr = "@firebase/performance", Sr = "@firebase/performance-compat", Cr = "@firebase/remote-config", wr = "@firebase/remote-config-compat", Tr = "@firebase/storage", Er = "@firebase/storage-compat", Dr = "@firebase/firestore", Or = "@firebase/vertexai", kr = "@firebase/firestore-compat", Ar = "firebase", jr = "11.0.1", Mr = "[DEFAULT]", Nr = {
	[nr]: "fire-core",
	[ar]: "fire-core-compat",
	[sr]: "fire-analytics",
	[or]: "fire-analytics-compat",
	[lr]: "fire-app-check",
	[cr]: "fire-app-check-compat",
	[ur]: "fire-auth",
	[dr]: "fire-auth-compat",
	[fr]: "fire-rtdb",
	[pr]: "fire-data-connect",
	[mr]: "fire-rtdb-compat",
	[hr]: "fire-fn",
	[gr]: "fire-fn-compat",
	[_r]: "fire-iid",
	[vr]: "fire-iid-compat",
	[yr]: "fire-fcm",
	[br]: "fire-fcm-compat",
	[xr]: "fire-perf",
	[Sr]: "fire-perf-compat",
	[Cr]: "fire-rc",
	[wr]: "fire-rc-compat",
	[Tr]: "fire-gcs",
	[Er]: "fire-gcs-compat",
	[Dr]: "fire-fst",
	[kr]: "fire-fst-compat",
	[Or]: "fire-vertex",
	"fire-js": "fire-js",
	[Ar]: "fire-js-all"
}, Pr = /* @__PURE__ */ new Map(), Fr = /* @__PURE__ */ new Map(), Ir = /* @__PURE__ */ new Map();
function Lr(e, t) {
	try {
		e.container.addComponent(t);
	} catch (n) {
		ir.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
	}
}
function Rr(e) {
	let t = e.name;
	if (Ir.has(t)) return ir.debug(`There were multiple attempts to register component ${t}.`), !1;
	Ir.set(t, e);
	for (let t of Pr.values()) Lr(t, e);
	for (let t of Fr.values()) Lr(t, e);
	return !0;
}
function zr(e, t) {
	let n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
	return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
function Br(e) {
	return e.settings !== void 0;
}
var Vr = new sn("app", "Firebase", {
	"no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
	"bad-app-name": "Illegal App name: '{$appName}'",
	"duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
	"app-deleted": "Firebase App named '{$appName}' already deleted",
	"server-app-deleted": "Firebase Server App has been deleted",
	"no-options": "Need to provide options, when not being deployed to hosting via source.",
	"invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
	"invalid-log-argument": "First argument to `onLog` must be null or a function.",
	"idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
	"idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
	"idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
	"idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
	"finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
	"invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}), Hr = class {
	constructor(e, t, n) {
		this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, t), this._name = t.name, this._automaticDataCollectionEnabled = t.automaticDataCollectionEnabled, this._container = n, this.container.addComponent(new bn("app", () => this, "PUBLIC"));
	}
	get automaticDataCollectionEnabled() {
		return this.checkDestroyed(), this._automaticDataCollectionEnabled;
	}
	set automaticDataCollectionEnabled(e) {
		this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
	}
	get name() {
		return this.checkDestroyed(), this._name;
	}
	get options() {
		return this.checkDestroyed(), this._options;
	}
	get config() {
		return this.checkDestroyed(), this._config;
	}
	get container() {
		return this._container;
	}
	get isDeleted() {
		return this._isDeleted;
	}
	set isDeleted(e) {
		this._isDeleted = e;
	}
	checkDestroyed() {
		if (this.isDeleted) throw Vr.create("app-deleted", { appName: this._name });
	}
}, Ur = jr;
function Wr(e, t = {}) {
	let n = e;
	typeof t != "object" && (t = { name: t });
	let r = Object.assign({
		name: Mr,
		automaticDataCollectionEnabled: !1
	}, t), i = r.name;
	if (typeof i != "string" || !i) throw Vr.create("bad-app-name", { appName: String(i) });
	if (n ||= Kt(), !n) throw Vr.create("no-options");
	let a = Pr.get(i);
	if (a) {
		if (dn(n, a.options) && dn(r, a.config)) return a;
		throw Vr.create("duplicate-app", { appName: i });
	}
	let o = new Tn(i);
	for (let e of Ir.values()) o.addComponent(e);
	let s = new Hr(n, r, o);
	return Pr.set(i, s), s;
}
function Gr(e = Mr) {
	let t = Pr.get(e);
	if (!t && e === "[DEFAULT]" && Kt()) return Wr();
	if (!t) throw Vr.create("no-app", { appName: e });
	return t;
}
function Kr(e, t, n) {
	let r = Nr[e] ?? e;
	n && (r += `-${n}`);
	let i = r.match(/\s|\//), a = t.match(/\s|\//);
	if (i || a) {
		let e = [`Unable to register library "${r}" with version "${t}":`];
		i && e.push(`library name "${r}" contains illegal characters (whitespace or "/")`), i && a && e.push("and"), a && e.push(`version name "${t}" contains illegal characters (whitespace or "/")`), ir.warn(e.join(" "));
		return;
	}
	Rr(new bn(`${r}-version`, () => ({
		library: r,
		version: t
	}), "VERSION"));
}
var qr = "firebase-heartbeat-database", Jr = 1, Yr = "firebase-heartbeat-store", Xr = null;
function Zr() {
	return Xr ||= Yn(qr, Jr, { upgrade: (e, t) => {
		switch (t) {
			case 0: try {
				e.createObjectStore(Yr);
			} catch (e) {
				console.warn(e);
			}
		}
	} }).catch((e) => {
		throw Vr.create("idb-open", { originalErrorMessage: e.message });
	}), Xr;
}
async function Qr(e) {
	try {
		let t = (await Zr()).transaction(Yr), n = await t.objectStore(Yr).get(ei(e));
		return await t.done, n;
	} catch (e) {
		if (e instanceof on) ir.warn(e.message);
		else {
			let t = Vr.create("idb-get", { originalErrorMessage: e?.message });
			ir.warn(t.message);
		}
	}
}
async function $r(e, t) {
	try {
		let n = (await Zr()).transaction(Yr, "readwrite");
		await n.objectStore(Yr).put(t, ei(e)), await n.done;
	} catch (e) {
		if (e instanceof on) ir.warn(e.message);
		else {
			let t = Vr.create("idb-set", { originalErrorMessage: e?.message });
			ir.warn(t.message);
		}
	}
}
function ei(e) {
	return `${e.name}!${e.options.appId}`;
}
var ti = 1024, ni = 720 * 60 * 60 * 1e3, ri = class {
	constructor(e) {
		this.container = e, this._heartbeatsCache = null;
		let t = this.container.getProvider("app").getImmediate();
		this._storage = new oi(t), this._heartbeatsCachePromise = this._storage.read().then((e) => (this._heartbeatsCache = e, e));
	}
	async triggerHeartbeat() {
		try {
			let e = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), t = ii();
			return this._heartbeatsCache?.heartbeats == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, this._heartbeatsCache?.heartbeats == null) || this._heartbeatsCache.lastSentHeartbeatDate === t || this._heartbeatsCache.heartbeats.some((e) => e.date === t) ? void 0 : (this._heartbeatsCache.heartbeats.push({
				date: t,
				agent: e
			}), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((e) => {
				let t = new Date(e.date).valueOf();
				return Date.now() - t <= ni;
			}), this._storage.overwrite(this._heartbeatsCache));
		} catch (e) {
			ir.warn(e);
		}
	}
	async getHeartbeatsHeader() {
		try {
			if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return "";
			let e = ii(), { heartbeatsToSend: t, unsentEntries: n } = ai(this._heartbeatsCache.heartbeats), r = Lt(JSON.stringify({
				version: 2,
				heartbeats: t
			}));
			return this._heartbeatsCache.lastSentHeartbeatDate = e, n.length > 0 ? (this._heartbeatsCache.heartbeats = n, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), r;
		} catch (e) {
			return ir.warn(e), "";
		}
	}
};
function ii() {
	return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function ai(e, t = ti) {
	let n = [], r = e.slice();
	for (let i of e) {
		let e = n.find((e) => e.agent === i.agent);
		if (!e) {
			if (n.push({
				agent: i.agent,
				dates: [i.date]
			}), si(n) > t) {
				n.pop();
				break;
			}
		} else if (e.dates.push(i.date), si(n) > t) {
			e.dates.pop();
			break;
		}
		r = r.slice(1);
	}
	return {
		heartbeatsToSend: n,
		unsentEntries: r
	};
}
var oi = class {
	constructor(e) {
		this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
	}
	async runIndexedDBEnvironmentCheck() {
		return nn() ? rn().then(() => !0).catch(() => !1) : !1;
	}
	async read() {
		if (await this._canUseIndexedDBPromise) {
			let e = await Qr(this.app);
			return e?.heartbeats ? e : { heartbeats: [] };
		} else return { heartbeats: [] };
	}
	async overwrite(e) {
		if (await this._canUseIndexedDBPromise) {
			let t = await this.read();
			return $r(this.app, {
				lastSentHeartbeatDate: e.lastSentHeartbeatDate ?? t.lastSentHeartbeatDate,
				heartbeats: e.heartbeats
			});
		} else return;
	}
	async add(e) {
		if (await this._canUseIndexedDBPromise) {
			let t = await this.read();
			return $r(this.app, {
				lastSentHeartbeatDate: e.lastSentHeartbeatDate ?? t.lastSentHeartbeatDate,
				heartbeats: [...t.heartbeats, ...e.heartbeats]
			});
		} else return;
	}
};
function si(e) {
	return Lt(JSON.stringify({
		version: 2,
		heartbeats: e
	})).length;
}
function ci(e) {
	Rr(new bn("platform-logger", (e) => new er(e), "PRIVATE")), Rr(new bn("heartbeat", (e) => new ri(e), "PRIVATE")), Kr(nr, rr, e), Kr(nr, rr, "esm2017"), Kr("fire-js", "");
}
ci("");
//#endregion
//#region ../node_modules/@firebase/webchannel-wrapper/dist/bloom-blob/esm/bloom_blob_es2018.js
var li = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ui = {}, di, fi;
(function() {
	var e;
	function t(e, t) {
		function n() {}
		n.prototype = t.prototype, e.D = t.prototype, e.prototype = new n(), e.prototype.constructor = e, e.C = function(e, n, r) {
			for (var i = Array(arguments.length - 2), a = 2; a < arguments.length; a++) i[a - 2] = arguments[a];
			return t.prototype[n].apply(e, i);
		};
	}
	function n() {
		this.blockSize = -1;
	}
	function r() {
		this.blockSize = -1, this.blockSize = 64, this.g = [
			,
			,
			,
			,
		], this.B = Array(this.blockSize), this.o = this.h = 0, this.s();
	}
	t(r, n), r.prototype.s = function() {
		this.g[0] = 1732584193, this.g[1] = 4023233417, this.g[2] = 2562383102, this.g[3] = 271733878, this.o = this.h = 0;
	};
	function i(e, t, n) {
		n ||= 0;
		var r = Array(16);
		if (typeof t == "string") for (var i = 0; 16 > i; ++i) r[i] = t.charCodeAt(n++) | t.charCodeAt(n++) << 8 | t.charCodeAt(n++) << 16 | t.charCodeAt(n++) << 24;
		else for (i = 0; 16 > i; ++i) r[i] = t[n++] | t[n++] << 8 | t[n++] << 16 | t[n++] << 24;
		t = e.g[0], n = e.g[1], i = e.g[2];
		var a = e.g[3], o = t + (a ^ n & (i ^ a)) + r[0] + 3614090360 & 4294967295;
		t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[1] + 3905402710 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[2] + 606105819 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[3] + 3250441966 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (a ^ n & (i ^ a)) + r[4] + 4118548399 & 4294967295, t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[5] + 1200080426 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[6] + 2821735955 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[7] + 4249261313 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (a ^ n & (i ^ a)) + r[8] + 1770035416 & 4294967295, t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[9] + 2336552879 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[10] + 4294925233 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[11] + 2304563134 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (a ^ n & (i ^ a)) + r[12] + 1804603682 & 4294967295, t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[13] + 4254626195 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[14] + 2792965006 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[15] + 1236535329 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (i ^ a & (n ^ i)) + r[1] + 4129170786 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[6] + 3225465664 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[11] + 643717713 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[0] + 3921069994 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (i ^ a & (n ^ i)) + r[5] + 3593408605 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[10] + 38016083 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[15] + 3634488961 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[4] + 3889429448 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (i ^ a & (n ^ i)) + r[9] + 568446438 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[14] + 3275163606 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[3] + 4107603335 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[8] + 1163531501 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (i ^ a & (n ^ i)) + r[13] + 2850285829 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[2] + 4243563512 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[7] + 1735328473 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[12] + 2368359562 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (n ^ i ^ a) + r[5] + 4294588738 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[8] + 2272392833 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[11] + 1839030562 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[14] + 4259657740 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (n ^ i ^ a) + r[1] + 2763975236 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[4] + 1272893353 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[7] + 4139469664 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[10] + 3200236656 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (n ^ i ^ a) + r[13] + 681279174 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[0] + 3936430074 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[3] + 3572445317 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[6] + 76029189 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (n ^ i ^ a) + r[9] + 3654602809 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[12] + 3873151461 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[15] + 530742520 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[2] + 3299628645 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (i ^ (n | ~a)) + r[0] + 4096336452 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[7] + 1126891415 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[14] + 2878612391 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[5] + 4237533241 & 4294967295, n = i + (o << 21 & 4294967295 | o >>> 11), o = t + (i ^ (n | ~a)) + r[12] + 1700485571 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[3] + 2399980690 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[10] + 4293915773 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[1] + 2240044497 & 4294967295, n = i + (o << 21 & 4294967295 | o >>> 11), o = t + (i ^ (n | ~a)) + r[8] + 1873313359 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[15] + 4264355552 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[6] + 2734768916 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[13] + 1309151649 & 4294967295, n = i + (o << 21 & 4294967295 | o >>> 11), o = t + (i ^ (n | ~a)) + r[4] + 4149444226 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[11] + 3174756917 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[2] + 718787259 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[9] + 3951481745 & 4294967295, e.g[0] = e.g[0] + t & 4294967295, e.g[1] = e.g[1] + (i + (o << 21 & 4294967295 | o >>> 11)) & 4294967295, e.g[2] = e.g[2] + i & 4294967295, e.g[3] = e.g[3] + a & 4294967295;
	}
	r.prototype.u = function(e, t) {
		t === void 0 && (t = e.length);
		for (var n = t - this.blockSize, r = this.B, a = this.h, o = 0; o < t;) {
			if (a == 0) for (; o <= n;) i(this, e, o), o += this.blockSize;
			if (typeof e == "string") {
				for (; o < t;) if (r[a++] = e.charCodeAt(o++), a == this.blockSize) {
					i(this, r), a = 0;
					break;
				}
			} else for (; o < t;) if (r[a++] = e[o++], a == this.blockSize) {
				i(this, r), a = 0;
				break;
			}
		}
		this.h = a, this.o += t;
	}, r.prototype.v = function() {
		var e = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
		e[0] = 128;
		for (var t = 1; t < e.length - 8; ++t) e[t] = 0;
		var n = 8 * this.o;
		for (t = e.length - 8; t < e.length; ++t) e[t] = n & 255, n /= 256;
		for (this.u(e), e = Array(16), t = n = 0; 4 > t; ++t) for (var r = 0; 32 > r; r += 8) e[n++] = this.g[t] >>> r & 255;
		return e;
	};
	function a(e, t) {
		var n = s;
		return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : n[e] = t(e);
	}
	function o(e, t) {
		this.h = t;
		for (var n = [], r = !0, i = e.length - 1; 0 <= i; i--) {
			var a = e[i] | 0;
			r && a == t || (n[i] = a, r = !1);
		}
		this.g = n;
	}
	var s = {};
	function c(e) {
		return -128 <= e && 128 > e ? a(e, function(e) {
			return new o([e | 0], 0 > e ? -1 : 0);
		}) : new o([e | 0], 0 > e ? -1 : 0);
	}
	function l(e) {
		if (isNaN(e) || !isFinite(e)) return d;
		if (0 > e) return g(l(-e));
		for (var t = [], n = 1, r = 0; e >= n; r++) t[r] = e / n | 0, n *= 4294967296;
		return new o(t, 0);
	}
	function u(e, t) {
		if (e.length == 0) throw Error("number format error: empty string");
		if (t ||= 10, 2 > t || 36 < t) throw Error("radix out of range: " + t);
		if (e.charAt(0) == "-") return g(u(e.substring(1), t));
		if (0 <= e.indexOf("-")) throw Error("number format error: interior \"-\" character");
		for (var n = l(t ** 8), r = d, i = 0; i < e.length; i += 8) {
			var a = Math.min(8, e.length - i), o = parseInt(e.substring(i, i + a), t);
			8 > a ? (a = l(t ** +a), r = r.j(a).add(l(o))) : (r = r.j(n), r = r.add(l(o)));
		}
		return r;
	}
	var d = c(0), f = c(1), p = c(16777216);
	e = o.prototype, e.m = function() {
		if (h(this)) return -g(this).m();
		for (var e = 0, t = 1, n = 0; n < this.g.length; n++) {
			var r = this.i(n);
			e += (0 <= r ? r : 4294967296 + r) * t, t *= 4294967296;
		}
		return e;
	}, e.toString = function(e) {
		if (e ||= 10, 2 > e || 36 < e) throw Error("radix out of range: " + e);
		if (m(this)) return "0";
		if (h(this)) return "-" + g(this).toString(e);
		for (var t = l(e ** 6), n = this, r = "";;) {
			var i = ne(n, t).g;
			n = ee(n, i.j(t));
			var a = ((0 < n.g.length ? n.g[0] : n.h) >>> 0).toString(e);
			if (n = i, m(n)) return a + r;
			for (; 6 > a.length;) a = "0" + a;
			r = a + r;
		}
	}, e.i = function(e) {
		return 0 > e ? 0 : e < this.g.length ? this.g[e] : this.h;
	};
	function m(e) {
		if (e.h != 0) return !1;
		for (var t = 0; t < e.g.length; t++) if (e.g[t] != 0) return !1;
		return !0;
	}
	function h(e) {
		return e.h == -1;
	}
	e.l = function(e) {
		return e = ee(this, e), h(e) ? -1 : +!m(e);
	};
	function g(e) {
		for (var t = e.g.length, n = [], r = 0; r < t; r++) n[r] = ~e.g[r];
		return new o(n, ~e.h).add(f);
	}
	e.abs = function() {
		return h(this) ? g(this) : this;
	}, e.add = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0, i = 0; i <= t; i++) {
			var a = r + (this.i(i) & 65535) + (e.i(i) & 65535), s = (a >>> 16) + (this.i(i) >>> 16) + (e.i(i) >>> 16);
			r = s >>> 16, a &= 65535, s &= 65535, n[i] = s << 16 | a;
		}
		return new o(n, n[n.length - 1] & -2147483648 ? -1 : 0);
	};
	function ee(e, t) {
		return e.add(g(t));
	}
	e.j = function(e) {
		if (m(this) || m(e)) return d;
		if (h(this)) return h(e) ? g(this).j(g(e)) : g(g(this).j(e));
		if (h(e)) return g(this.j(g(e)));
		if (0 > this.l(p) && 0 > e.l(p)) return l(this.m() * e.m());
		for (var t = this.g.length + e.g.length, n = [], r = 0; r < 2 * t; r++) n[r] = 0;
		for (r = 0; r < this.g.length; r++) for (var i = 0; i < e.g.length; i++) {
			var a = this.i(r) >>> 16, s = this.i(r) & 65535, c = e.i(i) >>> 16, u = e.i(i) & 65535;
			n[2 * r + 2 * i] += s * u, te(n, 2 * r + 2 * i), n[2 * r + 2 * i + 1] += a * u, te(n, 2 * r + 2 * i + 1), n[2 * r + 2 * i + 1] += s * c, te(n, 2 * r + 2 * i + 1), n[2 * r + 2 * i + 2] += a * c, te(n, 2 * r + 2 * i + 2);
		}
		for (r = 0; r < t; r++) n[r] = n[2 * r + 1] << 16 | n[2 * r];
		for (r = t; r < 2 * t; r++) n[r] = 0;
		return new o(n, 0);
	};
	function te(e, t) {
		for (; (e[t] & 65535) != e[t];) e[t + 1] += e[t] >>> 16, e[t] &= 65535, t++;
	}
	function _(e, t) {
		this.g = e, this.h = t;
	}
	function ne(e, t) {
		if (m(t)) throw Error("division by zero");
		if (m(e)) return new _(d, d);
		if (h(e)) return t = ne(g(e), t), new _(g(t.g), g(t.h));
		if (h(t)) return t = ne(e, g(t)), new _(g(t.g), t.h);
		if (30 < e.g.length) {
			if (h(e) || h(t)) throw Error("slowDivide_ only works with positive integers.");
			for (var n = f, r = t; 0 >= r.l(e);) n = re(n), r = re(r);
			var i = v(n, 1), a = v(r, 1);
			for (r = v(r, 2), n = v(n, 2); !m(r);) {
				var o = a.add(r);
				0 >= o.l(e) && (i = i.add(n), a = o), r = v(r, 1), n = v(n, 1);
			}
			return t = ee(e, i.j(t)), new _(i, t);
		}
		for (i = d; 0 <= e.l(t);) {
			for (n = Math.max(1, Math.floor(e.m() / t.m())), r = Math.ceil(Math.log(n) / Math.LN2), r = 48 >= r ? 1 : 2 ** (r - 48), a = l(n), o = a.j(t); h(o) || 0 < o.l(e);) n -= r, a = l(n), o = a.j(t);
			m(a) && (a = f), i = i.add(a), e = ee(e, o);
		}
		return new _(i, e);
	}
	e.A = function(e) {
		return ne(this, e).h;
	}, e.and = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0; r < t; r++) n[r] = this.i(r) & e.i(r);
		return new o(n, this.h & e.h);
	}, e.or = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0; r < t; r++) n[r] = this.i(r) | e.i(r);
		return new o(n, this.h | e.h);
	}, e.xor = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0; r < t; r++) n[r] = this.i(r) ^ e.i(r);
		return new o(n, this.h ^ e.h);
	};
	function re(e) {
		for (var t = e.g.length + 1, n = [], r = 0; r < t; r++) n[r] = e.i(r) << 1 | e.i(r - 1) >>> 31;
		return new o(n, e.h);
	}
	function v(e, t) {
		var n = t >> 5;
		t %= 32;
		for (var r = e.g.length - n, i = [], a = 0; a < r; a++) i[a] = 0 < t ? e.i(a + n) >>> t | e.i(a + n + 1) << 32 - t : e.i(a + n);
		return new o(i, e.h);
	}
	r.prototype.digest = r.prototype.v, r.prototype.reset = r.prototype.s, r.prototype.update = r.prototype.u, fi = ui.Md5 = r, o.prototype.add = o.prototype.add, o.prototype.multiply = o.prototype.j, o.prototype.modulo = o.prototype.A, o.prototype.compare = o.prototype.l, o.prototype.toNumber = o.prototype.m, o.prototype.toString = o.prototype.toString, o.prototype.getBits = o.prototype.i, o.fromNumber = l, o.fromString = u, di = ui.Integer = o;
}).apply(li === void 0 ? typeof self < "u" ? self : typeof window < "u" ? window : {} : li);
//#endregion
//#region ../node_modules/@firebase/webchannel-wrapper/dist/webchannel-blob/esm/webchannel_blob_es2018.js
var pi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, mi = {}, hi, gi, _i, vi, yi, bi, xi, Si;
(function() {
	var e, t = typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, t, n) {
		return e == Array.prototype || e == Object.prototype || (e[t] = n.value), e;
	};
	function n(e) {
		e = [
			typeof globalThis == "object" && globalThis,
			e,
			typeof window == "object" && window,
			typeof self == "object" && self,
			typeof pi == "object" && pi
		];
		for (var t = 0; t < e.length; ++t) {
			var n = e[t];
			if (n && n.Math == Math) return n;
		}
		throw Error("Cannot find global object");
	}
	var r = n(this);
	function i(e, n) {
		if (n) a: {
			var i = r;
			e = e.split(".");
			for (var a = 0; a < e.length - 1; a++) {
				var o = e[a];
				if (!(o in i)) break a;
				i = i[o];
			}
			e = e[e.length - 1], a = i[e], n = n(a), n != a && n != null && t(i, e, {
				configurable: !0,
				writable: !0,
				value: n
			});
		}
	}
	function a(e, t) {
		e instanceof String && (e += "");
		var n = 0, r = !1, i = { next: function() {
			if (!r && n < e.length) {
				var i = n++;
				return {
					value: t(i, e[i]),
					done: !1
				};
			}
			return r = !0, {
				done: !0,
				value: void 0
			};
		} };
		return i[Symbol.iterator] = function() {
			return i;
		}, i;
	}
	i("Array.prototype.values", function(e) {
		return e || function() {
			return a(this, function(e, t) {
				return t;
			});
		};
	});
	var o = o || {}, s = this || self;
	function c(e) {
		var t = typeof e;
		return t = t == "object" ? e ? Array.isArray(e) ? "array" : t : "null" : t, t == "array" || t == "object" && typeof e.length == "number";
	}
	function l(e) {
		var t = typeof e;
		return t == "object" && e != null || t == "function";
	}
	function u(e, t, n) {
		return e.call.apply(e.bind, arguments);
	}
	function d(e, t, n) {
		if (!e) throw Error();
		if (2 < arguments.length) {
			var r = Array.prototype.slice.call(arguments, 2);
			return function() {
				var n = Array.prototype.slice.call(arguments);
				return Array.prototype.unshift.apply(n, r), e.apply(t, n);
			};
		}
		return function() {
			return e.apply(t, arguments);
		};
	}
	function f(e, t, n) {
		return f = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? u : d, f.apply(null, arguments);
	}
	function p(e, t) {
		var n = Array.prototype.slice.call(arguments, 1);
		return function() {
			var t = n.slice();
			return t.push.apply(t, arguments), e.apply(this, t);
		};
	}
	function m(e, t) {
		function n() {}
		n.prototype = t.prototype, e.aa = t.prototype, e.prototype = new n(), e.prototype.constructor = e, e.Qb = function(e, n, r) {
			for (var i = Array(arguments.length - 2), a = 2; a < arguments.length; a++) i[a - 2] = arguments[a];
			return t.prototype[n].apply(e, i);
		};
	}
	function h(e) {
		let t = e.length;
		if (0 < t) {
			let n = Array(t);
			for (let r = 0; r < t; r++) n[r] = e[r];
			return n;
		}
		return [];
	}
	function g(e, t) {
		for (let t = 1; t < arguments.length; t++) {
			let n = arguments[t];
			if (c(n)) {
				let t = e.length || 0, r = n.length || 0;
				e.length = t + r;
				for (let i = 0; i < r; i++) e[t + i] = n[i];
			} else e.push(n);
		}
	}
	class ee {
		constructor(e, t) {
			this.i = e, this.j = t, this.h = 0, this.g = null;
		}
		get() {
			let e;
			return 0 < this.h ? (this.h--, e = this.g, this.g = e.next, e.next = null) : e = this.i(), e;
		}
	}
	function te(e) {
		return /^[\s\xa0]*$/.test(e);
	}
	function _() {
		var e = s.navigator;
		return (e &&= e.userAgent) ? e : "";
	}
	function ne(e) {
		return ne[" "](e), e;
	}
	ne[" "] = function() {};
	var re = _().indexOf("Gecko") != -1 && !(_().toLowerCase().indexOf("webkit") != -1 && _().indexOf("Edge") == -1) && !(_().indexOf("Trident") != -1 || _().indexOf("MSIE") != -1) && _().indexOf("Edge") == -1;
	function v(e, t, n) {
		for (let r in e) t.call(n, e[r], r, e);
	}
	function ie(e, t) {
		for (let n in e) t.call(void 0, e[n], n, e);
	}
	function ae(e) {
		let t = {};
		for (let n in e) t[n] = e[n];
		return t;
	}
	let oe = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function se(e, t) {
		let n, r;
		for (let t = 1; t < arguments.length; t++) {
			for (n in r = arguments[t], r) e[n] = r[n];
			for (let t = 0; t < oe.length; t++) n = oe[t], Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
		}
	}
	function ce(e) {
		var t = 1;
		e = e.split(":");
		let n = [];
		for (; 0 < t && e.length;) n.push(e.shift()), t--;
		return e.length && n.push(e.join(":")), n;
	}
	function le(e) {
		s.setTimeout(() => {
			throw e;
		}, 0);
	}
	function ue() {
		var e = ge;
		let t = null;
		return e.g && (t = e.g, e.g = e.g.next, e.g || (e.h = null), t.next = null), t;
	}
	class de {
		constructor() {
			this.h = this.g = null;
		}
		add(e, t) {
			let n = fe.get();
			n.set(e, t), this.h ? this.h.next = n : this.g = n, this.h = n;
		}
	}
	var fe = new ee(() => new pe(), (e) => e.reset());
	class pe {
		constructor() {
			this.next = this.g = this.h = null;
		}
		set(e, t) {
			this.h = e, this.g = t, this.next = null;
		}
		reset() {
			this.next = this.g = this.h = null;
		}
	}
	let me, he = !1, ge = new de(), _e = () => {
		let e = s.Promise.resolve(void 0);
		me = () => {
			e.then(ve);
		};
	};
	var ve = () => {
		for (var e; e = ue();) {
			try {
				e.h.call(e.g);
			} catch (e) {
				le(e);
			}
			var t = fe;
			t.j(e), 100 > t.h && (t.h++, e.next = t.g, t.g = e);
		}
		he = !1;
	};
	function ye() {
		this.s = this.s, this.C = this.C;
	}
	ye.prototype.s = !1, ye.prototype.ma = function() {
		this.s || (this.s = !0, this.N());
	}, ye.prototype.N = function() {
		if (this.C) for (; this.C.length;) this.C.shift()();
	};
	function y(e, t) {
		this.type = e, this.g = this.target = t, this.defaultPrevented = !1;
	}
	y.prototype.h = function() {
		this.defaultPrevented = !0;
	};
	var be = function() {
		if (!s.addEventListener || !Object.defineProperty) return !1;
		var e = !1, t = Object.defineProperty({}, "passive", { get: function() {
			e = !0;
		} });
		try {
			let e = () => {};
			s.addEventListener("test", e, t), s.removeEventListener("test", e, t);
		} catch {}
		return e;
	}();
	function xe(e, t) {
		if (y.call(this, e ? e.type : ""), this.relatedTarget = this.g = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.state = null, this.pointerId = 0, this.pointerType = "", this.i = null, e) {
			var n = this.type = e.type, r = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null;
			if (this.target = e.target || e.srcElement, this.g = t, t = e.relatedTarget) {
				if (re) {
					a: {
						try {
							ne(t.nodeName);
							var i = !0;
							break a;
						} catch {}
						i = !1;
					}
					i || (t = null);
				}
			} else n == "mouseover" ? t = e.fromElement : n == "mouseout" && (t = e.toElement);
			this.relatedTarget = t, r ? (this.clientX = r.clientX === void 0 ? r.pageX : r.clientX, this.clientY = r.clientY === void 0 ? r.pageY : r.clientY, this.screenX = r.screenX || 0, this.screenY = r.screenY || 0) : (this.clientX = e.clientX === void 0 ? e.pageX : e.clientX, this.clientY = e.clientY === void 0 ? e.pageY : e.clientY, this.screenX = e.screenX || 0, this.screenY = e.screenY || 0), this.button = e.button, this.key = e.key || "", this.ctrlKey = e.ctrlKey, this.altKey = e.altKey, this.shiftKey = e.shiftKey, this.metaKey = e.metaKey, this.pointerId = e.pointerId || 0, this.pointerType = typeof e.pointerType == "string" ? e.pointerType : Se[e.pointerType] || "", this.state = e.state, this.i = e, e.defaultPrevented && xe.aa.h.call(this);
		}
	}
	m(xe, y);
	var Se = {
		2: "touch",
		3: "pen",
		4: "mouse"
	};
	xe.prototype.h = function() {
		xe.aa.h.call(this);
		var e = this.i;
		e.preventDefault ? e.preventDefault() : e.returnValue = !1;
	};
	var Ce = "closure_listenable_" + (1e6 * Math.random() | 0), we = 0;
	function Te(e, t, n, r, i) {
		this.listener = e, this.proxy = null, this.src = t, this.type = n, this.capture = !!r, this.ha = i, this.key = ++we, this.da = this.fa = !1;
	}
	function Ee(e) {
		e.da = !0, e.listener = null, e.proxy = null, e.src = null, e.ha = null;
	}
	function De(e) {
		this.src = e, this.g = {}, this.h = 0;
	}
	De.prototype.add = function(e, t, n, r, i) {
		var a = e.toString();
		e = this.g[a], e || (e = this.g[a] = [], this.h++);
		var o = ke(e, t, r, i);
		return -1 < o ? (t = e[o], n || (t.fa = !1)) : (t = new Te(t, this.src, a, !!r, i), t.fa = n, e.push(t)), t;
	};
	function Oe(e, t) {
		var n = t.type;
		if (n in e.g) {
			var r = e.g[n], i = Array.prototype.indexOf.call(r, t, void 0), a;
			(a = 0 <= i) && Array.prototype.splice.call(r, i, 1), a && (Ee(t), e.g[n].length == 0 && (delete e.g[n], e.h--));
		}
	}
	function ke(e, t, n, r) {
		for (var i = 0; i < e.length; ++i) {
			var a = e[i];
			if (!a.da && a.listener == t && a.capture == !!n && a.ha == r) return i;
		}
		return -1;
	}
	var Ae = "closure_lm_" + (1e6 * Math.random() | 0), je = {};
	function Me(e, t, n, r, i) {
		if (r && r.once) return Pe(e, t, n, r, i);
		if (Array.isArray(t)) {
			for (var a = 0; a < t.length; a++) Me(e, t[a], n, r, i);
			return null;
		}
		return n = Ve(n), e && e[Ce] ? e.K(t, n, l(r) ? !!r.capture : !!r, i) : b(e, t, n, !1, r, i);
	}
	function b(e, t, n, r, i, a) {
		if (!t) throw Error("Invalid event type");
		var o = l(i) ? !!i.capture : !!i, s = ze(e);
		if (s || (e[Ae] = s = new De(e)), n = s.add(t, n, r, o, a), n.proxy) return n;
		if (r = Ne(), n.proxy = r, r.src = e, r.listener = n, e.addEventListener) be || (i = o), i === void 0 && (i = !1), e.addEventListener(t.toString(), r, i);
		else if (e.attachEvent) e.attachEvent(Le(t.toString()), r);
		else if (e.addListener && e.removeListener) e.addListener(r);
		else throw Error("addEventListener and attachEvent are unavailable.");
		return n;
	}
	function Ne() {
		function e(n) {
			return t.call(e.src, e.listener, n);
		}
		let t = Re;
		return e;
	}
	function Pe(e, t, n, r, i) {
		if (Array.isArray(t)) {
			for (var a = 0; a < t.length; a++) Pe(e, t[a], n, r, i);
			return null;
		}
		return n = Ve(n), e && e[Ce] ? e.L(t, n, l(r) ? !!r.capture : !!r, i) : b(e, t, n, !0, r, i);
	}
	function Fe(e, t, n, r, i) {
		if (Array.isArray(t)) for (var a = 0; a < t.length; a++) Fe(e, t[a], n, r, i);
		else r = l(r) ? !!r.capture : !!r, n = Ve(n), e && e[Ce] ? (e = e.i, t = String(t).toString(), t in e.g && (a = e.g[t], n = ke(a, n, r, i), -1 < n && (Ee(a[n]), Array.prototype.splice.call(a, n, 1), a.length == 0 && (delete e.g[t], e.h--)))) : (e &&= ze(e)) && (t = e.g[t.toString()], e = -1, t && (e = ke(t, n, r, i)), (n = -1 < e ? t[e] : null) && Ie(n));
	}
	function Ie(e) {
		if (typeof e != "number" && e && !e.da) {
			var t = e.src;
			if (t && t[Ce]) Oe(t.i, e);
			else {
				var n = e.type, r = e.proxy;
				t.removeEventListener ? t.removeEventListener(n, r, e.capture) : t.detachEvent ? t.detachEvent(Le(n), r) : t.addListener && t.removeListener && t.removeListener(r), (n = ze(t)) ? (Oe(n, e), n.h == 0 && (n.src = null, t[Ae] = null)) : Ee(e);
			}
		}
	}
	function Le(e) {
		return e in je ? je[e] : je[e] = "on" + e;
	}
	function Re(e, t) {
		if (e.da) e = !0;
		else {
			t = new xe(t, this);
			var n = e.listener, r = e.ha || e.src;
			e.fa && Ie(e), e = n.call(r, t);
		}
		return e;
	}
	function ze(e) {
		return e = e[Ae], e instanceof De ? e : null;
	}
	var Be = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
	function Ve(e) {
		return typeof e == "function" ? e : (e[Be] || (e[Be] = function(t) {
			return e.handleEvent(t);
		}), e[Be]);
	}
	function x() {
		ye.call(this), this.i = new De(this), this.M = this, this.F = null;
	}
	m(x, ye), x.prototype[Ce] = !0, x.prototype.removeEventListener = function(e, t, n, r) {
		Fe(this, e, t, n, r);
	};
	function S(e, t) {
		var n, r = e.F;
		if (r) for (n = []; r; r = r.F) n.push(r);
		if (e = e.M, r = t.type || t, typeof t == "string") t = new y(t, e);
		else if (t instanceof y) t.target = t.target || e;
		else {
			var i = t;
			t = new y(r, e), se(t, i);
		}
		if (i = !0, n) for (var a = n.length - 1; 0 <= a; a--) {
			var o = t.g = n[a];
			i = He(o, r, !0, t) && i;
		}
		if (o = t.g = e, i = He(o, r, !0, t) && i, i = He(o, r, !1, t) && i, n) for (a = 0; a < n.length; a++) o = t.g = n[a], i = He(o, r, !1, t) && i;
	}
	x.prototype.N = function() {
		if (x.aa.N.call(this), this.i) {
			var e = this.i, t;
			for (t in e.g) {
				for (var n = e.g[t], r = 0; r < n.length; r++) Ee(n[r]);
				delete e.g[t], e.h--;
			}
		}
		this.F = null;
	}, x.prototype.K = function(e, t, n, r) {
		return this.i.add(String(e), t, !1, n, r);
	}, x.prototype.L = function(e, t, n, r) {
		return this.i.add(String(e), t, !0, n, r);
	};
	function He(e, t, n, r) {
		if (t = e.i.g[String(t)], !t) return !0;
		t = t.concat();
		for (var i = !0, a = 0; a < t.length; ++a) {
			var o = t[a];
			if (o && !o.da && o.capture == n) {
				var s = o.listener, c = o.ha || o.src;
				o.fa && Oe(e.i, o), i = !1 !== s.call(c, r) && i;
			}
		}
		return i && !r.defaultPrevented;
	}
	function Ue(e, t, n) {
		if (typeof e == "function") n && (e = f(e, n));
		else if (e && typeof e.handleEvent == "function") e = f(e.handleEvent, e);
		else throw Error("Invalid listener argument");
		return 2147483647 < Number(t) ? -1 : s.setTimeout(e, t || 0);
	}
	function We(e) {
		e.g = Ue(() => {
			e.g = null, e.i && (e.i = !1, We(e));
		}, e.l);
		let t = e.h;
		e.h = null, e.m.apply(null, t);
	}
	class Ge extends ye {
		constructor(e, t) {
			super(), this.m = e, this.l = t, this.h = null, this.i = !1, this.g = null;
		}
		j(e) {
			this.h = arguments, this.g ? this.i = !0 : We(this);
		}
		N() {
			super.N(), this.g && (s.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
		}
	}
	function Ke(e) {
		ye.call(this), this.h = e, this.g = {};
	}
	m(Ke, ye);
	var qe = [];
	function Je(e) {
		v(e.g, function(e, t) {
			this.g.hasOwnProperty(t) && Ie(e);
		}, e), e.g = {};
	}
	Ke.prototype.N = function() {
		Ke.aa.N.call(this), Je(this);
	}, Ke.prototype.handleEvent = function() {
		throw Error("EventHandler.handleEvent not implemented");
	};
	var Ye = s.JSON.stringify, Xe = s.JSON.parse, Ze = class {
		stringify(e) {
			return s.JSON.stringify(e, void 0);
		}
		parse(e) {
			return s.JSON.parse(e, void 0);
		}
	};
	function Qe() {}
	Qe.prototype.h = null;
	function $e(e) {
		return e.h ||= e.i();
	}
	function et() {}
	var tt = {
		OPEN: "a",
		kb: "b",
		Ja: "c",
		wb: "d"
	};
	function nt() {
		y.call(this, "d");
	}
	m(nt, y);
	function rt() {
		y.call(this, "c");
	}
	m(rt, y);
	var it = {}, at = null;
	function ot() {
		return at ||= new x();
	}
	it.La = "serverreachability";
	function st(e) {
		y.call(this, it.La, e);
	}
	m(st, y);
	function ct(e) {
		let t = ot();
		S(t, new st(t));
	}
	it.STAT_EVENT = "statevent";
	function lt(e, t) {
		y.call(this, it.STAT_EVENT, e), this.stat = t;
	}
	m(lt, y);
	function ut(e) {
		let t = ot();
		S(t, new lt(t, e));
	}
	it.Ma = "timingevent";
	function dt(e, t) {
		y.call(this, it.Ma, e), this.size = t;
	}
	m(dt, y);
	function ft(e, t) {
		if (typeof e != "function") throw Error("Fn must not be null and must be a function");
		return s.setTimeout(function() {
			e();
		}, t);
	}
	function pt() {
		this.g = !0;
	}
	pt.prototype.xa = function() {
		this.g = !1;
	};
	function mt(e, t, n, r, i, a) {
		e.info(function() {
			if (e.g) if (a) for (var o = "", s = a.split("&"), c = 0; c < s.length; c++) {
				var l = s[c].split("=");
				if (1 < l.length) {
					var u = l[0];
					l = l[1];
					var d = u.split("_");
					o = 2 <= d.length && d[1] == "type" ? o + (u + "=" + l + "&") : o + (u + "=redacted&");
				}
			}
			else o = null;
			else o = a;
			return "XMLHTTP REQ (" + r + ") [attempt " + i + "]: " + t + "\n" + n + "\n" + o;
		});
	}
	function ht(e, t, n, r, i, a, o) {
		e.info(function() {
			return "XMLHTTP RESP (" + r + ") [ attempt " + i + "]: " + t + "\n" + n + "\n" + a + " " + o;
		});
	}
	function gt(e, t, n, r) {
		e.info(function() {
			return "XMLHTTP TEXT (" + t + "): " + vt(e, n) + (r ? " " + r : "");
		});
	}
	function _t(e, t) {
		e.info(function() {
			return "TIMEOUT: " + t;
		});
	}
	pt.prototype.info = function() {};
	function vt(e, t) {
		if (!e.g) return t;
		if (!t) return null;
		try {
			var n = JSON.parse(t);
			if (n) {
				for (e = 0; e < n.length; e++) if (Array.isArray(n[e])) {
					var r = n[e];
					if (!(2 > r.length)) {
						var i = r[1];
						if (Array.isArray(i) && !(1 > i.length)) {
							var a = i[0];
							if (a != "noop" && a != "stop" && a != "close") for (var o = 1; o < i.length; o++) i[o] = "";
						}
					}
				}
			}
			return Ye(n);
		} catch {
			return t;
		}
	}
	var yt = {
		NO_ERROR: 0,
		gb: 1,
		tb: 2,
		sb: 3,
		nb: 4,
		rb: 5,
		ub: 6,
		Ia: 7,
		TIMEOUT: 8,
		xb: 9
	}, bt = {
		lb: "complete",
		Hb: "success",
		Ja: "error",
		Ia: "abort",
		zb: "ready",
		Ab: "readystatechange",
		TIMEOUT: "timeout",
		vb: "incrementaldata",
		yb: "progress",
		ob: "downloadprogress",
		Pb: "uploadprogress"
	}, xt;
	function St() {}
	m(St, Qe), St.prototype.g = function() {
		return new XMLHttpRequest();
	}, St.prototype.i = function() {
		return {};
	}, xt = new St();
	function Ct(e, t, n, r) {
		this.j = e, this.i = t, this.l = n, this.R = r || 1, this.U = new Ke(this), this.I = 45e3, this.H = null, this.o = !1, this.m = this.A = this.v = this.L = this.F = this.S = this.B = null, this.D = [], this.g = null, this.C = 0, this.s = this.u = null, this.X = -1, this.J = !1, this.O = 0, this.M = null, this.W = this.K = this.T = this.P = !1, this.h = new wt();
	}
	function wt() {
		this.i = null, this.g = "", this.h = !1;
	}
	var Tt = {}, Et = {};
	function Dt(e, t, n) {
		e.L = 1, e.v = en(Xt(t)), e.m = n, e.P = !0, Ot(e, null);
	}
	function Ot(e, t) {
		e.F = Date.now(), jt(e), e.A = Xt(e.v);
		var n = e.A, r = e.R;
		Array.isArray(r) || (r = [String(r)]), mn(n.i, "t", r), e.C = 0, n = e.j.J, e.h = new wt(), e.g = rr(e.j, n ? t : null, !e.m), 0 < e.O && (e.M = new Ge(f(e.Y, e, e.g), e.O)), t = e.U, n = e.g, r = e.ca;
		var i = "readystatechange";
		Array.isArray(i) || (i && (qe[0] = i.toString()), i = qe);
		for (var a = 0; a < i.length; a++) {
			var o = Me(n, i[a], r || t.handleEvent, !1, t.h || t);
			if (!o) break;
			t.g[o.key] = o;
		}
		t = e.H ? ae(e.H) : {}, e.m ? (e.u ||= "POST", t["Content-Type"] = "application/x-www-form-urlencoded", e.g.ea(e.A, e.u, e.m, t)) : (e.u = "GET", e.g.ea(e.A, e.u, null, t)), ct(), mt(e.i, e.u, e.A, e.l, e.R, e.m);
	}
	Ct.prototype.ca = function(e) {
		e = e.target;
		let t = this.M;
		t && Pn(e) == 3 ? t.j() : this.Y(e);
	}, Ct.prototype.Y = function(e) {
		try {
			if (e == this.g) a: {
				let f = Pn(this.g);
				var t = this.g.Ba();
				let p = this.g.Z();
				if (!(3 > f) && (f != 3 || this.g && (this.h.h || this.g.oa() || Fn(this.g)))) {
					this.J || f != 4 || t == 7 || ct(t == 8 || 0 >= p ? 3 : 2), Nt(this);
					var n = this.g.Z();
					this.X = n;
					b: if (kt(this)) {
						var r = Fn(this.g);
						e = "";
						var i = r.length, a = Pn(this.g) == 4;
						if (!this.h.i) {
							if (typeof TextDecoder > "u") {
								Ft(this), Pt(this);
								var o = "";
								break b;
							}
							this.h.i = new s.TextDecoder();
						}
						for (t = 0; t < i; t++) this.h.h = !0, e += this.h.i.decode(r[t], { stream: !(a && t == i - 1) });
						r.length = 0, this.h.g += e, this.C = 0, o = this.h.g;
					} else o = this.g.oa();
					if (this.o = n == 200, ht(this.i, this.u, this.A, this.l, this.R, f, n), this.o) {
						if (this.T && !this.K) {
							b: {
								if (this.g) {
									var c, l = this.g;
									if ((c = l.g ? l.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !te(c)) {
										var u = c;
										break b;
									}
								}
								u = null;
							}
							if (n = u) gt(this.i, this.l, n, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, It(this, n);
							else {
								this.o = !1, this.s = 3, ut(12), Ft(this), Pt(this);
								break a;
							}
						}
						if (this.P) {
							n = !0;
							let e;
							for (; !this.J && this.C < o.length;) if (e = At(this, o), e == Et) {
								f == 4 && (this.s = 4, ut(14), n = !1), gt(this.i, this.l, null, "[Incomplete Response]");
								break;
							} else if (e == Tt) {
								this.s = 4, ut(15), gt(this.i, this.l, o, "[Invalid Chunk]"), n = !1;
								break;
							} else gt(this.i, this.l, e, null), It(this, e);
							if (kt(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0), f != 4 || o.length != 0 || this.h.h || (this.s = 1, ut(16), n = !1), this.o = this.o && n, !n) gt(this.i, this.l, o, "[Invalid Chunked Response]"), Ft(this), Pt(this);
							else if (0 < o.length && !this.W) {
								this.W = !0;
								var d = this.j;
								d.g == this && d.ba && !d.M && (d.j.info("Great, no buffering proxy detected. Bytes received: " + o.length), Yn(d), d.M = !0, ut(11));
							}
						} else gt(this.i, this.l, o, null), It(this, o);
						f == 4 && Ft(this), this.o && !this.J && (f == 4 ? Qn(this.j, this) : (this.o = !1, jt(this)));
					} else In(this.g), n == 400 && 0 < o.indexOf("Unknown SID") ? (this.s = 3, ut(12)) : (this.s = 0, ut(13)), Ft(this), Pt(this);
				}
			}
		} catch {}
	};
	function kt(e) {
		return e.g ? e.u == "GET" && e.L != 2 && e.j.Ca : !1;
	}
	function At(e, t) {
		var n = e.C, r = t.indexOf("\n", n);
		return r == -1 ? Et : (n = Number(t.substring(n, r)), isNaN(n) ? Tt : (r += 1, r + n > t.length ? Et : (t = t.slice(r, r + n), e.C = r + n, t)));
	}
	Ct.prototype.cancel = function() {
		this.J = !0, Ft(this);
	};
	function jt(e) {
		e.S = Date.now() + e.I, Mt(e, e.I);
	}
	function Mt(e, t) {
		if (e.B != null) throw Error("WatchDog timer not null");
		e.B = ft(f(e.ba, e), t);
	}
	function Nt(e) {
		e.B &&= (s.clearTimeout(e.B), null);
	}
	Ct.prototype.ba = function() {
		this.B = null;
		let e = Date.now();
		0 <= e - this.S ? (_t(this.i, this.A), this.L != 2 && (ct(), ut(17)), Ft(this), this.s = 2, Pt(this)) : Mt(this, this.S - e);
	};
	function Pt(e) {
		e.j.G == 0 || e.J || Qn(e.j, e);
	}
	function Ft(e) {
		Nt(e);
		var t = e.M;
		t && typeof t.ma == "function" && t.ma(), e.M = null, Je(e.U), e.g && (t = e.g, e.g = null, t.abort(), t.ma());
	}
	function It(e, t) {
		try {
			var n = e.j;
			if (n.G != 0 && (n.g == e || Vt(n.h, e))) {
				if (!e.K && Vt(n.h, e) && n.G == 3) {
					try {
						var r = n.Da.g.parse(t);
					} catch {
						r = null;
					}
					if (Array.isArray(r) && r.length == 3) {
						var i = r;
						if (i[0] == 0) {
							a: if (!n.u) {
								if (n.g) if (n.g.F + 3e3 < e.F) Zn(n), Bn(n);
								else break a;
								Jn(n), ut(18);
							}
						} else n.za = i[1], 0 < n.za - n.T && 37500 > i[2] && n.F && n.v == 0 && !n.C && (n.C = ft(f(n.Za, n), 6e3));
						if (1 >= Bt(n.h) && n.ca) {
							try {
								n.ca();
							} catch {}
							n.ca = void 0;
						}
					} else er(n, 11);
				} else if ((e.K || n.g == e) && Zn(n), !te(t)) for (i = n.Da.g.parse(t), t = 0; t < i.length; t++) {
					let l = i[t];
					if (n.T = l[0], l = l[1], n.G == 2) if (l[0] == "c") {
						n.K = l[1], n.ia = l[2];
						let t = l[3];
						t != null && (n.la = t, n.j.info("VER=" + n.la));
						let i = l[4];
						i != null && (n.Aa = i, n.j.info("SVER=" + n.Aa));
						let u = l[5];
						u != null && typeof u == "number" && 0 < u && (r = 1.5 * u, n.L = r, n.j.info("backChannelRequestTimeoutMs_=" + r)), r = n;
						let d = e.g;
						if (d) {
							let e = d.g ? d.g.getResponseHeader("X-Client-Wire-Protocol") : null;
							if (e) {
								var a = r.h;
								a.g || e.indexOf("spdy") == -1 && e.indexOf("quic") == -1 && e.indexOf("h2") == -1 || (a.j = a.l, a.g = /* @__PURE__ */ new Set(), a.h &&= (Ht(a, a.h), null));
							}
							if (r.D) {
								let e = d.g ? d.g.getResponseHeader("X-HTTP-Session-Id") : null;
								e && (r.ya = e, w(r.I, r.D, e));
							}
						}
						n.G = 3, n.l && n.l.ua(), n.ba && (n.R = Date.now() - e.F, n.j.info("Handshake RTT: " + n.R + "ms")), r = n;
						var o = e;
						if (r.qa = nr(r, r.J ? r.ia : null, r.W), o.K) {
							Ut(r.h, o);
							var s = o, c = r.L;
							c && (s.I = c), s.B && (Nt(s), jt(s)), r.g = o;
						} else qn(r);
						0 < n.i.length && Hn(n);
					} else l[0] != "stop" && l[0] != "close" || er(n, 7);
					else n.G == 3 && (l[0] == "stop" || l[0] == "close" ? l[0] == "stop" ? er(n, 7) : zn(n) : l[0] != "noop" && n.l && n.l.ta(l), n.v = 0);
				}
			}
			ct(4);
		} catch {}
	}
	var Lt = class {
		constructor(e, t) {
			this.g = e, this.map = t;
		}
	};
	function Rt(e) {
		this.l = e || 10, s.PerformanceNavigationTiming ? (e = s.performance.getEntriesByType("navigation"), e = 0 < e.length && (e[0].nextHopProtocol == "hq" || e[0].nextHopProtocol == "h2")) : e = !!(s.chrome && s.chrome.loadTimes && s.chrome.loadTimes() && s.chrome.loadTimes().wasFetchedViaSpdy), this.j = e ? this.l : 1, this.g = null, 1 < this.j && (this.g = /* @__PURE__ */ new Set()), this.h = null, this.i = [];
	}
	function zt(e) {
		return e.h ? !0 : e.g ? e.g.size >= e.j : !1;
	}
	function Bt(e) {
		return e.h ? 1 : e.g ? e.g.size : 0;
	}
	function Vt(e, t) {
		return e.h ? e.h == t : e.g ? e.g.has(t) : !1;
	}
	function Ht(e, t) {
		e.g ? e.g.add(t) : e.h = t;
	}
	function Ut(e, t) {
		e.h && e.h == t ? e.h = null : e.g && e.g.has(t) && e.g.delete(t);
	}
	Rt.prototype.cancel = function() {
		if (this.i = Wt(this), this.h) this.h.cancel(), this.h = null;
		else if (this.g && this.g.size !== 0) {
			for (let e of this.g.values()) e.cancel();
			this.g.clear();
		}
	};
	function Wt(e) {
		if (e.h != null) return e.i.concat(e.h.D);
		if (e.g != null && e.g.size !== 0) {
			let t = e.i;
			for (let n of e.g.values()) t = t.concat(n.D);
			return t;
		}
		return h(e.i);
	}
	function Gt(e) {
		if (e.V && typeof e.V == "function") return e.V();
		if (typeof Map < "u" && e instanceof Map || typeof Set < "u" && e instanceof Set) return Array.from(e.values());
		if (typeof e == "string") return e.split("");
		if (c(e)) {
			for (var t = [], n = e.length, r = 0; r < n; r++) t.push(e[r]);
			return t;
		}
		for (r in t = [], n = 0, e) t[n++] = e[r];
		return t;
	}
	function Kt(e) {
		if (e.na && typeof e.na == "function") return e.na();
		if (!e.V || typeof e.V != "function") {
			if (typeof Map < "u" && e instanceof Map) return Array.from(e.keys());
			if (!(typeof Set < "u" && e instanceof Set)) {
				if (c(e) || typeof e == "string") {
					var t = [];
					e = e.length;
					for (var n = 0; n < e; n++) t.push(n);
					return t;
				}
				t = [], n = 0;
				for (let r in e) t[n++] = r;
				return t;
			}
		}
	}
	function qt(e, t) {
		if (e.forEach && typeof e.forEach == "function") e.forEach(t, void 0);
		else if (c(e) || typeof e == "string") Array.prototype.forEach.call(e, t, void 0);
		else for (var n = Kt(e), r = Gt(e), i = r.length, a = 0; a < i; a++) t.call(void 0, r[a], n && n[a], e);
	}
	var Jt = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
	function Yt(e, t) {
		if (e) {
			e = e.split("&");
			for (var n = 0; n < e.length; n++) {
				var r = e[n].indexOf("="), i = null;
				if (0 <= r) {
					var a = e[n].substring(0, r);
					i = e[n].substring(r + 1);
				} else a = e[n];
				t(a, i ? decodeURIComponent(i.replace(/\+/g, " ")) : "");
			}
		}
	}
	function C(e) {
		if (this.g = this.o = this.j = "", this.s = null, this.m = this.l = "", this.h = !1, e instanceof C) {
			this.h = e.h, Zt(this, e.j), this.o = e.o, this.g = e.g, Qt(this, e.s), this.l = e.l;
			var t = e.i, n = new un();
			n.i = t.i, t.g && (n.g = new Map(t.g), n.h = t.h), $t(this, n), this.m = e.m;
		} else e && (t = String(e).match(Jt)) ? (this.h = !1, Zt(this, t[1] || "", !0), this.o = tn(t[2] || ""), this.g = tn(t[3] || "", !0), Qt(this, t[4]), this.l = tn(t[5] || "", !0), $t(this, t[6] || "", !0), this.m = tn(t[7] || "")) : (this.h = !1, this.i = new un(null, this.h));
	}
	C.prototype.toString = function() {
		var e = [], t = this.j;
		t && e.push(nn(t, an, !0), ":");
		var n = this.g;
		return (n || t == "file") && (e.push("//"), (t = this.o) && e.push(nn(t, an, !0), "@"), e.push(encodeURIComponent(String(n)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), n = this.s, n != null && e.push(":", String(n))), (n = this.l) && (this.g && n.charAt(0) != "/" && e.push("/"), e.push(nn(n, n.charAt(0) == "/" ? sn : on, !0))), (n = this.i.toString()) && e.push("?", n), (n = this.m) && e.push("#", nn(n, ln)), e.join("");
	};
	function Xt(e) {
		return new C(e);
	}
	function Zt(e, t, n) {
		e.j = n ? tn(t, !0) : t, e.j &&= e.j.replace(/:$/, "");
	}
	function Qt(e, t) {
		if (t) {
			if (t = Number(t), isNaN(t) || 0 > t) throw Error("Bad port number " + t);
			e.s = t;
		} else e.s = null;
	}
	function $t(e, t, n) {
		t instanceof un ? (e.i = t, gn(e.i, e.h)) : (n || (t = nn(t, cn)), e.i = new un(t, e.h));
	}
	function w(e, t, n) {
		e.i.set(t, n);
	}
	function en(e) {
		return w(e, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)), e;
	}
	function tn(e, t) {
		return e ? t ? decodeURI(e.replace(/%25/g, "%2525")) : decodeURIComponent(e) : "";
	}
	function nn(e, t, n) {
		return typeof e == "string" ? (e = encodeURI(e).replace(t, rn), n && (e = e.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), e) : null;
	}
	function rn(e) {
		return e = e.charCodeAt(0), "%" + (e >> 4 & 15).toString(16) + (e & 15).toString(16);
	}
	var an = /[#\/\?@]/g, on = /[#\?:]/g, sn = /[#\?]/g, cn = /[#\?@]/g, ln = /#/g;
	function un(e, t) {
		this.h = this.g = null, this.i = e || null, this.j = !!t;
	}
	function dn(e) {
		e.g || (e.g = /* @__PURE__ */ new Map(), e.h = 0, e.i && Yt(e.i, function(t, n) {
			e.add(decodeURIComponent(t.replace(/\+/g, " ")), n);
		}));
	}
	e = un.prototype, e.add = function(e, t) {
		dn(this), this.i = null, e = hn(this, e);
		var n = this.g.get(e);
		return n || this.g.set(e, n = []), n.push(t), this.h += 1, this;
	};
	function fn(e, t) {
		dn(e), t = hn(e, t), e.g.has(t) && (e.i = null, e.h -= e.g.get(t).length, e.g.delete(t));
	}
	function pn(e, t) {
		return dn(e), t = hn(e, t), e.g.has(t);
	}
	e.forEach = function(e, t) {
		dn(this), this.g.forEach(function(n, r) {
			n.forEach(function(n) {
				e.call(t, n, r, this);
			}, this);
		}, this);
	}, e.na = function() {
		dn(this);
		let e = Array.from(this.g.values()), t = Array.from(this.g.keys()), n = [];
		for (let r = 0; r < t.length; r++) {
			let i = e[r];
			for (let e = 0; e < i.length; e++) n.push(t[r]);
		}
		return n;
	}, e.V = function(e) {
		dn(this);
		let t = [];
		if (typeof e == "string") pn(this, e) && (t = t.concat(this.g.get(hn(this, e))));
		else {
			e = Array.from(this.g.values());
			for (let n = 0; n < e.length; n++) t = t.concat(e[n]);
		}
		return t;
	}, e.set = function(e, t) {
		return dn(this), this.i = null, e = hn(this, e), pn(this, e) && (this.h -= this.g.get(e).length), this.g.set(e, [t]), this.h += 1, this;
	}, e.get = function(e, t) {
		return e ? (e = this.V(e), 0 < e.length ? String(e[0]) : t) : t;
	};
	function mn(e, t, n) {
		fn(e, t), 0 < n.length && (e.i = null, e.g.set(hn(e, t), h(n)), e.h += n.length);
	}
	e.toString = function() {
		if (this.i) return this.i;
		if (!this.g) return "";
		let e = [], t = Array.from(this.g.keys());
		for (var n = 0; n < t.length; n++) {
			var r = t[n];
			let a = encodeURIComponent(String(r)), o = this.V(r);
			for (r = 0; r < o.length; r++) {
				var i = a;
				o[r] !== "" && (i += "=" + encodeURIComponent(String(o[r]))), e.push(i);
			}
		}
		return this.i = e.join("&");
	};
	function hn(e, t) {
		return t = String(t), e.j && (t = t.toLowerCase()), t;
	}
	function gn(e, t) {
		t && !e.j && (dn(e), e.i = null, e.g.forEach(function(e, t) {
			var n = t.toLowerCase();
			t != n && (fn(this, t), mn(this, n, e));
		}, e)), e.j = t;
	}
	function _n(e, t) {
		let n = new pt();
		if (s.Image) {
			let r = new Image();
			r.onload = p(yn, n, "TestLoadImage: loaded", !0, t, r), r.onerror = p(yn, n, "TestLoadImage: error", !1, t, r), r.onabort = p(yn, n, "TestLoadImage: abort", !1, t, r), r.ontimeout = p(yn, n, "TestLoadImage: timeout", !1, t, r), s.setTimeout(function() {
				r.ontimeout && r.ontimeout();
			}, 1e4), r.src = e;
		} else t(!1);
	}
	function vn(e, t) {
		let n = new pt(), r = new AbortController(), i = setTimeout(() => {
			r.abort(), yn(n, "TestPingServer: timeout", !1, t);
		}, 1e4);
		fetch(e, { signal: r.signal }).then((e) => {
			clearTimeout(i), e.ok ? yn(n, "TestPingServer: ok", !0, t) : yn(n, "TestPingServer: server error", !1, t);
		}).catch(() => {
			clearTimeout(i), yn(n, "TestPingServer: error", !1, t);
		});
	}
	function yn(e, t, n, r, i) {
		try {
			i && (i.onload = null, i.onerror = null, i.onabort = null, i.ontimeout = null), r(n);
		} catch {}
	}
	function T() {
		this.g = new Ze();
	}
	function bn(e, t, n) {
		let r = n || "";
		try {
			qt(e, function(e, n) {
				let i = e;
				l(e) && (i = Ye(e)), t.push(r + n + "=" + encodeURIComponent(i));
			});
		} catch (e) {
			throw t.push(r + "type=_badmap"), e;
		}
	}
	function xn(e) {
		this.l = e.Ub || null, this.j = e.eb || !1;
	}
	m(xn, Qe), xn.prototype.g = function() {
		return new Sn(this.l, this.j);
	}, xn.prototype.i = function(e) {
		return function() {
			return e;
		};
	}({});
	function Sn(e, t) {
		x.call(this), this.D = e, this.o = t, this.m = void 0, this.status = this.readyState = 0, this.responseType = this.responseText = this.response = this.statusText = "", this.onreadystatechange = null, this.u = new Headers(), this.h = null, this.B = "GET", this.A = "", this.g = !1, this.v = this.j = this.l = null;
	}
	m(Sn, x), e = Sn.prototype, e.open = function(e, t) {
		if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
		this.B = e, this.A = t, this.readyState = 1, Tn(this);
	}, e.send = function(e) {
		if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
		this.g = !0;
		let t = {
			headers: this.u,
			method: this.B,
			credentials: this.m,
			cache: void 0
		};
		e && (t.body = e), (this.D || s).fetch(new Request(this.A, t)).then(this.Sa.bind(this), this.ga.bind(this));
	}, e.abort = function() {
		this.response = this.responseText = "", this.u = new Headers(), this.status = 0, this.j && this.j.cancel("Request was aborted.").catch(() => {}), 1 <= this.readyState && this.g && this.readyState != 4 && (this.g = !1, wn(this)), this.readyState = 0;
	}, e.Sa = function(e) {
		if (this.g && (this.l = e, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = e.headers, this.readyState = 2, Tn(this)), this.g && (this.readyState = 3, Tn(this), this.g))) if (this.responseType === "arraybuffer") e.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
		else if (s.ReadableStream !== void 0 && "body" in e) {
			if (this.j = e.body.getReader(), this.o) {
				if (this.responseType) throw Error("responseType must be empty for \"streamBinaryChunks\" mode responses.");
				this.response = [];
			} else this.response = this.responseText = "", this.v = new TextDecoder();
			Cn(this);
		} else e.text().then(this.Ra.bind(this), this.ga.bind(this));
	};
	function Cn(e) {
		e.j.read().then(e.Pa.bind(e)).catch(e.ga.bind(e));
	}
	e.Pa = function(e) {
		if (this.g) {
			if (this.o && e.value) this.response.push(e.value);
			else if (!this.o) {
				var t = e.value ? e.value : new Uint8Array();
				(t = this.v.decode(t, { stream: !e.done })) && (this.response = this.responseText += t);
			}
			e.done ? wn(this) : Tn(this), this.readyState == 3 && Cn(this);
		}
	}, e.Ra = function(e) {
		this.g && (this.response = this.responseText = e, wn(this));
	}, e.Qa = function(e) {
		this.g && (this.response = e, wn(this));
	}, e.ga = function() {
		this.g && wn(this);
	};
	function wn(e) {
		e.readyState = 4, e.l = null, e.j = null, e.v = null, Tn(e);
	}
	e.setRequestHeader = function(e, t) {
		this.u.append(e, t);
	}, e.getResponseHeader = function(e) {
		return this.h && this.h.get(e.toLowerCase()) || "";
	}, e.getAllResponseHeaders = function() {
		if (!this.h) return "";
		let e = [], t = this.h.entries();
		for (var n = t.next(); !n.done;) n = n.value, e.push(n[0] + ": " + n[1]), n = t.next();
		return e.join("\r\n");
	};
	function Tn(e) {
		e.onreadystatechange && e.onreadystatechange.call(e);
	}
	Object.defineProperty(Sn.prototype, "withCredentials", {
		get: function() {
			return this.m === "include";
		},
		set: function(e) {
			this.m = e ? "include" : "same-origin";
		}
	});
	function En(e) {
		let t = "";
		return v(e, function(e, n) {
			t += n, t += ":", t += e, t += "\r\n";
		}), t;
	}
	function E(e, t, n) {
		a: {
			for (r in n) {
				var r = !1;
				break a;
			}
			r = !0;
		}
		r || (n = En(n), typeof e == "string" || w(e, t, n));
	}
	function D(e) {
		x.call(this), this.headers = /* @__PURE__ */ new Map(), this.o = e || null, this.h = !1, this.v = this.g = null, this.D = "", this.m = 0, this.l = "", this.j = this.B = this.u = this.A = !1, this.I = null, this.H = "", this.J = !1;
	}
	m(D, x);
	var Dn = /^https?$/i, On = ["POST", "PUT"];
	e = D.prototype, e.Ha = function(e) {
		this.J = e;
	}, e.ea = function(e, t, n, r) {
		if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + e);
		t = t ? t.toUpperCase() : "GET", this.D = e, this.l = "", this.m = 0, this.A = !1, this.h = !0, this.g = this.o ? this.o.g() : xt.g(), this.v = this.o ? $e(this.o) : $e(xt), this.g.onreadystatechange = f(this.Ea, this);
		try {
			this.B = !0, this.g.open(t, String(e), !0), this.B = !1;
		} catch (e) {
			kn(this, e);
			return;
		}
		if (e = n || "", n = new Map(this.headers), r) if (Object.getPrototypeOf(r) === Object.prototype) for (var i in r) n.set(i, r[i]);
		else if (typeof r.keys == "function" && typeof r.get == "function") for (let e of r.keys()) n.set(e, r.get(e));
		else throw Error("Unknown input type for opt_headers: " + String(r));
		r = Array.from(n.keys()).find((e) => e.toLowerCase() == "content-type"), i = s.FormData && e instanceof s.FormData, !(0 <= Array.prototype.indexOf.call(On, t, void 0)) || r || i || n.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
		for (let [e, t] of n) this.g.setRequestHeader(e, t);
		this.H && (this.g.responseType = this.H), "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
		try {
			Nn(this), this.u = !0, this.g.send(e), this.u = !1;
		} catch (e) {
			kn(this, e);
		}
	};
	function kn(e, t) {
		e.h = !1, e.g && (e.j = !0, e.g.abort(), e.j = !1), e.l = t, e.m = 5, An(e), Mn(e);
	}
	function An(e) {
		e.A || (e.A = !0, S(e, "complete"), S(e, "error"));
	}
	e.abort = function(e) {
		this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = e || 7, S(this, "complete"), S(this, "abort"), Mn(this));
	}, e.N = function() {
		this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Mn(this, !0)), D.aa.N.call(this);
	}, e.Ea = function() {
		this.s || (this.B || this.u || this.j ? jn(this) : this.bb());
	}, e.bb = function() {
		jn(this);
	};
	function jn(e) {
		if (e.h && o !== void 0 && (!e.v[1] || Pn(e) != 4 || e.Z() != 2)) {
			if (e.u && Pn(e) == 4) Ue(e.Ea, 0, e);
			else if (S(e, "readystatechange"), Pn(e) == 4) {
				e.h = !1;
				try {
					let o = e.Z();
					a: switch (o) {
						case 200:
						case 201:
						case 202:
						case 204:
						case 206:
						case 304:
						case 1223:
							var t = !0;
							break a;
						default: t = !1;
					}
					var n;
					if (!(n = t)) {
						var r;
						if (r = o === 0) {
							var i = String(e.D).match(Jt)[1] || null;
							!i && s.self && s.self.location && (i = s.self.location.protocol.slice(0, -1)), r = !Dn.test(i ? i.toLowerCase() : "");
						}
						n = r;
					}
					if (n) S(e, "complete"), S(e, "success");
					else {
						e.m = 6;
						try {
							var a = 2 < Pn(e) ? e.g.statusText : "";
						} catch {
							a = "";
						}
						e.l = a + " [" + e.Z() + "]", An(e);
					}
				} finally {
					Mn(e);
				}
			}
		}
	}
	function Mn(e, t) {
		if (e.g) {
			Nn(e);
			let n = e.g, r = e.v[0] ? () => {} : null;
			e.g = null, e.v = null, t || S(e, "ready");
			try {
				n.onreadystatechange = r;
			} catch {}
		}
	}
	function Nn(e) {
		e.I &&= (s.clearTimeout(e.I), null);
	}
	e.isActive = function() {
		return !!this.g;
	};
	function Pn(e) {
		return e.g ? e.g.readyState : 0;
	}
	e.Z = function() {
		try {
			return 2 < Pn(this) ? this.g.status : -1;
		} catch {
			return -1;
		}
	}, e.oa = function() {
		try {
			return this.g ? this.g.responseText : "";
		} catch {
			return "";
		}
	}, e.Oa = function(e) {
		if (this.g) {
			var t = this.g.responseText;
			return e && t.indexOf(e) == 0 && (t = t.substring(e.length)), Xe(t);
		}
	};
	function Fn(e) {
		try {
			if (!e.g) return null;
			if ("response" in e.g) return e.g.response;
			switch (e.H) {
				case "":
				case "text": return e.g.responseText;
				case "arraybuffer": if ("mozResponseArrayBuffer" in e.g) return e.g.mozResponseArrayBuffer;
			}
			return null;
		} catch {
			return null;
		}
	}
	function In(e) {
		let t = {};
		e = (e.g && 2 <= Pn(e) && e.g.getAllResponseHeaders() || "").split("\r\n");
		for (let r = 0; r < e.length; r++) {
			if (te(e[r])) continue;
			var n = ce(e[r]);
			let i = n[0];
			if (n = n[1], typeof n != "string") continue;
			n = n.trim();
			let a = t[i] || [];
			t[i] = a, a.push(n);
		}
		ie(t, function(e) {
			return e.join(", ");
		});
	}
	e.Ba = function() {
		return this.m;
	}, e.Ka = function() {
		return typeof this.l == "string" ? this.l : String(this.l);
	};
	function Ln(e, t, n) {
		return n && n.internalChannelParams && n.internalChannelParams[e] || t;
	}
	function Rn(e) {
		this.Aa = 0, this.i = [], this.j = new pt(), this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null, this.Ya = this.U = 0, this.Va = Ln("failFast", !1, e), this.F = this.C = this.u = this.s = this.l = null, this.X = !0, this.za = this.T = -1, this.Y = this.v = this.B = 0, this.Ta = Ln("baseRetryDelayMs", 5e3, e), this.cb = Ln("retryDelaySeedMs", 1e4, e), this.Wa = Ln("forwardChannelMaxRetries", 2, e), this.wa = Ln("forwardChannelRequestTimeoutMs", 2e4, e), this.pa = e && e.xmlHttpFactory || void 0, this.Xa = e && e.Tb || void 0, this.Ca = e && e.useFetchStreams || !1, this.L = void 0, this.J = e && e.supportsCrossDomainXhr || !1, this.K = "", this.h = new Rt(e && e.concurrentRequestLimit), this.Da = new T(), this.P = e && e.fastHandshake || !1, this.O = e && e.encodeInitMessageHeaders || !1, this.P && this.O && (this.O = !1), this.Ua = e && e.Rb || !1, e && e.xa && this.j.xa(), e && e.forceLongPolling && (this.X = !1), this.ba = !this.P && this.X && e && e.detectBufferingProxy || !1, this.ja = void 0, e && e.longPollingTimeout && 0 < e.longPollingTimeout && (this.ja = e.longPollingTimeout), this.ca = void 0, this.R = 0, this.M = !1, this.ka = this.A = null;
	}
	e = Rn.prototype, e.la = 8, e.G = 1, e.connect = function(e, t, n, r) {
		ut(0), this.W = e, this.H = t || {}, n && r !== void 0 && (this.H.OSID = n, this.H.OAID = r), this.F = this.X, this.I = nr(this, null, this.W), Hn(this);
	};
	function zn(e) {
		if (Vn(e), e.G == 3) {
			var t = e.U++, n = Xt(e.I);
			if (w(n, "SID", e.K), w(n, "RID", t), w(n, "TYPE", "terminate"), Gn(e, n), t = new Ct(e, e.j, t), t.L = 2, t.v = en(Xt(n)), n = !1, s.navigator && s.navigator.sendBeacon) try {
				n = s.navigator.sendBeacon(t.v.toString(), "");
			} catch {}
			!n && s.Image && (new Image().src = t.v, n = !0), n || (t.g = rr(t.j, null), t.g.ea(t.v)), t.F = Date.now(), jt(t);
		}
		tr(e);
	}
	function Bn(e) {
		e.g &&= (Yn(e), e.g.cancel(), null);
	}
	function Vn(e) {
		Bn(e), e.u &&= (s.clearTimeout(e.u), null), Zn(e), e.h.cancel(), e.s &&= (typeof e.s == "number" && s.clearTimeout(e.s), null);
	}
	function Hn(e) {
		if (!zt(e.h) && !e.s) {
			e.s = !0;
			var t = e.Ga;
			me || _e(), he ||= (me(), !0), ge.add(t, e), e.B = 0;
		}
	}
	function Un(e, t) {
		return Bt(e.h) >= e.h.j - +!!e.s ? !1 : e.s ? (e.i = t.D.concat(e.i), !0) : e.G == 1 || e.G == 2 || e.B >= (e.Va ? 0 : e.Wa) ? !1 : (e.s = ft(f(e.Ga, e, t), $n(e, e.B)), e.B++, !0);
	}
	e.Ga = function(e) {
		if (this.s) if (this.s = null, this.G == 1) {
			if (!e) {
				this.U = Math.floor(1e5 * Math.random()), e = this.U++;
				let i = new Ct(this, this.j, e), a = this.o;
				if (this.S && (a ? (a = ae(a), se(a, this.S)) : a = this.S), this.m !== null || this.O || (i.H = a, a = null), this.P) a: {
					for (var t = 0, n = 0; n < this.i.length; n++) {
						b: {
							var r = this.i[n];
							if ("__data__" in r.map && (r = r.map.__data__, typeof r == "string")) {
								r = r.length;
								break b;
							}
							r = void 0;
						}
						if (r === void 0) break;
						if (t += r, 4096 < t) {
							t = n;
							break a;
						}
						if (t === 4096 || n === this.i.length - 1) {
							t = n + 1;
							break a;
						}
					}
					t = 1e3;
				}
				else t = 1e3;
				t = Kn(this, i, t), n = Xt(this.I), w(n, "RID", e), w(n, "CVER", 22), this.D && w(n, "X-HTTP-Session-Id", this.D), Gn(this, n), a && (this.O ? t = "headers=" + encodeURIComponent(String(En(a))) + "&" + t : this.m && E(n, this.m, a)), Ht(this.h, i), this.Ua && w(n, "TYPE", "init"), this.P ? (w(n, "$req", t), w(n, "SID", "null"), i.T = !0, Dt(i, n, null)) : Dt(i, n, t), this.G = 2;
			}
		} else this.G == 3 && (e ? Wn(this, e) : this.i.length == 0 || zt(this.h) || Wn(this));
	};
	function Wn(e, t) {
		var n = t ? t.l : e.U++;
		let r = Xt(e.I);
		w(r, "SID", e.K), w(r, "RID", n), w(r, "AID", e.T), Gn(e, r), e.m && e.o && E(r, e.m, e.o), n = new Ct(e, e.j, n, e.B + 1), e.m === null && (n.H = e.o), t && (e.i = t.D.concat(e.i)), t = Kn(e, n, 1e3), n.I = Math.round(.5 * e.wa) + Math.round(.5 * e.wa * Math.random()), Ht(e.h, n), Dt(n, r, t);
	}
	function Gn(e, t) {
		e.H && v(e.H, function(e, n) {
			w(t, n, e);
		}), e.l && qt({}, function(e, n) {
			w(t, n, e);
		});
	}
	function Kn(e, t, n) {
		n = Math.min(e.i.length, n);
		var r = e.l ? f(e.l.Na, e.l, e) : null;
		a: {
			var i = e.i;
			let t = -1;
			for (;;) {
				let e = ["count=" + n];
				t == -1 ? 0 < n ? (t = i[0].g, e.push("ofs=" + t)) : t = 0 : e.push("ofs=" + t);
				let a = !0;
				for (let o = 0; o < n; o++) {
					let n = i[o].g, s = i[o].map;
					if (n -= t, 0 > n) t = Math.max(0, i[o].g - 100), a = !1;
					else try {
						bn(s, e, "req" + n + "_");
					} catch {
						r && r(s);
					}
				}
				if (a) {
					r = e.join("&");
					break a;
				}
			}
		}
		return e = e.i.splice(0, n), t.D = e, r;
	}
	function qn(e) {
		if (!e.g && !e.u) {
			e.Y = 1;
			var t = e.Fa;
			me || _e(), he ||= (me(), !0), ge.add(t, e), e.v = 0;
		}
	}
	function Jn(e) {
		return e.g || e.u || 3 <= e.v ? !1 : (e.Y++, e.u = ft(f(e.Fa, e), $n(e, e.v)), e.v++, !0);
	}
	e.Fa = function() {
		if (this.u = null, Xn(this), this.ba && !(this.M || this.g == null || 0 >= this.R)) {
			var e = 2 * this.R;
			this.j.info("BP detection timer enabled: " + e), this.A = ft(f(this.ab, this), e);
		}
	}, e.ab = function() {
		this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, ut(10), Bn(this), Xn(this));
	};
	function Yn(e) {
		e.A != null && (s.clearTimeout(e.A), e.A = null);
	}
	function Xn(e) {
		e.g = new Ct(e, e.j, "rpc", e.Y), e.m === null && (e.g.H = e.o), e.g.O = 0;
		var t = Xt(e.qa);
		w(t, "RID", "rpc"), w(t, "SID", e.K), w(t, "AID", e.T), w(t, "CI", e.F ? "0" : "1"), !e.F && e.ja && w(t, "TO", e.ja), w(t, "TYPE", "xmlhttp"), Gn(e, t), e.m && e.o && E(t, e.m, e.o), e.L && (e.g.I = e.L);
		var n = e.g;
		e = e.ia, n.L = 1, n.v = en(Xt(t)), n.m = null, n.P = !0, Ot(n, e);
	}
	e.Za = function() {
		this.C != null && (this.C = null, Bn(this), Jn(this), ut(19));
	};
	function Zn(e) {
		e.C != null && (s.clearTimeout(e.C), e.C = null);
	}
	function Qn(e, t) {
		var n = null;
		if (e.g == t) {
			Zn(e), Yn(e), e.g = null;
			var r = 2;
		} else if (Vt(e.h, t)) n = t.D, Ut(e.h, t), r = 1;
		else return;
		if (e.G != 0) {
			if (t.o) if (r == 1) {
				n = t.m ? t.m.length : 0, t = Date.now() - t.F;
				var i = e.B;
				r = ot(), S(r, new dt(r, n)), Hn(e);
			} else qn(e);
			else if (i = t.s, i == 3 || i == 0 && 0 < t.X || !(r == 1 && Un(e, t) || r == 2 && Jn(e))) switch (n && 0 < n.length && (t = e.h, t.i = t.i.concat(n)), i) {
				case 1:
					er(e, 5);
					break;
				case 4:
					er(e, 10);
					break;
				case 3:
					er(e, 6);
					break;
				default: er(e, 2);
			}
		}
	}
	function $n(e, t) {
		let n = e.Ta + Math.floor(Math.random() * e.cb);
		return e.isActive() || (n *= 2), n * t;
	}
	function er(e, t) {
		if (e.j.info("Error code " + t), t == 2) {
			var n = f(e.fb, e), r = e.Xa;
			let t = !r;
			r = new C(r || "//www.google.com/images/cleardot.gif"), s.location && s.location.protocol == "http" || Zt(r, "https"), en(r), t ? _n(r.toString(), n) : vn(r.toString(), n);
		} else ut(2);
		e.G = 0, e.l && e.l.sa(t), tr(e), Vn(e);
	}
	e.fb = function(e) {
		e ? (this.j.info("Successfully pinged google.com"), ut(2)) : (this.j.info("Failed to ping google.com"), ut(1));
	};
	function tr(e) {
		if (e.G = 0, e.ka = [], e.l) {
			let t = Wt(e.h);
			(t.length != 0 || e.i.length != 0) && (g(e.ka, t), g(e.ka, e.i), e.h.i.length = 0, h(e.i), e.i.length = 0), e.l.ra();
		}
	}
	function nr(e, t, n) {
		var r = n instanceof C ? Xt(n) : new C(n);
		if (r.g != "") t && (r.g = t + "." + r.g), Qt(r, r.s);
		else {
			var i = s.location;
			r = i.protocol, t = t ? t + "." + i.hostname : i.hostname, i = +i.port;
			var a = new C(null);
			r && Zt(a, r), t && (a.g = t), i && Qt(a, i), n && (a.l = n), r = a;
		}
		return n = e.D, t = e.ya, n && t && w(r, n, t), w(r, "VER", e.la), Gn(e, r), r;
	}
	function rr(e, t, n) {
		if (t && !e.J) throw Error("Can't create secondary domain capable XhrIo object.");
		return t = e.Ca && !e.pa ? new D(new xn({ eb: n })) : new D(e.pa), t.Ha(e.J), t;
	}
	e.isActive = function() {
		return !!this.l && this.l.isActive(this);
	};
	function ir() {}
	e = ir.prototype, e.ua = function() {}, e.ta = function() {}, e.sa = function() {}, e.ra = function() {}, e.isActive = function() {
		return !0;
	}, e.Na = function() {};
	function ar() {}
	ar.prototype.g = function(e, t) {
		return new or(e, t);
	};
	function or(e, t) {
		x.call(this), this.g = new Rn(t), this.l = e, this.h = t && t.messageUrlParams || null, e = t && t.messageHeaders || null, t && t.clientProtocolHeaderRequired && (e ? e["X-Client-Protocol"] = "webchannel" : e = { "X-Client-Protocol": "webchannel" }), this.g.o = e, e = t && t.initMessageHeaders || null, t && t.messageContentType && (e ? e["X-WebChannel-Content-Type"] = t.messageContentType : e = { "X-WebChannel-Content-Type": t.messageContentType }), t && t.va && (e ? e["X-WebChannel-Client-Profile"] = t.va : e = { "X-WebChannel-Client-Profile": t.va }), this.g.S = e, (e = t && t.Sb) && !te(e) && (this.g.m = e), this.v = t && t.supportsCrossDomainXhr || !1, this.u = t && t.sendRawJson || !1, (t &&= t.httpSessionIdParam) && !te(t) && (this.g.D = t, e = this.h, e !== null && t in e && (e = this.h, t in e && delete e[t])), this.j = new lr(this);
	}
	m(or, x), or.prototype.m = function() {
		this.g.l = this.j, this.v && (this.g.J = !0), this.g.connect(this.l, this.h || void 0);
	}, or.prototype.close = function() {
		zn(this.g);
	}, or.prototype.o = function(e) {
		var t = this.g;
		if (typeof e == "string") {
			var n = {};
			n.__data__ = e, e = n;
		} else this.u && (n = {}, n.__data__ = Ye(e), e = n);
		t.i.push(new Lt(t.Ya++, e)), t.G == 3 && Hn(t);
	}, or.prototype.N = function() {
		this.g.l = null, delete this.j, zn(this.g), delete this.g, or.aa.N.call(this);
	};
	function sr(e) {
		nt.call(this), e.__headers__ && (this.headers = e.__headers__, this.statusCode = e.__status__, delete e.__headers__, delete e.__status__);
		var t = e.__sm__;
		if (t) {
			a: {
				for (let n in t) {
					e = n;
					break a;
				}
				e = void 0;
			}
			(this.i = e) && (e = this.i, t = t !== null && e in t ? t[e] : void 0), this.data = t;
		} else this.data = e;
	}
	m(sr, nt);
	function cr() {
		rt.call(this), this.status = 1;
	}
	m(cr, rt);
	function lr(e) {
		this.g = e;
	}
	m(lr, ir), lr.prototype.ua = function() {
		S(this.g, "a");
	}, lr.prototype.ta = function(e) {
		S(this.g, new sr(e));
	}, lr.prototype.sa = function(e) {
		S(this.g, new cr());
	}, lr.prototype.ra = function() {
		S(this.g, "b");
	}, ar.prototype.createWebChannel = ar.prototype.g, or.prototype.send = or.prototype.o, or.prototype.open = or.prototype.m, or.prototype.close = or.prototype.close, Si = mi.createWebChannelTransport = function() {
		return new ar();
	}, xi = mi.getStatEventTarget = function() {
		return ot();
	}, bi = mi.Event = it, yi = mi.Stat = {
		mb: 0,
		pb: 1,
		qb: 2,
		Jb: 3,
		Ob: 4,
		Lb: 5,
		Mb: 6,
		Kb: 7,
		Ib: 8,
		Nb: 9,
		PROXY: 10,
		NOPROXY: 11,
		Gb: 12,
		Cb: 13,
		Db: 14,
		Bb: 15,
		Eb: 16,
		Fb: 17,
		ib: 18,
		hb: 19,
		jb: 20
	}, yt.NO_ERROR = 0, yt.TIMEOUT = 8, yt.HTTP_ERROR = 6, vi = mi.ErrorCode = yt, bt.COMPLETE = "complete", _i = mi.EventType = bt, et.EventType = tt, tt.OPEN = "a", tt.CLOSE = "b", tt.ERROR = "c", tt.MESSAGE = "d", x.prototype.listen = x.prototype.K, gi = mi.WebChannel = et, mi.FetchXmlHttpFactory = xn, D.prototype.listenOnce = D.prototype.L, D.prototype.getLastError = D.prototype.Ka, D.prototype.getLastErrorCode = D.prototype.Ba, D.prototype.getStatus = D.prototype.Z, D.prototype.getResponseJson = D.prototype.Oa, D.prototype.getResponseText = D.prototype.oa, D.prototype.send = D.prototype.ea, D.prototype.setWithCredentials = D.prototype.Ha, hi = mi.XhrIo = D;
}).apply(pi === void 0 ? typeof self < "u" ? self : typeof window < "u" ? window : {} : pi);
//#endregion
//#region ../node_modules/@firebase/firestore/dist/index.esm2017.js
var Ci = "@firebase/firestore", O = class {
	constructor(e) {
		this.uid = e;
	}
	isAuthenticated() {
		return this.uid != null;
	}
	toKey() {
		return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
	}
	isEqual(e) {
		return e.uid === this.uid;
	}
};
O.UNAUTHENTICATED = new O(null), O.GOOGLE_CREDENTIALS = new O("google-credentials-uid"), O.FIRST_PARTY = new O("first-party-uid"), O.MOCK_USER = new O("mock-user");
var wi = "11.0.0", Ti = new An("@firebase/firestore");
function Ei() {
	return Ti.logLevel;
}
function k(e, ...t) {
	if (Ti.logLevel <= E.DEBUG) {
		let n = t.map(ki);
		Ti.debug(`Firestore (${wi}): ${e}`, ...n);
	}
}
function Di(e, ...t) {
	if (Ti.logLevel <= E.ERROR) {
		let n = t.map(ki);
		Ti.error(`Firestore (${wi}): ${e}`, ...n);
	}
}
function Oi(e, ...t) {
	if (Ti.logLevel <= E.WARN) {
		let n = t.map(ki);
		Ti.warn(`Firestore (${wi}): ${e}`, ...n);
	}
}
function ki(e) {
	if (typeof e == "string") return e;
	try {
		return function(e) {
			return JSON.stringify(e);
		}(e);
	} catch {
		return e;
	}
}
function A(e = "Unexpected state") {
	let t = `FIRESTORE (${wi}) INTERNAL ASSERTION FAILED: ` + e;
	throw Di(t), Error(t);
}
function j(e, t) {
	e || A();
}
function M(e, t) {
	return e;
}
var N = {
	OK: "ok",
	CANCELLED: "cancelled",
	UNKNOWN: "unknown",
	INVALID_ARGUMENT: "invalid-argument",
	DEADLINE_EXCEEDED: "deadline-exceeded",
	NOT_FOUND: "not-found",
	ALREADY_EXISTS: "already-exists",
	PERMISSION_DENIED: "permission-denied",
	UNAUTHENTICATED: "unauthenticated",
	RESOURCE_EXHAUSTED: "resource-exhausted",
	FAILED_PRECONDITION: "failed-precondition",
	ABORTED: "aborted",
	OUT_OF_RANGE: "out-of-range",
	UNIMPLEMENTED: "unimplemented",
	INTERNAL: "internal",
	UNAVAILABLE: "unavailable",
	DATA_LOSS: "data-loss"
}, P = class extends on {
	constructor(e, t) {
		super(e, t), this.code = e, this.message = t, this.toString = () => `${this.name}: [code=${this.code}]: ${this.message}`;
	}
}, Ai = class {
	constructor() {
		this.promise = new Promise(((e, t) => {
			this.resolve = e, this.reject = t;
		}));
	}
}, ji = class {
	constructor(e, t) {
		this.user = t, this.type = "OAuth", this.headers = /* @__PURE__ */ new Map(), this.headers.set("Authorization", `Bearer ${e}`);
	}
}, Mi = class {
	getToken() {
		return Promise.resolve(null);
	}
	invalidateToken() {}
	start(e, t) {
		e.enqueueRetryable((() => t(O.UNAUTHENTICATED)));
	}
	shutdown() {}
}, Ni = class {
	constructor(e) {
		this.token = e, this.changeListener = null;
	}
	getToken() {
		return Promise.resolve(this.token);
	}
	invalidateToken() {}
	start(e, t) {
		this.changeListener = t, e.enqueueRetryable((() => t(this.token.user)));
	}
	shutdown() {
		this.changeListener = null;
	}
}, Pi = class {
	constructor(e) {
		this.t = e, this.currentUser = O.UNAUTHENTICATED, this.i = 0, this.forceRefresh = !1, this.auth = null;
	}
	start(e, t) {
		j(this.o === void 0);
		let n = this.i, r = (e) => this.i === n ? Promise.resolve() : (n = this.i, t(e)), i = new Ai();
		this.o = () => {
			this.i++, this.currentUser = this.u(), i.resolve(), i = new Ai(), e.enqueueRetryable((() => r(this.currentUser)));
		};
		let a = () => {
			let t = i;
			e.enqueueRetryable((async () => {
				await t.promise, await r(this.currentUser);
			}));
		}, o = (e) => {
			k("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), a());
		};
		this.t.onInit(((e) => o(e))), setTimeout((() => {
			if (!this.auth) {
				let e = this.t.getImmediate({ optional: !0 });
				e ? o(e) : (k("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new Ai());
			}
		}), 0), a();
	}
	getToken() {
		let e = this.i, t = this.forceRefresh;
		return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then(((t) => this.i === e ? t ? (j(typeof t.accessToken == "string"), new ji(t.accessToken, this.currentUser)) : null : (k("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()))) : Promise.resolve(null);
	}
	invalidateToken() {
		this.forceRefresh = !0;
	}
	shutdown() {
		this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
	}
	u() {
		let e = this.auth && this.auth.getUid();
		return j(e === null || typeof e == "string"), new O(e);
	}
}, Fi = class {
	constructor(e, t, n) {
		this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = O.FIRST_PARTY, this.I = /* @__PURE__ */ new Map();
	}
	T() {
		return this.P ? this.P() : null;
	}
	get headers() {
		this.I.set("X-Goog-AuthUser", this.l);
		let e = this.T();
		return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
	}
}, Ii = class {
	constructor(e, t, n) {
		this.l = e, this.h = t, this.P = n;
	}
	getToken() {
		return Promise.resolve(new Fi(this.l, this.h, this.P));
	}
	start(e, t) {
		e.enqueueRetryable((() => t(O.FIRST_PARTY)));
	}
	shutdown() {}
	invalidateToken() {}
}, Li = class {
	constructor(e) {
		this.value = e, this.type = "AppCheck", this.headers = /* @__PURE__ */ new Map(), e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
	}
}, Ri = class {
	constructor(e) {
		this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
	}
	start(e, t) {
		j(this.o === void 0);
		let n = (e) => {
			e.error != null && k("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
			let n = e.token !== this.R;
			return this.R = e.token, k("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
		};
		this.o = (t) => {
			e.enqueueRetryable((() => n(t)));
		};
		let r = (e) => {
			k("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
		};
		this.A.onInit(((e) => r(e))), setTimeout((() => {
			if (!this.appCheck) {
				let e = this.A.getImmediate({ optional: !0 });
				e ? r(e) : k("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
			}
		}), 0);
	}
	getToken() {
		let e = this.forceRefresh;
		return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then(((e) => e ? (j(typeof e.token == "string"), this.R = e.token, new Li(e.token)) : null)) : Promise.resolve(null);
	}
	invalidateToken() {
		this.forceRefresh = !0;
	}
	shutdown() {
		this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
	}
};
function zi(e) {
	let t = typeof self < "u" && (self.crypto || self.msCrypto), n = new Uint8Array(e);
	if (t && typeof t.getRandomValues == "function") t.getRandomValues(n);
	else for (let t = 0; t < e; t++) n[t] = Math.floor(256 * Math.random());
	return n;
}
var Bi = class {
	static newId() {
		let e = "";
		for (; e.length < 20;) {
			let t = zi(40);
			for (let n = 0; n < t.length; ++n) e.length < 20 && t[n] < 248 && (e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(t[n] % 62));
		}
		return e;
	}
};
function F(e, t) {
	return e < t ? -1 : +(e > t);
}
function Vi(e, t, n) {
	return e.length === t.length && e.every(((e, r) => n(e, t[r])));
}
var I = class e {
	constructor(e, t) {
		if (this.seconds = e, this.nanoseconds = t, t < 0 || t >= 1e9) throw new P(N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
		if (e < -62135596800 || e >= 253402300800) throw new P(N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
	}
	static now() {
		return e.fromMillis(Date.now());
	}
	static fromDate(t) {
		return e.fromMillis(t.getTime());
	}
	static fromMillis(t) {
		let n = Math.floor(t / 1e3);
		return new e(n, Math.floor(1e6 * (t - 1e3 * n)));
	}
	toDate() {
		return new Date(this.toMillis());
	}
	toMillis() {
		return 1e3 * this.seconds + this.nanoseconds / 1e6;
	}
	_compareTo(e) {
		return this.seconds === e.seconds ? F(this.nanoseconds, e.nanoseconds) : F(this.seconds, e.seconds);
	}
	isEqual(e) {
		return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
	}
	toString() {
		return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
	}
	toJSON() {
		return {
			seconds: this.seconds,
			nanoseconds: this.nanoseconds
		};
	}
	valueOf() {
		let e = this.seconds - -62135596800;
		return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
	}
}, L = class e {
	constructor(e) {
		this.timestamp = e;
	}
	static fromTimestamp(t) {
		return new e(t);
	}
	static min() {
		return new e(new I(0, 0));
	}
	static max() {
		return new e(new I(253402300799, 999999999));
	}
	compareTo(e) {
		return this.timestamp._compareTo(e.timestamp);
	}
	isEqual(e) {
		return this.timestamp.isEqual(e.timestamp);
	}
	toMicroseconds() {
		return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
	}
	toString() {
		return "SnapshotVersion(" + this.timestamp.toString() + ")";
	}
	toTimestamp() {
		return this.timestamp;
	}
}, Hi = class e {
	constructor(e, t, n) {
		t === void 0 ? t = 0 : t > e.length && A(), n === void 0 ? n = e.length - t : n > e.length - t && A(), this.segments = e, this.offset = t, this.len = n;
	}
	get length() {
		return this.len;
	}
	isEqual(t) {
		return e.comparator(this, t) === 0;
	}
	child(t) {
		let n = this.segments.slice(this.offset, this.limit());
		return t instanceof e ? t.forEach(((e) => {
			n.push(e);
		})) : n.push(t), this.construct(n);
	}
	limit() {
		return this.offset + this.length;
	}
	popFirst(e) {
		return e = e === void 0 ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
	}
	popLast() {
		return this.construct(this.segments, this.offset, this.length - 1);
	}
	firstSegment() {
		return this.segments[this.offset];
	}
	lastSegment() {
		return this.get(this.length - 1);
	}
	get(e) {
		return this.segments[this.offset + e];
	}
	isEmpty() {
		return this.length === 0;
	}
	isPrefixOf(e) {
		if (e.length < this.length) return !1;
		for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
		return !0;
	}
	isImmediateParentOf(e) {
		if (this.length + 1 !== e.length) return !1;
		for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
		return !0;
	}
	forEach(e) {
		for (let t = this.offset, n = this.limit(); t < n; t++) e(this.segments[t]);
	}
	toArray() {
		return this.segments.slice(this.offset, this.limit());
	}
	static comparator(e, t) {
		let n = Math.min(e.length, t.length);
		for (let r = 0; r < n; r++) {
			let n = e.get(r), i = t.get(r);
			if (n < i) return -1;
			if (n > i) return 1;
		}
		return e.length < t.length ? -1 : +(e.length > t.length);
	}
}, R = class e extends Hi {
	construct(t, n, r) {
		return new e(t, n, r);
	}
	canonicalString() {
		return this.toArray().join("/");
	}
	toString() {
		return this.canonicalString();
	}
	toUriEncodedString() {
		return this.toArray().map(encodeURIComponent).join("/");
	}
	static fromString(...t) {
		let n = [];
		for (let e of t) {
			if (e.indexOf("//") >= 0) throw new P(N.INVALID_ARGUMENT, `Invalid segment (${e}). Paths must not contain // in them.`);
			n.push(...e.split("/").filter(((e) => e.length > 0)));
		}
		return new e(n);
	}
	static emptyPath() {
		return new e([]);
	}
}, Ui = /^[_a-zA-Z][_a-zA-Z0-9]*$/, Wi = class e extends Hi {
	construct(t, n, r) {
		return new e(t, n, r);
	}
	static isValidIdentifier(e) {
		return Ui.test(e);
	}
	canonicalString() {
		return this.toArray().map(((t) => (t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), e.isValidIdentifier(t) || (t = "`" + t + "`"), t))).join(".");
	}
	toString() {
		return this.canonicalString();
	}
	isKeyField() {
		return this.length === 1 && this.get(0) === "__name__";
	}
	static keyField() {
		return new e(["__name__"]);
	}
	static fromServerFormat(t) {
		let n = [], r = "", i = 0, a = () => {
			if (r.length === 0) throw new P(N.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
			n.push(r), r = "";
		}, o = !1;
		for (; i < t.length;) {
			let e = t[i];
			if (e === "\\") {
				if (i + 1 === t.length) throw new P(N.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
				let e = t[i + 1];
				if (e !== "\\" && e !== "." && e !== "`") throw new P(N.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
				r += e, i += 2;
			} else e === "`" ? (o = !o, i++) : e !== "." || o ? (r += e, i++) : (a(), i++);
		}
		if (a(), o) throw new P(N.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
		return new e(n);
	}
	static emptyPath() {
		return new e([]);
	}
}, z = class e {
	constructor(e) {
		this.path = e;
	}
	static fromPath(t) {
		return new e(R.fromString(t));
	}
	static fromName(t) {
		return new e(R.fromString(t).popFirst(5));
	}
	static empty() {
		return new e(R.emptyPath());
	}
	get collectionGroup() {
		return this.path.popLast().lastSegment();
	}
	hasCollectionId(e) {
		return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
	}
	getCollectionGroup() {
		return this.path.get(this.path.length - 2);
	}
	getCollectionPath() {
		return this.path.popLast();
	}
	isEqual(e) {
		return e !== null && R.comparator(this.path, e.path) === 0;
	}
	toString() {
		return this.path.toString();
	}
	static comparator(e, t) {
		return R.comparator(e.path, t.path);
	}
	static isDocumentKey(e) {
		return e.length % 2 == 0;
	}
	static fromSegments(t) {
		return new e(new R(t.slice()));
	}
}, Gi = class {
	constructor(e, t, n, r) {
		this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
	}
};
Gi.UNKNOWN_ID = -1;
function Ki(e, t) {
	let n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1;
	return new Ji(L.fromTimestamp(r === 1e9 ? new I(n + 1, 0) : new I(n, r)), z.empty(), t);
}
function qi(e) {
	return new Ji(e.readTime, e.key, -1);
}
var Ji = class e {
	constructor(e, t, n) {
		this.readTime = e, this.documentKey = t, this.largestBatchId = n;
	}
	static min() {
		return new e(L.min(), z.empty(), -1);
	}
	static max() {
		return new e(L.max(), z.empty(), -1);
	}
};
function Yi(e, t) {
	let n = e.readTime.compareTo(t.readTime);
	return n === 0 ? (n = z.comparator(e.documentKey, t.documentKey), n === 0 ? F(e.largestBatchId, t.largestBatchId) : n) : n;
}
var Xi = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", Zi = class {
	constructor() {
		this.onCommittedListeners = [];
	}
	addOnCommittedListener(e) {
		this.onCommittedListeners.push(e);
	}
	raiseOnCommittedEvent() {
		this.onCommittedListeners.forEach(((e) => e()));
	}
};
async function Qi(e) {
	if (e.code !== N.FAILED_PRECONDITION || e.message !== Xi) throw e;
	k("LocalStore", "Unexpectedly lost primary lease");
}
var B = class e {
	constructor(e) {
		this.nextCallback = null, this.catchCallback = null, this.result = void 0, this.error = void 0, this.isDone = !1, this.callbackAttached = !1, e(((e) => {
			this.isDone = !0, this.result = e, this.nextCallback && this.nextCallback(e);
		}), ((e) => {
			this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
		}));
	}
	catch(e) {
		return this.next(void 0, e);
	}
	next(t, n) {
		return this.callbackAttached && A(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(n, this.error) : this.wrapSuccess(t, this.result) : new e(((e, r) => {
			this.nextCallback = (n) => {
				this.wrapSuccess(t, n).next(e, r);
			}, this.catchCallback = (t) => {
				this.wrapFailure(n, t).next(e, r);
			};
		}));
	}
	toPromise() {
		return new Promise(((e, t) => {
			this.next(e, t);
		}));
	}
	wrapUserFunction(t) {
		try {
			let n = t();
			return n instanceof e ? n : e.resolve(n);
		} catch (t) {
			return e.reject(t);
		}
	}
	wrapSuccess(t, n) {
		return t ? this.wrapUserFunction((() => t(n))) : e.resolve(n);
	}
	wrapFailure(t, n) {
		return t ? this.wrapUserFunction((() => t(n))) : e.reject(n);
	}
	static resolve(t) {
		return new e(((e, n) => {
			e(t);
		}));
	}
	static reject(t) {
		return new e(((e, n) => {
			n(t);
		}));
	}
	static waitFor(t) {
		return new e(((e, n) => {
			let r = 0, i = 0, a = !1;
			t.forEach(((t) => {
				++r, t.next((() => {
					++i, a && i === r && e();
				}), ((e) => n(e)));
			})), a = !0, i === r && e();
		}));
	}
	static or(t) {
		let n = e.resolve(!1);
		for (let r of t) n = n.next(((t) => t ? e.resolve(t) : r()));
		return n;
	}
	static forEach(e, t) {
		let n = [];
		return e.forEach(((e, r) => {
			n.push(t.call(this, e, r));
		})), this.waitFor(n);
	}
	static mapArray(t, n) {
		return new e(((e, r) => {
			let i = t.length, a = Array(i), o = 0;
			for (let s = 0; s < i; s++) {
				let c = s;
				n(t[c]).next(((t) => {
					a[c] = t, ++o, o === i && e(a);
				}), ((e) => r(e)));
			}
		}));
	}
	static doWhile(t, n) {
		return new e(((e, r) => {
			let i = () => {
				!0 === t() ? n().next((() => {
					i();
				}), r) : e();
			};
			i();
		}));
	}
};
function $i(e) {
	let t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
	return Number(n);
}
function ea(e) {
	return e.name === "IndexedDbTransactionError";
}
var ta = class {
	constructor(e, t) {
		this.previousValue = e, t && (t.sequenceNumberHandler = (e) => this.ie(e), this.se = (e) => t.writeSequenceNumber(e));
	}
	ie(e) {
		return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
	}
	next() {
		let e = ++this.previousValue;
		return this.se && this.se(e), e;
	}
};
ta.oe = -1;
function na(e) {
	return e == null;
}
function ra(e) {
	return e === 0 && 1 / e == -Infinity;
}
function ia(e) {
	return typeof e == "number" && Number.isInteger(e) && !ra(e) && e <= 2 ** 53 - 1 && e >= -(2 ** 53 - 1);
}
function aa(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) t.length > 0 && (t = sa(t)), t = oa(e.get(n), t);
	return sa(t);
}
function oa(e, t) {
	let n = t, r = e.length;
	for (let t = 0; t < r; t++) {
		let r = e.charAt(t);
		switch (r) {
			case "\0":
				n += "";
				break;
			case "":
				n += "";
				break;
			default: n += r;
		}
	}
	return n;
}
function sa(e) {
	return e + "";
}
function ca(e) {
	let t = 0;
	for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t++;
	return t;
}
function la(e, t) {
	for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function ua(e, t) {
	let n = [];
	for (let r in e) Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
	return n;
}
function da(e) {
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
	return !0;
}
var V = class e {
	constructor(e, t) {
		this.comparator = e, this.root = t || pa.EMPTY;
	}
	insert(t, n) {
		return new e(this.comparator, this.root.insert(t, n, this.comparator).copy(null, null, pa.BLACK, null, null));
	}
	remove(t) {
		return new e(this.comparator, this.root.remove(t, this.comparator).copy(null, null, pa.BLACK, null, null));
	}
	get(e) {
		let t = this.root;
		for (; !t.isEmpty();) {
			let n = this.comparator(e, t.key);
			if (n === 0) return t.value;
			n < 0 ? t = t.left : n > 0 && (t = t.right);
		}
		return null;
	}
	indexOf(e) {
		let t = 0, n = this.root;
		for (; !n.isEmpty();) {
			let r = this.comparator(e, n.key);
			if (r === 0) return t + n.left.size;
			r < 0 ? n = n.left : (t += n.left.size + 1, n = n.right);
		}
		return -1;
	}
	isEmpty() {
		return this.root.isEmpty();
	}
	get size() {
		return this.root.size;
	}
	minKey() {
		return this.root.minKey();
	}
	maxKey() {
		return this.root.maxKey();
	}
	inorderTraversal(e) {
		return this.root.inorderTraversal(e);
	}
	forEach(e) {
		this.inorderTraversal(((t, n) => (e(t, n), !1)));
	}
	toString() {
		let e = [];
		return this.inorderTraversal(((t, n) => (e.push(`${t}:${n}`), !1))), `{${e.join(", ")}}`;
	}
	reverseTraversal(e) {
		return this.root.reverseTraversal(e);
	}
	getIterator() {
		return new fa(this.root, null, this.comparator, !1);
	}
	getIteratorFrom(e) {
		return new fa(this.root, e, this.comparator, !1);
	}
	getReverseIterator() {
		return new fa(this.root, null, this.comparator, !0);
	}
	getReverseIteratorFrom(e) {
		return new fa(this.root, e, this.comparator, !0);
	}
}, fa = class {
	constructor(e, t, n, r) {
		this.isReverse = r, this.nodeStack = [];
		let i = 1;
		for (; !e.isEmpty();) if (i = t ? n(e.key, t) : 1, t && r && (i *= -1), i < 0) e = this.isReverse ? e.left : e.right;
		else {
			if (i === 0) {
				this.nodeStack.push(e);
				break;
			}
			this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
		}
	}
	getNext() {
		let e = this.nodeStack.pop(), t = {
			key: e.key,
			value: e.value
		};
		if (this.isReverse) for (e = e.left; !e.isEmpty();) this.nodeStack.push(e), e = e.right;
		else for (e = e.right; !e.isEmpty();) this.nodeStack.push(e), e = e.left;
		return t;
	}
	hasNext() {
		return this.nodeStack.length > 0;
	}
	peek() {
		if (this.nodeStack.length === 0) return null;
		let e = this.nodeStack[this.nodeStack.length - 1];
		return {
			key: e.key,
			value: e.value
		};
	}
}, pa = class e {
	constructor(t, n, r, i, a) {
		this.key = t, this.value = n, this.color = r ?? e.RED, this.left = i ?? e.EMPTY, this.right = a ?? e.EMPTY, this.size = this.left.size + 1 + this.right.size;
	}
	copy(t, n, r, i, a) {
		return new e(t ?? this.key, n ?? this.value, r ?? this.color, i ?? this.left, a ?? this.right);
	}
	isEmpty() {
		return !1;
	}
	inorderTraversal(e) {
		return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
	}
	reverseTraversal(e) {
		return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
	}
	min() {
		return this.left.isEmpty() ? this : this.left.min();
	}
	minKey() {
		return this.min().key;
	}
	maxKey() {
		return this.right.isEmpty() ? this.key : this.right.maxKey();
	}
	insert(e, t, n) {
		let r = this, i = n(e, r.key);
		return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : i === 0 ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
	}
	removeMin() {
		if (this.left.isEmpty()) return e.EMPTY;
		let t = this;
		return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
	}
	remove(t, n) {
		let r, i = this;
		if (n(t, i.key) < 0) i.left.isEmpty() || i.left.isRed() || i.left.left.isRed() || (i = i.moveRedLeft()), i = i.copy(null, null, null, i.left.remove(t, n), null);
		else {
			if (i.left.isRed() && (i = i.rotateRight()), i.right.isEmpty() || i.right.isRed() || i.right.left.isRed() || (i = i.moveRedRight()), n(t, i.key) === 0) {
				if (i.right.isEmpty()) return e.EMPTY;
				r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.removeMin());
			}
			i = i.copy(null, null, null, null, i.right.remove(t, n));
		}
		return i.fixUp();
	}
	isRed() {
		return this.color;
	}
	fixUp() {
		let e = this;
		return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
	}
	moveRedLeft() {
		let e = this.colorFlip();
		return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
	}
	moveRedRight() {
		let e = this.colorFlip();
		return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
	}
	rotateLeft() {
		let t = this.copy(null, null, e.RED, null, this.right.left);
		return this.right.copy(null, null, this.color, t, null);
	}
	rotateRight() {
		let t = this.copy(null, null, e.RED, this.left.right, null);
		return this.left.copy(null, null, this.color, null, t);
	}
	colorFlip() {
		let e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
		return this.copy(null, null, !this.color, e, t);
	}
	checkMaxDepth() {
		return 2 ** this.check() <= this.size + 1;
	}
	check() {
		if (this.isRed() && this.left.isRed() || this.right.isRed()) throw A();
		let e = this.left.check();
		if (e !== this.right.check()) throw A();
		return e + +!this.isRed();
	}
};
pa.EMPTY = null, pa.RED = !0, pa.BLACK = !1, pa.EMPTY = new class {
	constructor() {
		this.size = 0;
	}
	get key() {
		throw A();
	}
	get value() {
		throw A();
	}
	get color() {
		throw A();
	}
	get left() {
		throw A();
	}
	get right() {
		throw A();
	}
	copy(e, t, n, r, i) {
		return this;
	}
	insert(e, t, n) {
		return new pa(e, t);
	}
	remove(e, t) {
		return this;
	}
	isEmpty() {
		return !0;
	}
	inorderTraversal(e) {
		return !1;
	}
	reverseTraversal(e) {
		return !1;
	}
	minKey() {
		return null;
	}
	maxKey() {
		return null;
	}
	isRed() {
		return !1;
	}
	checkMaxDepth() {
		return !0;
	}
	check() {
		return 0;
	}
}();
var ma = class e {
	constructor(e) {
		this.comparator = e, this.data = new V(this.comparator);
	}
	has(e) {
		return this.data.get(e) !== null;
	}
	first() {
		return this.data.minKey();
	}
	last() {
		return this.data.maxKey();
	}
	get size() {
		return this.data.size;
	}
	indexOf(e) {
		return this.data.indexOf(e);
	}
	forEach(e) {
		this.data.inorderTraversal(((t, n) => (e(t), !1)));
	}
	forEachInRange(e, t) {
		let n = this.data.getIteratorFrom(e[0]);
		for (; n.hasNext();) {
			let r = n.getNext();
			if (this.comparator(r.key, e[1]) >= 0) return;
			t(r.key);
		}
	}
	forEachWhile(e, t) {
		let n;
		for (n = t === void 0 ? this.data.getIterator() : this.data.getIteratorFrom(t); n.hasNext();) if (!e(n.getNext().key)) return;
	}
	firstAfterOrEqual(e) {
		let t = this.data.getIteratorFrom(e);
		return t.hasNext() ? t.getNext().key : null;
	}
	getIterator() {
		return new ha(this.data.getIterator());
	}
	getIteratorFrom(e) {
		return new ha(this.data.getIteratorFrom(e));
	}
	add(e) {
		return this.copy(this.data.remove(e).insert(e, !0));
	}
	delete(e) {
		return this.has(e) ? this.copy(this.data.remove(e)) : this;
	}
	isEmpty() {
		return this.data.isEmpty();
	}
	unionWith(e) {
		let t = this;
		return t.size < e.size && (t = e, e = this), e.forEach(((e) => {
			t = t.add(e);
		})), t;
	}
	isEqual(t) {
		if (!(t instanceof e) || this.size !== t.size) return !1;
		let n = this.data.getIterator(), r = t.data.getIterator();
		for (; n.hasNext();) {
			let e = n.getNext().key, t = r.getNext().key;
			if (this.comparator(e, t) !== 0) return !1;
		}
		return !0;
	}
	toArray() {
		let e = [];
		return this.forEach(((t) => {
			e.push(t);
		})), e;
	}
	toString() {
		let e = [];
		return this.forEach(((t) => e.push(t))), "SortedSet(" + e.toString() + ")";
	}
	copy(t) {
		let n = new e(this.comparator);
		return n.data = t, n;
	}
}, ha = class {
	constructor(e) {
		this.iter = e;
	}
	getNext() {
		return this.iter.getNext().key;
	}
	hasNext() {
		return this.iter.hasNext();
	}
}, ga = class e {
	constructor(e) {
		this.fields = e, e.sort(Wi.comparator);
	}
	static empty() {
		return new e([]);
	}
	unionWith(t) {
		let n = new ma(Wi.comparator);
		for (let e of this.fields) n = n.add(e);
		for (let e of t) n = n.add(e);
		return new e(n.toArray());
	}
	covers(e) {
		for (let t of this.fields) if (t.isPrefixOf(e)) return !0;
		return !1;
	}
	isEqual(e) {
		return Vi(this.fields, e.fields, ((e, t) => e.isEqual(t)));
	}
}, _a = class extends Error {
	constructor() {
		super(...arguments), this.name = "Base64DecodeError";
	}
}, va = class e {
	constructor(e) {
		this.binaryString = e;
	}
	static fromBase64String(t) {
		return new e(function(e) {
			try {
				return atob(e);
			} catch (e) {
				throw typeof DOMException < "u" && e instanceof DOMException ? new _a("Invalid base64 string: " + e) : e;
			}
		}(t));
	}
	static fromUint8Array(t) {
		return new e(function(e) {
			let t = "";
			for (let n = 0; n < e.length; ++n) t += String.fromCharCode(e[n]);
			return t;
		}(t));
	}
	[Symbol.iterator]() {
		let e = 0;
		return { next: () => e < this.binaryString.length ? {
			value: this.binaryString.charCodeAt(e++),
			done: !1
		} : {
			value: void 0,
			done: !0
		} };
	}
	toBase64() {
		return function(e) {
			return btoa(e);
		}(this.binaryString);
	}
	toUint8Array() {
		return function(e) {
			let t = new Uint8Array(e.length);
			for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
			return t;
		}(this.binaryString);
	}
	approximateByteSize() {
		return 2 * this.binaryString.length;
	}
	compareTo(e) {
		return F(this.binaryString, e.binaryString);
	}
	isEqual(e) {
		return this.binaryString === e.binaryString;
	}
};
va.EMPTY_BYTE_STRING = new va("");
var ya = /* @__PURE__ */ new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function ba(e) {
	if (j(!!e), typeof e == "string") {
		let t = 0, n = ya.exec(e);
		if (j(!!n), n[1]) {
			let e = n[1];
			e = (e + "000000000").substr(0, 9), t = Number(e);
		}
		let r = new Date(e);
		return {
			seconds: Math.floor(r.getTime() / 1e3),
			nanos: t
		};
	}
	return {
		seconds: H(e.seconds),
		nanos: H(e.nanos)
	};
}
function H(e) {
	return typeof e == "number" ? e : typeof e == "string" ? Number(e) : 0;
}
function xa(e) {
	return typeof e == "string" ? va.fromBase64String(e) : va.fromUint8Array(e);
}
function Sa(e) {
	return (e?.mapValue?.fields || {}).__type__?.stringValue === "server_timestamp";
}
function Ca(e) {
	let t = e.mapValue.fields.__previous_value__;
	return Sa(t) ? Ca(t) : t;
}
function wa(e) {
	let t = ba(e.mapValue.fields.__local_write_time__.timestampValue);
	return new I(t.seconds, t.nanos);
}
var Ta = class {
	constructor(e, t, n, r, i, a, o, s, c) {
		this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = a, this.autoDetectLongPolling = o, this.longPollingOptions = s, this.useFetchStreams = c;
	}
}, Ea = class e {
	constructor(e, t) {
		this.projectId = e, this.database = t || "(default)";
	}
	static empty() {
		return new e("", "");
	}
	get isDefaultDatabase() {
		return this.database === "(default)";
	}
	isEqual(t) {
		return t instanceof e && t.projectId === this.projectId && t.database === this.database;
	}
}, Da = { mapValue: { fields: { __type__: { stringValue: "__max__" } } } };
function Oa(e) {
	return "nullValue" in e ? 0 : "booleanValue" in e ? 1 : "integerValue" in e || "doubleValue" in e ? 2 : "timestampValue" in e ? 3 : "stringValue" in e ? 5 : "bytesValue" in e ? 6 : "referenceValue" in e ? 7 : "geoPointValue" in e ? 8 : "arrayValue" in e ? 9 : "mapValue" in e ? Sa(e) ? 4 : Ga(e) ? 9007199254740991 : Ua(e) ? 10 : 11 : A();
}
function ka(e, t) {
	if (e === t) return !0;
	let n = Oa(e);
	if (n !== Oa(t)) return !1;
	switch (n) {
		case 0:
		case 9007199254740991: return !0;
		case 1: return e.booleanValue === t.booleanValue;
		case 4: return wa(e).isEqual(wa(t));
		case 3: return function(e, t) {
			if (typeof e.timestampValue == "string" && typeof t.timestampValue == "string" && e.timestampValue.length === t.timestampValue.length) return e.timestampValue === t.timestampValue;
			let n = ba(e.timestampValue), r = ba(t.timestampValue);
			return n.seconds === r.seconds && n.nanos === r.nanos;
		}(e, t);
		case 5: return e.stringValue === t.stringValue;
		case 6: return function(e, t) {
			return xa(e.bytesValue).isEqual(xa(t.bytesValue));
		}(e, t);
		case 7: return e.referenceValue === t.referenceValue;
		case 8: return function(e, t) {
			return H(e.geoPointValue.latitude) === H(t.geoPointValue.latitude) && H(e.geoPointValue.longitude) === H(t.geoPointValue.longitude);
		}(e, t);
		case 2: return function(e, t) {
			if ("integerValue" in e && "integerValue" in t) return H(e.integerValue) === H(t.integerValue);
			if ("doubleValue" in e && "doubleValue" in t) {
				let n = H(e.doubleValue), r = H(t.doubleValue);
				return n === r ? ra(n) === ra(r) : isNaN(n) && isNaN(r);
			}
			return !1;
		}(e, t);
		case 9: return Vi(e.arrayValue.values || [], t.arrayValue.values || [], ka);
		case 10:
		case 11: return function(e, t) {
			let n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
			if (ca(n) !== ca(r)) return !1;
			for (let e in n) if (n.hasOwnProperty(e) && (r[e] === void 0 || !ka(n[e], r[e]))) return !1;
			return !0;
		}(e, t);
		default: return A();
	}
}
function Aa(e, t) {
	return (e.values || []).find(((e) => ka(e, t))) !== void 0;
}
function ja(e, t) {
	if (e === t) return 0;
	let n = Oa(e), r = Oa(t);
	if (n !== r) return F(n, r);
	switch (n) {
		case 0:
		case 9007199254740991: return 0;
		case 1: return F(e.booleanValue, t.booleanValue);
		case 2: return function(e, t) {
			let n = H(e.integerValue || e.doubleValue), r = H(t.integerValue || t.doubleValue);
			return n < r ? -1 : n > r ? 1 : n === r ? 0 : isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
		}(e, t);
		case 3: return Ma(e.timestampValue, t.timestampValue);
		case 4: return Ma(wa(e), wa(t));
		case 5: return F(e.stringValue, t.stringValue);
		case 6: return function(e, t) {
			let n = xa(e), r = xa(t);
			return n.compareTo(r);
		}(e.bytesValue, t.bytesValue);
		case 7: return function(e, t) {
			let n = e.split("/"), r = t.split("/");
			for (let e = 0; e < n.length && e < r.length; e++) {
				let t = F(n[e], r[e]);
				if (t !== 0) return t;
			}
			return F(n.length, r.length);
		}(e.referenceValue, t.referenceValue);
		case 8: return function(e, t) {
			let n = F(H(e.latitude), H(t.latitude));
			return n === 0 ? F(H(e.longitude), H(t.longitude)) : n;
		}(e.geoPointValue, t.geoPointValue);
		case 9: return Na(e.arrayValue, t.arrayValue);
		case 10: return function(e, t) {
			let n = e.fields || {}, r = t.fields || {}, i = n.value?.arrayValue, a = r.value?.arrayValue, o = F(i?.values?.length || 0, a?.values?.length || 0);
			return o === 0 ? Na(i, a) : o;
		}(e.mapValue, t.mapValue);
		case 11: return function(e, t) {
			if (e === Da.mapValue && t === Da.mapValue) return 0;
			if (e === Da.mapValue) return 1;
			if (t === Da.mapValue) return -1;
			let n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, a = Object.keys(i);
			r.sort(), a.sort();
			for (let e = 0; e < r.length && e < a.length; ++e) {
				let t = F(r[e], a[e]);
				if (t !== 0) return t;
				let o = ja(n[r[e]], i[a[e]]);
				if (o !== 0) return o;
			}
			return F(r.length, a.length);
		}(e.mapValue, t.mapValue);
		default: throw A();
	}
}
function Ma(e, t) {
	if (typeof e == "string" && typeof t == "string" && e.length === t.length) return F(e, t);
	let n = ba(e), r = ba(t), i = F(n.seconds, r.seconds);
	return i === 0 ? F(n.nanos, r.nanos) : i;
}
function Na(e, t) {
	let n = e.values || [], r = t.values || [];
	for (let e = 0; e < n.length && e < r.length; ++e) {
		let t = ja(n[e], r[e]);
		if (t) return t;
	}
	return F(n.length, r.length);
}
function Pa(e) {
	return Fa(e);
}
function Fa(e) {
	return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(e) {
		let t = ba(e);
		return `time(${t.seconds},${t.nanos})`;
	}(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function(e) {
		return xa(e).toBase64();
	}(e.bytesValue) : "referenceValue" in e ? function(e) {
		return z.fromName(e).toString();
	}(e.referenceValue) : "geoPointValue" in e ? function(e) {
		return `geo(${e.latitude},${e.longitude})`;
	}(e.geoPointValue) : "arrayValue" in e ? function(e) {
		let t = "[", n = !0;
		for (let r of e.values || []) n ? n = !1 : t += ",", t += Fa(r);
		return t + "]";
	}(e.arrayValue) : "mapValue" in e ? function(e) {
		let t = Object.keys(e.fields || {}).sort(), n = "{", r = !0;
		for (let i of t) r ? r = !1 : n += ",", n += `${i}:${Fa(e.fields[i])}`;
		return n + "}";
	}(e.mapValue) : A();
}
function Ia(e) {
	switch (Oa(e)) {
		case 0:
		case 1: return 4;
		case 2: return 8;
		case 3:
		case 8: return 16;
		case 4:
			let t = Ca(e);
			return t ? 16 + Ia(t) : 16;
		case 5: return 2 * e.stringValue.length;
		case 6: return xa(e.bytesValue).approximateByteSize();
		case 7: return e.referenceValue.length;
		case 9: return function(e) {
			return (e.values || []).reduce(((e, t) => e + Ia(t)), 0);
		}(e.arrayValue);
		case 10:
		case 11: return function(e) {
			let t = 0;
			return la(e.fields, ((e, n) => {
				t += e.length + Ia(n);
			})), t;
		}(e.mapValue);
		default: throw A();
	}
}
function La(e, t) {
	return { referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}` };
}
function Ra(e) {
	return !!e && "integerValue" in e;
}
function za(e) {
	return !!e && "arrayValue" in e;
}
function Ba(e) {
	return !!e && "nullValue" in e;
}
function Va(e) {
	return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
function Ha(e) {
	return !!e && "mapValue" in e;
}
function Ua(e) {
	return (e?.mapValue?.fields || {}).__type__?.stringValue === "__vector__";
}
function Wa(e) {
	if (e.geoPointValue) return { geoPointValue: Object.assign({}, e.geoPointValue) };
	if (e.timestampValue && typeof e.timestampValue == "object") return { timestampValue: Object.assign({}, e.timestampValue) };
	if (e.mapValue) {
		let t = { mapValue: { fields: {} } };
		return la(e.mapValue.fields, ((e, n) => t.mapValue.fields[e] = Wa(n))), t;
	}
	if (e.arrayValue) {
		let t = { arrayValue: { values: [] } };
		for (let n = 0; n < (e.arrayValue.values || []).length; ++n) t.arrayValue.values[n] = Wa(e.arrayValue.values[n]);
		return t;
	}
	return Object.assign({}, e);
}
function Ga(e) {
	return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === "__max__";
}
var Ka = class e {
	constructor(e) {
		this.value = e;
	}
	static empty() {
		return new e({ mapValue: {} });
	}
	field(e) {
		if (e.isEmpty()) return this.value;
		{
			let t = this.value;
			for (let n = 0; n < e.length - 1; ++n) if (t = (t.mapValue.fields || {})[e.get(n)], !Ha(t)) return null;
			return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
		}
	}
	set(e, t) {
		this.getFieldsMap(e.popLast())[e.lastSegment()] = Wa(t);
	}
	setAll(e) {
		let t = Wi.emptyPath(), n = {}, r = [];
		e.forEach(((e, i) => {
			if (!t.isImmediateParentOf(i)) {
				let e = this.getFieldsMap(t);
				this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
			}
			e ? n[i.lastSegment()] = Wa(e) : r.push(i.lastSegment());
		}));
		let i = this.getFieldsMap(t);
		this.applyChanges(i, n, r);
	}
	delete(e) {
		let t = this.field(e.popLast());
		Ha(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
	}
	isEqual(e) {
		return ka(this.value, e.value);
	}
	getFieldsMap(e) {
		let t = this.value;
		t.mapValue.fields || (t.mapValue = { fields: {} });
		for (let n = 0; n < e.length; ++n) {
			let r = t.mapValue.fields[e.get(n)];
			Ha(r) && r.mapValue.fields || (r = { mapValue: { fields: {} } }, t.mapValue.fields[e.get(n)] = r), t = r;
		}
		return t.mapValue.fields;
	}
	applyChanges(e, t, n) {
		la(t, ((t, n) => e[t] = n));
		for (let t of n) delete e[t];
	}
	clone() {
		return new e(Wa(this.value));
	}
};
function qa(e) {
	let t = [];
	return la(e.fields, ((e, n) => {
		let r = new Wi([e]);
		if (Ha(n)) {
			let e = qa(n.mapValue).fields;
			if (e.length === 0) t.push(r);
			else for (let n of e) t.push(r.child(n));
		} else t.push(r);
	})), new ga(t);
}
var Ja = class e {
	constructor(e, t, n, r, i, a, o) {
		this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = a, this.documentState = o;
	}
	static newInvalidDocument(t) {
		return new e(t, 0, L.min(), L.min(), L.min(), Ka.empty(), 0);
	}
	static newFoundDocument(t, n, r, i) {
		return new e(t, 1, n, L.min(), r, i, 0);
	}
	static newNoDocument(t, n) {
		return new e(t, 2, n, L.min(), L.min(), Ka.empty(), 0);
	}
	static newUnknownDocument(t, n) {
		return new e(t, 3, n, L.min(), L.min(), Ka.empty(), 2);
	}
	convertToFoundDocument(e, t) {
		return !this.createTime.isEqual(L.min()) || this.documentType !== 2 && this.documentType !== 0 || (this.createTime = e), this.version = e, this.documentType = 1, this.data = t, this.documentState = 0, this;
	}
	convertToNoDocument(e) {
		return this.version = e, this.documentType = 2, this.data = Ka.empty(), this.documentState = 0, this;
	}
	convertToUnknownDocument(e) {
		return this.version = e, this.documentType = 3, this.data = Ka.empty(), this.documentState = 2, this;
	}
	setHasCommittedMutations() {
		return this.documentState = 2, this;
	}
	setHasLocalMutations() {
		return this.documentState = 1, this.version = L.min(), this;
	}
	setReadTime(e) {
		return this.readTime = e, this;
	}
	get hasLocalMutations() {
		return this.documentState === 1;
	}
	get hasCommittedMutations() {
		return this.documentState === 2;
	}
	get hasPendingWrites() {
		return this.hasLocalMutations || this.hasCommittedMutations;
	}
	isValidDocument() {
		return this.documentType !== 0;
	}
	isFoundDocument() {
		return this.documentType === 1;
	}
	isNoDocument() {
		return this.documentType === 2;
	}
	isUnknownDocument() {
		return this.documentType === 3;
	}
	isEqual(t) {
		return t instanceof e && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
	}
	mutableCopy() {
		return new e(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
	}
	toString() {
		return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
	}
}, Ya = class {
	constructor(e, t) {
		this.position = e, this.inclusive = t;
	}
};
function Xa(e, t, n) {
	let r = 0;
	for (let i = 0; i < e.position.length; i++) {
		let a = t[i], o = e.position[i];
		if (r = a.field.isKeyField() ? z.comparator(z.fromName(o.referenceValue), n.key) : ja(o, n.data.field(a.field)), a.dir === "desc" && (r *= -1), r !== 0) break;
	}
	return r;
}
function Za(e, t) {
	if (e === null) return t === null;
	if (t === null || e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
	for (let n = 0; n < e.position.length; n++) if (!ka(e.position[n], t.position[n])) return !1;
	return !0;
}
var Qa = class {
	constructor(e, t = "asc") {
		this.field = e, this.dir = t;
	}
};
function $a(e, t) {
	return e.dir === t.dir && e.field.isEqual(t.field);
}
var eo = class {}, U = class e extends eo {
	constructor(e, t, n) {
		super(), this.field = e, this.op = t, this.value = n;
	}
	static create(t, n, r) {
		return t.isKeyField() ? n === "in" || n === "not-in" ? this.createKeyFieldInFilter(t, n, r) : new co(t, n, r) : n === "array-contains" ? new po(t, r) : n === "in" ? new mo(t, r) : n === "not-in" ? new ho(t, r) : n === "array-contains-any" ? new go(t, r) : new e(t, n, r);
	}
	static createKeyFieldInFilter(e, t, n) {
		return t === "in" ? new lo(e, n) : new uo(e, n);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return this.op === "!=" ? t !== null && this.matchesComparison(ja(t, this.value)) : t !== null && Oa(this.value) === Oa(t) && this.matchesComparison(ja(t, this.value));
	}
	matchesComparison(e) {
		switch (this.op) {
			case "<": return e < 0;
			case "<=": return e <= 0;
			case "==": return e === 0;
			case "!=": return e !== 0;
			case ">": return e > 0;
			case ">=": return e >= 0;
			default: return A();
		}
	}
	isInequality() {
		return [
			"<",
			"<=",
			">",
			">=",
			"!=",
			"not-in"
		].indexOf(this.op) >= 0;
	}
	getFlattenedFilters() {
		return [this];
	}
	getFilters() {
		return [this];
	}
}, to = class e extends eo {
	constructor(e, t) {
		super(), this.filters = e, this.op = t, this.ae = null;
	}
	static create(t, n) {
		return new e(t, n);
	}
	matches(e) {
		return no(this) ? this.filters.find(((t) => !t.matches(e))) === void 0 : this.filters.find(((t) => t.matches(e))) !== void 0;
	}
	getFlattenedFilters() {
		return this.ae !== null || (this.ae = this.filters.reduce(((e, t) => e.concat(t.getFlattenedFilters())), [])), this.ae;
	}
	getFilters() {
		return Object.assign([], this.filters);
	}
};
function no(e) {
	return e.op === "and";
}
function ro(e) {
	return io(e) && no(e);
}
function io(e) {
	for (let t of e.filters) if (t instanceof to) return !1;
	return !0;
}
function ao(e) {
	if (e instanceof U) return e.field.canonicalString() + e.op.toString() + Pa(e.value);
	if (ro(e)) return e.filters.map(((e) => ao(e))).join(",");
	{
		let t = e.filters.map(((e) => ao(e))).join(",");
		return `${e.op}(${t})`;
	}
}
function oo(e, t) {
	return e instanceof U ? function(e, t) {
		return t instanceof U && e.op === t.op && e.field.isEqual(t.field) && ka(e.value, t.value);
	}(e, t) : e instanceof to ? function(e, t) {
		return t instanceof to && e.op === t.op && e.filters.length === t.filters.length ? e.filters.reduce(((e, n, r) => e && oo(n, t.filters[r])), !0) : !1;
	}(e, t) : void A();
}
function so(e) {
	return e instanceof U ? function(e) {
		return `${e.field.canonicalString()} ${e.op} ${Pa(e.value)}`;
	}(e) : e instanceof to ? function(e) {
		return e.op.toString() + " {" + e.getFilters().map(so).join(" ,") + "}";
	}(e) : "Filter";
}
var co = class extends U {
	constructor(e, t, n) {
		super(e, t, n), this.key = z.fromName(n.referenceValue);
	}
	matches(e) {
		let t = z.comparator(e.key, this.key);
		return this.matchesComparison(t);
	}
}, lo = class extends U {
	constructor(e, t) {
		super(e, "in", t), this.keys = fo("in", t);
	}
	matches(e) {
		return this.keys.some(((t) => t.isEqual(e.key)));
	}
}, uo = class extends U {
	constructor(e, t) {
		super(e, "not-in", t), this.keys = fo("not-in", t);
	}
	matches(e) {
		return !this.keys.some(((t) => t.isEqual(e.key)));
	}
};
function fo(e, t) {
	return (t.arrayValue?.values || []).map(((e) => z.fromName(e.referenceValue)));
}
var po = class extends U {
	constructor(e, t) {
		super(e, "array-contains", t);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return za(t) && Aa(t.arrayValue, this.value);
	}
}, mo = class extends U {
	constructor(e, t) {
		super(e, "in", t);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return t !== null && Aa(this.value.arrayValue, t);
	}
}, ho = class extends U {
	constructor(e, t) {
		super(e, "not-in", t);
	}
	matches(e) {
		if (Aa(this.value.arrayValue, { nullValue: "NULL_VALUE" })) return !1;
		let t = e.data.field(this.field);
		return t !== null && !Aa(this.value.arrayValue, t);
	}
}, go = class extends U {
	constructor(e, t) {
		super(e, "array-contains-any", t);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return !(!za(t) || !t.arrayValue.values) && t.arrayValue.values.some(((e) => Aa(this.value.arrayValue, e)));
	}
}, _o = class {
	constructor(e, t = null, n = [], r = [], i = null, a = null, o = null) {
		this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = a, this.endAt = o, this.ue = null;
	}
};
function vo(e, t = null, n = [], r = [], i = null, a = null, o = null) {
	return new _o(e, t, n, r, i, a, o);
}
function yo(e) {
	let t = M(e);
	if (t.ue === null) {
		let e = t.path.canonicalString();
		t.collectionGroup !== null && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map(((e) => ao(e))).join(","), e += "|ob:", e += t.orderBy.map(((e) => function(e) {
			return e.field.canonicalString() + e.dir;
		}(e))).join(","), na(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map(((e) => Pa(e))).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map(((e) => Pa(e))).join(",")), t.ue = e;
	}
	return t.ue;
}
function bo(e, t) {
	if (e.limit !== t.limit || e.orderBy.length !== t.orderBy.length) return !1;
	for (let n = 0; n < e.orderBy.length; n++) if (!$a(e.orderBy[n], t.orderBy[n])) return !1;
	if (e.filters.length !== t.filters.length) return !1;
	for (let n = 0; n < e.filters.length; n++) if (!oo(e.filters[n], t.filters[n])) return !1;
	return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!Za(e.startAt, t.startAt) && Za(e.endAt, t.endAt);
}
function xo(e) {
	return z.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
}
var So = class {
	constructor(e, t = null, n = [], r = [], i = null, a = "F", o = null, s = null) {
		this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = a, this.startAt = o, this.endAt = s, this.ce = null, this.le = null, this.he = null, this.startAt, this.endAt;
	}
};
function Co(e, t, n, r, i, a, o, s) {
	return new So(e, t, n, r, i, a, o, s);
}
function wo(e) {
	return new So(e);
}
function To(e) {
	return e.filters.length === 0 && e.limit === null && e.startAt == null && e.endAt == null && (e.explicitOrderBy.length === 0 || e.explicitOrderBy.length === 1 && e.explicitOrderBy[0].field.isKeyField());
}
function Eo(e) {
	return e.collectionGroup !== null;
}
function Do(e) {
	let t = M(e);
	if (t.ce === null) {
		t.ce = [];
		let e = /* @__PURE__ */ new Set();
		for (let n of t.explicitOrderBy) t.ce.push(n), e.add(n.field.canonicalString());
		let n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc";
		(function(e) {
			let t = new ma(Wi.comparator);
			return e.filters.forEach(((e) => {
				e.getFlattenedFilters().forEach(((e) => {
					e.isInequality() && (t = t.add(e.field));
				}));
			})), t;
		})(t).forEach(((r) => {
			e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new Qa(r, n));
		})), e.has(Wi.keyField().canonicalString()) || t.ce.push(new Qa(Wi.keyField(), n));
	}
	return t.ce;
}
function Oo(e) {
	let t = M(e);
	return t.le ||= Ao(t, Do(e)), t.le;
}
function ko(e) {
	let t = M(e);
	return t.he ||= Ao(t, e.explicitOrderBy), t.he;
}
function Ao(e, t) {
	if (e.limitType === "F") return vo(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
	{
		t = t.map(((e) => {
			let t = e.dir === "desc" ? "asc" : "desc";
			return new Qa(e.field, t);
		}));
		let n = e.endAt ? new Ya(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Ya(e.startAt.position, e.startAt.inclusive) : null;
		return vo(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
	}
}
function jo(e, t) {
	let n = e.filters.concat([t]);
	return new So(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function Mo(e, t, n) {
	return new So(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function No(e, t) {
	return bo(Oo(e), Oo(t)) && e.limitType === t.limitType;
}
function Po(e) {
	return `${yo(Oo(e))}|lt:${e.limitType}`;
}
function Fo(e) {
	return `Query(target=${function(e) {
		let t = e.path.canonicalString();
		return e.collectionGroup !== null && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map(((e) => so(e))).join(", ")}]`), na(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map(((e) => function(e) {
			return `${e.field.canonicalString()} (${e.dir})`;
		}(e))).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map(((e) => Pa(e))).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map(((e) => Pa(e))).join(",")), `Target(${t})`;
	}(Oo(e))}; limitType=${e.limitType})`;
}
function Io(e, t) {
	return t.isFoundDocument() && function(e, t) {
		let n = t.key.path;
		return e.collectionGroup === null ? z.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n) : t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n);
	}(e, t) && function(e, t) {
		for (let n of Do(e)) if (!n.field.isKeyField() && t.data.field(n.field) === null) return !1;
		return !0;
	}(e, t) && function(e, t) {
		for (let n of e.filters) if (!n.matches(t)) return !1;
		return !0;
	}(e, t) && function(e, t) {
		return !(e.startAt && !function(e, t, n) {
			let r = Xa(e, t, n);
			return e.inclusive ? r <= 0 : r < 0;
		}(e.startAt, Do(e), t) || e.endAt && !function(e, t, n) {
			let r = Xa(e, t, n);
			return e.inclusive ? r >= 0 : r > 0;
		}(e.endAt, Do(e), t));
	}(e, t);
}
function Lo(e) {
	return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
function Ro(e) {
	return (t, n) => {
		let r = !1;
		for (let i of Do(e)) {
			let e = zo(i, t, n);
			if (e !== 0) return e;
			r ||= i.field.isKeyField();
		}
		return 0;
	};
}
function zo(e, t, n) {
	let r = e.field.isKeyField() ? z.comparator(t.key, n.key) : function(e, t, n) {
		let r = t.data.field(e), i = n.data.field(e);
		return r !== null && i !== null ? ja(r, i) : A();
	}(e.field, t, n);
	switch (e.dir) {
		case "asc": return r;
		case "desc": return -1 * r;
		default: return A();
	}
}
var Bo = class {
	constructor(e, t) {
		this.mapKeyFn = e, this.equalsFn = t, this.inner = {}, this.innerSize = 0;
	}
	get(e) {
		let t = this.mapKeyFn(e), n = this.inner[t];
		if (n !== void 0) {
			for (let [t, r] of n) if (this.equalsFn(t, e)) return r;
		}
	}
	has(e) {
		return this.get(e) !== void 0;
	}
	set(e, t) {
		let n = this.mapKeyFn(e), r = this.inner[n];
		if (r === void 0) return this.inner[n] = [[e, t]], void this.innerSize++;
		for (let n = 0; n < r.length; n++) if (this.equalsFn(r[n][0], e)) return void (r[n] = [e, t]);
		r.push([e, t]), this.innerSize++;
	}
	delete(e) {
		let t = this.mapKeyFn(e), n = this.inner[t];
		if (n === void 0) return !1;
		for (let r = 0; r < n.length; r++) if (this.equalsFn(n[r][0], e)) return n.length === 1 ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
		return !1;
	}
	forEach(e) {
		la(this.inner, ((t, n) => {
			for (let [t, r] of n) e(t, r);
		}));
	}
	isEmpty() {
		return da(this.inner);
	}
	size() {
		return this.innerSize;
	}
}, Vo = new V(z.comparator);
function Ho() {
	return Vo;
}
var Uo = new V(z.comparator);
function Wo(...e) {
	let t = Uo;
	for (let n of e) t = t.insert(n.key, n);
	return t;
}
function Go(e) {
	let t = Uo;
	return e.forEach(((e, n) => t = t.insert(e, n.overlayedDocument))), t;
}
function Ko() {
	return Jo();
}
function qo() {
	return Jo();
}
function Jo() {
	return new Bo(((e) => e.toString()), ((e, t) => e.isEqual(t)));
}
var Yo = new V(z.comparator), Xo = new ma(z.comparator);
function W(...e) {
	let t = Xo;
	for (let n of e) t = t.add(n);
	return t;
}
var Zo = new ma(F);
function Qo() {
	return Zo;
}
function $o(e, t) {
	if (e.useProto3Json) {
		if (isNaN(t)) return { doubleValue: "NaN" };
		if (t === Infinity) return { doubleValue: "Infinity" };
		if (t === -Infinity) return { doubleValue: "-Infinity" };
	}
	return { doubleValue: ra(t) ? "-0" : t };
}
function es(e) {
	return { integerValue: "" + e };
}
function ts(e, t) {
	return ia(t) ? es(t) : $o(e, t);
}
var ns = class {
	constructor() {
		this._ = void 0;
	}
};
function rs(e, t, n) {
	return e instanceof os ? function(e, t) {
		let n = { fields: {
			__type__: { stringValue: "server_timestamp" },
			__local_write_time__: { timestampValue: {
				seconds: e.seconds,
				nanos: e.nanoseconds
			} }
		} };
		return t && Sa(t) && (t = Ca(t)), t && (n.fields.__previous_value__ = t), { mapValue: n };
	}(n, t) : e instanceof ss ? cs(e, t) : e instanceof ls ? us(e, t) : function(e, t) {
		let n = as(e, t), r = fs(n) + fs(e.Pe);
		return Ra(n) && Ra(e.Pe) ? es(r) : $o(e.serializer, r);
	}(e, t);
}
function is(e, t, n) {
	return e instanceof ss ? cs(e, t) : e instanceof ls ? us(e, t) : n;
}
function as(e, t) {
	return e instanceof ds ? function(e) {
		return Ra(e) || function(e) {
			return !!e && "doubleValue" in e;
		}(e);
	}(t) ? t : { integerValue: 0 } : null;
}
var os = class extends ns {}, ss = class extends ns {
	constructor(e) {
		super(), this.elements = e;
	}
};
function cs(e, t) {
	let n = ps(t);
	for (let t of e.elements) n.some(((e) => ka(e, t))) || n.push(t);
	return { arrayValue: { values: n } };
}
var ls = class extends ns {
	constructor(e) {
		super(), this.elements = e;
	}
};
function us(e, t) {
	let n = ps(t);
	for (let t of e.elements) n = n.filter(((e) => !ka(e, t)));
	return { arrayValue: { values: n } };
}
var ds = class extends ns {
	constructor(e, t) {
		super(), this.serializer = e, this.Pe = t;
	}
};
function fs(e) {
	return H(e.integerValue || e.doubleValue);
}
function ps(e) {
	return za(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
var ms = class {
	constructor(e, t) {
		this.field = e, this.transform = t;
	}
};
function hs(e, t) {
	return e.field.isEqual(t.field) && function(e, t) {
		return e instanceof ss && t instanceof ss || e instanceof ls && t instanceof ls ? Vi(e.elements, t.elements, ka) : e instanceof ds && t instanceof ds ? ka(e.Pe, t.Pe) : e instanceof os && t instanceof os;
	}(e.transform, t.transform);
}
var gs = class {
	constructor(e, t) {
		this.version = e, this.transformResults = t;
	}
}, _s = class e {
	constructor(e, t) {
		this.updateTime = e, this.exists = t;
	}
	static none() {
		return new e();
	}
	static exists(t) {
		return new e(void 0, t);
	}
	static updateTime(t) {
		return new e(t);
	}
	get isNone() {
		return this.updateTime === void 0 && this.exists === void 0;
	}
	isEqual(e) {
		return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
	}
};
function vs(e, t) {
	return e.updateTime === void 0 ? e.exists === void 0 || e.exists === t.isFoundDocument() : t.isFoundDocument() && t.version.isEqual(e.updateTime);
}
var ys = class {};
function bs(e, t) {
	if (!e.hasLocalMutations || t && t.fields.length === 0) return null;
	if (t === null) return e.isNoDocument() ? new As(e.key, _s.none()) : new Ts(e.key, e.data, _s.none());
	{
		let n = e.data, r = Ka.empty(), i = new ma(Wi.comparator);
		for (let e of t.fields) if (!i.has(e)) {
			let t = n.field(e);
			t === null && e.length > 1 && (e = e.popLast(), t = n.field(e)), t === null ? r.delete(e) : r.set(e, t), i = i.add(e);
		}
		return new Es(e.key, r, new ga(i.toArray()), _s.none());
	}
}
function xs(e, t, n) {
	e instanceof Ts ? function(e, t, n) {
		let r = e.value.clone(), i = Os(e.fieldTransforms, t, n.transformResults);
		r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
	}(e, t, n) : e instanceof Es ? function(e, t, n) {
		if (!vs(e.precondition, t)) return void t.convertToUnknownDocument(n.version);
		let r = Os(e.fieldTransforms, t, n.transformResults), i = t.data;
		i.setAll(Ds(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
	}(e, t, n) : function(e, t, n) {
		t.convertToNoDocument(n.version).setHasCommittedMutations();
	}(0, t, n);
}
function Ss(e, t, n, r) {
	return e instanceof Ts ? function(e, t, n, r) {
		if (!vs(e.precondition, t)) return n;
		let i = e.value.clone(), a = ks(e.fieldTransforms, r, t);
		return i.setAll(a), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
	}(e, t, n, r) : e instanceof Es ? function(e, t, n, r) {
		if (!vs(e.precondition, t)) return n;
		let i = ks(e.fieldTransforms, r, t), a = t.data;
		return a.setAll(Ds(e)), a.setAll(i), t.convertToFoundDocument(t.version, a).setHasLocalMutations(), n === null ? null : n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map(((e) => e.field)));
	}(e, t, n, r) : function(e, t, n) {
		return vs(e.precondition, t) ? (t.convertToNoDocument(t.version).setHasLocalMutations(), null) : n;
	}(e, t, n);
}
function Cs(e, t) {
	let n = null;
	for (let r of e.fieldTransforms) {
		let e = t.data.field(r.field), i = as(r.transform, e || null);
		i != null && (n === null && (n = Ka.empty()), n.set(r.field, i));
	}
	return n || null;
}
function ws(e, t) {
	return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function(e, t) {
		return e === void 0 && t === void 0 || !(!e || !t) && Vi(e, t, ((e, t) => hs(e, t)));
	}(e.fieldTransforms, t.fieldTransforms) && (e.type === 0 ? e.value.isEqual(t.value) : e.type !== 1 || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
var Ts = class extends ys {
	constructor(e, t, n, r = []) {
		super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0;
	}
	getFieldMask() {
		return null;
	}
}, Es = class extends ys {
	constructor(e, t, n, r, i = []) {
		super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1;
	}
	getFieldMask() {
		return this.fieldMask;
	}
};
function Ds(e) {
	let t = /* @__PURE__ */ new Map();
	return e.fieldMask.fields.forEach(((n) => {
		if (!n.isEmpty()) {
			let r = e.data.field(n);
			t.set(n, r);
		}
	})), t;
}
function Os(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	j(e.length === n.length);
	for (let i = 0; i < n.length; i++) {
		let a = e[i], o = a.transform, s = t.data.field(a.field);
		r.set(a.field, is(o, s, n[i]));
	}
	return r;
}
function ks(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let i of e) {
		let e = i.transform, a = n.data.field(i.field);
		r.set(i.field, rs(e, a, t));
	}
	return r;
}
var As = class extends ys {
	constructor(e, t) {
		super(), this.key = e, this.precondition = t, this.type = 2, this.fieldTransforms = [];
	}
	getFieldMask() {
		return null;
	}
}, js = class extends ys {
	constructor(e, t) {
		super(), this.key = e, this.precondition = t, this.type = 3, this.fieldTransforms = [];
	}
	getFieldMask() {
		return null;
	}
}, Ms = class {
	constructor(e, t, n, r) {
		this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
	}
	applyToRemoteDocument(e, t) {
		let n = t.mutationResults;
		for (let t = 0; t < this.mutations.length; t++) {
			let r = this.mutations[t];
			r.key.isEqual(e.key) && xs(r, e, n[t]);
		}
	}
	applyToLocalView(e, t) {
		for (let n of this.baseMutations) n.key.isEqual(e.key) && (t = Ss(n, e, t, this.localWriteTime));
		for (let n of this.mutations) n.key.isEqual(e.key) && (t = Ss(n, e, t, this.localWriteTime));
		return t;
	}
	applyToLocalDocumentSet(e, t) {
		let n = qo();
		return this.mutations.forEach(((r) => {
			let i = e.get(r.key), a = i.overlayedDocument, o = this.applyToLocalView(a, i.mutatedFields);
			o = t.has(r.key) ? null : o;
			let s = bs(a, o);
			s !== null && n.set(r.key, s), a.isValidDocument() || a.convertToNoDocument(L.min());
		})), n;
	}
	keys() {
		return this.mutations.reduce(((e, t) => e.add(t.key)), W());
	}
	isEqual(e) {
		return this.batchId === e.batchId && Vi(this.mutations, e.mutations, ((e, t) => ws(e, t))) && Vi(this.baseMutations, e.baseMutations, ((e, t) => ws(e, t)));
	}
}, Ns = class e {
	constructor(e, t, n, r) {
		this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
	}
	static from(t, n, r) {
		j(t.mutations.length === r.length);
		let i = function() {
			return Yo;
		}(), a = t.mutations;
		for (let e = 0; e < a.length; e++) i = i.insert(a[e].key, r[e].version);
		return new e(t, n, r, i);
	}
}, Ps = class {
	constructor(e, t) {
		this.largestBatchId = e, this.mutation = t;
	}
	getKey() {
		return this.mutation.key;
	}
	isEqual(e) {
		return e !== null && this.mutation === e.mutation;
	}
	toString() {
		return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
	}
}, Fs = class {
	constructor(e, t, n) {
		this.alias = e, this.aggregateType = t, this.fieldPath = n;
	}
}, Is = class {
	constructor(e, t) {
		this.count = e, this.unchangedNames = t;
	}
}, G, K;
function Ls(e) {
	switch (e) {
		default: return A();
		case N.CANCELLED:
		case N.UNKNOWN:
		case N.DEADLINE_EXCEEDED:
		case N.RESOURCE_EXHAUSTED:
		case N.INTERNAL:
		case N.UNAVAILABLE:
		case N.UNAUTHENTICATED: return !1;
		case N.INVALID_ARGUMENT:
		case N.NOT_FOUND:
		case N.ALREADY_EXISTS:
		case N.PERMISSION_DENIED:
		case N.FAILED_PRECONDITION:
		case N.ABORTED:
		case N.OUT_OF_RANGE:
		case N.UNIMPLEMENTED:
		case N.DATA_LOSS: return !0;
	}
}
function Rs(e) {
	if (e === void 0) return Di("GRPC error has no .code"), N.UNKNOWN;
	switch (e) {
		case G.OK: return N.OK;
		case G.CANCELLED: return N.CANCELLED;
		case G.UNKNOWN: return N.UNKNOWN;
		case G.DEADLINE_EXCEEDED: return N.DEADLINE_EXCEEDED;
		case G.RESOURCE_EXHAUSTED: return N.RESOURCE_EXHAUSTED;
		case G.INTERNAL: return N.INTERNAL;
		case G.UNAVAILABLE: return N.UNAVAILABLE;
		case G.UNAUTHENTICATED: return N.UNAUTHENTICATED;
		case G.INVALID_ARGUMENT: return N.INVALID_ARGUMENT;
		case G.NOT_FOUND: return N.NOT_FOUND;
		case G.ALREADY_EXISTS: return N.ALREADY_EXISTS;
		case G.PERMISSION_DENIED: return N.PERMISSION_DENIED;
		case G.FAILED_PRECONDITION: return N.FAILED_PRECONDITION;
		case G.ABORTED: return N.ABORTED;
		case G.OUT_OF_RANGE: return N.OUT_OF_RANGE;
		case G.UNIMPLEMENTED: return N.UNIMPLEMENTED;
		case G.DATA_LOSS: return N.DATA_LOSS;
		default: return A();
	}
}
(K = G ||= {})[K.OK = 0] = "OK", K[K.CANCELLED = 1] = "CANCELLED", K[K.UNKNOWN = 2] = "UNKNOWN", K[K.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", K[K.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", K[K.NOT_FOUND = 5] = "NOT_FOUND", K[K.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", K[K.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", K[K.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", K[K.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", K[K.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", K[K.ABORTED = 10] = "ABORTED", K[K.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", K[K.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", K[K.INTERNAL = 13] = "INTERNAL", K[K.UNAVAILABLE = 14] = "UNAVAILABLE", K[K.DATA_LOSS = 15] = "DATA_LOSS";
var zs = null;
function Bs() {
	return new TextEncoder();
}
var Vs = new di([4294967295, 4294967295], 0);
function Hs(e) {
	let t = Bs().encode(e), n = new fi();
	return n.update(t), new Uint8Array(n.digest());
}
function Us(e) {
	let t = new DataView(e.buffer), n = t.getUint32(0, !0), r = t.getUint32(4, !0), i = t.getUint32(8, !0), a = t.getUint32(12, !0);
	return [new di([n, r], 0), new di([i, a], 0)];
}
var Ws = class e {
	constructor(e, t, n) {
		if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new Gs(`Invalid padding: ${t}`);
		if (n < 0 || e.length > 0 && this.hashCount === 0) throw new Gs(`Invalid hash count: ${n}`);
		if (e.length === 0 && t !== 0) throw new Gs(`Invalid padding when bitmap length is 0: ${t}`);
		this.Ie = 8 * e.length - t, this.Te = di.fromNumber(this.Ie);
	}
	Ee(e, t, n) {
		let r = e.add(t.multiply(di.fromNumber(n)));
		return r.compare(Vs) === 1 && (r = new di([r.getBits(0), r.getBits(1)], 0)), r.modulo(this.Te).toNumber();
	}
	de(e) {
		return (this.bitmap[Math.floor(e / 8)] & 1 << e % 8) != 0;
	}
	mightContain(e) {
		if (this.Ie === 0) return !1;
		let [t, n] = Us(Hs(e));
		for (let e = 0; e < this.hashCount; e++) {
			let r = this.Ee(t, n, e);
			if (!this.de(r)) return !1;
		}
		return !0;
	}
	static create(t, n, r) {
		let i = t % 8 == 0 ? 0 : 8 - t % 8, a = new e(new Uint8Array(Math.ceil(t / 8)), i, n);
		return r.forEach(((e) => a.insert(e))), a;
	}
	insert(e) {
		if (this.Ie === 0) return;
		let [t, n] = Us(Hs(e));
		for (let e = 0; e < this.hashCount; e++) {
			let r = this.Ee(t, n, e);
			this.Ae(r);
		}
	}
	Ae(e) {
		let t = Math.floor(e / 8), n = e % 8;
		this.bitmap[t] |= 1 << n;
	}
}, Gs = class extends Error {
	constructor() {
		super(...arguments), this.name = "BloomFilterError";
	}
}, Ks = class e {
	constructor(e, t, n, r, i) {
		this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
	}
	static createSynthesizedRemoteEventForCurrentChange(t, n, r) {
		let i = /* @__PURE__ */ new Map();
		return i.set(t, qs.createSynthesizedTargetChangeForCurrentChange(t, n, r)), new e(L.min(), i, new V(F), Ho(), W());
	}
}, qs = class e {
	constructor(e, t, n, r, i) {
		this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
	}
	static createSynthesizedTargetChangeForCurrentChange(t, n, r) {
		return new e(r, n, W(), W(), W());
	}
}, Js = class {
	constructor(e, t, n, r) {
		this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
	}
}, Ys = class {
	constructor(e, t) {
		this.targetId = e, this.me = t;
	}
}, Xs = class {
	constructor(e, t, n = va.EMPTY_BYTE_STRING, r = null) {
		this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
	}
}, Zs = class {
	constructor() {
		this.fe = 0, this.ge = ec(), this.pe = va.EMPTY_BYTE_STRING, this.ye = !1, this.we = !0;
	}
	get current() {
		return this.ye;
	}
	get resumeToken() {
		return this.pe;
	}
	get Se() {
		return this.fe !== 0;
	}
	get be() {
		return this.we;
	}
	De(e) {
		e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
	}
	ve() {
		let e = W(), t = W(), n = W();
		return this.ge.forEach(((r, i) => {
			switch (i) {
				case 0:
					e = e.add(r);
					break;
				case 2:
					t = t.add(r);
					break;
				case 1:
					n = n.add(r);
					break;
				default: A();
			}
		})), new qs(this.pe, this.ye, e, t, n);
	}
	Ce() {
		this.we = !1, this.ge = ec();
	}
	Fe(e, t) {
		this.we = !0, this.ge = this.ge.insert(e, t);
	}
	Me(e) {
		this.we = !0, this.ge = this.ge.remove(e);
	}
	xe() {
		this.fe += 1;
	}
	Oe() {
		--this.fe, j(this.fe >= 0);
	}
	Ne() {
		this.we = !0, this.ye = !0;
	}
}, Qs = class {
	constructor(e) {
		this.Le = e, this.Be = /* @__PURE__ */ new Map(), this.ke = Ho(), this.qe = $s(), this.Qe = new V(F);
	}
	Ke(e) {
		for (let t of e.Re) e.Ve && e.Ve.isFoundDocument() ? this.$e(t, e.Ve) : this.Ue(t, e.key, e.Ve);
		for (let t of e.removedTargetIds) this.Ue(t, e.key, e.Ve);
	}
	We(e) {
		this.forEachTarget(e, ((t) => {
			let n = this.Ge(t);
			switch (e.state) {
				case 0:
					this.ze(t) && n.De(e.resumeToken);
					break;
				case 1:
					n.Oe(), n.Se || n.Ce(), n.De(e.resumeToken);
					break;
				case 2:
					n.Oe(), n.Se || this.removeTarget(t);
					break;
				case 3:
					this.ze(t) && (n.Ne(), n.De(e.resumeToken));
					break;
				case 4:
					this.ze(t) && (this.je(t), n.De(e.resumeToken));
					break;
				default: A();
			}
		}));
	}
	forEachTarget(e, t) {
		e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach(((e, n) => {
			this.ze(n) && t(n);
		}));
	}
	He(e) {
		let t = e.targetId, n = e.me.count, r = this.Je(t);
		if (r) {
			let i = r.target;
			if (xo(i)) if (n === 0) {
				let e = new z(i.path);
				this.Ue(t, e, Ja.newNoDocument(e, L.min()));
			} else j(n === 1);
			else {
				let r = this.Ye(t);
				if (r !== n) {
					let n = this.Ze(e), i = n ? this.Xe(n, e, r) : 1;
					if (i !== 0) {
						this.je(t);
						let e = i === 2 ? "TargetPurposeExistenceFilterMismatchBloom" : "TargetPurposeExistenceFilterMismatch";
						this.Qe = this.Qe.insert(t, e);
					}
					zs?.et(function(e, t, n, r, i) {
						let a = {
							localCacheCount: e,
							existenceFilterCount: t.count,
							databaseId: n.database,
							projectId: n.projectId
						}, o = t.unchangedNames;
						return o && (a.bloomFilter = {
							applied: i === 0,
							hashCount: o?.hashCount ?? 0,
							bitmapLength: o?.bits?.bitmap?.length ?? 0,
							padding: o?.bits?.padding ?? 0,
							mightContain: (e) => {
								var t;
								return (t = r?.mightContain(e)) != null && t;
							}
						}), a;
					}(r, e.me, this.Le.tt(), n, i));
				}
			}
		}
	}
	Ze(e) {
		let t = e.me.unchangedNames;
		if (!t || !t.bits) return null;
		let { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t, a, o;
		try {
			a = xa(n).toUint8Array();
		} catch (e) {
			if (e instanceof _a) return Oi("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
			throw e;
		}
		try {
			o = new Ws(a, r, i);
		} catch (e) {
			return Oi(e instanceof Gs ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
		}
		return o.Ie === 0 ? null : o;
	}
	Xe(e, t, n) {
		return t.me.count === n - this.nt(e, t.targetId) ? 0 : 2;
	}
	nt(e, t) {
		let n = this.Le.getRemoteKeysForTarget(t), r = 0;
		return n.forEach(((n) => {
			let i = this.Le.tt(), a = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
			e.mightContain(a) || (this.Ue(t, n, null), r++);
		})), r;
	}
	rt(e) {
		let t = /* @__PURE__ */ new Map();
		this.Be.forEach(((n, r) => {
			let i = this.Je(r);
			if (i) {
				if (n.current && xo(i.target)) {
					let t = new z(i.target.path);
					this.ke.get(t) !== null || this.it(r, t) || this.Ue(r, t, Ja.newNoDocument(t, e));
				}
				n.be && (t.set(r, n.ve()), n.Ce());
			}
		}));
		let n = W();
		this.qe.forEach(((e, t) => {
			let r = !0;
			t.forEachWhile(((e) => {
				let t = this.Je(e);
				return !t || t.purpose === "TargetPurposeLimboResolution" || (r = !1, !1);
			})), r && (n = n.add(e));
		})), this.ke.forEach(((t, n) => n.setReadTime(e)));
		let r = new Ks(e, t, this.Qe, this.ke, n);
		return this.ke = Ho(), this.qe = $s(), this.Qe = new V(F), r;
	}
	$e(e, t) {
		if (!this.ze(e)) return;
		let n = this.it(e, t.key) ? 2 : 0;
		this.Ge(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e));
	}
	Ue(e, t, n) {
		if (!this.ze(e)) return;
		let r = this.Ge(e);
		this.it(e, t) ? r.Fe(t, 1) : r.Me(t), this.qe = this.qe.insert(t, this.st(t).delete(e)), n && (this.ke = this.ke.insert(t, n));
	}
	removeTarget(e) {
		this.Be.delete(e);
	}
	Ye(e) {
		let t = this.Ge(e).ve();
		return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
	}
	xe(e) {
		this.Ge(e).xe();
	}
	Ge(e) {
		let t = this.Be.get(e);
		return t || (t = new Zs(), this.Be.set(e, t)), t;
	}
	st(e) {
		let t = this.qe.get(e);
		return t || (t = new ma(F), this.qe = this.qe.insert(e, t)), t;
	}
	ze(e) {
		let t = this.Je(e) !== null;
		return t || k("WatchChangeAggregator", "Detected inactive target", e), t;
	}
	Je(e) {
		let t = this.Be.get(e);
		return t && t.Se ? null : this.Le.ot(e);
	}
	je(e) {
		this.Be.set(e, new Zs()), this.Le.getRemoteKeysForTarget(e).forEach(((t) => {
			this.Ue(e, t, null);
		}));
	}
	it(e, t) {
		return this.Le.getRemoteKeysForTarget(e).has(t);
	}
};
function $s() {
	return new V(z.comparator);
}
function ec() {
	return new V(z.comparator);
}
var tc = {
	asc: "ASCENDING",
	desc: "DESCENDING"
}, nc = {
	"<": "LESS_THAN",
	"<=": "LESS_THAN_OR_EQUAL",
	">": "GREATER_THAN",
	">=": "GREATER_THAN_OR_EQUAL",
	"==": "EQUAL",
	"!=": "NOT_EQUAL",
	"array-contains": "ARRAY_CONTAINS",
	in: "IN",
	"not-in": "NOT_IN",
	"array-contains-any": "ARRAY_CONTAINS_ANY"
}, rc = {
	and: "AND",
	or: "OR"
}, ic = class {
	constructor(e, t) {
		this.databaseId = e, this.useProto3Json = t;
	}
};
function ac(e, t) {
	return e.useProto3Json || na(t) ? t : { value: t };
}
function oc(e, t) {
	return e.useProto3Json ? `${(/* @__PURE__ */ new Date(1e3 * t.seconds)).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z` : {
		seconds: "" + t.seconds,
		nanos: t.nanoseconds
	};
}
function sc(e, t) {
	return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
function cc(e, t) {
	return oc(e, t.toTimestamp());
}
function lc(e) {
	return j(!!e), L.fromTimestamp(function(e) {
		let t = ba(e);
		return new I(t.seconds, t.nanos);
	}(e));
}
function uc(e, t) {
	return dc(e, t).canonicalString();
}
function dc(e, t) {
	let n = function(e) {
		return new R([
			"projects",
			e.projectId,
			"databases",
			e.database
		]);
	}(e).child("documents");
	return t === void 0 ? n : n.child(t);
}
function fc(e) {
	let t = R.fromString(e);
	return j(Lc(t)), t;
}
function pc(e, t) {
	return uc(e.databaseId, t.path);
}
function mc(e, t) {
	let n = fc(t);
	if (n.get(1) !== e.databaseId.projectId) throw new P(N.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
	if (n.get(3) !== e.databaseId.database) throw new P(N.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
	return new z(vc(n));
}
function hc(e, t) {
	return uc(e.databaseId, t);
}
function gc(e) {
	let t = fc(e);
	return t.length === 4 ? R.emptyPath() : vc(t);
}
function _c(e) {
	return new R([
		"projects",
		e.databaseId.projectId,
		"databases",
		e.databaseId.database
	]).canonicalString();
}
function vc(e) {
	return j(e.length > 4 && e.get(4) === "documents"), e.popFirst(5);
}
function yc(e, t, n) {
	return {
		name: pc(e, t),
		fields: n.value.mapValue.fields
	};
}
function bc(e, t) {
	return "found" in t ? function(e, t) {
		j(!!t.found), t.found.name, t.found.updateTime;
		let n = mc(e, t.found.name), r = lc(t.found.updateTime), i = t.found.createTime ? lc(t.found.createTime) : L.min(), a = new Ka({ mapValue: { fields: t.found.fields } });
		return Ja.newFoundDocument(n, r, i, a);
	}(e, t) : "missing" in t ? function(e, t) {
		j(!!t.missing), j(!!t.readTime);
		let n = mc(e, t.missing), r = lc(t.readTime);
		return Ja.newNoDocument(n, r);
	}(e, t) : A();
}
function xc(e, t) {
	let n;
	if ("targetChange" in t) {
		t.targetChange;
		let r = function(e) {
			return e === "NO_CHANGE" ? 0 : e === "ADD" ? 1 : e === "REMOVE" ? 2 : e === "CURRENT" ? 3 : e === "RESET" ? 4 : A();
		}(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], a = function(e, t) {
			return e.useProto3Json ? (j(t === void 0 || typeof t == "string"), va.fromBase64String(t || "")) : (j(t === void 0 || t instanceof Buffer || t instanceof Uint8Array), va.fromUint8Array(t || new Uint8Array()));
		}(e, t.targetChange.resumeToken), o = t.targetChange.cause;
		n = new Xs(r, i, a, o && function(e) {
			return new P(e.code === void 0 ? N.UNKNOWN : Rs(e.code), e.message || "");
		}(o) || null);
	} else if ("documentChange" in t) {
		t.documentChange;
		let r = t.documentChange;
		r.document, r.document.name, r.document.updateTime;
		let i = mc(e, r.document.name), a = lc(r.document.updateTime), o = r.document.createTime ? lc(r.document.createTime) : L.min(), s = new Ka({ mapValue: { fields: r.document.fields } }), c = Ja.newFoundDocument(i, a, o, s);
		n = new Js(r.targetIds || [], r.removedTargetIds || [], c.key, c);
	} else if ("documentDelete" in t) {
		t.documentDelete;
		let r = t.documentDelete;
		r.document;
		let i = mc(e, r.document), a = r.readTime ? lc(r.readTime) : L.min(), o = Ja.newNoDocument(i, a);
		n = new Js([], r.removedTargetIds || [], o.key, o);
	} else if ("documentRemove" in t) {
		t.documentRemove;
		let r = t.documentRemove;
		r.document;
		let i = mc(e, r.document);
		n = new Js([], r.removedTargetIds || [], i, null);
	} else {
		if (!("filter" in t)) return A();
		{
			t.filter;
			let e = t.filter;
			e.targetId;
			let { count: r = 0, unchangedNames: i } = e, a = new Is(r, i), o = e.targetId;
			n = new Ys(o, a);
		}
	}
	return n;
}
function Sc(e, t) {
	let n;
	if (t instanceof Ts) n = { update: yc(e, t.key, t.value) };
	else if (t instanceof As) n = { delete: pc(e, t.key) };
	else if (t instanceof Es) n = {
		update: yc(e, t.key, t.data),
		updateMask: Ic(t.fieldMask)
	};
	else {
		if (!(t instanceof js)) return A();
		n = { verify: pc(e, t.key) };
	}
	return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map(((e) => function(e, t) {
		let n = t.transform;
		if (n instanceof os) return {
			fieldPath: t.field.canonicalString(),
			setToServerValue: "REQUEST_TIME"
		};
		if (n instanceof ss) return {
			fieldPath: t.field.canonicalString(),
			appendMissingElements: { values: n.elements }
		};
		if (n instanceof ls) return {
			fieldPath: t.field.canonicalString(),
			removeAllFromArray: { values: n.elements }
		};
		if (n instanceof ds) return {
			fieldPath: t.field.canonicalString(),
			increment: n.Pe
		};
		throw A();
	}(0, e)))), t.precondition.isNone || (n.currentDocument = function(e, t) {
		return t.updateTime === void 0 ? t.exists === void 0 ? A() : { exists: t.exists } : { updateTime: cc(e, t.updateTime) };
	}(e, t.precondition)), n;
}
function Cc(e, t) {
	return e && e.length > 0 ? (j(t !== void 0), e.map(((e) => function(e, t) {
		let n = e.updateTime ? lc(e.updateTime) : lc(t);
		return n.isEqual(L.min()) && (n = lc(t)), new gs(n, e.transformResults || []);
	}(e, t)))) : [];
}
function wc(e, t) {
	return { documents: [hc(e, t.path)] };
}
function Tc(e, t) {
	let n = { structuredQuery: {} }, r = t.path, i;
	t.collectionGroup === null ? (i = r.popLast(), n.structuredQuery.from = [{ collectionId: r.lastSegment() }]) : (i = r, n.structuredQuery.from = [{
		collectionId: t.collectionGroup,
		allDescendants: !0
	}]), n.parent = hc(e, i);
	let a = function(e) {
		if (e.length !== 0) return Fc(to.create(e, "and"));
	}(t.filters);
	a && (n.structuredQuery.where = a);
	let o = function(e) {
		if (e.length !== 0) return e.map(((e) => function(e) {
			return {
				field: Nc(e.field),
				direction: Ac(e.dir)
			};
		}(e)));
	}(t.orderBy);
	o && (n.structuredQuery.orderBy = o);
	let s = ac(e, t.limit);
	return s !== null && (n.structuredQuery.limit = s), t.startAt && (n.structuredQuery.startAt = function(e) {
		return {
			before: e.inclusive,
			values: e.position
		};
	}(t.startAt)), t.endAt && (n.structuredQuery.endAt = function(e) {
		return {
			before: !e.inclusive,
			values: e.position
		};
	}(t.endAt)), {
		_t: n,
		parent: i
	};
}
function Ec(e, t, n, r) {
	let { _t: i, parent: a } = Tc(e, t), o = {}, s = [], c = 0;
	return n.forEach(((e) => {
		let t = r ? e.alias : "aggregate_" + c++;
		o[t] = e.alias, e.aggregateType === "count" ? s.push({
			alias: t,
			count: {}
		}) : e.aggregateType === "avg" ? s.push({
			alias: t,
			avg: { field: Nc(e.fieldPath) }
		}) : e.aggregateType === "sum" && s.push({
			alias: t,
			sum: { field: Nc(e.fieldPath) }
		});
	})), {
		request: {
			structuredAggregationQuery: {
				aggregations: s,
				structuredQuery: i.structuredQuery
			},
			parent: i.parent
		},
		ut: o,
		parent: a
	};
}
function Dc(e) {
	let t = gc(e.parent), n = e.structuredQuery, r = n.from ? n.from.length : 0, i = null;
	if (r > 0) {
		j(r === 1);
		let e = n.from[0];
		e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
	}
	let a = [];
	n.where && (a = function(e) {
		let t = kc(e);
		return t instanceof to && ro(t) ? t.getFilters() : [t];
	}(n.where));
	let o = [];
	n.orderBy && (o = function(e) {
		return e.map(((e) => function(e) {
			return new Qa(Pc(e.field), function(e) {
				switch (e) {
					case "ASCENDING": return "asc";
					case "DESCENDING": return "desc";
					default: return;
				}
			}(e.direction));
		}(e)));
	}(n.orderBy));
	let s = null;
	n.limit && (s = function(e) {
		let t;
		return t = typeof e == "object" ? e.value : e, na(t) ? null : t;
	}(n.limit));
	let c = null;
	n.startAt && (c = function(e) {
		let t = !!e.before;
		return new Ya(e.values || [], t);
	}(n.startAt));
	let l = null;
	return n.endAt && (l = function(e) {
		let t = !e.before;
		return new Ya(e.values || [], t);
	}(n.endAt)), Co(t, i, o, a, s, "F", c, l);
}
function Oc(e, t) {
	let n = function(e) {
		switch (e) {
			case "TargetPurposeListen": return null;
			case "TargetPurposeExistenceFilterMismatch": return "existence-filter-mismatch";
			case "TargetPurposeExistenceFilterMismatchBloom": return "existence-filter-mismatch-bloom";
			case "TargetPurposeLimboResolution": return "limbo-document";
			default: return A();
		}
	}(t.purpose);
	return n == null ? null : { "goog-listen-tags": n };
}
function kc(e) {
	return e.unaryFilter === void 0 ? e.fieldFilter === void 0 ? e.compositeFilter === void 0 ? A() : function(e) {
		return to.create(e.compositeFilter.filters.map(((e) => kc(e))), function(e) {
			switch (e) {
				case "AND": return "and";
				case "OR": return "or";
				default: return A();
			}
		}(e.compositeFilter.op));
	}(e) : function(e) {
		return U.create(Pc(e.fieldFilter.field), function(e) {
			switch (e) {
				case "EQUAL": return "==";
				case "NOT_EQUAL": return "!=";
				case "GREATER_THAN": return ">";
				case "GREATER_THAN_OR_EQUAL": return ">=";
				case "LESS_THAN": return "<";
				case "LESS_THAN_OR_EQUAL": return "<=";
				case "ARRAY_CONTAINS": return "array-contains";
				case "IN": return "in";
				case "NOT_IN": return "not-in";
				case "ARRAY_CONTAINS_ANY": return "array-contains-any";
				default: return A();
			}
		}(e.fieldFilter.op), e.fieldFilter.value);
	}(e) : function(e) {
		switch (e.unaryFilter.op) {
			case "IS_NAN":
				let t = Pc(e.unaryFilter.field);
				return U.create(t, "==", { doubleValue: NaN });
			case "IS_NULL":
				let n = Pc(e.unaryFilter.field);
				return U.create(n, "==", { nullValue: "NULL_VALUE" });
			case "IS_NOT_NAN":
				let r = Pc(e.unaryFilter.field);
				return U.create(r, "!=", { doubleValue: NaN });
			case "IS_NOT_NULL":
				let i = Pc(e.unaryFilter.field);
				return U.create(i, "!=", { nullValue: "NULL_VALUE" });
			default: return A();
		}
	}(e);
}
function Ac(e) {
	return tc[e];
}
function jc(e) {
	return nc[e];
}
function Mc(e) {
	return rc[e];
}
function Nc(e) {
	return { fieldPath: e.canonicalString() };
}
function Pc(e) {
	return Wi.fromServerFormat(e.fieldPath);
}
function Fc(e) {
	return e instanceof U ? function(e) {
		if (e.op === "==") {
			if (Va(e.value)) return { unaryFilter: {
				field: Nc(e.field),
				op: "IS_NAN"
			} };
			if (Ba(e.value)) return { unaryFilter: {
				field: Nc(e.field),
				op: "IS_NULL"
			} };
		} else if (e.op === "!=") {
			if (Va(e.value)) return { unaryFilter: {
				field: Nc(e.field),
				op: "IS_NOT_NAN"
			} };
			if (Ba(e.value)) return { unaryFilter: {
				field: Nc(e.field),
				op: "IS_NOT_NULL"
			} };
		}
		return { fieldFilter: {
			field: Nc(e.field),
			op: jc(e.op),
			value: e.value
		} };
	}(e) : e instanceof to ? function(e) {
		let t = e.getFilters().map(((e) => Fc(e)));
		return t.length === 1 ? t[0] : { compositeFilter: {
			op: Mc(e.op),
			filters: t
		} };
	}(e) : A();
}
function Ic(e) {
	let t = [];
	return e.fields.forEach(((e) => t.push(e.canonicalString()))), { fieldPaths: t };
}
function Lc(e) {
	return e.length >= 4 && e.get(0) === "projects" && e.get(2) === "databases";
}
var Rc = class e {
	constructor(e, t, n, r, i = L.min(), a = L.min(), o = va.EMPTY_BYTE_STRING, s = null) {
		this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = a, this.resumeToken = o, this.expectedCount = s;
	}
	withSequenceNumber(t) {
		return new e(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
	}
	withResumeToken(t, n) {
		return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, t, null);
	}
	withExpectedCount(t) {
		return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, t);
	}
	withLastLimboFreeSnapshotVersion(t) {
		return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken, this.expectedCount);
	}
}, zc = class {
	constructor(e) {
		this.ct = e;
	}
};
function Bc(e) {
	let t = Dc({
		parent: e.parent,
		structuredQuery: e.structuredQuery
	});
	return e.limitType === "LAST" ? Mo(t, t.limit, "L") : t;
}
var Vc = class {
	constructor() {}
	It(e, t) {
		this.Tt(e, t), t.Et();
	}
	Tt(e, t) {
		if ("nullValue" in e) this.dt(t, 5);
		else if ("booleanValue" in e) this.dt(t, 10), t.At(+!!e.booleanValue);
		else if ("integerValue" in e) this.dt(t, 15), t.At(H(e.integerValue));
		else if ("doubleValue" in e) {
			let n = H(e.doubleValue);
			isNaN(n) ? this.dt(t, 13) : (this.dt(t, 15), ra(n) ? t.At(0) : t.At(n));
		} else if ("timestampValue" in e) {
			let n = e.timestampValue;
			this.dt(t, 20), typeof n == "string" && (n = ba(n)), t.Rt(`${n.seconds || ""}`), t.At(n.nanos || 0);
		} else if ("stringValue" in e) this.Vt(e.stringValue, t), this.ft(t);
		else if ("bytesValue" in e) this.dt(t, 30), t.gt(xa(e.bytesValue)), this.ft(t);
		else if ("referenceValue" in e) this.yt(e.referenceValue, t);
		else if ("geoPointValue" in e) {
			let n = e.geoPointValue;
			this.dt(t, 45), t.At(n.latitude || 0), t.At(n.longitude || 0);
		} else "mapValue" in e ? Ga(e) ? this.dt(t, 2 ** 53 - 1) : Ua(e) ? this.wt(e.mapValue, t) : (this.St(e.mapValue, t), this.ft(t)) : "arrayValue" in e ? (this.bt(e.arrayValue, t), this.ft(t)) : A();
	}
	Vt(e, t) {
		this.dt(t, 25), this.Dt(e, t);
	}
	Dt(e, t) {
		t.Rt(e);
	}
	St(e, t) {
		let n = e.fields || {};
		this.dt(t, 55);
		for (let e of Object.keys(n)) this.Vt(e, t), this.Tt(n[e], t);
	}
	wt(e, t) {
		let n = e.fields || {};
		this.dt(t, 53);
		let r = "value", i = n[r].arrayValue?.values?.length || 0;
		this.dt(t, 15), t.At(H(i)), this.Vt(r, t), this.Tt(n[r], t);
	}
	bt(e, t) {
		let n = e.values || [];
		this.dt(t, 50);
		for (let e of n) this.Tt(e, t);
	}
	yt(e, t) {
		this.dt(t, 37), z.fromName(e).path.forEach(((e) => {
			this.dt(t, 60), this.Dt(e, t);
		}));
	}
	dt(e, t) {
		e.At(t);
	}
	ft(e) {
		e.At(2);
	}
};
Vc.vt = new Vc();
var Hc = class {
	constructor() {
		this.un = new Uc();
	}
	addToCollectionParentIndex(e, t) {
		return this.un.add(t), B.resolve();
	}
	getCollectionParents(e, t) {
		return B.resolve(this.un.getEntries(t));
	}
	addFieldIndex(e, t) {
		return B.resolve();
	}
	deleteFieldIndex(e, t) {
		return B.resolve();
	}
	deleteAllFieldIndexes(e) {
		return B.resolve();
	}
	createTargetIndexes(e, t) {
		return B.resolve();
	}
	getDocumentsMatchingTarget(e, t) {
		return B.resolve(null);
	}
	getIndexType(e, t) {
		return B.resolve(0);
	}
	getFieldIndexes(e, t) {
		return B.resolve([]);
	}
	getNextCollectionGroupToUpdate(e) {
		return B.resolve(null);
	}
	getMinOffset(e, t) {
		return B.resolve(Ji.min());
	}
	getMinOffsetFromCollectionGroup(e, t) {
		return B.resolve(Ji.min());
	}
	updateCollectionGroup(e, t, n) {
		return B.resolve();
	}
	updateIndexEntries(e, t) {
		return B.resolve();
	}
}, Uc = class {
	constructor() {
		this.index = {};
	}
	add(e) {
		let t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new ma(R.comparator), i = !r.has(n);
		return this.index[t] = r.add(n), i;
	}
	has(e) {
		let t = e.lastSegment(), n = e.popLast(), r = this.index[t];
		return r && r.has(n);
	}
	getEntries(e) {
		return (this.index[e] || new ma(R.comparator)).toArray();
	}
}, Wc = {
	didRun: !1,
	sequenceNumbersCollected: 0,
	targetsRemoved: 0,
	documentsRemoved: 0
}, Gc = class e {
	constructor(e, t, n) {
		this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
	}
	static withCacheSize(t) {
		return new e(t, e.DEFAULT_COLLECTION_PERCENTILE, e.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
	}
};
Gc.DEFAULT_COLLECTION_PERCENTILE = 10, Gc.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, Gc.DEFAULT = new Gc(41943040, Gc.DEFAULT_COLLECTION_PERCENTILE, Gc.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), Gc.DISABLED = new Gc(-1, 0, 0);
var Kc = class e {
	constructor(e) {
		this.Ln = e;
	}
	next() {
		return this.Ln += 2, this.Ln;
	}
	static Bn() {
		return new e(0);
	}
	static kn() {
		return new e(-1);
	}
};
function qc([e, t], [n, r]) {
	let i = F(e, n);
	return i === 0 ? F(t, r) : i;
}
var Jc = class {
	constructor(e) {
		this.Un = e, this.buffer = new ma(qc), this.Wn = 0;
	}
	Gn() {
		return ++this.Wn;
	}
	zn(e) {
		let t = [e, this.Gn()];
		if (this.buffer.size < this.Un) this.buffer = this.buffer.add(t);
		else {
			let e = this.buffer.last();
			qc(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
		}
	}
	get maxValue() {
		return this.buffer.last()[0];
	}
}, Yc = class {
	constructor(e, t, n) {
		this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.jn = null;
	}
	start() {
		this.garbageCollector.params.cacheSizeCollectionThreshold !== -1 && this.Hn(6e4);
	}
	stop() {
		this.jn &&= (this.jn.cancel(), null);
	}
	get started() {
		return this.jn !== null;
	}
	Hn(e) {
		k("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), this.jn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection", e, (async () => {
			this.jn = null;
			try {
				await this.localStore.collectGarbage(this.garbageCollector);
			} catch (e) {
				ea(e) ? k("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await Qi(e);
			}
			await this.Hn(3e5);
		}));
	}
}, Xc = class {
	constructor(e, t) {
		this.Jn = e, this.params = t;
	}
	calculateTargetCount(e, t) {
		return this.Jn.Yn(e).next(((e) => Math.floor(t / 100 * e)));
	}
	nthSequenceNumber(e, t) {
		if (t === 0) return B.resolve(ta.oe);
		let n = new Jc(t);
		return this.Jn.forEachTarget(e, ((e) => n.zn(e.sequenceNumber))).next((() => this.Jn.Zn(e, ((e) => n.zn(e))))).next((() => n.maxValue));
	}
	removeTargets(e, t, n) {
		return this.Jn.removeTargets(e, t, n);
	}
	removeOrphanedDocuments(e, t) {
		return this.Jn.removeOrphanedDocuments(e, t);
	}
	collect(e, t) {
		return this.params.cacheSizeCollectionThreshold === -1 ? (k("LruGarbageCollector", "Garbage collection skipped; disabled"), B.resolve(Wc)) : this.getCacheSize(e).next(((n) => n < this.params.cacheSizeCollectionThreshold ? (k("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), Wc) : this.Xn(e, t)));
	}
	getCacheSize(e) {
		return this.Jn.getCacheSize(e);
	}
	Xn(e, t) {
		let n, r, i, a, o, s, c, l = Date.now();
		return this.calculateTargetCount(e, this.params.percentileToCollect).next(((t) => (t > this.params.maximumSequenceNumbersToCollect ? (k("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, a = Date.now(), this.nthSequenceNumber(e, r)))).next(((r) => (n = r, o = Date.now(), this.removeTargets(e, n, t)))).next(((t) => (i = t, s = Date.now(), this.removeOrphanedDocuments(e, n)))).next(((e) => (c = Date.now(), Ei() <= E.DEBUG && k("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${a - l}ms\n\tDetermined least recently used ${r} in ` + (o - a) + `ms
\tRemoved ${i} targets in ` + (s - o) + `ms
\tRemoved ${e} documents in ` + (c - s) + `ms
Total Duration: ${c - l}ms`), B.resolve({
			didRun: !0,
			sequenceNumbersCollected: r,
			targetsRemoved: i,
			documentsRemoved: e
		}))));
	}
};
function Zc(e, t) {
	return new Xc(e, t);
}
var Qc = class {
	constructor() {
		this.changes = new Bo(((e) => e.toString()), ((e, t) => e.isEqual(t))), this.changesApplied = !1;
	}
	addEntry(e) {
		this.assertNotApplied(), this.changes.set(e.key, e);
	}
	removeEntry(e, t) {
		this.assertNotApplied(), this.changes.set(e, Ja.newInvalidDocument(e).setReadTime(t));
	}
	getEntry(e, t) {
		this.assertNotApplied();
		let n = this.changes.get(t);
		return n === void 0 ? this.getFromCache(e, t) : B.resolve(n);
	}
	getEntries(e, t) {
		return this.getAllFromCache(e, t);
	}
	apply(e) {
		return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
	}
	assertNotApplied() {}
}, $c = class {
	constructor(e, t) {
		this.overlayedDocument = e, this.mutatedFields = t;
	}
}, el = class {
	constructor(e, t, n, r) {
		this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
	}
	getDocument(e, t) {
		let n = null;
		return this.documentOverlayCache.getOverlay(e, t).next(((r) => (n = r, this.remoteDocumentCache.getEntry(e, t)))).next(((e) => (n !== null && Ss(n.mutation, e, ga.empty(), I.now()), e)));
	}
	getDocuments(e, t) {
		return this.remoteDocumentCache.getEntries(e, t).next(((t) => this.getLocalViewOfDocuments(e, t, W()).next((() => t))));
	}
	getLocalViewOfDocuments(e, t, n = W()) {
		let r = Ko();
		return this.populateOverlays(e, r, t).next((() => this.computeViews(e, t, r, n).next(((e) => {
			let t = Wo();
			return e.forEach(((e, n) => {
				t = t.insert(e, n.overlayedDocument);
			})), t;
		}))));
	}
	getOverlayedDocuments(e, t) {
		let n = Ko();
		return this.populateOverlays(e, n, t).next((() => this.computeViews(e, t, n, W())));
	}
	populateOverlays(e, t, n) {
		let r = [];
		return n.forEach(((e) => {
			t.has(e) || r.push(e);
		})), this.documentOverlayCache.getOverlays(e, r).next(((e) => {
			e.forEach(((e, n) => {
				t.set(e, n);
			}));
		}));
	}
	computeViews(e, t, n, r) {
		let i = Ho(), a = Jo(), o = function() {
			return Jo();
		}();
		return t.forEach(((e, t) => {
			let o = n.get(t.key);
			r.has(t.key) && (o === void 0 || o.mutation instanceof Es) ? i = i.insert(t.key, t) : o === void 0 ? a.set(t.key, ga.empty()) : (a.set(t.key, o.mutation.getFieldMask()), Ss(o.mutation, t, o.mutation.getFieldMask(), I.now()));
		})), this.recalculateAndSaveOverlays(e, i).next(((e) => (e.forEach(((e, t) => a.set(e, t))), t.forEach(((e, t) => o.set(e, new $c(t, a.get(e) ?? null)))), o)));
	}
	recalculateAndSaveOverlays(e, t) {
		let n = Jo(), r = new V(((e, t) => e - t)), i = W();
		return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next(((e) => {
			for (let i of e) i.keys().forEach(((e) => {
				let a = t.get(e);
				if (a === null) return;
				let o = n.get(e) || ga.empty();
				o = i.applyToLocalView(a, o), n.set(e, o);
				let s = (r.get(i.batchId) || W()).add(e);
				r = r.insert(i.batchId, s);
			}));
		})).next((() => {
			let a = [], o = r.getReverseIterator();
			for (; o.hasNext();) {
				let r = o.getNext(), s = r.key, c = r.value, l = qo();
				c.forEach(((e) => {
					if (!i.has(e)) {
						let r = bs(t.get(e), n.get(e));
						r !== null && l.set(e, r), i = i.add(e);
					}
				})), a.push(this.documentOverlayCache.saveOverlays(e, s, l));
			}
			return B.waitFor(a);
		})).next((() => n));
	}
	recalculateAndSaveOverlaysForDocumentKeys(e, t) {
		return this.remoteDocumentCache.getEntries(e, t).next(((t) => this.recalculateAndSaveOverlays(e, t)));
	}
	getDocumentsMatchingQuery(e, t, n, r) {
		return function(e) {
			return z.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
		}(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : Eo(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
	}
	getNextDocuments(e, t, n, r) {
		return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next(((i) => {
			let a = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : B.resolve(Ko()), o = -1, s = i;
			return a.next(((t) => B.forEach(t, ((t, n) => (o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? B.resolve() : this.remoteDocumentCache.getEntry(e, t).next(((e) => {
				s = s.insert(t, e);
			}))))).next((() => this.populateOverlays(e, t, i))).next((() => this.computeViews(e, s, t, W()))).next(((e) => ({
				batchId: o,
				changes: Go(e)
			})))));
		}));
	}
	getDocumentsMatchingDocumentQuery(e, t) {
		return this.getDocument(e, new z(t)).next(((e) => {
			let t = Wo();
			return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
		}));
	}
	getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
		let i = t.collectionGroup, a = Wo();
		return this.indexManager.getCollectionParents(e, i).next(((o) => B.forEach(o, ((o) => {
			let s = function(e, t) {
				return new So(t, null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
			}(t, o.child(i));
			return this.getDocumentsMatchingCollectionQuery(e, s, n, r).next(((e) => {
				e.forEach(((e, t) => {
					a = a.insert(e, t);
				}));
			}));
		})).next((() => a))));
	}
	getDocumentsMatchingCollectionQuery(e, t, n, r) {
		let i;
		return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next(((a) => (i = a, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r)))).next(((e) => {
			i.forEach(((t, n) => {
				let r = n.getKey();
				e.get(r) === null && (e = e.insert(r, Ja.newInvalidDocument(r)));
			}));
			let n = Wo();
			return e.forEach(((e, r) => {
				let a = i.get(e);
				a !== void 0 && Ss(a.mutation, r, ga.empty(), I.now()), Io(t, r) && (n = n.insert(e, r));
			})), n;
		}));
	}
}, tl = class {
	constructor(e) {
		this.serializer = e, this.hr = /* @__PURE__ */ new Map(), this.Pr = /* @__PURE__ */ new Map();
	}
	getBundleMetadata(e, t) {
		return B.resolve(this.hr.get(t));
	}
	saveBundleMetadata(e, t) {
		return this.hr.set(t.id, function(e) {
			return {
				id: e.id,
				version: e.version,
				createTime: lc(e.createTime)
			};
		}(t)), B.resolve();
	}
	getNamedQuery(e, t) {
		return B.resolve(this.Pr.get(t));
	}
	saveNamedQuery(e, t) {
		return this.Pr.set(t.name, function(e) {
			return {
				name: e.name,
				query: Bc(e.bundledQuery),
				readTime: lc(e.readTime)
			};
		}(t)), B.resolve();
	}
}, nl = class {
	constructor() {
		this.overlays = new V(z.comparator), this.Ir = /* @__PURE__ */ new Map();
	}
	getOverlay(e, t) {
		return B.resolve(this.overlays.get(t));
	}
	getOverlays(e, t) {
		let n = Ko();
		return B.forEach(t, ((t) => this.getOverlay(e, t).next(((e) => {
			e !== null && n.set(t, e);
		})))).next((() => n));
	}
	saveOverlays(e, t, n) {
		return n.forEach(((n, r) => {
			this.ht(e, t, r);
		})), B.resolve();
	}
	removeOverlaysForBatchId(e, t, n) {
		let r = this.Ir.get(n);
		return r !== void 0 && (r.forEach(((e) => this.overlays = this.overlays.remove(e))), this.Ir.delete(n)), B.resolve();
	}
	getOverlaysForCollection(e, t, n) {
		let r = Ko(), i = t.length + 1, a = new z(t.child("")), o = this.overlays.getIteratorFrom(a);
		for (; o.hasNext();) {
			let e = o.getNext().value, a = e.getKey();
			if (!t.isPrefixOf(a.path)) break;
			a.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
		}
		return B.resolve(r);
	}
	getOverlaysForCollectionGroup(e, t, n, r) {
		let i = new V(((e, t) => e - t)), a = this.overlays.getIterator();
		for (; a.hasNext();) {
			let e = a.getNext().value;
			if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
				let t = i.get(e.largestBatchId);
				t === null && (t = Ko(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
			}
		}
		let o = Ko(), s = i.getIterator();
		for (; s.hasNext() && (s.getNext().value.forEach(((e, t) => o.set(e, t))), !(o.size() >= r)););
		return B.resolve(o);
	}
	ht(e, t, n) {
		let r = this.overlays.get(n.key);
		if (r !== null) {
			let e = this.Ir.get(r.largestBatchId).delete(n.key);
			this.Ir.set(r.largestBatchId, e);
		}
		this.overlays = this.overlays.insert(n.key, new Ps(t, n));
		let i = this.Ir.get(t);
		i === void 0 && (i = W(), this.Ir.set(t, i)), this.Ir.set(t, i.add(n.key));
	}
}, rl = class {
	constructor() {
		this.sessionToken = va.EMPTY_BYTE_STRING;
	}
	getSessionToken(e) {
		return B.resolve(this.sessionToken);
	}
	setSessionToken(e, t) {
		return this.sessionToken = t, B.resolve();
	}
}, il = class {
	constructor() {
		this.Tr = new ma(q.Er), this.dr = new ma(q.Ar);
	}
	isEmpty() {
		return this.Tr.isEmpty();
	}
	addReference(e, t) {
		let n = new q(e, t);
		this.Tr = this.Tr.add(n), this.dr = this.dr.add(n);
	}
	Rr(e, t) {
		e.forEach(((e) => this.addReference(e, t)));
	}
	removeReference(e, t) {
		this.Vr(new q(e, t));
	}
	mr(e, t) {
		e.forEach(((e) => this.removeReference(e, t)));
	}
	gr(e) {
		let t = new z(new R([])), n = new q(t, e), r = new q(t, e + 1), i = [];
		return this.dr.forEachInRange([n, r], ((e) => {
			this.Vr(e), i.push(e.key);
		})), i;
	}
	pr() {
		this.Tr.forEach(((e) => this.Vr(e)));
	}
	Vr(e) {
		this.Tr = this.Tr.delete(e), this.dr = this.dr.delete(e);
	}
	yr(e) {
		let t = new z(new R([])), n = new q(t, e), r = new q(t, e + 1), i = W();
		return this.dr.forEachInRange([n, r], ((e) => {
			i = i.add(e.key);
		})), i;
	}
	containsKey(e) {
		let t = new q(e, 0), n = this.Tr.firstAfterOrEqual(t);
		return n !== null && e.isEqual(n.key);
	}
}, q = class {
	constructor(e, t) {
		this.key = e, this.wr = t;
	}
	static Er(e, t) {
		return z.comparator(e.key, t.key) || F(e.wr, t.wr);
	}
	static Ar(e, t) {
		return F(e.wr, t.wr) || z.comparator(e.key, t.key);
	}
}, al = class {
	constructor(e, t) {
		this.indexManager = e, this.referenceDelegate = t, this.mutationQueue = [], this.Sr = 1, this.br = new ma(q.Er);
	}
	checkEmpty(e) {
		return B.resolve(this.mutationQueue.length === 0);
	}
	addMutationBatch(e, t, n, r) {
		let i = this.Sr;
		this.Sr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
		let a = new Ms(i, t, n, r);
		this.mutationQueue.push(a);
		for (let t of r) this.br = this.br.add(new q(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
		return B.resolve(a);
	}
	lookupMutationBatch(e, t) {
		return B.resolve(this.Dr(t));
	}
	getNextMutationBatchAfterBatchId(e, t) {
		let n = t + 1, r = this.vr(n), i = r < 0 ? 0 : r;
		return B.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
	}
	getHighestUnacknowledgedBatchId() {
		return B.resolve(this.mutationQueue.length === 0 ? -1 : this.Sr - 1);
	}
	getAllMutationBatches(e) {
		return B.resolve(this.mutationQueue.slice());
	}
	getAllMutationBatchesAffectingDocumentKey(e, t) {
		let n = new q(t, 0), r = new q(t, Infinity), i = [];
		return this.br.forEachInRange([n, r], ((e) => {
			let t = this.Dr(e.wr);
			i.push(t);
		})), B.resolve(i);
	}
	getAllMutationBatchesAffectingDocumentKeys(e, t) {
		let n = new ma(F);
		return t.forEach(((e) => {
			let t = new q(e, 0), r = new q(e, Infinity);
			this.br.forEachInRange([t, r], ((e) => {
				n = n.add(e.wr);
			}));
		})), B.resolve(this.Cr(n));
	}
	getAllMutationBatchesAffectingQuery(e, t) {
		let n = t.path, r = n.length + 1, i = n;
		z.isDocumentKey(i) || (i = i.child(""));
		let a = new q(new z(i), 0), o = new ma(F);
		return this.br.forEachWhile(((e) => {
			let t = e.key.path;
			return !!n.isPrefixOf(t) && (t.length === r && (o = o.add(e.wr)), !0);
		}), a), B.resolve(this.Cr(o));
	}
	Cr(e) {
		let t = [];
		return e.forEach(((e) => {
			let n = this.Dr(e);
			n !== null && t.push(n);
		})), t;
	}
	removeMutationBatch(e, t) {
		j(this.Fr(t.batchId, "removed") === 0), this.mutationQueue.shift();
		let n = this.br;
		return B.forEach(t.mutations, ((r) => {
			let i = new q(r.key, t.batchId);
			return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
		})).next((() => {
			this.br = n;
		}));
	}
	On(e) {}
	containsKey(e, t) {
		let n = new q(t, 0), r = this.br.firstAfterOrEqual(n);
		return B.resolve(t.isEqual(r && r.key));
	}
	performConsistencyCheck(e) {
		return this.mutationQueue.length, B.resolve();
	}
	Fr(e, t) {
		return this.vr(e);
	}
	vr(e) {
		return this.mutationQueue.length === 0 ? 0 : e - this.mutationQueue[0].batchId;
	}
	Dr(e) {
		let t = this.vr(e);
		return t < 0 || t >= this.mutationQueue.length ? null : this.mutationQueue[t];
	}
}, ol = class {
	constructor(e) {
		this.Mr = e, this.docs = function() {
			return new V(z.comparator);
		}(), this.size = 0;
	}
	setIndexManager(e) {
		this.indexManager = e;
	}
	addEntry(e, t) {
		let n = t.key, r = this.docs.get(n), i = r ? r.size : 0, a = this.Mr(t);
		return this.docs = this.docs.insert(n, {
			document: t.mutableCopy(),
			size: a
		}), this.size += a - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
	}
	removeEntry(e) {
		let t = this.docs.get(e);
		t && (this.docs = this.docs.remove(e), this.size -= t.size);
	}
	getEntry(e, t) {
		let n = this.docs.get(t);
		return B.resolve(n ? n.document.mutableCopy() : Ja.newInvalidDocument(t));
	}
	getEntries(e, t) {
		let n = Ho();
		return t.forEach(((e) => {
			let t = this.docs.get(e);
			n = n.insert(e, t ? t.document.mutableCopy() : Ja.newInvalidDocument(e));
		})), B.resolve(n);
	}
	getDocumentsMatchingQuery(e, t, n, r) {
		let i = Ho(), a = t.path, o = new z(a.child("")), s = this.docs.getIteratorFrom(o);
		for (; s.hasNext();) {
			let { key: e, value: { document: o } } = s.getNext();
			if (!a.isPrefixOf(e.path)) break;
			e.path.length > a.length + 1 || Yi(qi(o), n) <= 0 || (r.has(o.key) || Io(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
		}
		return B.resolve(i);
	}
	getAllFromCollectionGroup(e, t, n, r) {
		A();
	}
	Or(e, t) {
		return B.forEach(this.docs, ((e) => t(e)));
	}
	newChangeBuffer(e) {
		return new sl(this);
	}
	getSize(e) {
		return B.resolve(this.size);
	}
}, sl = class extends Qc {
	constructor(e) {
		super(), this.cr = e;
	}
	applyChanges(e) {
		let t = [];
		return this.changes.forEach(((n, r) => {
			r.isValidDocument() ? t.push(this.cr.addEntry(e, r)) : this.cr.removeEntry(n);
		})), B.waitFor(t);
	}
	getFromCache(e, t) {
		return this.cr.getEntry(e, t);
	}
	getAllFromCache(e, t) {
		return this.cr.getEntries(e, t);
	}
}, cl = class {
	constructor(e) {
		this.persistence = e, this.Nr = new Bo(((e) => yo(e)), bo), this.lastRemoteSnapshotVersion = L.min(), this.highestTargetId = 0, this.Lr = 0, this.Br = new il(), this.targetCount = 0, this.kr = Kc.Bn();
	}
	forEachTarget(e, t) {
		return this.Nr.forEach(((e, n) => t(n))), B.resolve();
	}
	getLastRemoteSnapshotVersion(e) {
		return B.resolve(this.lastRemoteSnapshotVersion);
	}
	getHighestSequenceNumber(e) {
		return B.resolve(this.Lr);
	}
	allocateTargetId(e) {
		return this.highestTargetId = this.kr.next(), B.resolve(this.highestTargetId);
	}
	setTargetsMetadata(e, t, n) {
		return n && (this.lastRemoteSnapshotVersion = n), t > this.Lr && (this.Lr = t), B.resolve();
	}
	Kn(e) {
		this.Nr.set(e.target, e);
		let t = e.targetId;
		t > this.highestTargetId && (this.kr = new Kc(t), this.highestTargetId = t), e.sequenceNumber > this.Lr && (this.Lr = e.sequenceNumber);
	}
	addTargetData(e, t) {
		return this.Kn(t), this.targetCount += 1, B.resolve();
	}
	updateTargetData(e, t) {
		return this.Kn(t), B.resolve();
	}
	removeTargetData(e, t) {
		return this.Nr.delete(t.target), this.Br.gr(t.targetId), --this.targetCount, B.resolve();
	}
	removeTargets(e, t, n) {
		let r = 0, i = [];
		return this.Nr.forEach(((a, o) => {
			o.sequenceNumber <= t && n.get(o.targetId) === null && (this.Nr.delete(a), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
		})), B.waitFor(i).next((() => r));
	}
	getTargetCount(e) {
		return B.resolve(this.targetCount);
	}
	getTargetData(e, t) {
		let n = this.Nr.get(t) || null;
		return B.resolve(n);
	}
	addMatchingKeys(e, t, n) {
		return this.Br.Rr(t, n), B.resolve();
	}
	removeMatchingKeys(e, t, n) {
		this.Br.mr(t, n);
		let r = this.persistence.referenceDelegate, i = [];
		return r && t.forEach(((t) => {
			i.push(r.markPotentiallyOrphaned(e, t));
		})), B.waitFor(i);
	}
	removeMatchingKeysForTargetId(e, t) {
		return this.Br.gr(t), B.resolve();
	}
	getMatchingKeysForTargetId(e, t) {
		let n = this.Br.yr(t);
		return B.resolve(n);
	}
	containsKey(e, t) {
		return B.resolve(this.Br.containsKey(t));
	}
}, ll = class {
	constructor(e, t) {
		this.qr = {}, this.overlays = {}, this.Qr = new ta(0), this.Kr = !1, this.Kr = !0, this.$r = new rl(), this.referenceDelegate = e(this), this.Ur = new cl(this), this.indexManager = new Hc(), this.remoteDocumentCache = function(e) {
			return new ol(e);
		}(((e) => this.referenceDelegate.Wr(e))), this.serializer = new zc(t), this.Gr = new tl(this.serializer);
	}
	start() {
		return Promise.resolve();
	}
	shutdown() {
		return this.Kr = !1, Promise.resolve();
	}
	get started() {
		return this.Kr;
	}
	setDatabaseDeletedListener() {}
	setNetworkEnabled() {}
	getIndexManager(e) {
		return this.indexManager;
	}
	getDocumentOverlayCache(e) {
		let t = this.overlays[e.toKey()];
		return t || (t = new nl(), this.overlays[e.toKey()] = t), t;
	}
	getMutationQueue(e, t) {
		let n = this.qr[e.toKey()];
		return n || (n = new al(t, this.referenceDelegate), this.qr[e.toKey()] = n), n;
	}
	getGlobalsCache() {
		return this.$r;
	}
	getTargetCache() {
		return this.Ur;
	}
	getRemoteDocumentCache() {
		return this.remoteDocumentCache;
	}
	getBundleCache() {
		return this.Gr;
	}
	runTransaction(e, t, n) {
		k("MemoryPersistence", "Starting transaction:", e);
		let r = new ul(this.Qr.next());
		return this.referenceDelegate.zr(), n(r).next(((e) => this.referenceDelegate.jr(r).next((() => e)))).toPromise().then(((e) => (r.raiseOnCommittedEvent(), e)));
	}
	Hr(e, t) {
		return B.or(Object.values(this.qr).map(((n) => () => n.containsKey(e, t))));
	}
}, ul = class extends Zi {
	constructor(e) {
		super(), this.currentSequenceNumber = e;
	}
}, dl = class e {
	constructor(e) {
		this.persistence = e, this.Jr = new il(), this.Yr = null;
	}
	static Zr(t) {
		return new e(t);
	}
	get Xr() {
		if (this.Yr) return this.Yr;
		throw A();
	}
	addReference(e, t, n) {
		return this.Jr.addReference(n, t), this.Xr.delete(n.toString()), B.resolve();
	}
	removeReference(e, t, n) {
		return this.Jr.removeReference(n, t), this.Xr.add(n.toString()), B.resolve();
	}
	markPotentiallyOrphaned(e, t) {
		return this.Xr.add(t.toString()), B.resolve();
	}
	removeTarget(e, t) {
		this.Jr.gr(t.targetId).forEach(((e) => this.Xr.add(e.toString())));
		let n = this.persistence.getTargetCache();
		return n.getMatchingKeysForTargetId(e, t.targetId).next(((e) => {
			e.forEach(((e) => this.Xr.add(e.toString())));
		})).next((() => n.removeTargetData(e, t)));
	}
	zr() {
		this.Yr = /* @__PURE__ */ new Set();
	}
	jr(e) {
		let t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
		return B.forEach(this.Xr, ((n) => {
			let r = z.fromPath(n);
			return this.ei(e, r).next(((e) => {
				e || t.removeEntry(r, L.min());
			}));
		})).next((() => (this.Yr = null, t.apply(e))));
	}
	updateLimboDocument(e, t) {
		return this.ei(e, t).next(((e) => {
			e ? this.Xr.delete(t.toString()) : this.Xr.add(t.toString());
		}));
	}
	Wr(e) {
		return 0;
	}
	ei(e, t) {
		return B.or([
			() => B.resolve(this.Jr.containsKey(t)),
			() => this.persistence.getTargetCache().containsKey(e, t),
			() => this.persistence.Hr(e, t)
		]);
	}
}, fl = class e {
	constructor(e, t) {
		this.persistence = e, this.ti = new Bo(((e) => aa(e.path)), ((e, t) => e.isEqual(t))), this.garbageCollector = Zc(this, t);
	}
	static Zr(t, n) {
		return new e(t, n);
	}
	zr() {}
	jr(e) {
		return B.resolve();
	}
	forEachTarget(e, t) {
		return this.persistence.getTargetCache().forEachTarget(e, t);
	}
	Yn(e) {
		let t = this.er(e);
		return this.persistence.getTargetCache().getTargetCount(e).next(((e) => t.next(((t) => e + t))));
	}
	er(e) {
		let t = 0;
		return this.Zn(e, ((e) => {
			t++;
		})).next((() => t));
	}
	Zn(e, t) {
		return B.forEach(this.ti, ((n, r) => this.nr(e, n, r).next(((e) => e ? B.resolve() : t(r)))));
	}
	removeTargets(e, t, n) {
		return this.persistence.getTargetCache().removeTargets(e, t, n);
	}
	removeOrphanedDocuments(e, t) {
		let n = 0, r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
		return r.Or(e, ((r) => this.nr(e, r, t).next(((e) => {
			e || (n++, i.removeEntry(r, L.min()));
		})))).next((() => i.apply(e))).next((() => n));
	}
	markPotentiallyOrphaned(e, t) {
		return this.ti.set(t, e.currentSequenceNumber), B.resolve();
	}
	removeTarget(e, t) {
		let n = t.withSequenceNumber(e.currentSequenceNumber);
		return this.persistence.getTargetCache().updateTargetData(e, n);
	}
	addReference(e, t, n) {
		return this.ti.set(n, e.currentSequenceNumber), B.resolve();
	}
	removeReference(e, t, n) {
		return this.ti.set(n, e.currentSequenceNumber), B.resolve();
	}
	updateLimboDocument(e, t) {
		return this.ti.set(t, e.currentSequenceNumber), B.resolve();
	}
	Wr(e) {
		let t = e.key.toString().length;
		return e.isFoundDocument() && (t += Ia(e.data.value)), t;
	}
	nr(e, t, n) {
		return B.or([
			() => this.persistence.Hr(e, t),
			() => this.persistence.getTargetCache().containsKey(e, t),
			() => {
				let e = this.ti.get(t);
				return B.resolve(e !== void 0 && e > n);
			}
		]);
	}
	getCacheSize(e) {
		return this.persistence.getRemoteDocumentCache().getSize(e);
	}
}, pl = class e {
	constructor(e, t, n, r) {
		this.targetId = e, this.fromCache = t, this.$i = n, this.Ui = r;
	}
	static Wi(t, n) {
		let r = W(), i = W();
		for (let e of n.docChanges) switch (e.type) {
			case 0:
				r = r.add(e.doc.key);
				break;
			case 1: i = i.add(e.doc.key);
		}
		return new e(t, n.fromCache, r, i);
	}
}, ml = class {
	constructor() {
		this._documentReadCount = 0;
	}
	get documentReadCount() {
		return this._documentReadCount;
	}
	incrementDocumentReadCount(e) {
		this._documentReadCount += e;
	}
}, hl = class {
	constructor() {
		this.Gi = !1, this.zi = !1, this.ji = 100, this.Hi = function() {
			return tn() ? 8 : $i(C()) > 0 ? 6 : 4;
		}();
	}
	initialize(e, t) {
		this.Ji = e, this.indexManager = t, this.Gi = !0;
	}
	getDocumentsMatchingQuery(e, t, n, r) {
		let i = { result: null };
		return this.Yi(e, t).next(((e) => {
			i.result = e;
		})).next((() => {
			if (!i.result) return this.Zi(e, t, r, n).next(((e) => {
				i.result = e;
			}));
		})).next((() => {
			if (i.result) return;
			let n = new ml();
			return this.Xi(e, t, n).next(((r) => {
				if (i.result = r, this.zi) return this.es(e, t, n, r.size);
			}));
		})).next((() => i.result));
	}
	es(e, t, n, r) {
		return n.documentReadCount < this.ji ? (Ei() <= E.DEBUG && k("QueryEngine", "SDK will not create cache indexes for query:", Fo(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.ji, "documents"), B.resolve()) : (Ei() <= E.DEBUG && k("QueryEngine", "Query:", Fo(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Hi * r ? (Ei() <= E.DEBUG && k("QueryEngine", "The SDK decides to create cache indexes for query:", Fo(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, Oo(t))) : B.resolve());
	}
	Yi(e, t) {
		if (To(t)) return B.resolve(null);
		let n = Oo(t);
		return this.indexManager.getIndexType(e, n).next(((r) => r === 0 ? null : (t.limit !== null && r === 1 && (t = Mo(t, null, "F"), n = Oo(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next(((r) => {
			let i = W(...r);
			return this.Ji.getDocuments(e, i).next(((r) => this.indexManager.getMinOffset(e, n).next(((n) => {
				let a = this.ts(t, r);
				return this.ns(t, a, i, n.readTime) ? this.Yi(e, Mo(t, null, "F")) : this.rs(e, a, t, n);
			}))));
		})))));
	}
	Zi(e, t, n, r) {
		return To(t) || r.isEqual(L.min()) ? B.resolve(null) : this.Ji.getDocuments(e, n).next(((i) => {
			let a = this.ts(t, i);
			return this.ns(t, a, n, r) ? B.resolve(null) : (Ei() <= E.DEBUG && k("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), Fo(t)), this.rs(e, a, t, Ki(r, -1)).next(((e) => e)));
		}));
	}
	ts(e, t) {
		let n = new ma(Ro(e));
		return t.forEach(((t, r) => {
			Io(e, r) && (n = n.add(r));
		})), n;
	}
	ns(e, t, n, r) {
		if (e.limit === null) return !1;
		if (n.size !== t.size) return !0;
		let i = e.limitType === "F" ? t.last() : t.first();
		return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
	}
	Xi(e, t, n) {
		return Ei() <= E.DEBUG && k("QueryEngine", "Using full collection scan to execute query:", Fo(t)), this.Ji.getDocumentsMatchingQuery(e, t, Ji.min(), n);
	}
	rs(e, t, n, r) {
		return this.Ji.getDocumentsMatchingQuery(e, n, r).next(((e) => (t.forEach(((t) => {
			e = e.insert(t.key, t);
		})), e)));
	}
}, gl = class {
	constructor(e, t, n, r) {
		this.persistence = e, this.ss = t, this.serializer = r, this.os = new V(F), this._s = new Bo(((e) => yo(e)), bo), this.us = /* @__PURE__ */ new Map(), this.cs = e.getRemoteDocumentCache(), this.Ur = e.getTargetCache(), this.Gr = e.getBundleCache(), this.ls(n);
	}
	ls(e) {
		this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new el(this.cs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.cs.setIndexManager(this.indexManager), this.ss.initialize(this.localDocuments, this.indexManager);
	}
	collectGarbage(e) {
		return this.persistence.runTransaction("Collect garbage", "readwrite-primary", ((t) => e.collect(t, this.os)));
	}
};
function _l(e, t, n, r) {
	return new gl(e, t, n, r);
}
async function vl(e, t) {
	let n = M(e);
	return await n.persistence.runTransaction("Handle user change", "readonly", ((e) => {
		let r;
		return n.mutationQueue.getAllMutationBatches(e).next(((i) => (r = i, n.ls(t), n.mutationQueue.getAllMutationBatches(e)))).next(((t) => {
			let i = [], a = [], o = W();
			for (let e of r) {
				i.push(e.batchId);
				for (let t of e.mutations) o = o.add(t.key);
			}
			for (let e of t) {
				a.push(e.batchId);
				for (let t of e.mutations) o = o.add(t.key);
			}
			return n.localDocuments.getDocuments(e, o).next(((e) => ({
				hs: e,
				removedBatchIds: i,
				addedBatchIds: a
			})));
		}));
	}));
}
function yl(e, t) {
	let n = M(e);
	return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", ((e) => {
		let r = t.batch.keys(), i = n.cs.newChangeBuffer({ trackRemovals: !0 });
		return function(e, t, n, r) {
			let i = n.batch, a = i.keys(), o = B.resolve();
			return a.forEach(((e) => {
				o = o.next((() => r.getEntry(t, e))).next(((t) => {
					let a = n.docVersions.get(e);
					j(a !== null), t.version.compareTo(a) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && (t.setReadTime(n.commitVersion), r.addEntry(t)));
				}));
			})), o.next((() => e.mutationQueue.removeMutationBatch(t, i)));
		}(n, e, t, i).next((() => i.apply(e))).next((() => n.mutationQueue.performConsistencyCheck(e))).next((() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId))).next((() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function(e) {
			let t = W();
			for (let n = 0; n < e.mutationResults.length; ++n) e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
			return t;
		}(t)))).next((() => n.localDocuments.getDocuments(e, r)));
	}));
}
function bl(e) {
	let t = M(e);
	return t.persistence.runTransaction("Get last remote snapshot version", "readonly", ((e) => t.Ur.getLastRemoteSnapshotVersion(e)));
}
function xl(e, t) {
	let n = M(e), r = t.snapshotVersion, i = n.os;
	return n.persistence.runTransaction("Apply remote event", "readwrite-primary", ((e) => {
		let a = n.cs.newChangeBuffer({ trackRemovals: !0 });
		i = n.os;
		let o = [];
		t.targetChanges.forEach(((a, s) => {
			let c = i.get(s);
			if (!c) return;
			o.push(n.Ur.removeMatchingKeys(e, a.removedDocuments, s).next((() => n.Ur.addMatchingKeys(e, a.addedDocuments, s))));
			let l = c.withSequenceNumber(e.currentSequenceNumber);
			t.targetMismatches.get(s) === null ? a.resumeToken.approximateByteSize() > 0 && (l = l.withResumeToken(a.resumeToken, r)) : l = l.withResumeToken(va.EMPTY_BYTE_STRING, L.min()).withLastLimboFreeSnapshotVersion(L.min()), i = i.insert(s, l), function(e, t, n) {
				return e.resumeToken.approximateByteSize() === 0 || t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8 ? !0 : n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
			}(c, l, a) && o.push(n.Ur.updateTargetData(e, l));
		}));
		let s = Ho(), c = W();
		if (t.documentUpdates.forEach(((r) => {
			t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
		})), o.push(Sl(e, a, t.documentUpdates).next(((e) => {
			s = e.Ps, c = e.Is;
		}))), !r.isEqual(L.min())) {
			let t = n.Ur.getLastRemoteSnapshotVersion(e).next(((t) => n.Ur.setTargetsMetadata(e, e.currentSequenceNumber, r)));
			o.push(t);
		}
		return B.waitFor(o).next((() => a.apply(e))).next((() => n.localDocuments.getLocalViewOfDocuments(e, s, c))).next((() => s));
	})).then(((e) => (n.os = i, e)));
}
function Sl(e, t, n) {
	let r = W(), i = W();
	return n.forEach(((e) => r = r.add(e))), t.getEntries(e, r).next(((e) => {
		let r = Ho();
		return n.forEach(((n, a) => {
			let o = e.get(n);
			a.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), a.isNoDocument() && a.version.isEqual(L.min()) ? (t.removeEntry(n, a.readTime), r = r.insert(n, a)) : !o.isValidDocument() || a.version.compareTo(o.version) > 0 || a.version.compareTo(o.version) === 0 && o.hasPendingWrites ? (t.addEntry(a), r = r.insert(n, a)) : k("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", a.version);
		})), {
			Ps: r,
			Is: i
		};
	}));
}
function Cl(e, t) {
	let n = M(e);
	return n.persistence.runTransaction("Get next mutation batch", "readonly", ((e) => (t === void 0 && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t))));
}
function wl(e, t) {
	let n = M(e);
	return n.persistence.runTransaction("Allocate target", "readwrite", ((e) => {
		let r;
		return n.Ur.getTargetData(e, t).next(((i) => i ? (r = i, B.resolve(r)) : n.Ur.allocateTargetId(e).next(((i) => (r = new Rc(t, i, "TargetPurposeListen", e.currentSequenceNumber), n.Ur.addTargetData(e, r).next((() => r)))))));
	})).then(((e) => {
		let r = n.os.get(e.targetId);
		return (r === null || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.os = n.os.insert(e.targetId, e), n._s.set(t, e.targetId)), e;
	}));
}
async function Tl(e, t, n) {
	let r = M(e), i = r.os.get(t), a = n ? "readwrite" : "readwrite-primary";
	try {
		n || await r.persistence.runTransaction("Release target", a, ((e) => r.persistence.referenceDelegate.removeTarget(e, i)));
	} catch (e) {
		if (!ea(e)) throw e;
		k("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
	}
	r.os = r.os.remove(t), r._s.delete(i.target);
}
function El(e, t, n) {
	let r = M(e), i = L.min(), a = W();
	return r.persistence.runTransaction("Execute query", "readwrite", ((e) => function(e, t, n) {
		let r = M(e), i = r._s.get(n);
		return i === void 0 ? r.Ur.getTargetData(t, n) : B.resolve(r.os.get(i));
	}(r, e, Oo(t)).next(((t) => {
		if (t) return i = t.lastLimboFreeSnapshotVersion, r.Ur.getMatchingKeysForTargetId(e, t.targetId).next(((e) => {
			a = e;
		}));
	})).next((() => r.ss.getDocumentsMatchingQuery(e, t, n ? i : L.min(), n ? a : W()))).next(((e) => (Dl(r, Lo(t), e), {
		documents: e,
		Ts: a
	})))));
}
function Dl(e, t, n) {
	let r = e.us.get(t) || L.min();
	n.forEach(((e, t) => {
		t.readTime.compareTo(r) > 0 && (r = t.readTime);
	})), e.us.set(t, r);
}
var Ol = class {
	constructor() {
		this.activeTargetIds = Qo();
	}
	fs(e) {
		this.activeTargetIds = this.activeTargetIds.add(e);
	}
	gs(e) {
		this.activeTargetIds = this.activeTargetIds.delete(e);
	}
	Vs() {
		let e = {
			activeTargetIds: this.activeTargetIds.toArray(),
			updateTimeMs: Date.now()
		};
		return JSON.stringify(e);
	}
}, kl = class {
	constructor() {
		this.so = new Ol(), this.oo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
	}
	addPendingMutation(e) {}
	updateMutationState(e, t, n) {}
	addLocalQueryTarget(e, t = !0) {
		return t && this.so.fs(e), this.oo[e] || "not-current";
	}
	updateQueryState(e, t, n) {
		this.oo[e] = t;
	}
	removeLocalQueryTarget(e) {
		this.so.gs(e);
	}
	isLocalQueryTarget(e) {
		return this.so.activeTargetIds.has(e);
	}
	clearQueryState(e) {
		delete this.oo[e];
	}
	getAllActiveQueryTargets() {
		return this.so.activeTargetIds;
	}
	isActiveQueryTarget(e) {
		return this.so.activeTargetIds.has(e);
	}
	start() {
		return this.so = new Ol(), Promise.resolve();
	}
	handleUserChange(e, t, n) {}
	setOnlineState(e) {}
	shutdown() {}
	writeSequenceNumber(e) {}
	notifyBundleLoaded(e) {}
}, Al = class {
	_o(e) {}
	shutdown() {}
}, jl = class {
	constructor() {
		this.ao = () => this.uo(), this.co = () => this.lo(), this.ho = [], this.Po();
	}
	_o(e) {
		this.ho.push(e);
	}
	shutdown() {
		window.removeEventListener("online", this.ao), window.removeEventListener("offline", this.co);
	}
	Po() {
		window.addEventListener("online", this.ao), window.addEventListener("offline", this.co);
	}
	uo() {
		k("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
		for (let e of this.ho) e(0);
	}
	lo() {
		k("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
		for (let e of this.ho) e(1);
	}
	static D() {
		return typeof window < "u" && window.addEventListener !== void 0 && window.removeEventListener !== void 0;
	}
}, Ml = null;
function Nl() {
	return Ml === null ? Ml = function() {
		return 268435456 + Math.round(2147483648 * Math.random());
	}() : Ml++, "0x" + Ml.toString(16);
}
var Pl = {
	BatchGetDocuments: "batchGet",
	Commit: "commit",
	RunQuery: "runQuery",
	RunAggregationQuery: "runAggregationQuery"
}, Fl = class {
	constructor(e) {
		this.Io = e.Io, this.To = e.To;
	}
	Eo(e) {
		this.Ao = e;
	}
	Ro(e) {
		this.Vo = e;
	}
	mo(e) {
		this.fo = e;
	}
	onMessage(e) {
		this.po = e;
	}
	close() {
		this.To();
	}
	send(e) {
		this.Io(e);
	}
	yo() {
		this.Ao();
	}
	wo() {
		this.Vo();
	}
	So(e) {
		this.fo(e);
	}
	bo(e) {
		this.po(e);
	}
}, Il = "WebChannelConnection", Ll = class extends class {
	constructor(e) {
		this.databaseInfo = e, this.databaseId = e.databaseId;
		let t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
		this.Do = t + "://" + e.host, this.vo = `projects/${n}/databases/${r}`, this.Co = this.databaseId.database === "(default)" ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
	}
	get Fo() {
		return !1;
	}
	Mo(e, t, n, r, i) {
		let a = Nl(), o = this.xo(e, t.toUriEncodedString());
		k("RestConnection", `Sending RPC '${e}' ${a}:`, o, n);
		let s = {
			"google-cloud-resource-prefix": this.vo,
			"x-goog-request-params": this.Co
		};
		return this.Oo(s, r, i), this.No(e, o, s, n).then(((t) => (k("RestConnection", `Received RPC '${e}' ${a}: `, t), t)), ((t) => {
			throw Oi("RestConnection", `RPC '${e}' ${a} failed with error: `, t, "url: ", o, "request:", n), t;
		}));
	}
	Lo(e, t, n, r, i, a) {
		return this.Mo(e, t, n, r, i);
	}
	Oo(e, t, n) {
		e["X-Goog-Api-Client"] = function() {
			return "gl-js/ fire/" + wi;
		}(), e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach(((t, n) => e[n] = t)), n && n.headers.forEach(((t, n) => e[n] = t));
	}
	xo(e, t) {
		let n = Pl[e];
		return `${this.Do}/v1/${t}:${n}`;
	}
	terminate() {}
} {
	constructor(e) {
		super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
	}
	No(e, t, n, r) {
		let i = Nl();
		return new Promise(((a, o) => {
			let s = new hi();
			s.setWithCredentials(!0), s.listenOnce(_i.COMPLETE, (() => {
				try {
					switch (s.getLastErrorCode()) {
						case vi.NO_ERROR:
							let t = s.getResponseJson();
							k(Il, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), a(t);
							break;
						case vi.TIMEOUT:
							k(Il, `RPC '${e}' ${i} timed out`), o(new P(N.DEADLINE_EXCEEDED, "Request time out"));
							break;
						case vi.HTTP_ERROR:
							let n = s.getStatus();
							if (k(Il, `RPC '${e}' ${i} failed with status:`, n, "response text:", s.getResponseText()), n > 0) {
								let e = s.getResponseJson();
								Array.isArray(e) && (e = e[0]);
								let t = e?.error;
								t && t.status && t.message ? o(new P(function(e) {
									let t = e.toLowerCase().replace(/_/g, "-");
									return Object.values(N).indexOf(t) >= 0 ? t : N.UNKNOWN;
								}(t.status), t.message)) : o(new P(N.UNKNOWN, "Server responded with status " + s.getStatus()));
							} else o(new P(N.UNAVAILABLE, "Connection failed."));
							break;
						default: A();
					}
				} finally {
					k(Il, `RPC '${e}' ${i} completed.`);
				}
			}));
			let c = JSON.stringify(r);
			k(Il, `RPC '${e}' ${i} sending request:`, r), s.send(t, "POST", c, n, 15);
		}));
	}
	Bo(e, t, n) {
		let r = Nl(), i = [
			this.Do,
			"/",
			"google.firestore.v1.Firestore",
			"/",
			e,
			"/channel"
		], a = Si(), o = xi(), s = {
			httpSessionIdParam: "gsessionid",
			initMessageHeaders: {},
			messageUrlParams: { database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}` },
			sendRawJson: !0,
			supportsCrossDomainXhr: !0,
			internalChannelParams: { forwardChannelRequestTimeoutMs: 6e5 },
			forceLongPolling: this.forceLongPolling,
			detectBufferingProxy: this.autoDetectLongPolling
		}, c = this.longPollingOptions.timeoutSeconds;
		c !== void 0 && (s.longPollingTimeout = Math.round(1e3 * c)), this.useFetchStreams && (s.useFetchStreams = !0), this.Oo(s.initMessageHeaders, t, n), s.encodeInitMessageHeaders = !0;
		let l = i.join("");
		k(Il, `Creating RPC '${e}' stream ${r}: ${l}`, s);
		let u = a.createWebChannel(l, s), d = !1, f = !1, p = new Fl({
			Io: (t) => {
				f ? k(Il, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (d ||= (k(Il, `Opening RPC '${e}' stream ${r} transport.`), u.open(), !0), k(Il, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
			},
			To: () => u.close()
		}), m = (e, t, n) => {
			e.listen(t, ((e) => {
				try {
					n(e);
				} catch (e) {
					setTimeout((() => {
						throw e;
					}), 0);
				}
			}));
		};
		return m(u, gi.EventType.OPEN, (() => {
			f || (k(Il, `RPC '${e}' stream ${r} transport opened.`), p.yo());
		})), m(u, gi.EventType.CLOSE, (() => {
			f || (f = !0, k(Il, `RPC '${e}' stream ${r} transport closed`), p.So());
		})), m(u, gi.EventType.ERROR, ((t) => {
			f || (f = !0, Oi(Il, `RPC '${e}' stream ${r} transport errored:`, t), p.So(new P(N.UNAVAILABLE, "The operation could not be completed")));
		})), m(u, gi.EventType.MESSAGE, ((t) => {
			if (!f) {
				let n = t.data[0];
				j(!!n);
				let i = n, a = i.error || i[0]?.error;
				if (a) {
					k(Il, `RPC '${e}' stream ${r} received error:`, a);
					let t = a.status, n = function(e) {
						let t = G[e];
						if (t !== void 0) return Rs(t);
					}(t), i = a.message;
					n === void 0 && (n = N.INTERNAL, i = "Unknown error status: " + t + " with message " + a.message), f = !0, p.So(new P(n, i)), u.close();
				} else k(Il, `RPC '${e}' stream ${r} received:`, n), p.bo(n);
			}
		})), m(o, bi.STAT_EVENT, ((t) => {
			t.stat === yi.PROXY ? k(Il, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === yi.NOPROXY && k(Il, `RPC '${e}' stream ${r} detected no buffering proxy`);
		})), setTimeout((() => {
			p.wo();
		}), 0), p;
	}
};
function Rl() {
	return typeof document < "u" ? document : null;
}
function zl(e) {
	return new ic(e, !0);
}
var Bl = class {
	constructor(e, t, n = 1e3, r = 1.5, i = 6e4) {
		this.ui = e, this.timerId = t, this.ko = n, this.qo = r, this.Qo = i, this.Ko = 0, this.$o = null, this.Uo = Date.now(), this.reset();
	}
	reset() {
		this.Ko = 0;
	}
	Wo() {
		this.Ko = this.Qo;
	}
	Go(e) {
		this.cancel();
		let t = Math.floor(this.Ko + this.zo()), n = Math.max(0, Date.now() - this.Uo), r = Math.max(0, t - n);
		r > 0 && k("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Ko} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.$o = this.ui.enqueueAfterDelay(this.timerId, r, (() => (this.Uo = Date.now(), e()))), this.Ko *= this.qo, this.Ko < this.ko && (this.Ko = this.ko), this.Ko > this.Qo && (this.Ko = this.Qo);
	}
	jo() {
		this.$o !== null && (this.$o.skipDelay(), this.$o = null);
	}
	cancel() {
		this.$o !== null && (this.$o.cancel(), this.$o = null);
	}
	zo() {
		return (Math.random() - .5) * this.Ko;
	}
}, Vl = class {
	constructor(e, t, n, r, i, a, o, s) {
		this.ui = e, this.Ho = n, this.Jo = r, this.connection = i, this.authCredentialsProvider = a, this.appCheckCredentialsProvider = o, this.listener = s, this.state = 0, this.Yo = 0, this.Zo = null, this.Xo = null, this.stream = null, this.e_ = 0, this.t_ = new Bl(e, t);
	}
	n_() {
		return this.state === 1 || this.state === 5 || this.r_();
	}
	r_() {
		return this.state === 2 || this.state === 3;
	}
	start() {
		this.e_ = 0, this.state === 4 ? this.i_() : this.auth();
	}
	async stop() {
		this.n_() && await this.close(0);
	}
	s_() {
		this.state = 0, this.t_.reset();
	}
	o_() {
		this.r_() && this.Zo === null && (this.Zo = this.ui.enqueueAfterDelay(this.Ho, 6e4, (() => this.__())));
	}
	a_(e) {
		this.u_(), this.stream.send(e);
	}
	async __() {
		if (this.r_()) return this.close(0);
	}
	u_() {
		this.Zo &&= (this.Zo.cancel(), null);
	}
	c_() {
		this.Xo &&= (this.Xo.cancel(), null);
	}
	async close(e, t) {
		this.u_(), this.c_(), this.t_.cancel(), this.Yo++, e === 4 ? t && t.code === N.RESOURCE_EXHAUSTED ? (Di(t.toString()), Di("Using maximum backoff delay to prevent overloading the backend."), this.t_.Wo()) : t && t.code === N.UNAUTHENTICATED && this.state !== 3 && (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()) : this.t_.reset(), this.stream !== null && (this.l_(), this.stream.close(), this.stream = null), this.state = e, await this.listener.mo(t);
	}
	l_() {}
	auth() {
		this.state = 1;
		let e = this.h_(this.Yo), t = this.Yo;
		Promise.all([this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken()]).then((([e, n]) => {
			this.Yo === t && this.P_(e, n);
		}), ((t) => {
			e((() => {
				let e = new P(N.UNKNOWN, "Fetching auth token failed: " + t.message);
				return this.I_(e);
			}));
		}));
	}
	P_(e, t) {
		let n = this.h_(this.Yo);
		this.stream = this.T_(e, t), this.stream.Eo((() => {
			n((() => this.listener.Eo()));
		})), this.stream.Ro((() => {
			n((() => (this.state = 2, this.Xo = this.ui.enqueueAfterDelay(this.Jo, 1e4, (() => (this.r_() && (this.state = 3), Promise.resolve()))), this.listener.Ro())));
		})), this.stream.mo(((e) => {
			n((() => this.I_(e)));
		})), this.stream.onMessage(((e) => {
			n((() => ++this.e_ == 1 ? this.E_(e) : this.onNext(e)));
		}));
	}
	i_() {
		this.state = 5, this.t_.Go((async () => {
			this.state = 0, this.start();
		}));
	}
	I_(e) {
		return k("PersistentStream", `close with error: ${e}`), this.stream = null, this.close(4, e);
	}
	h_(e) {
		return (t) => {
			this.ui.enqueueAndForget((() => this.Yo === e ? t() : (k("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve())));
		};
	}
}, Hl = class extends Vl {
	constructor(e, t, n, r, i, a) {
		super(e, "listen_stream_connection_backoff", "listen_stream_idle", "health_check_timeout", t, n, r, a), this.serializer = i;
	}
	T_(e, t) {
		return this.connection.Bo("Listen", e, t);
	}
	E_(e) {
		return this.onNext(e);
	}
	onNext(e) {
		this.t_.reset();
		let t = xc(this.serializer, e), n = function(e) {
			if (!("targetChange" in e)) return L.min();
			let t = e.targetChange;
			return t.targetIds && t.targetIds.length ? L.min() : t.readTime ? lc(t.readTime) : L.min();
		}(e);
		return this.listener.d_(t, n);
	}
	A_(e) {
		let t = {};
		t.database = _c(this.serializer), t.addTarget = function(e, t) {
			let n, r = t.target;
			if (n = xo(r) ? { documents: wc(e, r) } : { query: Tc(e, r)._t }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
				n.resumeToken = sc(e, t.resumeToken);
				let r = ac(e, t.expectedCount);
				r !== null && (n.expectedCount = r);
			} else if (t.snapshotVersion.compareTo(L.min()) > 0) {
				n.readTime = oc(e, t.snapshotVersion.toTimestamp());
				let r = ac(e, t.expectedCount);
				r !== null && (n.expectedCount = r);
			}
			return n;
		}(this.serializer, e);
		let n = Oc(this.serializer, e);
		n && (t.labels = n), this.a_(t);
	}
	R_(e) {
		let t = {};
		t.database = _c(this.serializer), t.removeTarget = e, this.a_(t);
	}
}, Ul = class extends Vl {
	constructor(e, t, n, r, i, a) {
		super(e, "write_stream_connection_backoff", "write_stream_idle", "health_check_timeout", t, n, r, a), this.serializer = i;
	}
	get V_() {
		return this.e_ > 0;
	}
	start() {
		this.lastStreamToken = void 0, super.start();
	}
	l_() {
		this.V_ && this.m_([]);
	}
	T_(e, t) {
		return this.connection.Bo("Write", e, t);
	}
	E_(e) {
		return j(!!e.streamToken), this.lastStreamToken = e.streamToken, j(!e.writeResults || e.writeResults.length === 0), this.listener.f_();
	}
	onNext(e) {
		j(!!e.streamToken), this.lastStreamToken = e.streamToken, this.t_.reset();
		let t = Cc(e.writeResults, e.commitTime), n = lc(e.commitTime);
		return this.listener.g_(n, t);
	}
	p_() {
		let e = {};
		e.database = _c(this.serializer), this.a_(e);
	}
	m_(e) {
		let t = {
			streamToken: this.lastStreamToken,
			writes: e.map(((e) => Sc(this.serializer, e)))
		};
		this.a_(t);
	}
}, Wl = class extends class {} {
	constructor(e, t, n, r) {
		super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.y_ = !1;
	}
	w_() {
		if (this.y_) throw new P(N.FAILED_PRECONDITION, "The client has already been terminated.");
	}
	Mo(e, t, n, r) {
		return this.w_(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then((([i, a]) => this.connection.Mo(e, dc(t, n), r, i, a))).catch(((e) => {
			throw e.name === "FirebaseError" ? (e.code === N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new P(N.UNKNOWN, e.toString());
		}));
	}
	Lo(e, t, n, r, i) {
		return this.w_(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then((([a, o]) => this.connection.Lo(e, dc(t, n), r, a, o, i))).catch(((e) => {
			throw e.name === "FirebaseError" ? (e.code === N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new P(N.UNKNOWN, e.toString());
		}));
	}
	terminate() {
		this.y_ = !0, this.connection.terminate();
	}
}, Gl = class {
	constructor(e, t) {
		this.asyncQueue = e, this.onlineStateHandler = t, this.state = "Unknown", this.S_ = 0, this.b_ = null, this.D_ = !0;
	}
	v_() {
		this.S_ === 0 && (this.C_("Unknown"), this.b_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout", 1e4, (() => (this.b_ = null, this.F_("Backend didn't respond within 10 seconds."), this.C_("Offline"), Promise.resolve()))));
	}
	M_(e) {
		this.state === "Online" ? this.C_("Unknown") : (this.S_++, this.S_ >= 1 && (this.x_(), this.F_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.C_("Offline")));
	}
	set(e) {
		this.x_(), this.S_ = 0, e === "Online" && (this.D_ = !1), this.C_(e);
	}
	C_(e) {
		e !== this.state && (this.state = e, this.onlineStateHandler(e));
	}
	F_(e) {
		let t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
		this.D_ ? (Di(t), this.D_ = !1) : k("OnlineStateTracker", t);
	}
	x_() {
		this.b_ !== null && (this.b_.cancel(), this.b_ = null);
	}
}, Kl = class {
	constructor(e, t, n, r, i) {
		this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, this.O_ = [], this.N_ = /* @__PURE__ */ new Map(), this.L_ = /* @__PURE__ */ new Set(), this.B_ = [], this.k_ = i, this.k_._o(((e) => {
			n.enqueueAndForget((async () => {
				tu(this) && (k("RemoteStore", "Restarting streams for network reachability change."), await async function(e) {
					let t = M(e);
					t.L_.add(4), await Jl(t), t.q_.set("Unknown"), t.L_.delete(4), await ql(t);
				}(this));
			}));
		})), this.q_ = new Gl(n, r);
	}
};
async function ql(e) {
	if (tu(e)) for (let t of e.B_) await t(!0);
}
async function Jl(e) {
	for (let t of e.B_) await t(!1);
}
function Yl(e, t) {
	let n = M(e);
	n.N_.has(t.targetId) || (n.N_.set(t.targetId, t), eu(n) ? $l(n) : bu(n).r_() && Zl(n, t));
}
function Xl(e, t) {
	let n = M(e), r = bu(n);
	n.N_.delete(t), r.r_() && Ql(n, t), n.N_.size === 0 && (r.r_() ? r.o_() : tu(n) && n.q_.set("Unknown"));
}
function Zl(e, t) {
	if (e.Q_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(L.min()) > 0) {
		let n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
		t = t.withExpectedCount(n);
	}
	bu(e).A_(t);
}
function Ql(e, t) {
	e.Q_.xe(t), bu(e).R_(t);
}
function $l(e) {
	e.Q_ = new Qs({
		getRemoteKeysForTarget: (t) => e.remoteSyncer.getRemoteKeysForTarget(t),
		ot: (t) => e.N_.get(t) || null,
		tt: () => e.datastore.serializer.databaseId
	}), bu(e).start(), e.q_.v_();
}
function eu(e) {
	return tu(e) && !bu(e).n_() && e.N_.size > 0;
}
function tu(e) {
	return M(e).L_.size === 0;
}
function nu(e) {
	e.Q_ = void 0;
}
async function ru(e) {
	e.q_.set("Online");
}
async function iu(e) {
	e.N_.forEach(((t, n) => {
		Zl(e, t);
	}));
}
async function au(e, t) {
	nu(e), eu(e) ? (e.q_.M_(t), $l(e)) : e.q_.set("Unknown");
}
async function ou(e, t, n) {
	if (e.q_.set("Online"), t instanceof Xs && t.state === 2 && t.cause) try {
		await async function(e, t) {
			let n = t.cause;
			for (let r of t.targetIds) e.N_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.N_.delete(r), e.Q_.removeTarget(r));
		}(e, t);
	} catch (n) {
		k("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await su(e, n);
	}
	else if (t instanceof Js ? e.Q_.Ke(t) : t instanceof Ys ? e.Q_.He(t) : e.Q_.We(t), !n.isEqual(L.min())) try {
		let t = await bl(e.localStore);
		n.compareTo(t) >= 0 && await function(e, t) {
			let n = e.Q_.rt(t);
			return n.targetChanges.forEach(((n, r) => {
				if (n.resumeToken.approximateByteSize() > 0) {
					let i = e.N_.get(r);
					i && e.N_.set(r, i.withResumeToken(n.resumeToken, t));
				}
			})), n.targetMismatches.forEach(((t, n) => {
				let r = e.N_.get(t);
				r && (e.N_.set(t, r.withResumeToken(va.EMPTY_BYTE_STRING, r.snapshotVersion)), Ql(e, t), Zl(e, new Rc(r.target, t, n, r.sequenceNumber)));
			})), e.remoteSyncer.applyRemoteEvent(n);
		}(e, n);
	} catch (t) {
		k("RemoteStore", "Failed to raise snapshot:", t), await su(e, t);
	}
}
async function su(e, t, n) {
	if (!ea(t)) throw t;
	e.L_.add(1), await Jl(e), e.q_.set("Offline"), n ||= () => bl(e.localStore), e.asyncQueue.enqueueRetryable((async () => {
		k("RemoteStore", "Retrying IndexedDB access"), await n(), e.L_.delete(1), await ql(e);
	}));
}
function cu(e, t) {
	return t().catch(((n) => su(e, n, t)));
}
async function lu(e) {
	let t = M(e), n = xu(t), r = t.O_.length > 0 ? t.O_[t.O_.length - 1].batchId : -1;
	for (; uu(t);) try {
		let e = await Cl(t.localStore, r);
		if (e === null) {
			t.O_.length === 0 && n.o_();
			break;
		}
		r = e.batchId, du(t, e);
	} catch (e) {
		await su(t, e);
	}
	fu(t) && pu(t);
}
function uu(e) {
	return tu(e) && e.O_.length < 10;
}
function du(e, t) {
	e.O_.push(t);
	let n = xu(e);
	n.r_() && n.V_ && n.m_(t.mutations);
}
function fu(e) {
	return tu(e) && !xu(e).n_() && e.O_.length > 0;
}
function pu(e) {
	xu(e).start();
}
async function mu(e) {
	xu(e).p_();
}
async function hu(e) {
	let t = xu(e);
	for (let n of e.O_) t.m_(n.mutations);
}
async function gu(e, t, n) {
	let r = e.O_.shift(), i = Ns.from(r, t, n);
	await cu(e, (() => e.remoteSyncer.applySuccessfulWrite(i))), await lu(e);
}
async function _u(e, t) {
	t && xu(e).V_ && await async function(e, t) {
		if (function(e) {
			return Ls(e) && e !== N.ABORTED;
		}(t.code)) {
			let n = e.O_.shift();
			xu(e).s_(), await cu(e, (() => e.remoteSyncer.rejectFailedWrite(n.batchId, t))), await lu(e);
		}
	}(e, t), fu(e) && pu(e);
}
async function vu(e, t) {
	let n = M(e);
	n.asyncQueue.verifyOperationInProgress(), k("RemoteStore", "RemoteStore received new credentials");
	let r = tu(n);
	n.L_.add(3), await Jl(n), r && n.q_.set("Unknown"), await n.remoteSyncer.handleCredentialChange(t), n.L_.delete(3), await ql(n);
}
async function yu(e, t) {
	let n = M(e);
	t ? (n.L_.delete(2), await ql(n)) : t || (n.L_.add(2), await Jl(n), n.q_.set("Unknown"));
}
function bu(e) {
	return e.K_ || (e.K_ = function(e, t, n) {
		let r = M(e);
		return r.w_(), new Hl(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
	}(e.datastore, e.asyncQueue, {
		Eo: ru.bind(null, e),
		Ro: iu.bind(null, e),
		mo: au.bind(null, e),
		d_: ou.bind(null, e)
	}), e.B_.push((async (t) => {
		t ? (e.K_.s_(), eu(e) ? $l(e) : e.q_.set("Unknown")) : (await e.K_.stop(), nu(e));
	}))), e.K_;
}
function xu(e) {
	return e.U_ || (e.U_ = function(e, t, n) {
		let r = M(e);
		return r.w_(), new Ul(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
	}(e.datastore, e.asyncQueue, {
		Eo: () => Promise.resolve(),
		Ro: mu.bind(null, e),
		mo: _u.bind(null, e),
		f_: hu.bind(null, e),
		g_: gu.bind(null, e)
	}), e.B_.push((async (t) => {
		t ? (e.U_.s_(), await lu(e)) : (await e.U_.stop(), e.O_.length > 0 && (k("RemoteStore", `Stopping write stream with ${e.O_.length} pending writes`), e.O_ = []));
	}))), e.U_;
}
var Su = class e {
	constructor(e, t, n, r, i) {
		this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new Ai(), this.then = this.deferred.promise.then.bind(this.deferred.promise), this.deferred.promise.catch(((e) => {}));
	}
	get promise() {
		return this.deferred.promise;
	}
	static createAndSchedule(t, n, r, i, a) {
		let o = new e(t, n, Date.now() + r, i, a);
		return o.start(r), o;
	}
	start(e) {
		this.timerHandle = setTimeout((() => this.handleDelayElapsed()), e);
	}
	skipDelay() {
		return this.handleDelayElapsed();
	}
	cancel(e) {
		this.timerHandle !== null && (this.clearTimeout(), this.deferred.reject(new P(N.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
	}
	handleDelayElapsed() {
		this.asyncQueue.enqueueAndForget((() => this.timerHandle === null ? Promise.resolve() : (this.clearTimeout(), this.op().then(((e) => this.deferred.resolve(e))))));
	}
	clearTimeout() {
		this.timerHandle !== null && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
	}
};
function Cu(e, t) {
	if (Di("AsyncQueue", `${t}: ${e}`), ea(e)) return new P(N.UNAVAILABLE, `${t}: ${e}`);
	throw e;
}
var wu = class e {
	constructor(e) {
		this.comparator = e ? (t, n) => e(t, n) || z.comparator(t.key, n.key) : (e, t) => z.comparator(e.key, t.key), this.keyedMap = Wo(), this.sortedSet = new V(this.comparator);
	}
	static emptySet(t) {
		return new e(t.comparator);
	}
	has(e) {
		return this.keyedMap.get(e) != null;
	}
	get(e) {
		return this.keyedMap.get(e);
	}
	first() {
		return this.sortedSet.minKey();
	}
	last() {
		return this.sortedSet.maxKey();
	}
	isEmpty() {
		return this.sortedSet.isEmpty();
	}
	indexOf(e) {
		let t = this.keyedMap.get(e);
		return t ? this.sortedSet.indexOf(t) : -1;
	}
	get size() {
		return this.sortedSet.size;
	}
	forEach(e) {
		this.sortedSet.inorderTraversal(((t, n) => (e(t), !1)));
	}
	add(e) {
		let t = this.delete(e.key);
		return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
	}
	delete(e) {
		let t = this.get(e);
		return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
	}
	isEqual(t) {
		if (!(t instanceof e) || this.size !== t.size) return !1;
		let n = this.sortedSet.getIterator(), r = t.sortedSet.getIterator();
		for (; n.hasNext();) {
			let e = n.getNext().key, t = r.getNext().key;
			if (!e.isEqual(t)) return !1;
		}
		return !0;
	}
	toString() {
		let e = [];
		return this.forEach(((t) => {
			e.push(t.toString());
		})), e.length === 0 ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
	}
	copy(t, n) {
		let r = new e();
		return r.comparator = this.comparator, r.keyedMap = t, r.sortedSet = n, r;
	}
}, Tu = class {
	constructor() {
		this.W_ = new V(z.comparator);
	}
	track(e) {
		let t = e.doc.key, n = this.W_.get(t);
		n ? e.type !== 0 && n.type === 3 ? this.W_ = this.W_.insert(t, e) : e.type === 3 && n.type !== 1 ? this.W_ = this.W_.insert(t, {
			type: n.type,
			doc: e.doc
		}) : e.type === 2 && n.type === 2 ? this.W_ = this.W_.insert(t, {
			type: 2,
			doc: e.doc
		}) : e.type === 2 && n.type === 0 ? this.W_ = this.W_.insert(t, {
			type: 0,
			doc: e.doc
		}) : e.type === 1 && n.type === 0 ? this.W_ = this.W_.remove(t) : e.type === 1 && n.type === 2 ? this.W_ = this.W_.insert(t, {
			type: 1,
			doc: n.doc
		}) : e.type === 0 && n.type === 1 ? this.W_ = this.W_.insert(t, {
			type: 2,
			doc: e.doc
		}) : A() : this.W_ = this.W_.insert(t, e);
	}
	G_() {
		let e = [];
		return this.W_.inorderTraversal(((t, n) => {
			e.push(n);
		})), e;
	}
}, Eu = class e {
	constructor(e, t, n, r, i, a, o, s, c) {
		this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = a, this.syncStateChanged = o, this.excludesMetadataChanges = s, this.hasCachedResults = c;
	}
	static fromInitialDocuments(t, n, r, i, a) {
		let o = [];
		return n.forEach(((e) => {
			o.push({
				type: 0,
				doc: e
			});
		})), new e(t, n, wu.emptySet(n), o, r, i, !0, !1, a);
	}
	get hasPendingWrites() {
		return !this.mutatedKeys.isEmpty();
	}
	isEqual(e) {
		if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && No(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
		let t = this.docChanges, n = e.docChanges;
		if (t.length !== n.length) return !1;
		for (let e = 0; e < t.length; e++) if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
		return !0;
	}
}, Du = class {
	constructor() {
		this.z_ = void 0, this.j_ = [];
	}
	H_() {
		return this.j_.some(((e) => e.J_()));
	}
}, Ou = class {
	constructor() {
		this.queries = ku(), this.onlineState = "Unknown", this.Y_ = /* @__PURE__ */ new Set();
	}
	terminate() {
		(function(e, t) {
			let n = M(e), r = n.queries;
			n.queries = ku(), r.forEach(((e, n) => {
				for (let e of n.j_) e.onError(t);
			}));
		})(this, new P(N.ABORTED, "Firestore shutting down"));
	}
};
function ku() {
	return new Bo(((e) => Po(e)), No);
}
async function Au(e, t) {
	let n = M(e), r = 3, i = t.query, a = n.queries.get(i);
	a ? !a.H_() && t.J_() && (r = 2) : (a = new Du(), r = +!t.J_());
	try {
		switch (r) {
			case 0:
				a.z_ = await n.onListen(i, !0);
				break;
			case 1:
				a.z_ = await n.onListen(i, !1);
				break;
			case 2: await n.onFirstRemoteStoreListen(i);
		}
	} catch (e) {
		let n = Cu(e, `Initialization of query '${Fo(t.query)}' failed`);
		t.onError(n);
		return;
	}
	n.queries.set(i, a), a.j_.push(t), t.Z_(n.onlineState), a.z_ && t.X_(a.z_) && Pu(n);
}
async function ju(e, t) {
	let n = M(e), r = t.query, i = 3, a = n.queries.get(r);
	if (a) {
		let e = a.j_.indexOf(t);
		e >= 0 && (a.j_.splice(e, 1), a.j_.length === 0 ? i = +!t.J_() : !a.H_() && t.J_() && (i = 2));
	}
	switch (i) {
		case 0: return n.queries.delete(r), n.onUnlisten(r, !0);
		case 1: return n.queries.delete(r), n.onUnlisten(r, !1);
		case 2: return n.onLastRemoteStoreUnlisten(r);
		default: return;
	}
}
function Mu(e, t) {
	let n = M(e), r = !1;
	for (let e of t) {
		let t = e.query, i = n.queries.get(t);
		if (i) {
			for (let t of i.j_) t.X_(e) && (r = !0);
			i.z_ = e;
		}
	}
	r && Pu(n);
}
function Nu(e, t, n) {
	let r = M(e), i = r.queries.get(t);
	if (i) for (let e of i.j_) e.onError(n);
	r.queries.delete(t);
}
function Pu(e) {
	e.Y_.forEach(((e) => {
		e.next();
	}));
}
var Fu, Iu;
(Iu = Fu ||= {}).ea = "default", Iu.Cache = "cache";
var Lu = class {
	constructor(e, t, n) {
		this.query = e, this.ta = t, this.na = !1, this.ra = null, this.onlineState = "Unknown", this.options = n || {};
	}
	X_(e) {
		if (!this.options.includeMetadataChanges) {
			let t = [];
			for (let n of e.docChanges) n.type !== 3 && t.push(n);
			e = new Eu(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, !0, e.hasCachedResults);
		}
		let t = !1;
		return this.na ? this.ia(e) && (this.ta.next(e), t = !0) : this.sa(e, this.onlineState) && (this.oa(e), t = !0), this.ra = e, t;
	}
	onError(e) {
		this.ta.error(e);
	}
	Z_(e) {
		this.onlineState = e;
		let t = !1;
		return this.ra && !this.na && this.sa(this.ra, e) && (this.oa(this.ra), t = !0), t;
	}
	sa(e, t) {
		if (!e.fromCache || !this.J_()) return !0;
		let n = t !== "Offline";
		return (!this.options._a || !n) && (!e.docs.isEmpty() || e.hasCachedResults || t === "Offline");
	}
	ia(e) {
		if (e.docChanges.length > 0) return !0;
		let t = this.ra && this.ra.hasPendingWrites !== e.hasPendingWrites;
		return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
	}
	oa(e) {
		e = Eu.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.na = !0, this.ta.next(e);
	}
	J_() {
		return this.options.source !== Fu.Cache;
	}
}, Ru = class {
	constructor(e) {
		this.key = e;
	}
}, zu = class {
	constructor(e) {
		this.key = e;
	}
}, Bu = class {
	constructor(e, t) {
		this.query = e, this.Ta = t, this.Ea = null, this.hasCachedResults = !1, this.current = !1, this.da = W(), this.mutatedKeys = W(), this.Aa = Ro(e), this.Ra = new wu(this.Aa);
	}
	get Va() {
		return this.Ta;
	}
	ma(e, t) {
		let n = t ? t.fa : new Tu(), r = t ? t.Ra : this.Ra, i = t ? t.mutatedKeys : this.mutatedKeys, a = r, o = !1, s = this.query.limitType === "F" && r.size === this.query.limit ? r.last() : null, c = this.query.limitType === "L" && r.size === this.query.limit ? r.first() : null;
		if (e.inorderTraversal(((e, t) => {
			let l = r.get(e), u = Io(this.query, t) ? t : null, d = !!l && this.mutatedKeys.has(l.key), f = !!u && (u.hasLocalMutations || this.mutatedKeys.has(u.key) && u.hasCommittedMutations), p = !1;
			l && u ? l.data.isEqual(u.data) ? d !== f && (n.track({
				type: 3,
				doc: u
			}), p = !0) : this.ga(l, u) || (n.track({
				type: 2,
				doc: u
			}), p = !0, (s && this.Aa(u, s) > 0 || c && this.Aa(u, c) < 0) && (o = !0)) : !l && u ? (n.track({
				type: 0,
				doc: u
			}), p = !0) : l && !u && (n.track({
				type: 1,
				doc: l
			}), p = !0, (s || c) && (o = !0)), p && (u ? (a = a.add(u), i = f ? i.add(e) : i.delete(e)) : (a = a.delete(e), i = i.delete(e)));
		})), this.query.limit !== null) for (; a.size > this.query.limit;) {
			let e = this.query.limitType === "F" ? a.last() : a.first();
			a = a.delete(e.key), i = i.delete(e.key), n.track({
				type: 1,
				doc: e
			});
		}
		return {
			Ra: a,
			fa: n,
			ns: o,
			mutatedKeys: i
		};
	}
	ga(e, t) {
		return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
	}
	applyChanges(e, t, n, r) {
		let i = this.Ra;
		this.Ra = e.Ra, this.mutatedKeys = e.mutatedKeys;
		let a = e.fa.G_();
		a.sort(((e, t) => function(e, t) {
			let n = (e) => {
				switch (e) {
					case 0: return 1;
					case 2:
					case 3: return 2;
					case 1: return 0;
					default: return A();
				}
			};
			return n(e) - n(t);
		}(e.type, t.type) || this.Aa(e.doc, t.doc))), this.pa(n), r = r != null && r;
		let o = t && !r ? this.ya() : [], s = this.da.size === 0 && this.current && !r ? 1 : 0, c = s !== this.Ea;
		return this.Ea = s, a.length !== 0 || c ? {
			snapshot: new Eu(this.query, e.Ra, i, a, e.mutatedKeys, s === 0, c, !1, !!n && n.resumeToken.approximateByteSize() > 0),
			wa: o
		} : { wa: o };
	}
	Z_(e) {
		return this.current && e === "Offline" ? (this.current = !1, this.applyChanges({
			Ra: this.Ra,
			fa: new Tu(),
			mutatedKeys: this.mutatedKeys,
			ns: !1
		}, !1)) : { wa: [] };
	}
	Sa(e) {
		return !this.Ta.has(e) && !!this.Ra.has(e) && !this.Ra.get(e).hasLocalMutations;
	}
	pa(e) {
		e && (e.addedDocuments.forEach(((e) => this.Ta = this.Ta.add(e))), e.modifiedDocuments.forEach(((e) => {})), e.removedDocuments.forEach(((e) => this.Ta = this.Ta.delete(e))), this.current = e.current);
	}
	ya() {
		if (!this.current) return [];
		let e = this.da;
		this.da = W(), this.Ra.forEach(((e) => {
			this.Sa(e.key) && (this.da = this.da.add(e.key));
		}));
		let t = [];
		return e.forEach(((e) => {
			this.da.has(e) || t.push(new zu(e));
		})), this.da.forEach(((n) => {
			e.has(n) || t.push(new Ru(n));
		})), t;
	}
	ba(e) {
		this.Ta = e.Ts, this.da = W();
		let t = this.ma(e.documents);
		return this.applyChanges(t, !0);
	}
	Da() {
		return Eu.fromInitialDocuments(this.query, this.Ra, this.mutatedKeys, this.Ea === 0, this.hasCachedResults);
	}
}, Vu = class {
	constructor(e, t, n) {
		this.query = e, this.targetId = t, this.view = n;
	}
}, Hu = class {
	constructor(e) {
		this.key = e, this.va = !1;
	}
}, Uu = class {
	constructor(e, t, n, r, i, a) {
		this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = a, this.Ca = {}, this.Fa = new Bo(((e) => Po(e)), No), this.Ma = /* @__PURE__ */ new Map(), this.xa = /* @__PURE__ */ new Set(), this.Oa = new V(z.comparator), this.Na = /* @__PURE__ */ new Map(), this.La = new il(), this.Ba = {}, this.ka = /* @__PURE__ */ new Map(), this.qa = Kc.kn(), this.onlineState = "Unknown", this.Qa = void 0;
	}
	get isPrimaryClient() {
		return !0 === this.Qa;
	}
};
async function Wu(e, t, n = !0) {
	let r = fd(e), i, a = r.Fa.get(t);
	return a ? (r.sharedClientState.addLocalQueryTarget(a.targetId), i = a.view.Da()) : i = await Ku(r, t, n, !0), i;
}
async function Gu(e, t) {
	await Ku(fd(e), t, !0, !1);
}
async function Ku(e, t, n, r) {
	let i = await wl(e.localStore, Oo(t)), a = i.targetId, o = e.sharedClientState.addLocalQueryTarget(a, n), s;
	return r && (s = await qu(e, t, a, o === "current", i.resumeToken)), e.isPrimaryClient && n && Yl(e.remoteStore, i), s;
}
async function qu(e, t, n, r, i) {
	e.Ka = (t, n, r) => async function(e, t, n, r) {
		let i = t.view.ma(n);
		i.ns && (i = await El(e.localStore, t.query, !1).then((({ documents: e }) => t.view.ma(e, i))));
		let a = r && r.targetChanges.get(t.targetId), o = r && r.targetMismatches.get(t.targetId) != null, s = t.view.applyChanges(i, e.isPrimaryClient, a, o);
		return od(e, t.targetId, s.wa), s.snapshot;
	}(e, t, n, r);
	let a = await El(e.localStore, t, !0), o = new Bu(t, a.Ts), s = o.ma(a.documents), c = qs.createSynthesizedTargetChangeForCurrentChange(n, r && e.onlineState !== "Offline", i), l = o.applyChanges(s, e.isPrimaryClient, c);
	od(e, n, l.wa);
	let u = new Vu(t, n, o);
	return e.Fa.set(t, u), e.Ma.has(n) ? e.Ma.get(n).push(t) : e.Ma.set(n, [t]), l.snapshot;
}
async function Ju(e, t, n) {
	let r = M(e), i = r.Fa.get(t), a = r.Ma.get(i.targetId);
	if (a.length > 1) return r.Ma.set(i.targetId, a.filter(((e) => !No(e, t)))), void r.Fa.delete(t);
	r.isPrimaryClient ? (r.sharedClientState.removeLocalQueryTarget(i.targetId), r.sharedClientState.isActiveQueryTarget(i.targetId) || await Tl(r.localStore, i.targetId, !1).then((() => {
		r.sharedClientState.clearQueryState(i.targetId), n && Xl(r.remoteStore, i.targetId), id(r, i.targetId);
	})).catch(Qi)) : (id(r, i.targetId), await Tl(r.localStore, i.targetId, !0));
}
async function Yu(e, t) {
	let n = M(e), r = n.Fa.get(t), i = n.Ma.get(r.targetId);
	n.isPrimaryClient && i.length === 1 && (n.sharedClientState.removeLocalQueryTarget(r.targetId), Xl(n.remoteStore, r.targetId));
}
async function Xu(e, t, n) {
	let r = pd(e);
	try {
		let e = await function(e, t) {
			let n = M(e), r = I.now(), i = t.reduce(((e, t) => e.add(t.key)), W()), a, o;
			return n.persistence.runTransaction("Locally write mutations", "readwrite", ((e) => {
				let s = Ho(), c = W();
				return n.cs.getEntries(e, i).next(((e) => {
					s = e, s.forEach(((e, t) => {
						t.isValidDocument() || (c = c.add(e));
					}));
				})).next((() => n.localDocuments.getOverlayedDocuments(e, s))).next(((i) => {
					a = i;
					let o = [];
					for (let e of t) {
						let t = Cs(e, a.get(e.key).overlayedDocument);
						t != null && o.push(new Es(e.key, t, qa(t.value.mapValue), _s.exists(!0)));
					}
					return n.mutationQueue.addMutationBatch(e, r, o, t);
				})).next(((t) => {
					o = t;
					let r = t.applyToLocalDocumentSet(a, c);
					return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
				}));
			})).then((() => ({
				batchId: o.batchId,
				changes: Go(a)
			})));
		}(r.localStore, t);
		r.sharedClientState.addPendingMutation(e.batchId), function(e, t, n) {
			let r = e.Ba[e.currentUser.toKey()];
			r ||= new V(F), r = r.insert(t, n), e.Ba[e.currentUser.toKey()] = r;
		}(r, e.batchId, n), await ld(r, e.changes), await lu(r.remoteStore);
	} catch (e) {
		let t = Cu(e, "Failed to persist write");
		n.reject(t);
	}
}
async function Zu(e, t) {
	let n = M(e);
	try {
		let e = await xl(n.localStore, t);
		t.targetChanges.forEach(((e, t) => {
			let r = n.Na.get(t);
			r && (j(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.va = !0 : e.modifiedDocuments.size > 0 ? j(r.va) : e.removedDocuments.size > 0 && (j(r.va), r.va = !1));
		})), await ld(n, e, t);
	} catch (e) {
		await Qi(e);
	}
}
function Qu(e, t, n) {
	let r = M(e);
	if (r.isPrimaryClient && n === 0 || !r.isPrimaryClient && n === 1) {
		let e = [];
		r.Fa.forEach(((n, r) => {
			let i = r.view.Z_(t);
			i.snapshot && e.push(i.snapshot);
		})), function(e, t) {
			let n = M(e);
			n.onlineState = t;
			let r = !1;
			n.queries.forEach(((e, n) => {
				for (let e of n.j_) e.Z_(t) && (r = !0);
			})), r && Pu(n);
		}(r.eventManager, t), e.length && r.Ca.d_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
	}
}
async function $u(e, t, n) {
	let r = M(e);
	r.sharedClientState.updateQueryState(t, "rejected", n);
	let i = r.Na.get(t), a = i && i.key;
	if (a) {
		let e = new V(z.comparator);
		e = e.insert(a, Ja.newNoDocument(a, L.min()));
		let n = W().add(a);
		await Zu(r, new Ks(L.min(), /* @__PURE__ */ new Map(), new V(F), e, n)), r.Oa = r.Oa.remove(a), r.Na.delete(t), cd(r);
	} else await Tl(r.localStore, t, !1).then((() => id(r, t, n))).catch(Qi);
}
async function ed(e, t) {
	let n = M(e), r = t.batch.batchId;
	try {
		let e = await yl(n.localStore, t);
		rd(n, r, null), nd(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await ld(n, e);
	} catch (e) {
		await Qi(e);
	}
}
async function td(e, t, n) {
	let r = M(e);
	try {
		let e = await function(e, t) {
			let n = M(e);
			return n.persistence.runTransaction("Reject batch", "readwrite-primary", ((e) => {
				let r;
				return n.mutationQueue.lookupMutationBatch(e, t).next(((t) => (j(t !== null), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t)))).next((() => n.mutationQueue.performConsistencyCheck(e))).next((() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t))).next((() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r))).next((() => n.localDocuments.getDocuments(e, r)));
			}));
		}(r.localStore, t);
		rd(r, t, n), nd(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await ld(r, e);
	} catch (e) {
		await Qi(e);
	}
}
function nd(e, t) {
	(e.ka.get(t) || []).forEach(((e) => {
		e.resolve();
	})), e.ka.delete(t);
}
function rd(e, t, n) {
	let r = M(e), i = r.Ba[r.currentUser.toKey()];
	if (i) {
		let e = i.get(t);
		e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Ba[r.currentUser.toKey()] = i;
	}
}
function id(e, t, n = null) {
	e.sharedClientState.removeLocalQueryTarget(t);
	for (let r of e.Ma.get(t)) e.Fa.delete(r), n && e.Ca.$a(r, n);
	e.Ma.delete(t), e.isPrimaryClient && e.La.gr(t).forEach(((t) => {
		e.La.containsKey(t) || ad(e, t);
	}));
}
function ad(e, t) {
	e.xa.delete(t.path.canonicalString());
	let n = e.Oa.get(t);
	n !== null && (Xl(e.remoteStore, n), e.Oa = e.Oa.remove(t), e.Na.delete(n), cd(e));
}
function od(e, t, n) {
	for (let r of n) r instanceof Ru ? (e.La.addReference(r.key, t), sd(e, r)) : r instanceof zu ? (k("SyncEngine", "Document no longer in limbo: " + r.key), e.La.removeReference(r.key, t), e.La.containsKey(r.key) || ad(e, r.key)) : A();
}
function sd(e, t) {
	let n = t.key, r = n.path.canonicalString();
	e.Oa.get(n) || e.xa.has(r) || (k("SyncEngine", "New document in limbo: " + n), e.xa.add(r), cd(e));
}
function cd(e) {
	for (; e.xa.size > 0 && e.Oa.size < e.maxConcurrentLimboResolutions;) {
		let t = e.xa.values().next().value;
		e.xa.delete(t);
		let n = new z(R.fromString(t)), r = e.qa.next();
		e.Na.set(r, new Hu(n)), e.Oa = e.Oa.insert(n, r), Yl(e.remoteStore, new Rc(Oo(wo(n.path)), r, "TargetPurposeLimboResolution", ta.oe));
	}
}
async function ld(e, t, n) {
	let r = M(e), i = [], a = [], o = [];
	r.Fa.isEmpty() || (r.Fa.forEach(((e, s) => {
		o.push(r.Ka(s, t, n).then(((e) => {
			if ((e || n) && r.isPrimaryClient) {
				let t = e ? !e.fromCache : n?.targetChanges.get(s.targetId)?.current;
				r.sharedClientState.updateQueryState(s.targetId, t ? "current" : "not-current");
			}
			if (e) {
				i.push(e);
				let t = pl.Wi(s.targetId, e);
				a.push(t);
			}
		})));
	})), await Promise.all(o), r.Ca.d_(i), await async function(e, t) {
		let n = M(e);
		try {
			await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", ((e) => B.forEach(t, ((t) => B.forEach(t.$i, ((r) => n.persistence.referenceDelegate.addReference(e, t.targetId, r))).next((() => B.forEach(t.Ui, ((r) => n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))))))));
		} catch (e) {
			if (!ea(e)) throw e;
			k("LocalStore", "Failed to update sequence numbers: " + e);
		}
		for (let e of t) {
			let t = e.targetId;
			if (!e.fromCache) {
				let e = n.os.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
				n.os = n.os.insert(t, i);
			}
		}
	}(r.localStore, a));
}
async function ud(e, t) {
	let n = M(e);
	if (!n.currentUser.isEqual(t)) {
		k("SyncEngine", "User change. New user:", t.toKey());
		let e = await vl(n.localStore, t);
		n.currentUser = t, function(e, t) {
			e.ka.forEach(((e) => {
				e.forEach(((e) => {
					e.reject(new P(N.CANCELLED, t));
				}));
			})), e.ka.clear();
		}(n, "'waitForPendingWrites' promise is rejected due to a user change."), n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await ld(n, e.hs);
	}
}
function dd(e, t) {
	let n = M(e), r = n.Na.get(t);
	if (r && r.va) return W().add(r.key);
	{
		let e = W(), r = n.Ma.get(t);
		if (!r) return e;
		for (let t of r) {
			let r = n.Fa.get(t);
			e = e.unionWith(r.view.Va);
		}
		return e;
	}
}
function fd(e) {
	let t = M(e);
	return t.remoteStore.remoteSyncer.applyRemoteEvent = Zu.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = dd.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $u.bind(null, t), t.Ca.d_ = Mu.bind(null, t.eventManager), t.Ca.$a = Nu.bind(null, t.eventManager), t;
}
function pd(e) {
	let t = M(e);
	return t.remoteStore.remoteSyncer.applySuccessfulWrite = ed.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = td.bind(null, t), t;
}
var md = class {
	constructor() {
		this.kind = "memory", this.synchronizeTabs = !1;
	}
	async initialize(e) {
		this.serializer = zl(e.databaseInfo.databaseId), this.sharedClientState = this.Wa(e), this.persistence = this.Ga(e), await this.persistence.start(), this.localStore = this.za(e), this.gcScheduler = this.ja(e, this.localStore), this.indexBackfillerScheduler = this.Ha(e, this.localStore);
	}
	ja(e, t) {
		return null;
	}
	Ha(e, t) {
		return null;
	}
	za(e) {
		return _l(this.persistence, new hl(), e.initialUser, this.serializer);
	}
	Ga(e) {
		return new ll(dl.Zr, this.serializer);
	}
	Wa(e) {
		return new kl();
	}
	async terminate() {
		var e, t;
		(e = this.gcScheduler) == null || e.stop(), (t = this.indexBackfillerScheduler) == null || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
	}
};
md.provider = { build: () => new md() };
var hd = class extends md {
	constructor(e) {
		super(), this.cacheSizeBytes = e;
	}
	ja(e, t) {
		j(this.persistence.referenceDelegate instanceof fl);
		let n = this.persistence.referenceDelegate.garbageCollector;
		return new Yc(n, e.asyncQueue, t);
	}
	Ga(e) {
		let t = this.cacheSizeBytes === void 0 ? Gc.DEFAULT : Gc.withCacheSize(this.cacheSizeBytes);
		return new ll(((e) => fl.Zr(e, t)), this.serializer);
	}
}, gd = class {
	async initialize(e, t) {
		this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e) => Qu(this.syncEngine, e, 1), this.remoteStore.remoteSyncer.handleCredentialChange = ud.bind(null, this.syncEngine), await yu(this.remoteStore, this.syncEngine.isPrimaryClient));
	}
	createEventManager(e) {
		return function() {
			return new Ou();
		}();
	}
	createDatastore(e) {
		let t = zl(e.databaseInfo.databaseId), n = function(e) {
			return new Ll(e);
		}(e.databaseInfo);
		return function(e, t, n, r) {
			return new Wl(e, t, n, r);
		}(e.authCredentials, e.appCheckCredentials, n, t);
	}
	createRemoteStore(e) {
		return function(e, t, n, r, i) {
			return new Kl(e, t, n, r, i);
		}(this.localStore, this.datastore, e.asyncQueue, ((e) => Qu(this.syncEngine, e, 0)), function() {
			return jl.D() ? new jl() : new Al();
		}());
	}
	createSyncEngine(e, t) {
		return function(e, t, n, r, i, a, o) {
			let s = new Uu(e, t, n, r, i, a);
			return o && (s.Qa = !0), s;
		}(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
	}
	async terminate() {
		var e, t;
		await async function(e) {
			let t = M(e);
			k("RemoteStore", "RemoteStore shutting down."), t.L_.add(5), await Jl(t), t.k_.shutdown(), t.q_.set("Unknown");
		}(this.remoteStore), (e = this.datastore) == null || e.terminate(), (t = this.eventManager) == null || t.terminate();
	}
};
gd.provider = { build: () => new gd() };
var _d = class {
	constructor(e) {
		this.observer = e, this.muted = !1;
	}
	next(e) {
		this.muted || this.observer.next && this.Ya(this.observer.next, e);
	}
	error(e) {
		this.muted || (this.observer.error ? this.Ya(this.observer.error, e) : Di("Uncaught Error in snapshot listener:", e.toString()));
	}
	Za() {
		this.muted = !0;
	}
	Ya(e, t) {
		setTimeout((() => {
			this.muted || e(t);
		}), 0);
	}
}, vd = class {
	constructor(e) {
		this.datastore = e, this.readVersions = /* @__PURE__ */ new Map(), this.mutations = [], this.committed = !1, this.lastTransactionError = null, this.writtenDocs = /* @__PURE__ */ new Set();
	}
	async lookup(e) {
		if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new P(N.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
		let t = await async function(e, t) {
			let n = M(e), r = { documents: t.map(((e) => pc(n.serializer, e))) }, i = await n.Lo("BatchGetDocuments", n.serializer.databaseId, R.emptyPath(), r, t.length), a = /* @__PURE__ */ new Map();
			i.forEach(((e) => {
				let t = bc(n.serializer, e);
				a.set(t.key.toString(), t);
			}));
			let o = [];
			return t.forEach(((e) => {
				let t = a.get(e.toString());
				j(!!t), o.push(t);
			})), o;
		}(this.datastore, e);
		return t.forEach(((e) => this.recordVersion(e))), t;
	}
	set(e, t) {
		this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
	}
	update(e, t) {
		try {
			this.write(t.toMutation(e, this.preconditionForUpdate(e)));
		} catch (e) {
			this.lastTransactionError = e;
		}
		this.writtenDocs.add(e.toString());
	}
	delete(e) {
		this.write(new As(e, this.precondition(e))), this.writtenDocs.add(e.toString());
	}
	async commit() {
		if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
		let e = this.readVersions;
		this.mutations.forEach(((t) => {
			e.delete(t.key.toString());
		})), e.forEach(((e, t) => {
			let n = z.fromPath(t);
			this.mutations.push(new js(n, this.precondition(n)));
		})), await async function(e, t) {
			let n = M(e), r = { writes: t.map(((e) => Sc(n.serializer, e))) };
			await n.Mo("Commit", n.serializer.databaseId, R.emptyPath(), r);
		}(this.datastore, this.mutations), this.committed = !0;
	}
	recordVersion(e) {
		let t;
		if (e.isFoundDocument()) t = e.version;
		else {
			if (!e.isNoDocument()) throw A();
			t = L.min();
		}
		let n = this.readVersions.get(e.key.toString());
		if (n) {
			if (!t.isEqual(n)) throw new P(N.ABORTED, "Document version changed between two reads.");
		} else this.readVersions.set(e.key.toString(), t);
	}
	precondition(e) {
		let t = this.readVersions.get(e.toString());
		return !this.writtenDocs.has(e.toString()) && t ? t.isEqual(L.min()) ? _s.exists(!1) : _s.updateTime(t) : _s.none();
	}
	preconditionForUpdate(e) {
		let t = this.readVersions.get(e.toString());
		if (!this.writtenDocs.has(e.toString()) && t) {
			if (t.isEqual(L.min())) throw new P(N.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
			return _s.updateTime(t);
		}
		return _s.exists(!0);
	}
	write(e) {
		this.ensureCommitNotCalled(), this.mutations.push(e);
	}
	ensureCommitNotCalled() {}
}, yd = class {
	constructor(e, t, n, r, i) {
		this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this._u = n.maxAttempts, this.t_ = new Bl(this.asyncQueue, "transaction_retry");
	}
	au() {
		--this._u, this.uu();
	}
	uu() {
		this.t_.Go((async () => {
			let e = new vd(this.datastore), t = this.cu(e);
			t && t.then(((t) => {
				this.asyncQueue.enqueueAndForget((() => e.commit().then((() => {
					this.deferred.resolve(t);
				})).catch(((e) => {
					this.lu(e);
				}))));
			})).catch(((e) => {
				this.lu(e);
			}));
		}));
	}
	cu(e) {
		try {
			let t = this.updateFunction(e);
			return !na(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
		} catch (e) {
			return this.deferred.reject(e), null;
		}
	}
	lu(e) {
		this._u > 0 && this.hu(e) ? (--this._u, this.asyncQueue.enqueueAndForget((() => (this.uu(), Promise.resolve())))) : this.deferred.reject(e);
	}
	hu(e) {
		if (e.name === "FirebaseError") {
			let t = e.code;
			return t === "aborted" || t === "failed-precondition" || t === "already-exists" || !Ls(t);
		}
		return !1;
	}
}, bd = class {
	constructor(e, t, n, r, i) {
		this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = O.UNAUTHENTICATED, this.clientId = Bi.newId(), this.authCredentialListener = () => Promise.resolve(), this.appCheckCredentialListener = () => Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, (async (e) => {
			k("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
		})), this.appCheckCredentials.start(n, ((e) => (k("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user))));
	}
	get configuration() {
		return {
			asyncQueue: this.asyncQueue,
			databaseInfo: this.databaseInfo,
			clientId: this.clientId,
			authCredentials: this.authCredentials,
			appCheckCredentials: this.appCheckCredentials,
			initialUser: this.user,
			maxConcurrentLimboResolutions: 100
		};
	}
	setCredentialChangeListener(e) {
		this.authCredentialListener = e;
	}
	setAppCheckTokenChangeListener(e) {
		this.appCheckCredentialListener = e;
	}
	terminate() {
		this.asyncQueue.enterRestrictedMode();
		let e = new Ai();
		return this.asyncQueue.enqueueAndForgetEvenWhileRestricted((async () => {
			try {
				this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
			} catch (t) {
				let n = Cu(t, "Failed to shutdown persistence");
				e.reject(n);
			}
		})), e.promise;
	}
};
async function xd(e, t) {
	e.asyncQueue.verifyOperationInProgress(), k("FirestoreClient", "Initializing OfflineComponentProvider");
	let n = e.configuration;
	await t.initialize(n);
	let r = n.initialUser;
	e.setCredentialChangeListener((async (e) => {
		r.isEqual(e) || (await vl(t.localStore, e), r = e);
	})), t.persistence.setDatabaseDeletedListener((() => e.terminate())), e._offlineComponents = t;
}
async function Sd(e, t) {
	e.asyncQueue.verifyOperationInProgress();
	let n = await Cd(e);
	k("FirestoreClient", "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), e.setCredentialChangeListener(((e) => vu(t.remoteStore, e))), e.setAppCheckTokenChangeListener(((e, n) => vu(t.remoteStore, n))), e._onlineComponents = t;
}
async function Cd(e) {
	if (!e._offlineComponents) if (e._uninitializedComponentsProvider) {
		k("FirestoreClient", "Using user provided OfflineComponentProvider");
		try {
			await xd(e, e._uninitializedComponentsProvider._offline);
		} catch (t) {
			let n = t;
			if (!function(e) {
				return e.name === "FirebaseError" ? e.code === N.FAILED_PRECONDITION || e.code === N.UNIMPLEMENTED : !(typeof DOMException < "u" && e instanceof DOMException) || e.code === 22 || e.code === 20 || e.code === 11;
			}(n)) throw n;
			Oi("Error using user provided cache. Falling back to memory cache: " + n), await xd(e, new md());
		}
	} else k("FirestoreClient", "Using default OfflineComponentProvider"), await xd(e, new hd(void 0));
	return e._offlineComponents;
}
async function wd(e) {
	return e._onlineComponents || (e._uninitializedComponentsProvider ? (k("FirestoreClient", "Using user provided OnlineComponentProvider"), await Sd(e, e._uninitializedComponentsProvider._online)) : (k("FirestoreClient", "Using default OnlineComponentProvider"), await Sd(e, new gd()))), e._onlineComponents;
}
function Td(e) {
	return wd(e).then(((e) => e.syncEngine));
}
function Ed(e) {
	return wd(e).then(((e) => e.datastore));
}
async function Dd(e) {
	let t = await wd(e), n = t.eventManager;
	return n.onListen = Wu.bind(null, t.syncEngine), n.onUnlisten = Ju.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = Gu.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = Yu.bind(null, t.syncEngine), n;
}
function Od(e, t, n = {}) {
	let r = new Ai();
	return e.asyncQueue.enqueueAndForget((async () => function(e, t, n, r, i) {
		let a = new _d({
			next: (s) => {
				a.Za(), t.enqueueAndForget((() => ju(e, o)));
				let c = s.docs.has(n);
				!c && s.fromCache ? i.reject(new P(N.UNAVAILABLE, "Failed to get document because the client is offline.")) : c && s.fromCache && r && r.source === "server" ? i.reject(new P(N.UNAVAILABLE, "Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to \"server\" to retrieve the cached document.)")) : i.resolve(s);
			},
			error: (e) => i.reject(e)
		}), o = new Lu(wo(n.path), a, {
			includeMetadataChanges: !0,
			_a: !0
		});
		return Au(e, o);
	}(await Dd(e), e.asyncQueue, t, n, r))), r.promise;
}
function kd(e, t, n = {}) {
	let r = new Ai();
	return e.asyncQueue.enqueueAndForget((async () => function(e, t, n, r, i) {
		let a = new _d({
			next: (n) => {
				a.Za(), t.enqueueAndForget((() => ju(e, o))), n.fromCache && r.source === "server" ? i.reject(new P(N.UNAVAILABLE, "Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to \"server\" to retrieve the cached documents.)")) : i.resolve(n);
			},
			error: (e) => i.reject(e)
		}), o = new Lu(n, a, {
			includeMetadataChanges: !0,
			_a: !0
		});
		return Au(e, o);
	}(await Dd(e), e.asyncQueue, t, n, r))), r.promise;
}
function Ad(e, t, n) {
	let r = new Ai();
	return e.asyncQueue.enqueueAndForget((async () => {
		try {
			let i = await Ed(e);
			r.resolve(async function(e, t, n) {
				let r = M(e), { request: i, ut: a, parent: o } = Ec(r.serializer, ko(t), n);
				r.connection.Fo || delete i.parent;
				let s = (await r.Lo("RunAggregationQuery", r.serializer.databaseId, o, i, 1)).filter(((e) => !!e.result));
				j(s.length === 1);
				let c = s[0].result?.aggregateFields;
				return Object.keys(c).reduce(((e, t) => (e[a[t]] = c[t], e)), {});
			}(i, t, n));
		} catch (e) {
			r.reject(e);
		}
	})), r.promise;
}
function jd(e) {
	let t = {};
	return e.timeoutSeconds !== void 0 && (t.timeoutSeconds = e.timeoutSeconds), t;
}
var Md = /* @__PURE__ */ new Map();
function Nd(e, t, n) {
	if (!n) throw new P(N.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
function Pd(e, t, n, r) {
	if (!0 === t && !0 === r) throw new P(N.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
function Fd(e) {
	if (!z.isDocumentKey(e)) throw new P(N.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
function Id(e) {
	if (z.isDocumentKey(e)) throw new P(N.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
function Ld(e) {
	if (e === void 0) return "undefined";
	if (e === null) return "null";
	if (typeof e == "string") return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
	if (typeof e == "number" || typeof e == "boolean") return "" + e;
	if (typeof e == "object") {
		if (e instanceof Array) return "an array";
		{
			let t = function(e) {
				return e.constructor ? e.constructor.name : null;
			}(e);
			return t ? `a custom ${t} object` : "an object";
		}
	}
	return typeof e == "function" ? "a function" : A();
}
function Rd(e, t) {
	if ("_delegate" in e && (e = e._delegate), !(e instanceof t)) {
		if (t.name === e.constructor.name) throw new P(N.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
		{
			let n = Ld(e);
			throw new P(N.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
		}
	}
	return e;
}
function zd(e, t) {
	if (t <= 0) throw new P(N.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
var Bd = class {
	constructor(e) {
		var t;
		if (e.host === void 0) {
			if (e.ssl !== void 0) throw new P(N.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
			this.host = "firestore.googleapis.com", this.ssl = !0;
		} else this.host = e.host, this.ssl = (t = e.ssl) == null || t;
		if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, e.cacheSizeBytes === void 0) this.cacheSizeBytes = 41943040;
		else {
			if (e.cacheSizeBytes !== -1 && e.cacheSizeBytes < 1048576) throw new P(N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
			this.cacheSizeBytes = e.cacheSizeBytes;
		}
		Pd("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : e.experimentalAutoDetectLongPolling === void 0 ? this.experimentalAutoDetectLongPolling = !0 : this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = jd(e.experimentalLongPollingOptions ?? {}), function(e) {
			if (e.timeoutSeconds !== void 0) {
				if (isNaN(e.timeoutSeconds)) throw new P(N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
				if (e.timeoutSeconds < 5) throw new P(N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
				if (e.timeoutSeconds > 30) throw new P(N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
			}
		}(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
	}
	isEqual(e) {
		return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function(e, t) {
			return e.timeoutSeconds === t.timeoutSeconds;
		}(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
	}
}, Vd = class {
	constructor(e, t, n, r) {
		this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new Bd({}), this._settingsFrozen = !1, this._terminateTask = "notTerminated";
	}
	get app() {
		if (!this._app) throw new P(N.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
		return this._app;
	}
	get _initialized() {
		return this._settingsFrozen;
	}
	get _terminated() {
		return this._terminateTask !== "notTerminated";
	}
	_setSettings(e) {
		if (this._settingsFrozen) throw new P(N.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
		this._settings = new Bd(e), e.credentials !== void 0 && (this._authCredentials = function(e) {
			if (!e) return new Mi();
			switch (e.type) {
				case "firstParty": return new Ii(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
				case "provider": return e.client;
				default: throw new P(N.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
			}
		}(e.credentials));
	}
	_getSettings() {
		return this._settings;
	}
	_freezeSettings() {
		return this._settingsFrozen = !0, this._settings;
	}
	_delete() {
		return this._terminateTask === "notTerminated" && (this._terminateTask = this._terminate()), this._terminateTask;
	}
	async _restart() {
		this._terminateTask === "notTerminated" ? await this._terminate() : this._terminateTask = "notTerminated";
	}
	toJSON() {
		return {
			app: this._app,
			databaseId: this._databaseId,
			settings: this._settings
		};
	}
	_terminate() {
		return function(e) {
			let t = Md.get(e);
			t && (k("ComponentProvider", "Removing Datastore"), Md.delete(e), t.terminate());
		}(this), Promise.resolve();
	}
};
function Hd(e, t, n, r = {}) {
	let i = (e = Rd(e, Vd))._getSettings(), a = `${t}:${n}`;
	if (i.host !== "firestore.googleapis.com" && i.host !== a && Oi("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, i), {
		host: a,
		ssl: !1
	})), r.mockUserToken) {
		let t, n;
		if (typeof r.mockUserToken == "string") t = r.mockUserToken, n = O.MOCK_USER;
		else {
			t = Yt(r.mockUserToken, e._app?.options.projectId);
			let i = r.mockUserToken.sub || r.mockUserToken.user_id;
			if (!i) throw new P(N.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
			n = new O(i);
		}
		e._authCredentials = new Ni(new ji(t, n));
	}
}
var Ud = class e {
	constructor(e, t, n) {
		this.converter = t, this._query = n, this.type = "query", this.firestore = e;
	}
	withConverter(t) {
		return new e(this.firestore, t, this._query);
	}
}, Wd = class e {
	constructor(e, t, n) {
		this.converter = t, this._key = n, this.type = "document", this.firestore = e;
	}
	get _path() {
		return this._key.path;
	}
	get id() {
		return this._key.path.lastSegment();
	}
	get path() {
		return this._key.path.canonicalString();
	}
	get parent() {
		return new Gd(this.firestore, this.converter, this._key.path.popLast());
	}
	withConverter(t) {
		return new e(this.firestore, t, this._key);
	}
}, Gd = class e extends Ud {
	constructor(e, t, n) {
		super(e, t, wo(n)), this._path = n, this.type = "collection";
	}
	get id() {
		return this._query.path.lastSegment();
	}
	get path() {
		return this._query.path.canonicalString();
	}
	get parent() {
		let e = this._path.popLast();
		return e.isEmpty() ? null : new Wd(this.firestore, null, new z(e));
	}
	withConverter(t) {
		return new e(this.firestore, t, this._path);
	}
};
function Kd(e, t, ...n) {
	if (e = T(e), Nd("collection", "path", t), e instanceof Vd) {
		let r = R.fromString(t, ...n);
		return Id(r), new Gd(e, null, r);
	}
	{
		if (!(e instanceof Wd || e instanceof Gd)) throw new P(N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
		let r = e._path.child(R.fromString(t, ...n));
		return Id(r), new Gd(e.firestore, null, r);
	}
}
function qd(e, t, ...n) {
	if (e = T(e), arguments.length === 1 && (t = Bi.newId()), Nd("doc", "path", t), e instanceof Vd) {
		let r = R.fromString(t, ...n);
		return Fd(r), new Wd(e, null, new z(r));
	}
	{
		if (!(e instanceof Wd || e instanceof Gd)) throw new P(N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
		let r = e._path.child(R.fromString(t, ...n));
		return Fd(r), new Wd(e.firestore, e instanceof Gd ? e.converter : null, new z(r));
	}
}
var Jd = class {
	constructor(e = Promise.resolve()) {
		this.Pu = [], this.Iu = !1, this.Tu = [], this.Eu = null, this.du = !1, this.Au = !1, this.Ru = [], this.t_ = new Bl(this, "async_queue_retry"), this.Vu = () => {
			let e = Rl();
			e && k("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.t_.jo();
		}, this.mu = e;
		let t = Rl();
		t && typeof t.addEventListener == "function" && t.addEventListener("visibilitychange", this.Vu);
	}
	get isShuttingDown() {
		return this.Iu;
	}
	enqueueAndForget(e) {
		this.enqueue(e);
	}
	enqueueAndForgetEvenWhileRestricted(e) {
		this.fu(), this.gu(e);
	}
	enterRestrictedMode(e) {
		if (!this.Iu) {
			this.Iu = !0, this.Au = e || !1;
			let t = Rl();
			t && typeof t.removeEventListener == "function" && t.removeEventListener("visibilitychange", this.Vu);
		}
	}
	enqueue(e) {
		if (this.fu(), this.Iu) return new Promise((() => {}));
		let t = new Ai();
		return this.gu((() => this.Iu && this.Au ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise))).then((() => t.promise));
	}
	enqueueRetryable(e) {
		this.enqueueAndForget((() => (this.Pu.push(e), this.pu())));
	}
	async pu() {
		if (this.Pu.length !== 0) {
			try {
				await this.Pu[0](), this.Pu.shift(), this.t_.reset();
			} catch (e) {
				if (!ea(e)) throw e;
				k("AsyncQueue", "Operation failed with retryable error: " + e);
			}
			this.Pu.length > 0 && this.t_.Go((() => this.pu()));
		}
	}
	gu(e) {
		let t = this.mu.then((() => (this.du = !0, e().catch(((e) => {
			throw this.Eu = e, this.du = !1, Di("INTERNAL UNHANDLED ERROR: ", function(e) {
				let t = e.message || "";
				return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
			}(e)), e;
		})).then(((e) => (this.du = !1, e))))));
		return this.mu = t, t;
	}
	enqueueAfterDelay(e, t, n) {
		this.fu(), this.Ru.indexOf(e) > -1 && (t = 0);
		let r = Su.createAndSchedule(this, e, t, n, ((e) => this.yu(e)));
		return this.Tu.push(r), r;
	}
	fu() {
		this.Eu && A();
	}
	verifyOperationInProgress() {}
	async wu() {
		let e;
		do
			e = this.mu, await e;
		while (e !== this.mu);
	}
	Su(e) {
		for (let t of this.Tu) if (t.timerId === e) return !0;
		return !1;
	}
	bu(e) {
		return this.wu().then((() => {
			this.Tu.sort(((e, t) => e.targetTimeMs - t.targetTimeMs));
			for (let t of this.Tu) if (t.skipDelay(), e !== "all" && t.timerId === e) break;
			return this.wu();
		}));
	}
	Du(e) {
		this.Ru.push(e);
	}
	yu(e) {
		let t = this.Tu.indexOf(e);
		this.Tu.splice(t, 1);
	}
};
function Yd(e) {
	return function(e, t) {
		if (typeof e != "object" || !e) return !1;
		let n = e;
		for (let e of t) if (e in n && typeof n[e] == "function") return !0;
		return !1;
	}(e, [
		"next",
		"error",
		"complete"
	]);
}
var Xd = class extends Vd {
	constructor(e, t, n, r) {
		super(e, t, n, r), this.type = "firestore", this._queue = new Jd(), this._persistenceKey = r?.name || "[DEFAULT]";
	}
	async _terminate() {
		if (this._firestoreClient) {
			let e = this._firestoreClient.terminate();
			this._queue = new Jd(e), this._firestoreClient = void 0, await e;
		}
	}
};
function Zd(e, t, n) {
	n ||= "(default)";
	let r = zr(e, "firestore");
	if (r.isInitialized(n)) {
		let e = r.getImmediate({ identifier: n });
		if (dn(r.getOptions(n), t)) return e;
		throw new P(N.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
	}
	if (t.cacheSizeBytes !== void 0 && t.localCache !== void 0) throw new P(N.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
	if (t.cacheSizeBytes !== void 0 && t.cacheSizeBytes !== -1 && t.cacheSizeBytes < 1048576) throw new P(N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
	return r.initialize({
		options: t,
		instanceIdentifier: n
	});
}
function Qd(e, t) {
	let n = typeof e == "object" ? e : Gr(), r = typeof e == "string" ? e : t || "(default)", i = zr(n, "firestore").getImmediate({ identifier: r });
	if (!i._initialized) {
		let e = Gt("firestore");
		e && Hd(i, ...e);
	}
	return i;
}
function $d(e) {
	if (e._terminated) throw new P(N.FAILED_PRECONDITION, "The client has already been terminated.");
	return e._firestoreClient || ef(e), e._firestoreClient;
}
function ef(e) {
	var t, n;
	let r = e._freezeSettings(), i = function(e, t, n, r) {
		return new Ta(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, jd(r.experimentalLongPollingOptions), r.useFetchStreams);
	}(e._databaseId, e._app?.options.appId || "", e._persistenceKey, r);
	e._componentsProvider || (t = r.localCache) != null && t._offlineComponentProvider && (n = r.localCache) != null && n._onlineComponentProvider && (e._componentsProvider = {
		_offline: r.localCache._offlineComponentProvider,
		_online: r.localCache._onlineComponentProvider
	}), e._firestoreClient = new bd(e._authCredentials, e._appCheckCredentials, e._queue, i, e._componentsProvider && function(e) {
		let t = e?._online.build();
		return {
			_offline: e?._offline.build(t),
			_online: t
		};
	}(e._componentsProvider));
}
var tf = class {
	constructor(e = "count", t) {
		this._internalFieldPath = t, this.type = "AggregateField", this.aggregateType = e;
	}
}, nf = class {
	constructor(e, t, n) {
		this._userDataWriter = t, this._data = n, this.type = "AggregateQuerySnapshot", this.query = e;
	}
	data() {
		return this._userDataWriter.convertObjectMap(this._data);
	}
}, rf = class e {
	constructor(e) {
		this._byteString = e;
	}
	static fromBase64String(t) {
		try {
			return new e(va.fromBase64String(t));
		} catch (e) {
			throw new P(N.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
		}
	}
	static fromUint8Array(t) {
		return new e(va.fromUint8Array(t));
	}
	toBase64() {
		return this._byteString.toBase64();
	}
	toUint8Array() {
		return this._byteString.toUint8Array();
	}
	toString() {
		return "Bytes(base64: " + this.toBase64() + ")";
	}
	isEqual(e) {
		return this._byteString.isEqual(e._byteString);
	}
}, af = class {
	constructor(...e) {
		for (let t = 0; t < e.length; ++t) if (e[t].length === 0) throw new P(N.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
		this._internalPath = new Wi(e);
	}
	isEqual(e) {
		return this._internalPath.isEqual(e._internalPath);
	}
};
function of() {
	return new af("__name__");
}
var sf = class {
	constructor(e) {
		this._methodName = e;
	}
}, cf = class {
	constructor(e, t) {
		if (!isFinite(e) || e < -90 || e > 90) throw new P(N.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
		if (!isFinite(t) || t < -180 || t > 180) throw new P(N.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
		this._lat = e, this._long = t;
	}
	get latitude() {
		return this._lat;
	}
	get longitude() {
		return this._long;
	}
	isEqual(e) {
		return this._lat === e._lat && this._long === e._long;
	}
	toJSON() {
		return {
			latitude: this._lat,
			longitude: this._long
		};
	}
	_compareTo(e) {
		return F(this._lat, e._lat) || F(this._long, e._long);
	}
}, lf = class {
	constructor(e) {
		this._values = (e || []).map(((e) => e));
	}
	toArray() {
		return this._values.map(((e) => e));
	}
	isEqual(e) {
		return function(e, t) {
			if (e.length !== t.length) return !1;
			for (let n = 0; n < e.length; ++n) if (e[n] !== t[n]) return !1;
			return !0;
		}(this._values, e._values);
	}
}, uf = /^__.*__$/, df = class {
	constructor(e, t, n) {
		this.data = e, this.fieldMask = t, this.fieldTransforms = n;
	}
	toMutation(e, t) {
		return this.fieldMask === null ? new Ts(e, this.data, t, this.fieldTransforms) : new Es(e, this.data, this.fieldMask, t, this.fieldTransforms);
	}
}, ff = class {
	constructor(e, t, n) {
		this.data = e, this.fieldMask = t, this.fieldTransforms = n;
	}
	toMutation(e, t) {
		return new Es(e, this.data, this.fieldMask, t, this.fieldTransforms);
	}
};
function pf(e) {
	switch (e) {
		case 0:
		case 2:
		case 1: return !0;
		case 3:
		case 4: return !1;
		default: throw A();
	}
}
var mf = class e {
	constructor(e, t, n, r, i, a) {
		this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, i === void 0 && this.vu(), this.fieldTransforms = i || [], this.fieldMask = a || [];
	}
	get path() {
		return this.settings.path;
	}
	get Cu() {
		return this.settings.Cu;
	}
	Fu(t) {
		return new e(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
	}
	Mu(e) {
		let t = this.path?.child(e), n = this.Fu({
			path: t,
			xu: !1
		});
		return n.Ou(e), n;
	}
	Nu(e) {
		let t = this.path?.child(e), n = this.Fu({
			path: t,
			xu: !1
		});
		return n.vu(), n;
	}
	Lu(e) {
		return this.Fu({
			path: void 0,
			xu: !0
		});
	}
	Bu(e) {
		return jf(e, this.settings.methodName, this.settings.ku || !1, this.path, this.settings.qu);
	}
	contains(e) {
		return this.fieldMask.find(((t) => e.isPrefixOf(t))) !== void 0 || this.fieldTransforms.find(((t) => e.isPrefixOf(t.field))) !== void 0;
	}
	vu() {
		if (this.path) for (let e = 0; e < this.path.length; e++) this.Ou(this.path.get(e));
	}
	Ou(e) {
		if (e.length === 0) throw this.Bu("Document fields must not be empty");
		if (pf(this.Cu) && uf.test(e)) throw this.Bu("Document fields cannot begin and end with \"__\"");
	}
}, hf = class {
	constructor(e, t, n) {
		this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || zl(e);
	}
	Qu(e, t, n, r = !1) {
		return new mf({
			Cu: e,
			methodName: t,
			qu: n,
			path: Wi.emptyPath(),
			xu: !1,
			ku: r
		}, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
	}
};
function gf(e) {
	let t = e._freezeSettings(), n = zl(e._databaseId);
	return new hf(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
function _f(e, t, n, r, i, a = {}) {
	let o = e.Qu(a.merge || a.mergeFields ? 2 : 0, t, n, i);
	Df("Data must be an object, but it was:", o, r);
	let s = Tf(r, o), c, l;
	if (a.merge) c = new ga(o.fieldMask), l = o.fieldTransforms;
	else if (a.mergeFields) {
		let e = [];
		for (let r of a.mergeFields) {
			let i = Of(t, r, n);
			if (!o.contains(i)) throw new P(N.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
			Mf(e, i) || e.push(i);
		}
		c = new ga(e), l = o.fieldTransforms.filter(((e) => c.covers(e.field)));
	} else c = null, l = o.fieldTransforms;
	return new df(new Ka(s), c, l);
}
var vf = class e extends sf {
	_toFieldTransform(e) {
		if (e.Cu !== 2) throw e.Cu === 1 ? e.Bu(`${this._methodName}() can only appear at the top level of your update data`) : e.Bu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
		return e.fieldMask.push(e.path), null;
	}
	isEqual(t) {
		return t instanceof e;
	}
};
function yf(e, t, n) {
	return new mf({
		Cu: 3,
		qu: t.settings.qu,
		methodName: e._methodName,
		xu: n
	}, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
var bf = class e extends sf {
	constructor(e, t) {
		super(e), this.Ku = t;
	}
	_toFieldTransform(e) {
		let t = yf(this, e, !0), n = new ss(this.Ku.map(((e) => wf(e, t))));
		return new ms(e.path, n);
	}
	isEqual(t) {
		return t instanceof e && dn(this.Ku, t.Ku);
	}
};
function xf(e, t, n, r) {
	let i = e.Qu(1, t, n);
	Df("Data must be an object, but it was:", i, r);
	let a = [], o = Ka.empty();
	return la(r, ((e, r) => {
		let s = Af(t, e, n);
		r = T(r);
		let c = i.Nu(s);
		if (r instanceof vf) a.push(s);
		else {
			let e = wf(r, c);
			e != null && (a.push(s), o.set(s, e));
		}
	})), new ff(o, new ga(a), i.fieldTransforms);
}
function Sf(e, t, n, r, i, a) {
	let o = e.Qu(1, t, n), s = [Of(t, r, n)], c = [i];
	if (a.length % 2 != 0) throw new P(N.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
	for (let e = 0; e < a.length; e += 2) s.push(Of(t, a[e])), c.push(a[e + 1]);
	let l = [], u = Ka.empty();
	for (let e = s.length - 1; e >= 0; --e) if (!Mf(l, s[e])) {
		let t = s[e], n = c[e];
		n = T(n);
		let r = o.Nu(t);
		if (n instanceof vf) l.push(t);
		else {
			let e = wf(n, r);
			e != null && (l.push(t), u.set(t, e));
		}
	}
	return new ff(u, new ga(l), o.fieldTransforms);
}
function Cf(e, t, n, r = !1) {
	return wf(n, e.Qu(r ? 4 : 3, t));
}
function wf(e, t) {
	if (Ef(e = T(e))) return Df("Unsupported field value:", t, e), Tf(e, t);
	if (e instanceof sf) return function(e, t) {
		if (!pf(t.Cu)) throw t.Bu(`${e._methodName}() can only be used with update() and set()`);
		if (!t.path) throw t.Bu(`${e._methodName}() is not currently supported inside arrays`);
		let n = e._toFieldTransform(t);
		n && t.fieldTransforms.push(n);
	}(e, t), null;
	if (e === void 0 && t.ignoreUndefinedProperties) return null;
	if (t.path && t.fieldMask.push(t.path), e instanceof Array) {
		if (t.settings.xu && t.Cu !== 4) throw t.Bu("Nested arrays are not supported");
		return function(e, t) {
			let n = [], r = 0;
			for (let i of e) {
				let e = wf(i, t.Lu(r));
				e ??= { nullValue: "NULL_VALUE" }, n.push(e), r++;
			}
			return { arrayValue: { values: n } };
		}(e, t);
	}
	return function(e, t) {
		if ((e = T(e)) === null) return { nullValue: "NULL_VALUE" };
		if (typeof e == "number") return ts(t.serializer, e);
		if (typeof e == "boolean") return { booleanValue: e };
		if (typeof e == "string") return { stringValue: e };
		if (e instanceof Date) {
			let n = I.fromDate(e);
			return { timestampValue: oc(t.serializer, n) };
		}
		if (e instanceof I) {
			let n = new I(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
			return { timestampValue: oc(t.serializer, n) };
		}
		if (e instanceof cf) return { geoPointValue: {
			latitude: e.latitude,
			longitude: e.longitude
		} };
		if (e instanceof rf) return { bytesValue: sc(t.serializer, e._byteString) };
		if (e instanceof Wd) {
			let n = t.databaseId, r = e.firestore._databaseId;
			if (!r.isEqual(n)) throw t.Bu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
			return { referenceValue: uc(e.firestore._databaseId || t.databaseId, e._key.path) };
		}
		if (e instanceof lf) return function(e, t) {
			return { mapValue: { fields: {
				__type__: { stringValue: "__vector__" },
				value: { arrayValue: { values: e.toArray().map(((e) => {
					if (typeof e != "number") throw t.Bu("VectorValues must only contain numeric values.");
					return $o(t.serializer, e);
				})) } }
			} } };
		}(e, t);
		throw t.Bu(`Unsupported field value: ${Ld(e)}`);
	}(e, t);
}
function Tf(e, t) {
	let n = {};
	return da(e) ? t.path && t.path.length > 0 && t.fieldMask.push(t.path) : la(e, ((e, r) => {
		let i = wf(r, t.Mu(e));
		i != null && (n[e] = i);
	})), { mapValue: { fields: n } };
}
function Ef(e) {
	return !(typeof e != "object" || !e || e instanceof Array || e instanceof Date || e instanceof I || e instanceof cf || e instanceof rf || e instanceof Wd || e instanceof sf || e instanceof lf);
}
function Df(e, t, n) {
	if (!Ef(n) || !function(e) {
		return typeof e == "object" && !!e && (Object.getPrototypeOf(e) === Object.prototype || Object.getPrototypeOf(e) === null);
	}(n)) {
		let r = Ld(n);
		throw r === "an object" ? t.Bu(e + " a custom object") : t.Bu(e + " " + r);
	}
}
function Of(e, t, n) {
	if ((t = T(t)) instanceof af) return t._internalPath;
	if (typeof t == "string") return Af(e, t);
	throw jf("Field path arguments must be of type string or ", e, !1, void 0, n);
}
var kf = /* @__PURE__ */ RegExp("[~\\*/\\[\\]]");
function Af(e, t, n) {
	if (t.search(kf) >= 0) throw jf(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, !1, void 0, n);
	try {
		return new af(...t.split("."))._internalPath;
	} catch {
		throw jf(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, !1, void 0, n);
	}
}
function jf(e, t, n, r, i) {
	let a = r && !r.isEmpty(), o = i !== void 0, s = `Function ${t}() called with invalid data`;
	n && (s += " (via `toFirestore()`)"), s += ". ";
	let c = "";
	return (a || o) && (c += " (found", a && (c += ` in field ${r}`), o && (c += ` in document ${i}`), c += ")"), new P(N.INVALID_ARGUMENT, s + e + c);
}
function Mf(e, t) {
	return e.some(((e) => e.isEqual(t)));
}
var Nf = class {
	constructor(e, t, n, r, i) {
		this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
	}
	get id() {
		return this._key.path.lastSegment();
	}
	get ref() {
		return new Wd(this._firestore, this._converter, this._key);
	}
	exists() {
		return this._document !== null;
	}
	data() {
		if (this._document) {
			if (this._converter) {
				let e = new Pf(this._firestore, this._userDataWriter, this._key, this._document, null);
				return this._converter.fromFirestore(e);
			}
			return this._userDataWriter.convertValue(this._document.data.value);
		}
	}
	get(e) {
		if (this._document) {
			let t = this._document.data.field(Ff("DocumentSnapshot.get", e));
			if (t !== null) return this._userDataWriter.convertValue(t);
		}
	}
}, Pf = class extends Nf {
	data() {
		return super.data();
	}
};
function Ff(e, t) {
	return typeof t == "string" ? Af(e, t) : t instanceof af ? t._internalPath : t._delegate._internalPath;
}
function If(e) {
	if (e.limitType === "L" && e.explicitOrderBy.length === 0) throw new P(N.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
var Lf = class {}, Rf = class extends Lf {};
function zf(e, t, ...n) {
	let r = [];
	t instanceof Lf && r.push(t), r = r.concat(n), function(e) {
		let t = e.filter(((e) => e instanceof Vf)).length, n = e.filter(((e) => e instanceof Bf)).length;
		if (t > 1 || t > 0 && n > 0) throw new P(N.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
	}(r);
	for (let t of r) e = t._apply(e);
	return e;
}
var Bf = class e extends Rf {
	constructor(e, t, n) {
		super(), this._field = e, this._op = t, this._value = n, this.type = "where";
	}
	static _create(t, n, r) {
		return new e(t, n, r);
	}
	_apply(e) {
		let t = this._parse(e);
		return Jf(e._query, t), new Ud(e.firestore, e.converter, jo(e._query, t));
	}
	_parse(e) {
		let t = gf(e.firestore);
		return function(e, t, n, r, i, a, o) {
			let s;
			if (i.isKeyField()) {
				if (a === "array-contains" || a === "array-contains-any") throw new P(N.INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
				if (a === "in" || a === "not-in") {
					qf(o, a);
					let t = [];
					for (let n of o) t.push(Kf(r, e, n));
					s = { arrayValue: { values: t } };
				} else s = Kf(r, e, o);
			} else a !== "in" && a !== "not-in" && a !== "array-contains-any" || qf(o, a), s = Cf(n, t, o, a === "in" || a === "not-in");
			return U.create(i, a, s);
		}(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
	}
};
function J(e, t, n) {
	let r = t, i = Ff("where", e);
	return Bf._create(i, r, n);
}
var Vf = class e extends Lf {
	constructor(e, t) {
		super(), this.type = e, this._queryConstraints = t;
	}
	static _create(t, n) {
		return new e(t, n);
	}
	_parse(e) {
		let t = this._queryConstraints.map(((t) => t._parse(e))).filter(((e) => e.getFilters().length > 0));
		return t.length === 1 ? t[0] : to.create(t, this._getOperator());
	}
	_apply(e) {
		let t = this._parse(e);
		return t.getFilters().length === 0 ? e : (function(e, t) {
			let n = e, r = t.getFlattenedFilters();
			for (let e of r) Jf(n, e), n = jo(n, e);
		}(e._query, t), new Ud(e.firestore, e.converter, jo(e._query, t)));
	}
	_getQueryConstraints() {
		return this._queryConstraints;
	}
	_getOperator() {
		return this.type === "and" ? "and" : "or";
	}
}, Hf = class e extends Rf {
	constructor(e, t) {
		super(), this._field = e, this._direction = t, this.type = "orderBy";
	}
	static _create(t, n) {
		return new e(t, n);
	}
	_apply(e) {
		let t = function(e, t, n) {
			if (e.startAt !== null) throw new P(N.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
			if (e.endAt !== null) throw new P(N.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
			return new Qa(t, n);
		}(e._query, this._field, this._direction);
		return new Ud(e.firestore, e.converter, function(e, t) {
			let n = e.explicitOrderBy.concat([t]);
			return new So(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
		}(e._query, t));
	}
};
function Uf(e, t = "asc") {
	let n = t, r = Ff("orderBy", e);
	return Hf._create(r, n);
}
var Wf = class e extends Rf {
	constructor(e, t, n) {
		super(), this.type = e, this._limit = t, this._limitType = n;
	}
	static _create(t, n, r) {
		return new e(t, n, r);
	}
	_apply(e) {
		return new Ud(e.firestore, e.converter, Mo(e._query, this._limit, this._limitType));
	}
};
function Gf(e) {
	return zd("limit", e), Wf._create("limit", e, "F");
}
function Kf(e, t, n) {
	if (typeof (n = T(n)) == "string") {
		if (n === "") throw new P(N.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
		if (!Eo(t) && n.indexOf("/") !== -1) throw new P(N.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
		let r = t.path.child(R.fromString(n));
		if (!z.isDocumentKey(r)) throw new P(N.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
		return La(e, new z(r));
	}
	if (n instanceof Wd) return La(e, n._key);
	throw new P(N.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${Ld(n)}.`);
}
function qf(e, t) {
	if (!Array.isArray(e) || e.length === 0) throw new P(N.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
function Jf(e, t) {
	let n = function(e, t) {
		for (let n of e) for (let e of n.getFlattenedFilters()) if (t.indexOf(e.op) >= 0) return e.op;
		return null;
	}(e.filters, function(e) {
		switch (e) {
			case "!=": return ["!=", "not-in"];
			case "array-contains-any":
			case "in": return ["not-in"];
			case "not-in": return [
				"array-contains-any",
				"in",
				"not-in",
				"!="
			];
			default: return [];
		}
	}(t.op));
	if (n !== null) throw n === t.op ? new P(N.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new P(N.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
var Yf = class {
	convertValue(e, t = "none") {
		switch (Oa(e)) {
			case 0: return null;
			case 1: return e.booleanValue;
			case 2: return H(e.integerValue || e.doubleValue);
			case 3: return this.convertTimestamp(e.timestampValue);
			case 4: return this.convertServerTimestamp(e, t);
			case 5: return e.stringValue;
			case 6: return this.convertBytes(xa(e.bytesValue));
			case 7: return this.convertReference(e.referenceValue);
			case 8: return this.convertGeoPoint(e.geoPointValue);
			case 9: return this.convertArray(e.arrayValue, t);
			case 11: return this.convertObject(e.mapValue, t);
			case 10: return this.convertVectorValue(e.mapValue);
			default: throw A();
		}
	}
	convertObject(e, t) {
		return this.convertObjectMap(e.fields, t);
	}
	convertObjectMap(e, t = "none") {
		let n = {};
		return la(e, ((e, r) => {
			n[e] = this.convertValue(r, t);
		})), n;
	}
	convertVectorValue(e) {
		return new lf((e.fields?.value.arrayValue?.values)?.map(((e) => H(e.doubleValue))));
	}
	convertGeoPoint(e) {
		return new cf(H(e.latitude), H(e.longitude));
	}
	convertArray(e, t) {
		return (e.values || []).map(((e) => this.convertValue(e, t)));
	}
	convertServerTimestamp(e, t) {
		switch (t) {
			case "previous":
				let n = Ca(e);
				return n == null ? null : this.convertValue(n, t);
			case "estimate": return this.convertTimestamp(wa(e));
			default: return null;
		}
	}
	convertTimestamp(e) {
		let t = ba(e);
		return new I(t.seconds, t.nanos);
	}
	convertDocumentKey(e, t) {
		let n = R.fromString(e);
		j(Lc(n));
		let r = new Ea(n.get(1), n.get(3)), i = new z(n.popFirst(5));
		return r.isEqual(t) || Di(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
	}
};
function Xf(e, t, n) {
	let r;
	return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
var Zf = class extends Yf {
	constructor(e) {
		super(), this.firestore = e;
	}
	convertBytes(e) {
		return new rf(e);
	}
	convertReference(e) {
		let t = this.convertDocumentKey(e, this.firestore._databaseId);
		return new Wd(this.firestore, null, t);
	}
};
function Qf() {
	return new tf("count");
}
var $f = class {
	constructor(e, t) {
		this.hasPendingWrites = e, this.fromCache = t;
	}
	isEqual(e) {
		return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
	}
}, ep = class extends Nf {
	constructor(e, t, n, r, i, a) {
		super(e, t, n, r, a), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
	}
	exists() {
		return super.exists();
	}
	data(e = {}) {
		if (this._document) {
			if (this._converter) {
				let t = new tp(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, null);
				return this._converter.fromFirestore(t, e);
			}
			return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
		}
	}
	get(e, t = {}) {
		if (this._document) {
			let n = this._document.data.field(Ff("DocumentSnapshot.get", e));
			if (n !== null) return this._userDataWriter.convertValue(n, t.serverTimestamps);
		}
	}
}, tp = class extends ep {
	data(e = {}) {
		return super.data(e);
	}
}, np = class {
	constructor(e, t, n, r) {
		this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $f(r.hasPendingWrites, r.fromCache), this.query = n;
	}
	get docs() {
		let e = [];
		return this.forEach(((t) => e.push(t))), e;
	}
	get size() {
		return this._snapshot.docs.size;
	}
	get empty() {
		return this.size === 0;
	}
	forEach(e, t) {
		this._snapshot.docs.forEach(((n) => {
			e.call(t, new tp(this._firestore, this._userDataWriter, n.key, n, new $f(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
		}));
	}
	docChanges(e = {}) {
		let t = !!e.includeMetadataChanges;
		if (t && this._snapshot.excludesMetadataChanges) throw new P(N.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
		return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = function(e, t) {
			if (e._snapshot.oldDocs.isEmpty()) {
				let t = 0;
				return e._snapshot.docChanges.map(((n) => {
					let r = new tp(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $f(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
					return n.doc, {
						type: "added",
						doc: r,
						oldIndex: -1,
						newIndex: t++
					};
				}));
			}
			{
				let n = e._snapshot.oldDocs;
				return e._snapshot.docChanges.filter(((e) => t || e.type !== 3)).map(((t) => {
					let r = new tp(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $f(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter), i = -1, a = -1;
					return t.type !== 0 && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), t.type !== 1 && (n = n.add(t.doc), a = n.indexOf(t.doc.key)), {
						type: rp(t.type),
						doc: r,
						oldIndex: i,
						newIndex: a
					};
				}));
			}
		}(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
	}
};
function rp(e) {
	switch (e) {
		case 0: return "added";
		case 2:
		case 3: return "modified";
		case 1: return "removed";
		default: return A();
	}
}
function ip(e) {
	e = Rd(e, Wd);
	let t = Rd(e.firestore, Xd);
	return Od($d(t), e._key).then(((n) => fp(t, e, n)));
}
var ap = class extends Yf {
	constructor(e) {
		super(), this.firestore = e;
	}
	convertBytes(e) {
		return new rf(e);
	}
	convertReference(e) {
		let t = this.convertDocumentKey(e, this.firestore._databaseId);
		return new Wd(this.firestore, null, t);
	}
};
function op(e) {
	e = Rd(e, Ud);
	let t = Rd(e.firestore, Xd), n = $d(t), r = new ap(t);
	return If(e._query), kd(n, e._query).then(((n) => new np(t, r, e, n)));
}
function sp(e, t, n) {
	e = Rd(e, Wd);
	let r = Rd(e.firestore, Xd), i = Xf(e.converter, t, n);
	return dp(r, [_f(gf(r), "setDoc", e._key, i, e.converter !== null, n).toMutation(e._key, _s.none())]);
}
function cp(e, t, n, ...r) {
	e = Rd(e, Wd);
	let i = Rd(e.firestore, Xd), a = gf(i), o;
	return o = typeof (t = T(t)) == "string" || t instanceof af ? Sf(a, "updateDoc", e._key, t, n, r) : xf(a, "updateDoc", e._key, t), dp(i, [o.toMutation(e._key, _s.exists(!0))]);
}
function lp(e) {
	return dp(Rd(e.firestore, Xd), [new As(e._key, _s.none())]);
}
function up(e, ...t) {
	e = T(e);
	let n = {
		includeMetadataChanges: !1,
		source: "default"
	}, r = 0;
	typeof t[r] != "object" || Yd(t[r]) || (n = t[r], r++);
	let i = {
		includeMetadataChanges: n.includeMetadataChanges,
		source: n.source
	};
	if (Yd(t[r])) {
		let e = t[r];
		t[r] = e.next?.bind(e), t[r + 1] = e.error?.bind(e), t[r + 2] = e.complete?.bind(e);
	}
	let a, o, s;
	if (e instanceof Wd) o = Rd(e.firestore, Xd), s = wo(e._key.path), a = {
		next: (n) => {
			t[r] && t[r](fp(o, e, n));
		},
		error: t[r + 1],
		complete: t[r + 2]
	};
	else {
		let n = Rd(e, Ud);
		o = Rd(n.firestore, Xd), s = n._query;
		let i = new ap(o);
		a = {
			next: (e) => {
				t[r] && t[r](new np(o, i, n, e));
			},
			error: t[r + 1],
			complete: t[r + 2]
		}, If(e._query);
	}
	return function(e, t, n, r) {
		let i = new _d(r), a = new Lu(t, i, n);
		return e.asyncQueue.enqueueAndForget((async () => Au(await Dd(e), a))), () => {
			i.Za(), e.asyncQueue.enqueueAndForget((async () => ju(await Dd(e), a)));
		};
	}($d(o), s, i, a);
}
function dp(e, t) {
	return function(e, t) {
		let n = new Ai();
		return e.asyncQueue.enqueueAndForget((async () => Xu(await Td(e), t, n))), n.promise;
	}($d(e), t);
}
function fp(e, t, n) {
	let r = n.docs.get(t._key);
	return new ep(e, new ap(e), t._key, r, new $f(n.hasPendingWrites, n.fromCache), t.converter);
}
function pp(e) {
	return mp(e, { count: Qf() });
}
function mp(e, t) {
	let n = Rd(e.firestore, Xd), r = $d(n), i = ua(t, ((e, t) => new Fs(t, e.aggregateType, e._internalFieldPath)));
	return Ad(r, e._query, i).then(((t) => function(e, t, n) {
		return new nf(t, new ap(e), n);
	}(n, e, t)));
}
var hp = { maxAttempts: 5 };
function gp(e, t) {
	if ((e = T(e)).firestore !== t) throw new P(N.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
	return e;
}
var _p = class extends class {
	constructor(e, t) {
		this._firestore = e, this._transaction = t, this._dataReader = gf(e);
	}
	get(e) {
		let t = gp(e, this._firestore), n = new Zf(this._firestore);
		return this._transaction.lookup([t._key]).then(((e) => {
			if (!e || e.length !== 1) return A();
			let r = e[0];
			if (r.isFoundDocument()) return new Nf(this._firestore, n, r.key, r, t.converter);
			if (r.isNoDocument()) return new Nf(this._firestore, n, t._key, null, t.converter);
			throw A();
		}));
	}
	set(e, t, n) {
		let r = gp(e, this._firestore), i = Xf(r.converter, t, n), a = _f(this._dataReader, "Transaction.set", r._key, i, r.converter !== null, n);
		return this._transaction.set(r._key, a), this;
	}
	update(e, t, n, ...r) {
		let i = gp(e, this._firestore), a;
		return a = typeof (t = T(t)) == "string" || t instanceof af ? Sf(this._dataReader, "Transaction.update", i._key, t, n, r) : xf(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, a), this;
	}
	delete(e) {
		let t = gp(e, this._firestore);
		return this._transaction.delete(t._key), this;
	}
} {
	constructor(e, t) {
		super(e, t), this._firestore = e;
	}
	get(e) {
		let t = gp(e, this._firestore), n = new ap(this._firestore);
		return super.get(e).then(((e) => new ep(this._firestore, n, t._key, e._document, new $f(!1, !1), t.converter)));
	}
};
function vp(e, t, n) {
	e = Rd(e, Xd);
	let r = Object.assign(Object.assign({}, hp), n);
	return (function(e) {
		if (e.maxAttempts < 1) throw new P(N.INVALID_ARGUMENT, "Max attempts must be at least 1");
	})(r), function(e, t, n) {
		let r = new Ai();
		return e.asyncQueue.enqueueAndForget((async () => {
			let i = await Ed(e);
			new yd(e.asyncQueue, i, n, t, r).au();
		})), r.promise;
	}($d(e), ((n) => t(new _p(e, n))), r);
}
function yp(...e) {
	return new bf("arrayUnion", e);
}
(function(e, t = !0) {
	(function(e) {
		wi = e;
	})(Ur), Rr(new bn("firestore", ((e, { instanceIdentifier: n, options: r }) => {
		let i = e.getProvider("app").getImmediate(), a = new Xd(new Pi(e.getProvider("auth-internal")), new Ri(e.getProvider("app-check-internal")), function(e, t) {
			if (!Object.prototype.hasOwnProperty.apply(e.options, ["projectId"])) throw new P(N.INVALID_ARGUMENT, "\"projectId\" not provided in firebase.initializeApp.");
			return new Ea(e.options.projectId, t);
		}(i, n), i);
		return r = Object.assign({ useFetchStreams: t }, r), a._setSettings(r), a;
	}), "PUBLIC").setMultipleInstances(!0)), Kr(Ci, "4.7.4", e), Kr(Ci, "4.7.4", "esm2017");
})();
//#endregion
//#region src/firestore/firestore.constant.ts
var Y = /* @__PURE__ */ function(e) {
	return e.Plans = "Plans", e.Audit = "Audit", e.Comments = "Comments", e.CustomGeoboundaries = "CustomGeoboundaries", e.Clients = "Clients", e.Brands = "Brands", e.SharedPlans = "SharedPlans", e.Subscriptions = "Subscriptions", e.FeaturedPackages = "FeaturedPackages", e.FeaturedPackagesLock = "FeaturedPackagesLock", e.FeaturedPackagesPurchases = "FeaturedPackagesPurchases", e;
}({}), bp = /* @__PURE__ */ function(e) {
	return e.Comments = "Comments", e.Plans = "Plans", e;
}({}), xp = /* @__PURE__ */ function(e) {
	return e.Comments = "LatestPlanComments", e;
}({});
//#endregion
//#region src/helpers/formatter.helper.ts
function X(e) {
	return "\n" + JSON.stringify(e, null, 2);
}
//#endregion
//#region ../node_modules/tslib/tslib.es6.mjs
function Sp(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
//#endregion
//#region ../node_modules/@firebase/auth/dist/esm2017/index-a7d5cfcc.js
function Cp() {
	return { "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK." };
}
var wp = Cp, Tp = new sn("auth", "Firebase", Cp()), Ep = new An("@firebase/auth");
function Dp(e, ...t) {
	Ep.logLevel <= E.WARN && Ep.warn(`Auth (${Ur}): ${e}`, ...t);
}
function Op(e, ...t) {
	Ep.logLevel <= E.ERROR && Ep.error(`Auth (${Ur}): ${e}`, ...t);
}
function kp(e, ...t) {
	throw Np(e, ...t);
}
function Ap(e, ...t) {
	return Np(e, ...t);
}
function jp(e, t, n) {
	return new sn("auth", "Firebase", Object.assign(Object.assign({}, wp()), { [t]: n })).create(t, { appName: e.name });
}
function Mp(e) {
	return jp(e, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function Np(e, ...t) {
	if (typeof e != "string") {
		let n = t[0], r = [...t.slice(1)];
		return r[0] && (r[0].appName = e.name), e._errorFactory.create(n, ...r);
	}
	return Tp.create(e, ...t);
}
function Z(e, t, ...n) {
	if (!e) throw Np(t, ...n);
}
function Pp(e) {
	let t = "INTERNAL ASSERTION FAILED: " + e;
	throw Op(t), Error(t);
}
function Fp(e, t) {
	e || Pp(t);
}
function Ip() {
	return typeof self < "u" && self.location?.href || "";
}
function Lp() {
	return Rp() === "http:" || Rp() === "https:";
}
function Rp() {
	return typeof self < "u" && self.location?.protocol || null;
}
function zp() {
	return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && (Lp() || $t() || "connection" in navigator) ? navigator.onLine : !0;
}
function Bp() {
	if (typeof navigator > "u") return null;
	let e = navigator;
	return e.languages && e.languages[0] || e.language || null;
}
var Vp = class {
	constructor(e, t) {
		this.shortDelay = e, this.longDelay = t, Fp(t > e, "Short delay should be less than long delay!"), this.isMobile = Xt() || w();
	}
	get() {
		return zp() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
	}
};
function Hp(e, t) {
	Fp(e.emulator, "Emulator should always be set here");
	let { url: n } = e.emulator;
	return t ? `${n}${t.startsWith("/") ? t.slice(1) : t}` : n;
}
var Up = class {
	static initialize(e, t, n) {
		this.fetchImpl = e, t && (this.headersImpl = t), n && (this.responseImpl = n);
	}
	static fetch() {
		if (this.fetchImpl) return this.fetchImpl;
		if (typeof self < "u" && "fetch" in self) return self.fetch;
		if (typeof globalThis < "u" && globalThis.fetch) return globalThis.fetch;
		if (typeof fetch < "u") return fetch;
		Pp("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
	}
	static headers() {
		if (this.headersImpl) return this.headersImpl;
		if (typeof self < "u" && "Headers" in self) return self.Headers;
		if (typeof globalThis < "u" && globalThis.Headers) return globalThis.Headers;
		if (typeof Headers < "u") return Headers;
		Pp("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
	}
	static response() {
		if (this.responseImpl) return this.responseImpl;
		if (typeof self < "u" && "Response" in self) return self.Response;
		if (typeof globalThis < "u" && globalThis.Response) return globalThis.Response;
		if (typeof Response < "u") return Response;
		Pp("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
	}
}, Wp = {
	CREDENTIAL_MISMATCH: "custom-token-mismatch",
	MISSING_CUSTOM_TOKEN: "internal-error",
	INVALID_IDENTIFIER: "invalid-email",
	MISSING_CONTINUE_URI: "internal-error",
	INVALID_PASSWORD: "wrong-password",
	MISSING_PASSWORD: "missing-password",
	INVALID_LOGIN_CREDENTIALS: "invalid-credential",
	EMAIL_EXISTS: "email-already-in-use",
	PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
	INVALID_IDP_RESPONSE: "invalid-credential",
	INVALID_PENDING_TOKEN: "invalid-credential",
	FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
	MISSING_REQ_TYPE: "internal-error",
	EMAIL_NOT_FOUND: "user-not-found",
	RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
	EXPIRED_OOB_CODE: "expired-action-code",
	INVALID_OOB_CODE: "invalid-action-code",
	MISSING_OOB_CODE: "internal-error",
	CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
	INVALID_ID_TOKEN: "invalid-user-token",
	TOKEN_EXPIRED: "user-token-expired",
	USER_NOT_FOUND: "user-token-expired",
	TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
	PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
	INVALID_CODE: "invalid-verification-code",
	INVALID_SESSION_INFO: "invalid-verification-id",
	INVALID_TEMPORARY_PROOF: "invalid-credential",
	MISSING_SESSION_INFO: "missing-verification-id",
	SESSION_EXPIRED: "code-expired",
	MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
	UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
	INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
	ADMIN_ONLY_OPERATION: "admin-restricted-operation",
	INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
	MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
	MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
	MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
	SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
	SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
	BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
	RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
	MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
	INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
	INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
	MISSING_CLIENT_TYPE: "missing-client-type",
	MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
	INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
	INVALID_REQ_TYPE: "invalid-req-type"
}, Gp = new Vp(3e4, 6e4);
function Q(e, t) {
	return e.tenantId && !t.tenantId ? Object.assign(Object.assign({}, t), { tenantId: e.tenantId }) : t;
}
async function Kp(e, t, n, r, i = {}) {
	return qp(e, i, async () => {
		let i = {}, a = {};
		r && (t === "GET" ? a = r : i = { body: JSON.stringify(r) });
		let o = pn(Object.assign({ key: e.config.apiKey }, a)).slice(1), s = await e._getAdditionalHeaders();
		s["Content-Type"] = "application/json", e.languageCode && (s["X-Firebase-Locale"] = e.languageCode);
		let c = Object.assign({
			method: t,
			headers: s
		}, i);
		return Qt() || (c.referrerPolicy = "no-referrer"), Up.fetch()(Yp(e, e.config.apiHost, n, o), c);
	});
}
async function qp(e, t, n) {
	e._canInitEmulator = !1;
	let r = Object.assign(Object.assign({}, Wp), t);
	try {
		let t = new Zp(e), i = await Promise.race([n(), t.promise]);
		t.clearNetworkTimeout();
		let a = await i.json();
		if ("needConfirmation" in a) throw Qp(e, "account-exists-with-different-credential", a);
		if (i.ok && !("errorMessage" in a)) return a;
		{
			let [t, n] = (i.ok ? a.errorMessage : a.error.message).split(" : ");
			if (t === "FEDERATED_USER_ID_ALREADY_LINKED") throw Qp(e, "credential-already-in-use", a);
			if (t === "EMAIL_EXISTS") throw Qp(e, "email-already-in-use", a);
			if (t === "USER_DISABLED") throw Qp(e, "user-disabled", a);
			let o = r[t] || t.toLowerCase().replace(/[_\s]+/g, "-");
			if (n) throw jp(e, o, n);
			kp(e, o);
		}
	} catch (t) {
		if (t instanceof on) throw t;
		kp(e, "network-request-failed", { message: String(t) });
	}
}
async function Jp(e, t, n, r, i = {}) {
	let a = await Kp(e, t, n, r, i);
	return "mfaPendingCredential" in a && kp(e, "multi-factor-auth-required", { _serverResponse: a }), a;
}
function Yp(e, t, n, r) {
	let i = `${t}${n}?${r}`;
	return e.config.emulator ? Hp(e.config, i) : `${e.config.apiScheme}://${i}`;
}
function Xp(e) {
	switch (e) {
		case "ENFORCE": return "ENFORCE";
		case "AUDIT": return "AUDIT";
		case "OFF": return "OFF";
		default: return "ENFORCEMENT_STATE_UNSPECIFIED";
	}
}
var Zp = class {
	constructor(e) {
		this.auth = e, this.timer = null, this.promise = new Promise((e, t) => {
			this.timer = setTimeout(() => t(Ap(this.auth, "network-request-failed")), Gp.get());
		});
	}
	clearNetworkTimeout() {
		clearTimeout(this.timer);
	}
};
function Qp(e, t, n) {
	let r = { appName: e.name };
	n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
	let i = Ap(e, t, r);
	return i.customData._tokenResponse = n, i;
}
function $p(e) {
	return e !== void 0 && e.enterprise !== void 0;
}
var em = class {
	constructor(e) {
		if (this.siteKey = "", this.recaptchaEnforcementState = [], e.recaptchaKey === void 0) throw Error("recaptchaKey undefined");
		this.siteKey = e.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = e.recaptchaEnforcementState;
	}
	getProviderEnforcementState(e) {
		if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
		for (let t of this.recaptchaEnforcementState) if (t.provider && t.provider === e) return Xp(t.enforcementState);
		return null;
	}
	isProviderEnabled(e) {
		return this.getProviderEnforcementState(e) === "ENFORCE" || this.getProviderEnforcementState(e) === "AUDIT";
	}
	isAnyProviderEnabled() {
		return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER") || this.isProviderEnabled("PHONE_PROVIDER");
	}
};
async function tm(e, t) {
	return Kp(e, "GET", "/v2/recaptchaConfig", Q(e, t));
}
async function nm(e, t) {
	return Kp(e, "POST", "/v1/accounts:delete", t);
}
async function rm(e, t) {
	return Kp(e, "POST", "/v1/accounts:lookup", t);
}
function im(e) {
	if (e) try {
		let t = new Date(Number(e));
		if (!isNaN(t.getTime())) return t.toUTCString();
	} catch {}
}
async function am(e, t = !1) {
	let n = T(e), r = await n.getIdToken(t), i = sm(r);
	Z(i && i.exp && i.auth_time && i.iat, n.auth, "internal-error");
	let a = typeof i.firebase == "object" ? i.firebase : void 0, o = a?.sign_in_provider;
	return {
		claims: i,
		token: r,
		authTime: im(om(i.auth_time)),
		issuedAtTime: im(om(i.iat)),
		expirationTime: im(om(i.exp)),
		signInProvider: o || null,
		signInSecondFactor: a?.sign_in_second_factor || null
	};
}
function om(e) {
	return Number(e) * 1e3;
}
function sm(e) {
	let [t, n, r] = e.split(".");
	if (t === void 0 || n === void 0 || r === void 0) return Op("JWT malformed, contained fewer than 3 sections"), null;
	try {
		let e = Rt(n);
		return e ? JSON.parse(e) : (Op("Failed to decode base64 JWT payload"), null);
	} catch (e) {
		return Op("Caught error parsing JWT payload as JSON", e?.toString()), null;
	}
}
function cm(e) {
	let t = sm(e);
	return Z(t, "internal-error"), Z(t.exp !== void 0, "internal-error"), Z(t.iat !== void 0, "internal-error"), Number(t.exp) - Number(t.iat);
}
async function lm(e, t, n = !1) {
	if (n) return t;
	try {
		return await t;
	} catch (t) {
		throw t instanceof on && um(t) && e.auth.currentUser === e && await e.auth.signOut(), t;
	}
}
function um({ code: e }) {
	return e === "auth/user-disabled" || e === "auth/user-token-expired";
}
var dm = class {
	constructor(e) {
		this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
	}
	_start() {
		this.isRunning || (this.isRunning = !0, this.schedule());
	}
	_stop() {
		this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
	}
	getInterval(e) {
		if (e) {
			let e = this.errorBackoff;
			return this.errorBackoff = Math.min(this.errorBackoff * 2, 96e4), e;
		} else {
			this.errorBackoff = 3e4;
			let e = (this.user.stsTokenManager.expirationTime ?? 0) - Date.now() - 3e5;
			return Math.max(0, e);
		}
	}
	schedule(e = !1) {
		if (!this.isRunning) return;
		let t = this.getInterval(e);
		this.timerId = setTimeout(async () => {
			await this.iteration();
		}, t);
	}
	async iteration() {
		try {
			await this.user.getIdToken(!0);
		} catch (e) {
			e?.code === "auth/network-request-failed" && this.schedule(!0);
			return;
		}
		this.schedule();
	}
}, fm = class {
	constructor(e, t) {
		this.createdAt = e, this.lastLoginAt = t, this._initializeTime();
	}
	_initializeTime() {
		this.lastSignInTime = im(this.lastLoginAt), this.creationTime = im(this.createdAt);
	}
	_copy(e) {
		this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
	}
	toJSON() {
		return {
			createdAt: this.createdAt,
			lastLoginAt: this.lastLoginAt
		};
	}
};
async function pm(e) {
	let t = e.auth, n = await lm(e, rm(t, { idToken: await e.getIdToken() }));
	Z(n?.users.length, t, "internal-error");
	let r = n.users[0];
	e._notifyReloadListener(r);
	let i = r.providerUserInfo?.length ? gm(r.providerUserInfo) : [], a = hm(e.providerData, i), o = e.isAnonymous, s = !(e.email && r.passwordHash) && !a?.length, c = o ? s : !1, l = {
		uid: r.localId,
		displayName: r.displayName || null,
		photoURL: r.photoUrl || null,
		email: r.email || null,
		emailVerified: r.emailVerified || !1,
		phoneNumber: r.phoneNumber || null,
		tenantId: r.tenantId || null,
		providerData: a,
		metadata: new fm(r.createdAt, r.lastLoginAt),
		isAnonymous: c
	};
	Object.assign(e, l);
}
async function mm(e) {
	let t = T(e);
	await pm(t), await t.auth._persistUserIfCurrent(t), t.auth._notifyListenersIfCurrent(t);
}
function hm(e, t) {
	return [...e.filter((e) => !t.some((t) => t.providerId === e.providerId)), ...t];
}
function gm(e) {
	return e.map((e) => {
		var { providerId: t } = e, n = Sp(e, ["providerId"]);
		return {
			providerId: t,
			uid: n.rawId || "",
			displayName: n.displayName || null,
			email: n.email || null,
			phoneNumber: n.phoneNumber || null,
			photoURL: n.photoUrl || null
		};
	});
}
async function _m(e, t) {
	let n = await qp(e, {}, async () => {
		let n = pn({
			grant_type: "refresh_token",
			refresh_token: t
		}).slice(1), { tokenApiHost: r, apiKey: i } = e.config, a = Yp(e, r, "/v1/token", `key=${i}`), o = await e._getAdditionalHeaders();
		return o["Content-Type"] = "application/x-www-form-urlencoded", Up.fetch()(a, {
			method: "POST",
			headers: o,
			body: n
		});
	});
	return {
		accessToken: n.access_token,
		expiresIn: n.expires_in,
		refreshToken: n.refresh_token
	};
}
async function vm(e, t) {
	return Kp(e, "POST", "/v2/accounts:revokeToken", Q(e, t));
}
var ym = class e {
	constructor() {
		this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
	}
	get isExpired() {
		return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
	}
	updateFromServerResponse(e) {
		Z(e.idToken, "internal-error"), Z(e.idToken !== void 0, "internal-error"), Z(e.refreshToken !== void 0, "internal-error");
		let t = "expiresIn" in e && e.expiresIn !== void 0 ? Number(e.expiresIn) : cm(e.idToken);
		this.updateTokensAndExpiration(e.idToken, e.refreshToken, t);
	}
	updateFromIdToken(e) {
		Z(e.length !== 0, "internal-error");
		let t = cm(e);
		this.updateTokensAndExpiration(e, null, t);
	}
	async getToken(e, t = !1) {
		return !t && this.accessToken && !this.isExpired ? this.accessToken : (Z(this.refreshToken, e, "user-token-expired"), this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null);
	}
	clearRefreshToken() {
		this.refreshToken = null;
	}
	async refresh(e, t) {
		let { accessToken: n, refreshToken: r, expiresIn: i } = await _m(e, t);
		this.updateTokensAndExpiration(n, r, Number(i));
	}
	updateTokensAndExpiration(e, t, n) {
		this.refreshToken = t || null, this.accessToken = e || null, this.expirationTime = Date.now() + n * 1e3;
	}
	static fromJSON(t, n) {
		let { refreshToken: r, accessToken: i, expirationTime: a } = n, o = new e();
		return r && (Z(typeof r == "string", "internal-error", { appName: t }), o.refreshToken = r), i && (Z(typeof i == "string", "internal-error", { appName: t }), o.accessToken = i), a && (Z(typeof a == "number", "internal-error", { appName: t }), o.expirationTime = a), o;
	}
	toJSON() {
		return {
			refreshToken: this.refreshToken,
			accessToken: this.accessToken,
			expirationTime: this.expirationTime
		};
	}
	_assign(e) {
		this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
	}
	_clone() {
		return Object.assign(new e(), this.toJSON());
	}
	_performRefresh() {
		return Pp("not implemented");
	}
};
function bm(e, t) {
	Z(typeof e == "string" || e === void 0, "internal-error", { appName: t });
}
var xm = class e {
	constructor(e) {
		var { uid: t, auth: n, stsTokenManager: r } = e, i = Sp(e, [
			"uid",
			"auth",
			"stsTokenManager"
		]);
		this.providerId = "firebase", this.proactiveRefresh = new dm(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = t, this.auth = n, this.stsTokenManager = r, this.accessToken = r.accessToken, this.displayName = i.displayName || null, this.email = i.email || null, this.emailVerified = i.emailVerified || !1, this.phoneNumber = i.phoneNumber || null, this.photoURL = i.photoURL || null, this.isAnonymous = i.isAnonymous || !1, this.tenantId = i.tenantId || null, this.providerData = i.providerData ? [...i.providerData] : [], this.metadata = new fm(i.createdAt || void 0, i.lastLoginAt || void 0);
	}
	async getIdToken(e) {
		let t = await lm(this, this.stsTokenManager.getToken(this.auth, e));
		return Z(t, this.auth, "internal-error"), this.accessToken !== t && (this.accessToken = t, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), t;
	}
	getIdTokenResult(e) {
		return am(this, e);
	}
	reload() {
		return mm(this);
	}
	_assign(e) {
		this !== e && (Z(this.uid === e.uid, this.auth, "internal-error"), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((e) => Object.assign({}, e)), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
	}
	_clone(t) {
		let n = new e(Object.assign(Object.assign({}, this), {
			auth: t,
			stsTokenManager: this.stsTokenManager._clone()
		}));
		return n.metadata._copy(this.metadata), n;
	}
	_onReload(e) {
		Z(!this.reloadListener, this.auth, "internal-error"), this.reloadListener = e, this.reloadUserInfo &&= (this._notifyReloadListener(this.reloadUserInfo), null);
	}
	_notifyReloadListener(e) {
		this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
	}
	_startProactiveRefresh() {
		this.proactiveRefresh._start();
	}
	_stopProactiveRefresh() {
		this.proactiveRefresh._stop();
	}
	async _updateTokensIfNecessary(e, t = !1) {
		let n = !1;
		e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), n = !0), t && await pm(this), await this.auth._persistUserIfCurrent(this), n && this.auth._notifyListenersIfCurrent(this);
	}
	async delete() {
		if (Br(this.auth.app)) return Promise.reject(Mp(this.auth));
		let e = await this.getIdToken();
		return await lm(this, nm(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
	}
	toJSON() {
		return Object.assign(Object.assign({
			uid: this.uid,
			email: this.email || void 0,
			emailVerified: this.emailVerified,
			displayName: this.displayName || void 0,
			isAnonymous: this.isAnonymous,
			photoURL: this.photoURL || void 0,
			phoneNumber: this.phoneNumber || void 0,
			tenantId: this.tenantId || void 0,
			providerData: this.providerData.map((e) => Object.assign({}, e)),
			stsTokenManager: this.stsTokenManager.toJSON(),
			_redirectEventId: this._redirectEventId
		}, this.metadata.toJSON()), {
			apiKey: this.auth.config.apiKey,
			appName: this.auth.name
		});
	}
	get refreshToken() {
		return this.stsTokenManager.refreshToken || "";
	}
	static _fromJSON(t, n) {
		let r = n.displayName ?? void 0, i = n.email ?? void 0, a = n.phoneNumber ?? void 0, o = n.photoURL ?? void 0, s = n.tenantId ?? void 0, c = n._redirectEventId ?? void 0, l = n.createdAt ?? void 0, u = n.lastLoginAt ?? void 0, { uid: d, emailVerified: f, isAnonymous: p, providerData: m, stsTokenManager: h } = n;
		Z(d && h, t, "internal-error");
		let g = ym.fromJSON(this.name, h);
		Z(typeof d == "string", t, "internal-error"), bm(r, t.name), bm(i, t.name), Z(typeof f == "boolean", t, "internal-error"), Z(typeof p == "boolean", t, "internal-error"), bm(a, t.name), bm(o, t.name), bm(s, t.name), bm(c, t.name), bm(l, t.name), bm(u, t.name);
		let ee = new e({
			uid: d,
			auth: t,
			email: i,
			emailVerified: f,
			displayName: r,
			isAnonymous: p,
			photoURL: o,
			phoneNumber: a,
			tenantId: s,
			stsTokenManager: g,
			createdAt: l,
			lastLoginAt: u
		});
		return m && Array.isArray(m) && (ee.providerData = m.map((e) => Object.assign({}, e))), c && (ee._redirectEventId = c), ee;
	}
	static async _fromIdTokenResponse(t, n, r = !1) {
		let i = new ym();
		i.updateFromServerResponse(n);
		let a = new e({
			uid: n.localId,
			auth: t,
			stsTokenManager: i,
			isAnonymous: r
		});
		return await pm(a), a;
	}
	static async _fromGetAccountInfoResponse(t, n, r) {
		let i = n.users[0];
		Z(i.localId !== void 0, "internal-error");
		let a = i.providerUserInfo === void 0 ? [] : gm(i.providerUserInfo), o = !(i.email && i.passwordHash) && !a?.length, s = new ym();
		s.updateFromIdToken(r);
		let c = new e({
			uid: i.localId,
			auth: t,
			stsTokenManager: s,
			isAnonymous: o
		}), l = {
			uid: i.localId,
			displayName: i.displayName || null,
			photoURL: i.photoUrl || null,
			email: i.email || null,
			emailVerified: i.emailVerified || !1,
			phoneNumber: i.phoneNumber || null,
			tenantId: i.tenantId || null,
			providerData: a,
			metadata: new fm(i.createdAt, i.lastLoginAt),
			isAnonymous: !(i.email && i.passwordHash) && !a?.length
		};
		return Object.assign(c, l), c;
	}
}, Sm = /* @__PURE__ */ new Map();
function Cm(e) {
	Fp(e instanceof Function, "Expected a class definition");
	let t = Sm.get(e);
	return t ? (Fp(t instanceof e, "Instance stored in cache mismatched with class"), t) : (t = new e(), Sm.set(e, t), t);
}
var wm = class {
	constructor() {
		this.type = "NONE", this.storage = {};
	}
	async _isAvailable() {
		return !0;
	}
	async _set(e, t) {
		this.storage[e] = t;
	}
	async _get(e) {
		let t = this.storage[e];
		return t === void 0 ? null : t;
	}
	async _remove(e) {
		delete this.storage[e];
	}
	_addListener(e, t) {}
	_removeListener(e, t) {}
};
wm.type = "NONE";
var Tm = wm;
function Em(e, t, n) {
	return `firebase:${e}:${t}:${n}`;
}
var Dm = class e {
	constructor(e, t, n) {
		this.persistence = e, this.auth = t, this.userKey = n;
		let { config: r, name: i } = this.auth;
		this.fullUserKey = Em(this.userKey, r.apiKey, i), this.fullPersistenceKey = Em("persistence", r.apiKey, i), this.boundEventHandler = t._onStorageEvent.bind(t), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
	}
	setCurrentUser(e) {
		return this.persistence._set(this.fullUserKey, e.toJSON());
	}
	async getCurrentUser() {
		let e = await this.persistence._get(this.fullUserKey);
		return e ? xm._fromJSON(this.auth, e) : null;
	}
	removeCurrentUser() {
		return this.persistence._remove(this.fullUserKey);
	}
	savePersistenceForRedirect() {
		return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
	}
	async setPersistence(e) {
		if (this.persistence === e) return;
		let t = await this.getCurrentUser();
		if (await this.removeCurrentUser(), this.persistence = e, t) return this.setCurrentUser(t);
	}
	delete() {
		this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
	}
	static async create(t, n, r = "authUser") {
		if (!n.length) return new e(Cm(Tm), t, r);
		let i = (await Promise.all(n.map(async (e) => {
			if (await e._isAvailable()) return e;
		}))).filter((e) => e), a = i[0] || Cm(Tm), o = Em(r, t.config.apiKey, t.name), s = null;
		for (let e of n) try {
			let n = await e._get(o);
			if (n) {
				let r = xm._fromJSON(t, n);
				e !== a && (s = r), a = e;
				break;
			}
		} catch {}
		let c = i.filter((e) => e._shouldAllowMigration);
		return !a._shouldAllowMigration || !c.length ? new e(a, t, r) : (a = c[0], s && await a._set(o, s.toJSON()), await Promise.all(n.map(async (e) => {
			if (e !== a) try {
				await e._remove(o);
			} catch {}
		})), new e(a, t, r));
	}
};
function Om(e) {
	let t = e.toLowerCase();
	if (t.includes("opera/") || t.includes("opr/") || t.includes("opios/")) return "Opera";
	if (Mm(t)) return "IEMobile";
	if (t.includes("msie") || t.includes("trident/")) return "IE";
	if (t.includes("edge/")) return "Edge";
	if (km(t)) return "Firefox";
	if (t.includes("silk/")) return "Silk";
	if (Pm(t)) return "Blackberry";
	if (Fm(t)) return "Webos";
	if (Am(t)) return "Safari";
	if ((t.includes("chrome/") || jm(t)) && !t.includes("edge/")) return "Chrome";
	if (Nm(t)) return "Android";
	{
		let t = e.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/);
		if (t?.length === 2) return t[1];
	}
	return "Other";
}
function km(e = C()) {
	return /firefox\//i.test(e);
}
function Am(e = C()) {
	let t = e.toLowerCase();
	return t.includes("safari/") && !t.includes("chrome/") && !t.includes("crios/") && !t.includes("android");
}
function jm(e = C()) {
	return /crios\//i.test(e);
}
function Mm(e = C()) {
	return /iemobile/i.test(e);
}
function Nm(e = C()) {
	return /android/i.test(e);
}
function Pm(e = C()) {
	return /blackberry/i.test(e);
}
function Fm(e = C()) {
	return /webos/i.test(e);
}
function Im(e = C()) {
	return /iphone|ipad|ipod/i.test(e) || /macintosh/i.test(e) && /mobile/i.test(e);
}
function Lm(e = C()) {
	return Im(e) && !!window.navigator?.standalone;
}
function Rm() {
	return en() && document.documentMode === 10;
}
function zm(e = C()) {
	return Im(e) || Nm(e) || Fm(e) || Pm(e) || /windows phone/i.test(e) || Mm(e);
}
function Bm(e, t = []) {
	let n;
	switch (e) {
		case "Browser":
			n = Om(C());
			break;
		case "Worker":
			n = `${Om(C())}-${e}`;
			break;
		default: n = e;
	}
	let r = t.length ? t.join(",") : "FirebaseCore-web";
	return `${n}/JsCore/${Ur}/${r}`;
}
var Vm = class {
	constructor(e) {
		this.auth = e, this.queue = [];
	}
	pushCallback(e, t) {
		let n = (t) => new Promise((n, r) => {
			try {
				n(e(t));
			} catch (e) {
				r(e);
			}
		});
		n.onAbort = t, this.queue.push(n);
		let r = this.queue.length - 1;
		return () => {
			this.queue[r] = () => Promise.resolve();
		};
	}
	async runMiddleware(e) {
		if (this.auth.currentUser === e) return;
		let t = [];
		try {
			for (let n of this.queue) await n(e), n.onAbort && t.push(n.onAbort);
		} catch (e) {
			t.reverse();
			for (let e of t) try {
				e();
			} catch {}
			throw this.auth._errorFactory.create("login-blocked", { originalMessage: e?.message });
		}
	}
};
async function Hm(e, t = {}) {
	return Kp(e, "GET", "/v2/passwordPolicy", Q(e, t));
}
var Um = 6, Wm = class {
	constructor(e) {
		let t = e.customStrengthOptions;
		this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = t.minPasswordLength ?? Um, t.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = t.maxPasswordLength), t.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = t.containsLowercaseCharacter), t.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = t.containsUppercaseCharacter), t.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = t.containsNumericCharacter), t.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = t.containsNonAlphanumericCharacter), this.enforcementState = e.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = e.allowedNonAlphanumericCharacters?.join("") ?? "", this.forceUpgradeOnSignin = e.forceUpgradeOnSignin ?? !1, this.schemaVersion = e.schemaVersion;
	}
	validatePassword(e) {
		let t = {
			isValid: !0,
			passwordPolicy: this
		};
		return this.validatePasswordLengthOptions(e, t), this.validatePasswordCharacterOptions(e, t), t.isValid &&= t.meetsMinPasswordLength ?? !0, t.isValid &&= t.meetsMaxPasswordLength ?? !0, t.isValid &&= t.containsLowercaseLetter ?? !0, t.isValid &&= t.containsUppercaseLetter ?? !0, t.isValid &&= t.containsNumericCharacter ?? !0, t.isValid &&= t.containsNonAlphanumericCharacter ?? !0, t;
	}
	validatePasswordLengthOptions(e, t) {
		let n = this.customStrengthOptions.minPasswordLength, r = this.customStrengthOptions.maxPasswordLength;
		n && (t.meetsMinPasswordLength = e.length >= n), r && (t.meetsMaxPasswordLength = e.length <= r);
	}
	validatePasswordCharacterOptions(e, t) {
		this.updatePasswordCharacterOptionsStatuses(t, !1, !1, !1, !1);
		let n;
		for (let r = 0; r < e.length; r++) n = e.charAt(r), this.updatePasswordCharacterOptionsStatuses(t, n >= "a" && n <= "z", n >= "A" && n <= "Z", n >= "0" && n <= "9", this.allowedNonAlphanumericCharacters.includes(n));
	}
	updatePasswordCharacterOptionsStatuses(e, t, n, r, i) {
		this.customStrengthOptions.containsLowercaseLetter && (e.containsLowercaseLetter ||= t), this.customStrengthOptions.containsUppercaseLetter && (e.containsUppercaseLetter ||= n), this.customStrengthOptions.containsNumericCharacter && (e.containsNumericCharacter ||= r), this.customStrengthOptions.containsNonAlphanumericCharacter && (e.containsNonAlphanumericCharacter ||= i);
	}
}, Gm = class {
	constructor(e, t, n, r) {
		this.app = e, this.heartbeatServiceProvider = t, this.appCheckServiceProvider = n, this.config = r, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new qm(this), this.idTokenSubscription = new qm(this), this.beforeStateQueue = new Vm(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = Tp, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = r.sdkClientVersion;
	}
	_initializeWithPersistence(e, t) {
		return t && (this._popupRedirectResolver = Cm(t)), this._initializationPromise = this.queue(async () => {
			if (!this._deleted && (this.persistenceManager = await Dm.create(this, e), !this._deleted)) {
				if (this._popupRedirectResolver?._shouldInitProactively) try {
					await this._popupRedirectResolver._initialize(this);
				} catch {}
				await this.initializeCurrentUser(t), this.lastNotifiedUid = this.currentUser?.uid || null, !this._deleted && (this._isInitialized = !0);
			}
		}), this._initializationPromise;
	}
	async _onStorageEvent() {
		if (this._deleted) return;
		let e = await this.assertedPersistence.getCurrentUser();
		if (!(!this.currentUser && !e)) {
			if (this.currentUser && e && this.currentUser.uid === e.uid) {
				this._currentUser._assign(e), await this.currentUser.getIdToken();
				return;
			}
			await this._updateCurrentUser(e, !0);
		}
	}
	async initializeCurrentUserFromIdToken(e) {
		try {
			let t = await rm(this, { idToken: e }), n = await xm._fromGetAccountInfoResponse(this, t, e);
			await this.directlySetCurrentUser(n);
		} catch (e) {
			console.warn("FirebaseServerApp could not login user with provided authIdToken: ", e), await this.directlySetCurrentUser(null);
		}
	}
	async initializeCurrentUser(e) {
		if (Br(this.app)) {
			let e = this.app.settings.authIdToken;
			return e ? new Promise((t) => {
				setTimeout(() => this.initializeCurrentUserFromIdToken(e).then(t, t));
			}) : this.directlySetCurrentUser(null);
		}
		let t = await this.assertedPersistence.getCurrentUser(), n = t, r = !1;
		if (e && this.config.authDomain) {
			await this.getOrInitRedirectPersistenceManager();
			let t = this.redirectUser?._redirectEventId, i = n?._redirectEventId, a = await this.tryRedirectSignIn(e);
			(!t || t === i) && a?.user && (n = a.user, r = !0);
		}
		if (!n) return this.directlySetCurrentUser(null);
		if (!n._redirectEventId) {
			if (r) try {
				await this.beforeStateQueue.runMiddleware(n);
			} catch (e) {
				n = t, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(e));
			}
			return n ? this.reloadAndSetCurrentUserOrClear(n) : this.directlySetCurrentUser(null);
		}
		return Z(this._popupRedirectResolver, this, "argument-error"), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === n._redirectEventId ? this.directlySetCurrentUser(n) : this.reloadAndSetCurrentUserOrClear(n);
	}
	async tryRedirectSignIn(e) {
		let t = null;
		try {
			t = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
		} catch {
			await this._setRedirectUser(null);
		}
		return t;
	}
	async reloadAndSetCurrentUserOrClear(e) {
		try {
			await pm(e);
		} catch (e) {
			if (e?.code !== "auth/network-request-failed") return this.directlySetCurrentUser(null);
		}
		return this.directlySetCurrentUser(e);
	}
	useDeviceLanguage() {
		this.languageCode = Bp();
	}
	async _delete() {
		this._deleted = !0;
	}
	async updateCurrentUser(e) {
		if (Br(this.app)) return Promise.reject(Mp(this));
		let t = e ? T(e) : null;
		return t && Z(t.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token"), this._updateCurrentUser(t && t._clone(this));
	}
	async _updateCurrentUser(e, t = !1) {
		if (!this._deleted) return e && Z(this.tenantId === e.tenantId, this, "tenant-id-mismatch"), t || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
			await this.directlySetCurrentUser(e), this.notifyAuthListeners();
		});
	}
	async signOut() {
		return Br(this.app) ? Promise.reject(Mp(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(null, !0));
	}
	setPersistence(e) {
		return Br(this.app) ? Promise.reject(Mp(this)) : this.queue(async () => {
			await this.assertedPersistence.setPersistence(Cm(e));
		});
	}
	_getRecaptchaConfig() {
		return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
	}
	async validatePassword(e) {
		this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
		let t = this._getPasswordPolicyInternal();
		return t.schemaVersion === this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? t.validatePassword(e) : Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {}));
	}
	_getPasswordPolicyInternal() {
		return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
	}
	async _updatePasswordPolicy() {
		let e = new Wm(await Hm(this));
		this.tenantId === null ? this._projectPasswordPolicy = e : this._tenantPasswordPolicies[this.tenantId] = e;
	}
	_getPersistence() {
		return this.assertedPersistence.persistence.type;
	}
	_updateErrorMap(e) {
		this._errorFactory = new sn("auth", "Firebase", e());
	}
	onAuthStateChanged(e, t, n) {
		return this.registerStateListener(this.authStateSubscription, e, t, n);
	}
	beforeAuthStateChanged(e, t) {
		return this.beforeStateQueue.pushCallback(e, t);
	}
	onIdTokenChanged(e, t, n) {
		return this.registerStateListener(this.idTokenSubscription, e, t, n);
	}
	authStateReady() {
		return new Promise((e, t) => {
			if (this.currentUser) e();
			else {
				let n = this.onAuthStateChanged(() => {
					n(), e();
				}, t);
			}
		});
	}
	async revokeAccessToken(e) {
		if (this.currentUser) {
			let t = {
				providerId: "apple.com",
				tokenType: "ACCESS_TOKEN",
				token: e,
				idToken: await this.currentUser.getIdToken()
			};
			this.tenantId != null && (t.tenantId = this.tenantId), await vm(this, t);
		}
	}
	toJSON() {
		return {
			apiKey: this.config.apiKey,
			authDomain: this.config.authDomain,
			appName: this.name,
			currentUser: this._currentUser?.toJSON()
		};
	}
	async _setRedirectUser(e, t) {
		let n = await this.getOrInitRedirectPersistenceManager(t);
		return e === null ? n.removeCurrentUser() : n.setCurrentUser(e);
	}
	async getOrInitRedirectPersistenceManager(e) {
		if (!this.redirectPersistenceManager) {
			let t = e && Cm(e) || this._popupRedirectResolver;
			Z(t, this, "argument-error"), this.redirectPersistenceManager = await Dm.create(this, [Cm(t._redirectPersistence)], "redirectUser"), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
		}
		return this.redirectPersistenceManager;
	}
	async _redirectUserForId(e) {
		return this._isInitialized && await this.queue(async () => {}), this._currentUser?._redirectEventId === e ? this._currentUser : this.redirectUser?._redirectEventId === e ? this.redirectUser : null;
	}
	async _persistUserIfCurrent(e) {
		if (e === this.currentUser) return this.queue(async () => this.directlySetCurrentUser(e));
	}
	_notifyListenersIfCurrent(e) {
		e === this.currentUser && this.notifyAuthListeners();
	}
	_key() {
		return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
	}
	_startProactiveRefresh() {
		this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
	}
	_stopProactiveRefresh() {
		this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
	}
	get _currentUser() {
		return this.currentUser;
	}
	notifyAuthListeners() {
		if (!this._isInitialized) return;
		this.idTokenSubscription.next(this.currentUser);
		let e = this.currentUser?.uid ?? null;
		this.lastNotifiedUid !== e && (this.lastNotifiedUid = e, this.authStateSubscription.next(this.currentUser));
	}
	registerStateListener(e, t, n, r) {
		if (this._deleted) return () => {};
		let i = typeof t == "function" ? t : t.next.bind(t), a = !1, o = this._isInitialized ? Promise.resolve() : this._initializationPromise;
		if (Z(o, this, "internal-error"), o.then(() => {
			a || i(this.currentUser);
		}), typeof t == "function") {
			let i = e.addObserver(t, n, r);
			return () => {
				a = !0, i();
			};
		} else {
			let n = e.addObserver(t);
			return () => {
				a = !0, n();
			};
		}
	}
	async directlySetCurrentUser(e) {
		this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh(), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
	}
	queue(e) {
		return this.operations = this.operations.then(e, e), this.operations;
	}
	get assertedPersistence() {
		return Z(this.persistenceManager, this, "internal-error"), this.persistenceManager;
	}
	_logFramework(e) {
		!e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = Bm(this.config.clientPlatform, this._getFrameworks()));
	}
	_getFrameworks() {
		return this.frameworks;
	}
	async _getAdditionalHeaders() {
		let e = { "X-Client-Version": this.clientVersion };
		this.app.options.appId && (e["X-Firebase-gmpid"] = this.app.options.appId);
		let t = await this.heartbeatServiceProvider.getImmediate({ optional: !0 })?.getHeartbeatsHeader();
		t && (e["X-Firebase-Client"] = t);
		let n = await this._getAppCheckToken();
		return n && (e["X-Firebase-AppCheck"] = n), e;
	}
	async _getAppCheckToken() {
		let e = await this.appCheckServiceProvider.getImmediate({ optional: !0 })?.getToken();
		return e?.error && Dp(`Error while retrieving App Check token: ${e.error}`), e?.token;
	}
};
function Km(e) {
	return T(e);
}
var qm = class {
	constructor(e) {
		this.auth = e, this.observer = null, this.addObserver = gn((e) => this.observer = e);
	}
	get next() {
		return Z(this.observer, this.auth, "internal-error"), this.observer.next.bind(this.observer);
	}
}, Jm = {
	async loadJS() {
		throw Error("Unable to load external scripts");
	},
	recaptchaV2Script: "",
	recaptchaEnterpriseScript: "",
	gapiScript: ""
};
function Ym(e) {
	Jm = e;
}
function Xm(e) {
	return Jm.loadJS(e);
}
function Zm() {
	return Jm.recaptchaEnterpriseScript;
}
function Qm() {
	return Jm.gapiScript;
}
function $m(e) {
	return `__${e}${Math.floor(Math.random() * 1e6)}`;
}
var eh = class {
	constructor() {
		this.enterprise = new th();
	}
	ready(e) {
		e();
	}
	execute(e, t) {
		return Promise.resolve("token");
	}
	render(e, t) {
		return "";
	}
}, th = class {
	ready(e) {
		e();
	}
	execute(e, t) {
		return Promise.resolve("token");
	}
	render(e, t) {
		return "";
	}
}, nh = "recaptcha-enterprise", rh = "NO_RECAPTCHA", ih = class {
	constructor(e) {
		this.type = nh, this.auth = Km(e);
	}
	async verify(e = "verify", t = !1) {
		async function n(e) {
			if (!t) {
				if (e.tenantId == null && e._agentRecaptchaConfig != null) return e._agentRecaptchaConfig.siteKey;
				if (e.tenantId != null && e._tenantRecaptchaConfigs[e.tenantId] !== void 0) return e._tenantRecaptchaConfigs[e.tenantId].siteKey;
			}
			return new Promise(async (t, n) => {
				tm(e, {
					clientType: "CLIENT_TYPE_WEB",
					version: "RECAPTCHA_ENTERPRISE"
				}).then((r) => {
					if (r.recaptchaKey === void 0) n(/* @__PURE__ */ Error("recaptcha Enterprise site key undefined"));
					else {
						let n = new em(r);
						return e.tenantId == null ? e._agentRecaptchaConfig = n : e._tenantRecaptchaConfigs[e.tenantId] = n, t(n.siteKey);
					}
				}).catch((e) => {
					n(e);
				});
			});
		}
		function r(t, n, r) {
			let i = window.grecaptcha;
			$p(i) ? i.enterprise.ready(() => {
				i.enterprise.execute(t, { action: e }).then((e) => {
					n(e);
				}).catch(() => {
					n(rh);
				});
			}) : r(Error("No reCAPTCHA enterprise script loaded."));
		}
		return this.auth.settings.appVerificationDisabledForTesting ? new eh().execute("siteKey", { action: "verify" }) : new Promise((e, i) => {
			n(this.auth).then((n) => {
				if (!t && $p(window.grecaptcha)) r(n, e, i);
				else {
					if (typeof window > "u") {
						i(/* @__PURE__ */ Error("RecaptchaVerifier is only supported in browser"));
						return;
					}
					let t = Zm();
					t.length !== 0 && (t += n), Xm(t).then(() => {
						r(n, e, i);
					}).catch((e) => {
						i(e);
					});
				}
			}).catch((e) => {
				i(e);
			});
		});
	}
};
async function ah(e, t, n, r = !1, i = !1) {
	let a = new ih(e), o;
	if (i) o = rh;
	else try {
		o = await a.verify(n);
	} catch {
		o = await a.verify(n, !0);
	}
	let s = Object.assign({}, t);
	if (n === "mfaSmsEnrollment" || n === "mfaSmsSignIn") {
		if ("phoneEnrollmentInfo" in s) {
			let e = s.phoneEnrollmentInfo.phoneNumber, t = s.phoneEnrollmentInfo.recaptchaToken;
			Object.assign(s, { phoneEnrollmentInfo: {
				phoneNumber: e,
				recaptchaToken: t,
				captchaResponse: o,
				clientType: "CLIENT_TYPE_WEB",
				recaptchaVersion: "RECAPTCHA_ENTERPRISE"
			} });
		} else if ("phoneSignInInfo" in s) {
			let e = s.phoneSignInInfo.recaptchaToken;
			Object.assign(s, { phoneSignInInfo: {
				recaptchaToken: e,
				captchaResponse: o,
				clientType: "CLIENT_TYPE_WEB",
				recaptchaVersion: "RECAPTCHA_ENTERPRISE"
			} });
		}
		return s;
	}
	return r ? Object.assign(s, { captchaResp: o }) : Object.assign(s, { captchaResponse: o }), Object.assign(s, { clientType: "CLIENT_TYPE_WEB" }), Object.assign(s, { recaptchaVersion: "RECAPTCHA_ENTERPRISE" }), s;
}
async function oh(e, t, n, r, i) {
	return i === "EMAIL_PASSWORD_PROVIDER" ? e._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER") ? r(e, await ah(e, t, n, n === "getOobCode")) : r(e, t).catch(async (i) => i.code === "auth/missing-recaptcha-token" ? (console.log(`${n} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`), r(e, await ah(e, t, n, n === "getOobCode"))) : Promise.reject(i)) : i === "PHONE_PROVIDER" ? e._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER") ? r(e, await ah(e, t, n)).catch(async (i) => e._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER") === "AUDIT" && (i.code === "auth/missing-recaptcha-token" || i.code === "auth/invalid-app-credential") ? (console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${n} flow.`), r(e, await ah(e, t, n, !1, !0))) : Promise.reject(i)) : r(e, await ah(e, t, n, !1, !0)) : Promise.reject(i + " provider is not supported.");
}
async function sh(e) {
	let t = Km(e), n = new em(await tm(t, {
		clientType: "CLIENT_TYPE_WEB",
		version: "RECAPTCHA_ENTERPRISE"
	}));
	t.tenantId == null ? t._agentRecaptchaConfig = n : t._tenantRecaptchaConfigs[t.tenantId] = n, n.isAnyProviderEnabled() && new ih(t).verify();
}
function ch(e, t) {
	let n = zr(e, "auth");
	if (n.isInitialized()) {
		let e = n.getImmediate();
		if (dn(n.getOptions(), t ?? {})) return e;
		kp(e, "already-initialized");
	}
	return n.initialize({ options: t });
}
function lh(e, t) {
	let n = t?.persistence || [], r = (Array.isArray(n) ? n : [n]).map(Cm);
	t?.errorMap && e._updateErrorMap(t.errorMap), e._initializeWithPersistence(r, t?.popupRedirectResolver);
}
function uh(e, t, n) {
	let r = Km(e);
	Z(r._canInitEmulator, r, "emulator-config-failed"), Z(/^https?:\/\//.test(t), r, "invalid-emulator-scheme");
	let i = !!n?.disableWarnings, a = dh(t), { host: o, port: s } = fh(t), c = s === null ? "" : `:${s}`;
	r.config.emulator = { url: `${a}//${o}${c}/` }, r.settings.appVerificationDisabledForTesting = !0, r.emulatorConfig = Object.freeze({
		host: o,
		port: s,
		protocol: a.replace(":", ""),
		options: Object.freeze({ disableWarnings: i })
	}), i || mh();
}
function dh(e) {
	let t = e.indexOf(":");
	return t < 0 ? "" : e.substr(0, t + 1);
}
function fh(e) {
	let t = dh(e), n = /(\/\/)?([^?#/]+)/.exec(e.substr(t.length));
	if (!n) return {
		host: "",
		port: null
	};
	let r = n[2].split("@").pop() || "", i = /^(\[[^\]]+\])(:|$)/.exec(r);
	if (i) {
		let e = i[1];
		return {
			host: e,
			port: ph(r.substr(e.length + 1))
		};
	} else {
		let [e, t] = r.split(":");
		return {
			host: e,
			port: ph(t)
		};
	}
}
function ph(e) {
	if (!e) return null;
	let t = Number(e);
	return isNaN(t) ? null : t;
}
function mh() {
	function e() {
		let e = document.createElement("p"), t = e.style;
		e.innerText = "Running in emulator mode. Do not use with production credentials.", t.position = "fixed", t.width = "100%", t.backgroundColor = "#ffffff", t.border = ".1em solid #000000", t.color = "#b50000", t.bottom = "0px", t.left = "0px", t.margin = "0px", t.zIndex = "10000", t.textAlign = "center", e.classList.add("firebase-emulator-warning"), document.body.appendChild(e);
	}
	typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", e) : e());
}
var hh = class {
	constructor(e, t) {
		this.providerId = e, this.signInMethod = t;
	}
	toJSON() {
		return Pp("not implemented");
	}
	_getIdTokenResponse(e) {
		return Pp("not implemented");
	}
	_linkToIdToken(e, t) {
		return Pp("not implemented");
	}
	_getReauthenticationResolver(e) {
		return Pp("not implemented");
	}
};
async function gh(e, t) {
	return Kp(e, "POST", "/v1/accounts:signUp", t);
}
async function _h(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithPassword", Q(e, t));
}
async function vh(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithEmailLink", Q(e, t));
}
async function yh(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithEmailLink", Q(e, t));
}
var bh = class e extends hh {
	constructor(e, t, n, r = null) {
		super("password", n), this._email = e, this._password = t, this._tenantId = r;
	}
	static _fromEmailAndPassword(t, n) {
		return new e(t, n, "password");
	}
	static _fromEmailAndCode(t, n, r = null) {
		return new e(t, n, "emailLink", r);
	}
	toJSON() {
		return {
			email: this._email,
			password: this._password,
			signInMethod: this.signInMethod,
			tenantId: this._tenantId
		};
	}
	static fromJSON(e) {
		let t = typeof e == "string" ? JSON.parse(e) : e;
		if (t?.email && t?.password) {
			if (t.signInMethod === "password") return this._fromEmailAndPassword(t.email, t.password);
			if (t.signInMethod === "emailLink") return this._fromEmailAndCode(t.email, t.password, t.tenantId);
		}
		return null;
	}
	async _getIdTokenResponse(e) {
		switch (this.signInMethod) {
			case "password": return oh(e, {
				returnSecureToken: !0,
				email: this._email,
				password: this._password,
				clientType: "CLIENT_TYPE_WEB"
			}, "signInWithPassword", _h, "EMAIL_PASSWORD_PROVIDER");
			case "emailLink": return vh(e, {
				email: this._email,
				oobCode: this._password
			});
			default: kp(e, "internal-error");
		}
	}
	async _linkToIdToken(e, t) {
		switch (this.signInMethod) {
			case "password": return oh(e, {
				idToken: t,
				returnSecureToken: !0,
				email: this._email,
				password: this._password,
				clientType: "CLIENT_TYPE_WEB"
			}, "signUpPassword", gh, "EMAIL_PASSWORD_PROVIDER");
			case "emailLink": return yh(e, {
				idToken: t,
				email: this._email,
				oobCode: this._password
			});
			default: kp(e, "internal-error");
		}
	}
	_getReauthenticationResolver(e) {
		return this._getIdTokenResponse(e);
	}
};
async function xh(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithIdp", Q(e, t));
}
var Sh = "http://localhost", Ch = class e extends hh {
	constructor() {
		super(...arguments), this.pendingToken = null;
	}
	static _fromParams(t) {
		let n = new e(t.providerId, t.signInMethod);
		return t.idToken || t.accessToken ? (t.idToken && (n.idToken = t.idToken), t.accessToken && (n.accessToken = t.accessToken), t.nonce && !t.pendingToken && (n.nonce = t.nonce), t.pendingToken && (n.pendingToken = t.pendingToken)) : t.oauthToken && t.oauthTokenSecret ? (n.accessToken = t.oauthToken, n.secret = t.oauthTokenSecret) : kp("argument-error"), n;
	}
	toJSON() {
		return {
			idToken: this.idToken,
			accessToken: this.accessToken,
			secret: this.secret,
			nonce: this.nonce,
			pendingToken: this.pendingToken,
			providerId: this.providerId,
			signInMethod: this.signInMethod
		};
	}
	static fromJSON(t) {
		let n = typeof t == "string" ? JSON.parse(t) : t, { providerId: r, signInMethod: i } = n, a = Sp(n, ["providerId", "signInMethod"]);
		if (!r || !i) return null;
		let o = new e(r, i);
		return o.idToken = a.idToken || void 0, o.accessToken = a.accessToken || void 0, o.secret = a.secret, o.nonce = a.nonce, o.pendingToken = a.pendingToken || null, o;
	}
	_getIdTokenResponse(e) {
		return xh(e, this.buildRequest());
	}
	_linkToIdToken(e, t) {
		let n = this.buildRequest();
		return n.idToken = t, xh(e, n);
	}
	_getReauthenticationResolver(e) {
		let t = this.buildRequest();
		return t.autoCreate = !1, xh(e, t);
	}
	buildRequest() {
		let e = {
			requestUri: Sh,
			returnSecureToken: !0
		};
		if (this.pendingToken) e.pendingToken = this.pendingToken;
		else {
			let t = {};
			this.idToken && (t.id_token = this.idToken), this.accessToken && (t.access_token = this.accessToken), this.secret && (t.oauth_token_secret = this.secret), t.providerId = this.providerId, this.nonce && !this.pendingToken && (t.nonce = this.nonce), e.postBody = pn(t);
		}
		return e;
	}
};
async function wh(e, t) {
	return Kp(e, "POST", "/v1/accounts:sendVerificationCode", Q(e, t));
}
async function Th(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithPhoneNumber", Q(e, t));
}
async function Eh(e, t) {
	let n = await Jp(e, "POST", "/v1/accounts:signInWithPhoneNumber", Q(e, t));
	if (n.temporaryProof) throw Qp(e, "account-exists-with-different-credential", n);
	return n;
}
var Dh = { USER_NOT_FOUND: "user-not-found" };
async function Oh(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithPhoneNumber", Q(e, Object.assign(Object.assign({}, t), { operation: "REAUTH" })), Dh);
}
var kh = class e extends hh {
	constructor(e) {
		super("phone", "phone"), this.params = e;
	}
	static _fromVerification(t, n) {
		return new e({
			verificationId: t,
			verificationCode: n
		});
	}
	static _fromTokenResponse(t, n) {
		return new e({
			phoneNumber: t,
			temporaryProof: n
		});
	}
	_getIdTokenResponse(e) {
		return Th(e, this._makeVerificationRequest());
	}
	_linkToIdToken(e, t) {
		return Eh(e, Object.assign({ idToken: t }, this._makeVerificationRequest()));
	}
	_getReauthenticationResolver(e) {
		return Oh(e, this._makeVerificationRequest());
	}
	_makeVerificationRequest() {
		let { temporaryProof: e, phoneNumber: t, verificationId: n, verificationCode: r } = this.params;
		return e && t ? {
			temporaryProof: e,
			phoneNumber: t
		} : {
			sessionInfo: n,
			code: r
		};
	}
	toJSON() {
		let e = { providerId: this.providerId };
		return this.params.phoneNumber && (e.phoneNumber = this.params.phoneNumber), this.params.temporaryProof && (e.temporaryProof = this.params.temporaryProof), this.params.verificationCode && (e.verificationCode = this.params.verificationCode), this.params.verificationId && (e.verificationId = this.params.verificationId), e;
	}
	static fromJSON(t) {
		typeof t == "string" && (t = JSON.parse(t));
		let { verificationId: n, verificationCode: r, phoneNumber: i, temporaryProof: a } = t;
		return !r && !n && !i && !a ? null : new e({
			verificationId: n,
			verificationCode: r,
			phoneNumber: i,
			temporaryProof: a
		});
	}
};
function Ah(e) {
	switch (e) {
		case "recoverEmail": return "RECOVER_EMAIL";
		case "resetPassword": return "PASSWORD_RESET";
		case "signIn": return "EMAIL_SIGNIN";
		case "verifyEmail": return "VERIFY_EMAIL";
		case "verifyAndChangeEmail": return "VERIFY_AND_CHANGE_EMAIL";
		case "revertSecondFactorAddition": return "REVERT_SECOND_FACTOR_ADDITION";
		default: return null;
	}
}
function jh(e) {
	let t = mn(hn(e)).link, n = t ? mn(hn(t)).deep_link_id : null, r = mn(hn(e)).deep_link_id;
	return (r ? mn(hn(r)).link : null) || r || n || t || e;
}
var Mh = class e {
	constructor(e) {
		let t = mn(hn(e)), n = t.apiKey ?? null, r = t.oobCode ?? null, i = Ah(t.mode ?? null);
		Z(n && r && i, "argument-error"), this.apiKey = n, this.operation = i, this.code = r, this.continueUrl = t.continueUrl ?? null, this.languageCode = t.languageCode ?? null, this.tenantId = t.tenantId ?? null;
	}
	static parseLink(t) {
		let n = jh(t);
		try {
			return new e(n);
		} catch {
			return null;
		}
	}
}, Nh = class e {
	constructor() {
		this.providerId = e.PROVIDER_ID;
	}
	static credential(e, t) {
		return bh._fromEmailAndPassword(e, t);
	}
	static credentialWithLink(e, t) {
		let n = Mh.parseLink(t);
		return Z(n, "argument-error"), bh._fromEmailAndCode(e, n.code, n.tenantId);
	}
};
Nh.PROVIDER_ID = "password", Nh.EMAIL_PASSWORD_SIGN_IN_METHOD = "password", Nh.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
var Ph = class {
	constructor(e) {
		this.providerId = e, this.defaultLanguageCode = null, this.customParameters = {};
	}
	setDefaultLanguage(e) {
		this.defaultLanguageCode = e;
	}
	setCustomParameters(e) {
		return this.customParameters = e, this;
	}
	getCustomParameters() {
		return this.customParameters;
	}
}, Fh = class extends Ph {
	constructor() {
		super(...arguments), this.scopes = [];
	}
	addScope(e) {
		return this.scopes.includes(e) || this.scopes.push(e), this;
	}
	getScopes() {
		return [...this.scopes];
	}
}, Ih = class e extends Fh {
	constructor() {
		super("facebook.com");
	}
	static credential(t) {
		return Ch._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.FACEBOOK_SIGN_IN_METHOD,
			accessToken: t
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken) return null;
		try {
			return e.credential(t.oauthAccessToken);
		} catch {
			return null;
		}
	}
};
Ih.FACEBOOK_SIGN_IN_METHOD = "facebook.com", Ih.PROVIDER_ID = "facebook.com";
var Lh = class e extends Fh {
	constructor() {
		super("google.com"), this.addScope("profile");
	}
	static credential(t, n) {
		return Ch._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.GOOGLE_SIGN_IN_METHOD,
			idToken: t,
			accessToken: n
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t) return null;
		let { oauthIdToken: n, oauthAccessToken: r } = t;
		if (!n && !r) return null;
		try {
			return e.credential(n, r);
		} catch {
			return null;
		}
	}
};
Lh.GOOGLE_SIGN_IN_METHOD = "google.com", Lh.PROVIDER_ID = "google.com";
var Rh = class e extends Fh {
	constructor() {
		super("github.com");
	}
	static credential(t) {
		return Ch._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.GITHUB_SIGN_IN_METHOD,
			accessToken: t
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken) return null;
		try {
			return e.credential(t.oauthAccessToken);
		} catch {
			return null;
		}
	}
};
Rh.GITHUB_SIGN_IN_METHOD = "github.com", Rh.PROVIDER_ID = "github.com";
var zh = class e extends Fh {
	constructor() {
		super("twitter.com");
	}
	static credential(t, n) {
		return Ch._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.TWITTER_SIGN_IN_METHOD,
			oauthToken: t,
			oauthTokenSecret: n
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t) return null;
		let { oauthAccessToken: n, oauthTokenSecret: r } = t;
		if (!n || !r) return null;
		try {
			return e.credential(n, r);
		} catch {
			return null;
		}
	}
};
zh.TWITTER_SIGN_IN_METHOD = "twitter.com", zh.PROVIDER_ID = "twitter.com";
var Bh = class e {
	constructor(e) {
		this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
	}
	static async _fromIdTokenResponse(t, n, r, i = !1) {
		return new e({
			user: await xm._fromIdTokenResponse(t, r, i),
			providerId: Vh(r),
			_tokenResponse: r,
			operationType: n
		});
	}
	static async _forOperation(t, n, r) {
		return await t._updateTokensIfNecessary(r, !0), new e({
			user: t,
			providerId: Vh(r),
			_tokenResponse: r,
			operationType: n
		});
	}
};
function Vh(e) {
	return e.providerId ? e.providerId : "phoneNumber" in e ? "phone" : null;
}
var Hh = class e extends on {
	constructor(t, n, r, i) {
		super(n.code, n.message), this.operationType = r, this.user = i, Object.setPrototypeOf(this, e.prototype), this.customData = {
			appName: t.name,
			tenantId: t.tenantId ?? void 0,
			_serverResponse: n.customData._serverResponse,
			operationType: r
		};
	}
	static _fromErrorAndOperation(t, n, r, i) {
		return new e(t, n, r, i);
	}
};
function Uh(e, t, n, r) {
	return (t === "reauthenticate" ? n._getReauthenticationResolver(e) : n._getIdTokenResponse(e)).catch((n) => {
		throw n.code === "auth/multi-factor-auth-required" ? Hh._fromErrorAndOperation(e, n, t, r) : n;
	});
}
async function Wh(e, t, n = !1) {
	let r = await lm(e, t._linkToIdToken(e.auth, await e.getIdToken()), n);
	return Bh._forOperation(e, "link", r);
}
async function Gh(e, t, n = !1) {
	let { auth: r } = e;
	if (Br(r.app)) return Promise.reject(Mp(r));
	let i = "reauthenticate";
	try {
		let a = await lm(e, Uh(r, i, t, e), n);
		Z(a.idToken, r, "internal-error");
		let o = sm(a.idToken);
		Z(o, r, "internal-error");
		let { sub: s } = o;
		return Z(e.uid === s, r, "user-mismatch"), Bh._forOperation(e, i, a);
	} catch (e) {
		throw e?.code === "auth/user-not-found" && kp(r, "user-mismatch"), e;
	}
}
async function Kh(e, t, n = !1) {
	if (Br(e.app)) return Promise.reject(Mp(e));
	let r = "signIn", i = await Uh(e, r, t), a = await Bh._fromIdTokenResponse(e, r, i);
	return n || await e._updateCurrentUser(a.user), a;
}
async function qh(e, t) {
	return Jp(e, "POST", "/v1/accounts:signInWithCustomToken", Q(e, t));
}
async function Jh(e, t) {
	if (Br(e.app)) return Promise.reject(Mp(e));
	let n = Km(e), r = await qh(n, {
		token: t,
		returnSecureToken: !0
	}), i = await Bh._fromIdTokenResponse(n, "signIn", r);
	return await n._updateCurrentUser(i.user), i;
}
function Yh(e, t, n, r) {
	return T(e).onIdTokenChanged(t, n, r);
}
function Xh(e, t, n) {
	return T(e).beforeAuthStateChanged(t, n);
}
function Zh(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaEnrollment:start", Q(e, t));
}
function Qh(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaEnrollment:finalize", Q(e, t));
}
function $h(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaEnrollment:start", Q(e, t));
}
function eg(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaEnrollment:finalize", Q(e, t));
}
var tg = "__sak", ng = class {
	constructor(e, t) {
		this.storageRetriever = e, this.type = t;
	}
	_isAvailable() {
		try {
			return this.storage ? (this.storage.setItem(tg, "1"), this.storage.removeItem(tg), Promise.resolve(!0)) : Promise.resolve(!1);
		} catch {
			return Promise.resolve(!1);
		}
	}
	_set(e, t) {
		return this.storage.setItem(e, JSON.stringify(t)), Promise.resolve();
	}
	_get(e) {
		let t = this.storage.getItem(e);
		return Promise.resolve(t ? JSON.parse(t) : null);
	}
	_remove(e) {
		return this.storage.removeItem(e), Promise.resolve();
	}
	get storage() {
		return this.storageRetriever();
	}
}, rg = 1e3, ig = 10, ag = class extends ng {
	constructor() {
		super(() => window.localStorage, "LOCAL"), this.boundEventHandler = (e, t) => this.onStorageEvent(e, t), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.fallbackToPolling = zm(), this._shouldAllowMigration = !0;
	}
	forAllChangedKeys(e) {
		for (let t of Object.keys(this.listeners)) {
			let n = this.storage.getItem(t), r = this.localCache[t];
			n !== r && e(t, r, n);
		}
	}
	onStorageEvent(e, t = !1) {
		if (!e.key) {
			this.forAllChangedKeys((e, t, n) => {
				this.notifyListeners(e, n);
			});
			return;
		}
		let n = e.key;
		t ? this.detachListener() : this.stopPolling();
		let r = () => {
			let e = this.storage.getItem(n);
			!t && this.localCache[n] === e || this.notifyListeners(n, e);
		}, i = this.storage.getItem(n);
		Rm() && i !== e.newValue && e.newValue !== e.oldValue ? setTimeout(r, ig) : r();
	}
	notifyListeners(e, t) {
		this.localCache[e] = t;
		let n = this.listeners[e];
		if (n) for (let e of Array.from(n)) e(t && JSON.parse(t));
	}
	startPolling() {
		this.stopPolling(), this.pollTimer = setInterval(() => {
			this.forAllChangedKeys((e, t, n) => {
				this.onStorageEvent(new StorageEvent("storage", {
					key: e,
					oldValue: t,
					newValue: n
				}), !0);
			});
		}, rg);
	}
	stopPolling() {
		this.pollTimer &&= (clearInterval(this.pollTimer), null);
	}
	attachListener() {
		window.addEventListener("storage", this.boundEventHandler);
	}
	detachListener() {
		window.removeEventListener("storage", this.boundEventHandler);
	}
	_addListener(e, t) {
		Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this.localCache[e] = this.storage.getItem(e)), this.listeners[e].add(t);
	}
	_removeListener(e, t) {
		this.listeners[e] && (this.listeners[e].delete(t), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
	}
	async _set(e, t) {
		await super._set(e, t), this.localCache[e] = JSON.stringify(t);
	}
	async _get(e) {
		let t = await super._get(e);
		return this.localCache[e] = JSON.stringify(t), t;
	}
	async _remove(e) {
		await super._remove(e), delete this.localCache[e];
	}
};
ag.type = "LOCAL";
var og = ag, sg = class extends ng {
	constructor() {
		super(() => window.sessionStorage, "SESSION");
	}
	_addListener(e, t) {}
	_removeListener(e, t) {}
};
sg.type = "SESSION";
var cg = sg;
function lg(e) {
	return Promise.all(e.map(async (e) => {
		try {
			return {
				fulfilled: !0,
				value: await e
			};
		} catch (e) {
			return {
				fulfilled: !1,
				reason: e
			};
		}
	}));
}
var ug = class e {
	constructor(e) {
		this.eventTarget = e, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
	}
	static _getInstance(t) {
		let n = this.receivers.find((e) => e.isListeningto(t));
		if (n) return n;
		let r = new e(t);
		return this.receivers.push(r), r;
	}
	isListeningto(e) {
		return this.eventTarget === e;
	}
	async handleEvent(e) {
		let t = e, { eventId: n, eventType: r, data: i } = t.data, a = this.handlersMap[r];
		if (!a?.size) return;
		t.ports[0].postMessage({
			status: "ack",
			eventId: n,
			eventType: r
		});
		let o = await lg(Array.from(a).map(async (e) => e(t.origin, i)));
		t.ports[0].postMessage({
			status: "done",
			eventId: n,
			eventType: r,
			response: o
		});
	}
	_subscribe(e, t) {
		Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[e] || (this.handlersMap[e] = /* @__PURE__ */ new Set()), this.handlersMap[e].add(t);
	}
	_unsubscribe(e, t) {
		this.handlersMap[e] && t && this.handlersMap[e].delete(t), (!t || this.handlersMap[e].size === 0) && delete this.handlersMap[e], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
	}
};
ug.receivers = [];
function dg(e = "", t = 10) {
	let n = "";
	for (let e = 0; e < t; e++) n += Math.floor(Math.random() * 10);
	return e + n;
}
var fg = class {
	constructor(e) {
		this.target = e, this.handlers = /* @__PURE__ */ new Set();
	}
	removeMessageHandler(e) {
		e.messageChannel && (e.messageChannel.port1.removeEventListener("message", e.onMessage), e.messageChannel.port1.close()), this.handlers.delete(e);
	}
	async _send(e, t, n = 50) {
		let r = typeof MessageChannel < "u" ? new MessageChannel() : null;
		if (!r) throw Error("connection_unavailable");
		let i, a;
		return new Promise((o, s) => {
			let c = dg("", 20);
			r.port1.start();
			let l = setTimeout(() => {
				s(/* @__PURE__ */ Error("unsupported_event"));
			}, n);
			a = {
				messageChannel: r,
				onMessage(e) {
					let t = e;
					if (t.data.eventId === c) switch (t.data.status) {
						case "ack":
							clearTimeout(l), i = setTimeout(() => {
								s(/* @__PURE__ */ Error("timeout"));
							}, 3e3);
							break;
						case "done":
							clearTimeout(i), o(t.data.response);
							break;
						default:
							clearTimeout(l), clearTimeout(i), s(/* @__PURE__ */ Error("invalid_response"));
							break;
					}
				}
			}, this.handlers.add(a), r.port1.addEventListener("message", a.onMessage), this.target.postMessage({
				eventType: e,
				eventId: c,
				data: t
			}, [r.port2]);
		}).finally(() => {
			a && this.removeMessageHandler(a);
		});
	}
};
function pg() {
	return window;
}
function mg(e) {
	pg().location.href = e;
}
function hg() {
	return pg().WorkerGlobalScope !== void 0 && typeof pg().importScripts == "function";
}
async function gg() {
	if (!(navigator != null && navigator.serviceWorker)) return null;
	try {
		return (await navigator.serviceWorker.ready).active;
	} catch {
		return null;
	}
}
function _g() {
	return (navigator == null ? void 0 : navigator.serviceWorker)?.controller || null;
}
function vg() {
	return hg() ? self : null;
}
var yg = "firebaseLocalStorageDb", bg = 1, xg = "firebaseLocalStorage", Sg = "fbase_key", Cg = class {
	constructor(e) {
		this.request = e;
	}
	toPromise() {
		return new Promise((e, t) => {
			this.request.addEventListener("success", () => {
				e(this.request.result);
			}), this.request.addEventListener("error", () => {
				t(this.request.error);
			});
		});
	}
};
function wg(e, t) {
	return e.transaction([xg], t ? "readwrite" : "readonly").objectStore(xg);
}
function Tg() {
	return new Cg(indexedDB.deleteDatabase(yg)).toPromise();
}
function Eg() {
	let e = indexedDB.open(yg, bg);
	return new Promise((t, n) => {
		e.addEventListener("error", () => {
			n(e.error);
		}), e.addEventListener("upgradeneeded", () => {
			let t = e.result;
			try {
				t.createObjectStore(xg, { keyPath: Sg });
			} catch (e) {
				n(e);
			}
		}), e.addEventListener("success", async () => {
			let n = e.result;
			n.objectStoreNames.contains(xg) ? t(n) : (n.close(), await Tg(), t(await Eg()));
		});
	});
}
async function Dg(e, t, n) {
	return new Cg(wg(e, !0).put({
		[Sg]: t,
		value: n
	})).toPromise();
}
async function Og(e, t) {
	let n = await new Cg(wg(e, !1).get(t)).toPromise();
	return n === void 0 ? null : n.value;
}
function kg(e, t) {
	return new Cg(wg(e, !0).delete(t)).toPromise();
}
var Ag = 800, jg = 3, Mg = class {
	constructor() {
		this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {}, () => {});
	}
	async _openDb() {
		return this.db ||= await Eg(), this.db;
	}
	async _withRetries(e) {
		let t = 0;
		for (;;) try {
			return await e(await this._openDb());
		} catch (e) {
			if (t++ > jg) throw e;
			this.db &&= (this.db.close(), void 0);
		}
	}
	async initializeServiceWorkerMessaging() {
		return hg() ? this.initializeReceiver() : this.initializeSender();
	}
	async initializeReceiver() {
		this.receiver = ug._getInstance(vg()), this.receiver._subscribe("keyChanged", async (e, t) => ({ keyProcessed: (await this._poll()).includes(t.key) })), this.receiver._subscribe("ping", async (e, t) => ["keyChanged"]);
	}
	async initializeSender() {
		if (this.activeServiceWorker = await gg(), !this.activeServiceWorker) return;
		this.sender = new fg(this.activeServiceWorker);
		let e = await this.sender._send("ping", {}, 800);
		e && e[0]?.fulfilled && e[0]?.value.includes("keyChanged") && (this.serviceWorkerReceiverAvailable = !0);
	}
	async notifyServiceWorker(e) {
		if (!(!this.sender || !this.activeServiceWorker || _g() !== this.activeServiceWorker)) try {
			await this.sender._send("keyChanged", { key: e }, this.serviceWorkerReceiverAvailable ? 800 : 50);
		} catch {}
	}
	async _isAvailable() {
		try {
			if (!indexedDB) return !1;
			let e = await Eg();
			return await Dg(e, tg, "1"), await kg(e, tg), !0;
		} catch {}
		return !1;
	}
	async _withPendingWrite(e) {
		this.pendingWrites++;
		try {
			await e();
		} finally {
			this.pendingWrites--;
		}
	}
	async _set(e, t) {
		return this._withPendingWrite(async () => (await this._withRetries((n) => Dg(n, e, t)), this.localCache[e] = t, this.notifyServiceWorker(e)));
	}
	async _get(e) {
		let t = await this._withRetries((t) => Og(t, e));
		return this.localCache[e] = t, t;
	}
	async _remove(e) {
		return this._withPendingWrite(async () => (await this._withRetries((t) => kg(t, e)), delete this.localCache[e], this.notifyServiceWorker(e)));
	}
	async _poll() {
		let e = await this._withRetries((e) => new Cg(wg(e, !1).getAll()).toPromise());
		if (!e || this.pendingWrites !== 0) return [];
		let t = [], n = /* @__PURE__ */ new Set();
		if (e.length !== 0) for (let { fbase_key: r, value: i } of e) n.add(r), JSON.stringify(this.localCache[r]) !== JSON.stringify(i) && (this.notifyListeners(r, i), t.push(r));
		for (let e of Object.keys(this.localCache)) this.localCache[e] && !n.has(e) && (this.notifyListeners(e, null), t.push(e));
		return t;
	}
	notifyListeners(e, t) {
		this.localCache[e] = t;
		let n = this.listeners[e];
		if (n) for (let e of Array.from(n)) e(t);
	}
	startPolling() {
		this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), Ag);
	}
	stopPolling() {
		this.pollTimer &&= (clearInterval(this.pollTimer), null);
	}
	_addListener(e, t) {
		Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this._get(e)), this.listeners[e].add(t);
	}
	_removeListener(e, t) {
		this.listeners[e] && (this.listeners[e].delete(t), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && this.stopPolling();
	}
};
Mg.type = "LOCAL";
var Ng = Mg;
function Pg(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaSignIn:start", Q(e, t));
}
function Fg(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaSignIn:finalize", Q(e, t));
}
function Ig(e, t) {
	return Kp(e, "POST", "/v2/accounts/mfaSignIn:finalize", Q(e, t));
}
$m("rcb"), new Vp(3e4, 6e4);
var Lg = "recaptcha";
async function Rg(e, t, n) {
	if (!e._getRecaptchaConfig()) try {
		await sh(e);
	} catch {
		console.log("Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.");
	}
	try {
		let r;
		if (r = typeof t == "string" ? { phoneNumber: t } : t, "session" in r) {
			let t = r.session;
			if ("phoneNumber" in r) return Z(t.type === "enroll", e, "internal-error"), (await oh(e, {
				idToken: t.credential,
				phoneEnrollmentInfo: {
					phoneNumber: r.phoneNumber,
					clientType: "CLIENT_TYPE_WEB"
				}
			}, "mfaSmsEnrollment", async (e, t) => t.phoneEnrollmentInfo.captchaResponse === rh ? (Z(n?.type === Lg, e, "argument-error"), Zh(e, await zg(e, t, n))) : Zh(e, t), "PHONE_PROVIDER").catch((e) => Promise.reject(e))).phoneSessionInfo.sessionInfo;
			{
				Z(t.type === "signin", e, "internal-error");
				let i = r.multiFactorHint?.uid || r.multiFactorUid;
				return Z(i, e, "missing-multi-factor-info"), (await oh(e, {
					mfaPendingCredential: t.credential,
					mfaEnrollmentId: i,
					phoneSignInInfo: { clientType: "CLIENT_TYPE_WEB" }
				}, "mfaSmsSignIn", async (e, t) => t.phoneSignInInfo.captchaResponse === rh ? (Z(n?.type === Lg, e, "argument-error"), Pg(e, await zg(e, t, n))) : Pg(e, t), "PHONE_PROVIDER").catch((e) => Promise.reject(e))).phoneResponseInfo.sessionInfo;
			}
		} else return (await oh(e, {
			phoneNumber: r.phoneNumber,
			clientType: "CLIENT_TYPE_WEB"
		}, "sendVerificationCode", async (e, t) => t.captchaResponse === rh ? (Z(n?.type === Lg, e, "argument-error"), wh(e, await zg(e, t, n))) : wh(e, t), "PHONE_PROVIDER").catch((e) => Promise.reject(e))).sessionInfo;
	} finally {
		n?._reset();
	}
}
async function zg(e, t, n) {
	Z(n.type === Lg, e, "argument-error");
	let r = await n.verify();
	Z(typeof r == "string", e, "argument-error");
	let i = Object.assign({}, t);
	if ("phoneEnrollmentInfo" in i) {
		let e = i.phoneEnrollmentInfo.phoneNumber, t = i.phoneEnrollmentInfo.captchaResponse, n = i.phoneEnrollmentInfo.clientType, a = i.phoneEnrollmentInfo.recaptchaVersion;
		return Object.assign(i, { phoneEnrollmentInfo: {
			phoneNumber: e,
			recaptchaToken: r,
			captchaResponse: t,
			clientType: n,
			recaptchaVersion: a
		} }), i;
	} else if ("phoneSignInInfo" in i) {
		let e = i.phoneSignInInfo.captchaResponse, t = i.phoneSignInInfo.clientType, n = i.phoneSignInInfo.recaptchaVersion;
		return Object.assign(i, { phoneSignInInfo: {
			recaptchaToken: r,
			captchaResponse: e,
			clientType: t,
			recaptchaVersion: n
		} }), i;
	} else return Object.assign(i, { recaptchaToken: r }), i;
}
var Bg = class e {
	constructor(t) {
		this.providerId = e.PROVIDER_ID, this.auth = Km(t);
	}
	verifyPhoneNumber(e, t) {
		return Rg(this.auth, e, T(t));
	}
	static credential(e, t) {
		return kh._fromVerification(e, t);
	}
	static credentialFromResult(t) {
		let n = t;
		return e.credentialFromTaggedObject(n);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: e }) {
		if (!e) return null;
		let { phoneNumber: t, temporaryProof: n } = e;
		return t && n ? kh._fromTokenResponse(t, n) : null;
	}
};
Bg.PROVIDER_ID = "phone", Bg.PHONE_SIGN_IN_METHOD = "phone";
function Vg(e, t) {
	return t ? Cm(t) : (Z(e._popupRedirectResolver, e, "argument-error"), e._popupRedirectResolver);
}
var Hg = class extends hh {
	constructor(e) {
		super("custom", "custom"), this.params = e;
	}
	_getIdTokenResponse(e) {
		return xh(e, this._buildIdpRequest());
	}
	_linkToIdToken(e, t) {
		return xh(e, this._buildIdpRequest(t));
	}
	_getReauthenticationResolver(e) {
		return xh(e, this._buildIdpRequest());
	}
	_buildIdpRequest(e) {
		let t = {
			requestUri: this.params.requestUri,
			sessionId: this.params.sessionId,
			postBody: this.params.postBody,
			tenantId: this.params.tenantId,
			pendingToken: this.params.pendingToken,
			returnSecureToken: !0,
			returnIdpCredential: !0
		};
		return e && (t.idToken = e), t;
	}
};
function Ug(e) {
	return Kh(e.auth, new Hg(e), e.bypassAuthState);
}
function Wg(e) {
	let { auth: t, user: n } = e;
	return Z(n, t, "internal-error"), Gh(n, new Hg(e), e.bypassAuthState);
}
async function Gg(e) {
	let { auth: t, user: n } = e;
	return Z(n, t, "internal-error"), Wh(n, new Hg(e), e.bypassAuthState);
}
var Kg = class {
	constructor(e, t, n, r, i = !1) {
		this.auth = e, this.resolver = n, this.user = r, this.bypassAuthState = i, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(t) ? t : [t];
	}
	execute() {
		return new Promise(async (e, t) => {
			this.pendingPromise = {
				resolve: e,
				reject: t
			};
			try {
				this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
			} catch (e) {
				this.reject(e);
			}
		});
	}
	async onAuthEvent(e) {
		let { urlResponse: t, sessionId: n, postBody: r, tenantId: i, error: a, type: o } = e;
		if (a) {
			this.reject(a);
			return;
		}
		let s = {
			auth: this.auth,
			requestUri: t,
			sessionId: n,
			tenantId: i || void 0,
			postBody: r || void 0,
			user: this.user,
			bypassAuthState: this.bypassAuthState
		};
		try {
			this.resolve(await this.getIdpTask(o)(s));
		} catch (e) {
			this.reject(e);
		}
	}
	onError(e) {
		this.reject(e);
	}
	getIdpTask(e) {
		switch (e) {
			case "signInViaPopup":
			case "signInViaRedirect": return Ug;
			case "linkViaPopup":
			case "linkViaRedirect": return Gg;
			case "reauthViaPopup":
			case "reauthViaRedirect": return Wg;
			default: kp(this.auth, "internal-error");
		}
	}
	resolve(e) {
		Fp(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(e), this.unregisterAndCleanUp();
	}
	reject(e) {
		Fp(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(e), this.unregisterAndCleanUp();
	}
	unregisterAndCleanUp() {
		this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
	}
}, qg = new Vp(2e3, 1e4), Jg = class e extends Kg {
	constructor(t, n, r, i, a) {
		super(t, n, i, a), this.provider = r, this.authWindow = null, this.pollId = null, e.currentPopupAction && e.currentPopupAction.cancel(), e.currentPopupAction = this;
	}
	async executeNotNull() {
		let e = await this.execute();
		return Z(e, this.auth, "internal-error"), e;
	}
	async onExecution() {
		Fp(this.filter.length === 1, "Popup operations only handle one event");
		let e = dg();
		this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], e), this.authWindow.associatedEvent = e, this.resolver._originValidation(this.auth).catch((e) => {
			this.reject(e);
		}), this.resolver._isIframeWebStorageSupported(this.auth, (e) => {
			e || this.reject(Ap(this.auth, "web-storage-unsupported"));
		}), this.pollUserCancellation();
	}
	get eventId() {
		return this.authWindow?.associatedEvent || null;
	}
	cancel() {
		this.reject(Ap(this.auth, "cancelled-popup-request"));
	}
	cleanUp() {
		this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, e.currentPopupAction = null;
	}
	pollUserCancellation() {
		let e = () => {
			if (this.authWindow?.window?.closed) {
				this.pollId = window.setTimeout(() => {
					this.pollId = null, this.reject(Ap(this.auth, "popup-closed-by-user"));
				}, 8e3);
				return;
			}
			this.pollId = window.setTimeout(e, qg.get());
		};
		e();
	}
};
Jg.currentPopupAction = null;
var Yg = "pendingRedirect", Xg = /* @__PURE__ */ new Map(), Zg = class extends Kg {
	constructor(e, t, n = !1) {
		super(e, [
			"signInViaRedirect",
			"linkViaRedirect",
			"reauthViaRedirect",
			"unknown"
		], t, void 0, n), this.eventId = null;
	}
	async execute() {
		let e = Xg.get(this.auth._key());
		if (!e) {
			try {
				let t = await Qg(this.resolver, this.auth) ? await super.execute() : null;
				e = () => Promise.resolve(t);
			} catch (t) {
				e = () => Promise.reject(t);
			}
			Xg.set(this.auth._key(), e);
		}
		return this.bypassAuthState || Xg.set(this.auth._key(), () => Promise.resolve(null)), e();
	}
	async onAuthEvent(e) {
		if (e.type === "signInViaRedirect") return super.onAuthEvent(e);
		if (e.type === "unknown") {
			this.resolve(null);
			return;
		}
		if (e.eventId) {
			let t = await this.auth._redirectUserForId(e.eventId);
			if (t) return this.user = t, super.onAuthEvent(e);
			this.resolve(null);
		}
	}
	async onExecution() {}
	cleanUp() {}
};
async function Qg(e, t) {
	let n = t_(t), r = e_(e);
	if (!await r._isAvailable()) return !1;
	let i = await r._get(n) === "true";
	return await r._remove(n), i;
}
function $g(e, t) {
	Xg.set(e._key(), t);
}
function e_(e) {
	return Cm(e._redirectPersistence);
}
function t_(e) {
	return Em(Yg, e.config.apiKey, e.name);
}
async function n_(e, t, n = !1) {
	if (Br(e.app)) return Promise.reject(Mp(e));
	let r = Km(e), i = await new Zg(r, Vg(r, t), n).execute();
	return i && !n && (delete i.user._redirectEventId, await r._persistUserIfCurrent(i.user), await r._setRedirectUser(null, t)), i;
}
var r_ = 600 * 1e3, i_ = class {
	constructor(e) {
		this.auth = e, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
	}
	registerConsumer(e) {
		this.consumers.add(e), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, e) && (this.sendToConsumer(this.queuedRedirectEvent, e), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
	}
	unregisterConsumer(e) {
		this.consumers.delete(e);
	}
	onEvent(e) {
		if (this.hasEventBeenHandled(e)) return !1;
		let t = !1;
		return this.consumers.forEach((n) => {
			this.isEventForConsumer(e, n) && (t = !0, this.sendToConsumer(e, n), this.saveEventToCache(e));
		}), this.hasHandledPotentialRedirect || !s_(e) ? t : (this.hasHandledPotentialRedirect = !0, t ||= (this.queuedRedirectEvent = e, !0), t);
	}
	sendToConsumer(e, t) {
		if (e.error && !o_(e)) {
			let n = e.error.code?.split("auth/")[1] || "internal-error";
			t.onError(Ap(this.auth, n));
		} else t.onAuthEvent(e);
	}
	isEventForConsumer(e, t) {
		let n = t.eventId === null || !!e.eventId && e.eventId === t.eventId;
		return t.filter.includes(e.type) && n;
	}
	hasEventBeenHandled(e) {
		return Date.now() - this.lastProcessedEventTime >= r_ && this.cachedEventUids.clear(), this.cachedEventUids.has(a_(e));
	}
	saveEventToCache(e) {
		this.cachedEventUids.add(a_(e)), this.lastProcessedEventTime = Date.now();
	}
};
function a_(e) {
	return [
		e.type,
		e.eventId,
		e.sessionId,
		e.tenantId
	].filter((e) => e).join("-");
}
function o_({ type: e, error: t }) {
	return e === "unknown" && t?.code === "auth/no-auth-event";
}
function s_(e) {
	switch (e.type) {
		case "signInViaRedirect":
		case "linkViaRedirect":
		case "reauthViaRedirect": return !0;
		case "unknown": return o_(e);
		default: return !1;
	}
}
async function c_(e, t = {}) {
	return Kp(e, "GET", "/v1/projects", t);
}
var l_ = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, u_ = /^https?/;
async function d_(e) {
	if (e.config.emulator) return;
	let { authorizedDomains: t } = await c_(e);
	for (let e of t) try {
		if (f_(e)) return;
	} catch {}
	kp(e, "unauthorized-domain");
}
function f_(e) {
	let t = Ip(), { protocol: n, hostname: r } = new URL(t);
	if (e.startsWith("chrome-extension://")) {
		let i = new URL(e);
		return i.hostname === "" && r === "" ? n === "chrome-extension:" && e.replace("chrome-extension://", "") === t.replace("chrome-extension://", "") : n === "chrome-extension:" && i.hostname === r;
	}
	if (!u_.test(n)) return !1;
	if (l_.test(e)) return r === e;
	let i = e.replace(/\./g, "\\.");
	return RegExp("^(.+\\." + i + "|" + i + ")$", "i").test(r);
}
var p_ = new Vp(3e4, 6e4);
function m_() {
	let e = pg().___jsl;
	if (e?.H) {
		for (let t of Object.keys(e.H)) if (e.H[t].r = e.H[t].r || [], e.H[t].L = e.H[t].L || [], e.H[t].r = [...e.H[t].L], e.CP) for (let t = 0; t < e.CP.length; t++) e.CP[t] = null;
	}
}
function h_(e) {
	return new Promise((t, n) => {
		function r() {
			m_(), gapi.load("gapi.iframes", {
				callback: () => {
					t(gapi.iframes.getContext());
				},
				ontimeout: () => {
					m_(), n(Ap(e, "network-request-failed"));
				},
				timeout: p_.get()
			});
		}
		if (pg().gapi?.iframes?.Iframe) t(gapi.iframes.getContext());
		else if (pg().gapi?.load) r();
		else {
			let t = $m("iframefcb");
			return pg()[t] = () => {
				gapi.load ? r() : n(Ap(e, "network-request-failed"));
			}, Xm(`${Qm()}?onload=${t}`).catch((e) => n(e));
		}
	}).catch((e) => {
		throw g_ = null, e;
	});
}
var g_ = null;
function __(e) {
	return g_ ||= h_(e), g_;
}
var v_ = new Vp(5e3, 15e3), y_ = "__/auth/iframe", b_ = "emulator/auth/iframe", x_ = {
	style: {
		position: "absolute",
		top: "-100px",
		width: "1px",
		height: "1px"
	},
	"aria-hidden": "true",
	tabindex: "-1"
}, S_ = new Map([
	["identitytoolkit.googleapis.com", "p"],
	["staging-identitytoolkit.sandbox.googleapis.com", "s"],
	["test-identitytoolkit.sandbox.googleapis.com", "t"]
]);
function C_(e) {
	let t = e.config;
	Z(t.authDomain, e, "auth-domain-config-required");
	let n = t.emulator ? Hp(t, b_) : `https://${e.config.authDomain}/${y_}`, r = {
		apiKey: t.apiKey,
		appName: e.name,
		v: Ur
	}, i = S_.get(e.config.apiHost);
	i && (r.eid = i);
	let a = e._getFrameworks();
	return a.length && (r.fw = a.join(",")), `${n}?${pn(r).slice(1)}`;
}
async function w_(e) {
	let t = await __(e), n = pg().gapi;
	return Z(n, e, "internal-error"), t.open({
		where: document.body,
		url: C_(e),
		messageHandlersFilter: n.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
		attributes: x_,
		dontclear: !0
	}, (t) => new Promise(async (n, r) => {
		await t.restyle({ setHideOnLeave: !1 });
		let i = Ap(e, "network-request-failed"), a = pg().setTimeout(() => {
			r(i);
		}, v_.get());
		function o() {
			pg().clearTimeout(a), n(t);
		}
		t.ping(o).then(o, () => {
			r(i);
		});
	}));
}
var T_ = {
	location: "yes",
	resizable: "yes",
	statusbar: "yes",
	toolbar: "no"
}, E_ = 500, D_ = 600, O_ = "_blank", k_ = "http://localhost", A_ = class {
	constructor(e) {
		this.window = e, this.associatedEvent = null;
	}
	close() {
		if (this.window) try {
			this.window.close();
		} catch {}
	}
};
function j_(e, t, n, r = E_, i = D_) {
	let a = Math.max((window.screen.availHeight - i) / 2, 0).toString(), o = Math.max((window.screen.availWidth - r) / 2, 0).toString(), s = "", c = Object.assign(Object.assign({}, T_), {
		width: r.toString(),
		height: i.toString(),
		top: a,
		left: o
	}), l = C().toLowerCase();
	n && (s = jm(l) ? O_ : n), km(l) && (t ||= k_, c.scrollbars = "yes");
	let u = Object.entries(c).reduce((e, [t, n]) => `${e}${t}=${n},`, "");
	if (Lm(l) && s !== "_self") return M_(t || "", s), new A_(null);
	let d = window.open(t || "", s, u);
	Z(d, e, "popup-blocked");
	try {
		d.focus();
	} catch {}
	return new A_(d);
}
function M_(e, t) {
	let n = document.createElement("a");
	n.href = e, n.target = t;
	let r = document.createEvent("MouseEvent");
	r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), n.dispatchEvent(r);
}
var N_ = "__/auth/handler", P_ = "emulator/auth/handler", F_ = "fac";
async function I_(e, t, n, r, i, a) {
	Z(e.config.authDomain, e, "auth-domain-config-required"), Z(e.config.apiKey, e, "invalid-api-key");
	let o = {
		apiKey: e.config.apiKey,
		appName: e.name,
		authType: n,
		redirectUrl: r,
		v: Ur,
		eventId: i
	};
	if (t instanceof Ph) {
		t.setDefaultLanguage(e.languageCode), o.providerId = t.providerId || "", un(t.getCustomParameters()) || (o.customParameters = JSON.stringify(t.getCustomParameters()));
		for (let [e, t] of Object.entries(a || {})) o[e] = t;
	}
	if (t instanceof Fh) {
		let e = t.getScopes().filter((e) => e !== "");
		e.length > 0 && (o.scopes = e.join(","));
	}
	e.tenantId && (o.tid = e.tenantId);
	let s = o;
	for (let e of Object.keys(s)) s[e] === void 0 && delete s[e];
	let c = await e._getAppCheckToken(), l = c ? `#${F_}=${encodeURIComponent(c)}` : "";
	return `${L_(e)}?${pn(s).slice(1)}${l}`;
}
function L_({ config: e }) {
	return e.emulator ? Hp(e, P_) : `https://${e.authDomain}/${N_}`;
}
var R_ = "webStorageSupport", z_ = class {
	constructor() {
		this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = cg, this._completeRedirectFn = n_, this._overrideRedirectResult = $g;
	}
	async _openPopup(e, t, n, r) {
		return Fp(this.eventManagers[e._key()]?.manager, "_initialize() not called before _openPopup()"), j_(e, await I_(e, t, n, Ip(), r), dg());
	}
	async _openRedirect(e, t, n, r) {
		return await this._originValidation(e), mg(await I_(e, t, n, Ip(), r)), new Promise(() => {});
	}
	_initialize(e) {
		let t = e._key();
		if (this.eventManagers[t]) {
			let { manager: e, promise: n } = this.eventManagers[t];
			return e ? Promise.resolve(e) : (Fp(n, "If manager is not set, promise should be"), n);
		}
		let n = this.initAndGetManager(e);
		return this.eventManagers[t] = { promise: n }, n.catch(() => {
			delete this.eventManagers[t];
		}), n;
	}
	async initAndGetManager(e) {
		let t = await w_(e), n = new i_(e);
		return t.register("authEvent", (t) => (Z(t?.authEvent, e, "invalid-auth-event"), { status: n.onEvent(t.authEvent) ? "ACK" : "ERROR" }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[e._key()] = { manager: n }, this.iframes[e._key()] = t, n;
	}
	_isIframeWebStorageSupported(e, t) {
		this.iframes[e._key()].send(R_, { type: R_ }, (n) => {
			let r = n?.[0]?.[R_];
			r !== void 0 && t(!!r), kp(e, "internal-error");
		}, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
	}
	_originValidation(e) {
		let t = e._key();
		return this.originValidationPromises[t] || (this.originValidationPromises[t] = d_(e)), this.originValidationPromises[t];
	}
	get _shouldInitProactively() {
		return zm() || Am() || Im();
	}
}, B_ = class {
	constructor(e) {
		this.factorId = e;
	}
	_process(e, t, n) {
		switch (t.type) {
			case "enroll": return this._finalizeEnroll(e, t.credential, n);
			case "signin": return this._finalizeSignIn(e, t.credential);
			default: return Pp("unexpected MultiFactorSessionType");
		}
	}
}, V_ = class e extends B_ {
	constructor(e) {
		super("phone"), this.credential = e;
	}
	static _fromCredential(t) {
		return new e(t);
	}
	_finalizeEnroll(e, t, n) {
		return Qh(e, {
			idToken: t,
			displayName: n,
			phoneVerificationInfo: this.credential._makeVerificationRequest()
		});
	}
	_finalizeSignIn(e, t) {
		return Fg(e, {
			mfaPendingCredential: t,
			phoneVerificationInfo: this.credential._makeVerificationRequest()
		});
	}
}, H_ = class {
	constructor() {}
	static assertion(e) {
		return V_._fromCredential(e);
	}
};
H_.FACTOR_ID = "phone";
var U_ = class {
	static assertionForEnrollment(e, t) {
		return W_._fromSecret(e, t);
	}
	static assertionForSignIn(e, t) {
		return W_._fromEnrollmentId(e, t);
	}
	static async generateSecret(e) {
		let t = e;
		Z(t.user?.auth !== void 0, "internal-error");
		let n = await $h(t.user.auth, {
			idToken: t.credential,
			totpEnrollmentInfo: {}
		});
		return G_._fromStartTotpMfaEnrollmentResponse(n, t.user.auth);
	}
};
U_.FACTOR_ID = "totp";
var W_ = class e extends B_ {
	constructor(e, t, n) {
		super("totp"), this.otp = e, this.enrollmentId = t, this.secret = n;
	}
	static _fromSecret(t, n) {
		return new e(n, void 0, t);
	}
	static _fromEnrollmentId(t, n) {
		return new e(n, t);
	}
	async _finalizeEnroll(e, t, n) {
		return Z(this.secret !== void 0, e, "argument-error"), eg(e, {
			idToken: t,
			displayName: n,
			totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
		});
	}
	async _finalizeSignIn(e, t) {
		Z(this.enrollmentId !== void 0 && this.otp !== void 0, e, "argument-error");
		let n = { verificationCode: this.otp };
		return Ig(e, {
			mfaPendingCredential: t,
			mfaEnrollmentId: this.enrollmentId,
			totpVerificationInfo: n
		});
	}
}, G_ = class e {
	constructor(e, t, n, r, i, a, o) {
		this.sessionInfo = a, this.auth = o, this.secretKey = e, this.hashingAlgorithm = t, this.codeLength = n, this.codeIntervalSeconds = r, this.enrollmentCompletionDeadline = i;
	}
	static _fromStartTotpMfaEnrollmentResponse(t, n) {
		return new e(t.totpSessionInfo.sharedSecretKey, t.totpSessionInfo.hashingAlgorithm, t.totpSessionInfo.verificationCodeLength, t.totpSessionInfo.periodSec, new Date(t.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), t.totpSessionInfo.sessionInfo, n);
	}
	_makeTotpVerificationInfo(e) {
		return {
			sessionInfo: this.sessionInfo,
			verificationCode: e
		};
	}
	generateQrCodeUrl(e, t) {
		let n = !1;
		return (K_(e) || K_(t)) && (n = !0), n && (K_(e) && (e = this.auth.currentUser?.email || "unknownuser"), K_(t) && (t = this.auth.name)), `otpauth://totp/${t}:${e}?secret=${this.secretKey}&issuer=${t}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
	}
};
function K_(e) {
	return e === void 0 || e?.length === 0;
}
var q_ = "@firebase/auth", J_ = "1.8.0", Y_ = class {
	constructor(e) {
		this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
	}
	getUid() {
		return this.assertAuthConfigured(), this.auth.currentUser?.uid || null;
	}
	async getToken(e) {
		return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
	}
	addAuthTokenListener(e) {
		if (this.assertAuthConfigured(), this.internalListeners.has(e)) return;
		let t = this.auth.onIdTokenChanged((t) => {
			e(t?.stsTokenManager.accessToken || null);
		});
		this.internalListeners.set(e, t), this.updateProactiveRefresh();
	}
	removeAuthTokenListener(e) {
		this.assertAuthConfigured();
		let t = this.internalListeners.get(e);
		t && (this.internalListeners.delete(e), t(), this.updateProactiveRefresh());
	}
	assertAuthConfigured() {
		Z(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth");
	}
	updateProactiveRefresh() {
		this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
	}
};
function X_(e) {
	switch (e) {
		case "Node": return "node";
		case "ReactNative": return "rn";
		case "Worker": return "webworker";
		case "Cordova": return "cordova";
		case "WebExtension": return "web-extension";
		default: return;
	}
}
function Z_(e) {
	Rr(new bn("auth", (t, { options: n }) => {
		let r = t.getProvider("app").getImmediate(), i = t.getProvider("heartbeat"), a = t.getProvider("app-check-internal"), { apiKey: o, authDomain: s } = r.options;
		Z(o && !o.includes(":"), "invalid-api-key", { appName: r.name });
		let c = new Gm(r, i, a, {
			apiKey: o,
			authDomain: s,
			clientPlatform: e,
			apiHost: "identitytoolkit.googleapis.com",
			tokenApiHost: "securetoken.googleapis.com",
			apiScheme: "https",
			sdkClientVersion: Bm(e)
		});
		return lh(c, n), c;
	}, "PUBLIC").setInstantiationMode("EXPLICIT").setInstanceCreatedCallback((e, t, n) => {
		e.getProvider("auth-internal").initialize();
	})), Rr(new bn("auth-internal", (e) => ((e) => new Y_(e))(Km(e.getProvider("auth").getImmediate())), "PRIVATE").setInstantiationMode("EXPLICIT")), Kr(q_, J_, X_(e)), Kr(q_, J_, "esm2017");
}
var Q_ = qt("authIdTokenMaxAge") || 300, $_ = null, ev = (e) => async (t) => {
	let n = t && await t.getIdTokenResult(), r = n && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(n.issuedAtTime)) / 1e3;
	if (r && r > Q_) return;
	let i = n?.token;
	$_ !== i && ($_ = i, await fetch(e, {
		method: i ? "POST" : "DELETE",
		headers: i ? { Authorization: `Bearer ${i}` } : {}
	}));
};
function tv(e = Gr()) {
	let t = zr(e, "auth");
	if (t.isInitialized()) return t.getImmediate();
	let n = ch(e, {
		popupRedirectResolver: z_,
		persistence: [
			Ng,
			og,
			cg
		]
	}), r = qt("authTokenSyncURL");
	if (r && typeof isSecureContext == "boolean" && isSecureContext) {
		let e = new URL(r, location.origin);
		if (location.origin === e.origin) {
			let t = ev(e.toString());
			Xh(n, t, () => t(n.currentUser)), Yh(n, (e) => t(e));
		}
	}
	let i = Wt("auth");
	return i && uh(n, `http://${i}`), n;
}
function nv() {
	return document.getElementsByTagName("head")?.[0] ?? document;
}
//#endregion
//#region ../node_modules/firebase/app/dist/esm/index.esm.js
Ym({
	loadJS(e) {
		return new Promise((t, n) => {
			let r = document.createElement("script");
			r.setAttribute("src", e), r.onload = t, r.onerror = (e) => {
				let t = Ap("internal-error");
				t.customData = e, n(t);
			}, r.type = "text/javascript", r.charset = "UTF-8", nv().appendChild(r);
		});
	},
	gapiScript: "https://apis.google.com/js/api.js",
	recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
	recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
}), Z_("Browser"), Kr("firebase", "11.0.1", "app");
//#endregion
//#region src/helpers/common.helper.ts
async function rv(e) {
	return new Promise((t) => setTimeout(t, e));
}
function iv(e, t) {
	let n;
	return (...r) => (clearTimeout(n), new Promise((i) => {
		n = setTimeout(() => i(e(...r)), t);
	}));
}
//#endregion
//#region src/firestore/firestore.helper.ts
async function av(e, t, n) {
	let r = `Bearer ${n}`;
	try {
		let n = Ke(e, t, m.FirebaseToken);
		if (!n) throw Error("⭕️ Firebase ERROR: No cloud function url define for getting firebase token. Check metadata file");
		let i = await (await fetch(n, { headers: { Authorization: r } })).json();
		if (!i || !i.firebase_token) throw Error("⭕️ Firebase ERROR: No token returned");
		return i.firebase_token;
	} catch (e) {
		throw Error(`⭕️ Firebase ERROR: Cloud function error ${X(e)}`);
	}
}
function ov(e) {
	let n = t(e);
	return {
		expiration: n.exp,
		userId: n.uid,
		userAccountId: n.claims.user_account_id
	};
}
function sv(e) {
	if (e === void 0 || e.length < 15) return !1;
	let { expiration: t } = ov(e);
	return t > (/* @__PURE__ */ new Date()).getTime() / 1e3;
}
async function cv(e, t, n) {
	let r = [
		300,
		600,
		1200,
		2400,
		4800
	], i = "", a = 0;
	for (; a < 5;) try {
		return i = await av(e, t, n), i;
	} catch {
		let e = r[a];
		a++, console.warn(`⭕️ Firebase: Had to retry calling cloud function for retreiving a firebase token. Attempt ${a} of 5. Waitting ${e}ms before retrying.`), await rv(e);
	}
	throw Error(`⭕️ Firebase ERROR: Not able to retrieve token for firebase after ${a} attemps`);
}
function lv(e) {
	let t = localStorage.getItem(Ue(e));
	if (t !== null) return t;
}
function uv(e, t) {
	localStorage.setItem(Ue(e), t);
}
function dv(e) {
	let t = lv(e);
	return t === void 0 ? !1 : sv(t);
}
function fv(e, t) {
	Zd(Wr(qe(e, t)), { experimentalForceLongPolling: !0 });
}
async function pv(e, t, n, r) {
	let i = "";
	return !r && dv(e) ? i = lv(e) : (i = await cv(e, t, n), uv(e, i)), i;
}
async function mv(e, t, n) {
	try {
		fv(e, t);
		let r = Gr(), i = await pv(e, t, n, !1), a = tv(r), o = a.currentUser;
		if (o) return console.debug("⭕️ Firebase: Already logged in, Reusing user's credentials"), o.uid;
		let s = await Jh(a, i);
		if (console.debug("⭕️ Firebase: User not logged --> Signning in"), !s) throw Error("⭕️ Firebase ERROR: No user credentials");
		return s.user.uid;
	} catch (e) {
		throw Error(`⭕️ Firebase ERROR: Error signing in with custom token ${X(e)}`);
	}
}
async function hv(e, t, n) {
	return await pv(e, t, n, !1);
}
async function $(e, t) {
	let n = _e.getInstance().getToken();
	if (n === void 0 || n.length < 15) throw Error("⭕️ Firebase ERROR: Trying to get DB Firestore, but no Carto3 token provided");
	return await mv(e, t, n), Qd(Gr());
}
async function gv(e, n, r) {
	let i = t(await pv(e, n, r, !0)).claims.role, a = Object.values(ee), o = a.find((e) => i === e);
	if (!o) {
		let e = `Unexpected role value: Role ${i} not found in roles: ${a}`;
		throw console.error(`👩🏻‍🦰 ${e}`), Error(e);
	}
	return o;
}
//#endregion
//#region src/helpers/auth.helper.ts
function _v(e) {
	let n = t(_e.getInstance().getToken()), r = n[e.auth0_user_key], i = n.sub;
	if (!r) throw Error("No user email found in token");
	if (!i) throw Error("No user id found in token");
	return {
		userEmail: r,
		userId: i
	};
}
//#endregion
//#region src/firestore/firestore.service.ts
function vv(e, t, n, r) {
	let i = n, a = `${t.getAppVersion()}_${i[0]}`;
	return i.shift(), r && i.push(r), {
		collectionPath: a,
		collectionPathSegments: i
	};
}
function yv(e) {
	let t = Object.keys(e).filter((t) => e[t] === void 0);
	if (t.length > 0) {
		let e = `Object properties with undefined values cannot be persisted on Firestore.Invalid object properties: ${t.join(", ")}`;
		throw console.error(e), Error(e);
	}
}
function bv(e, t, n = !1) {
	let { userEmail: r, userId: i } = _v(e), a = I.now();
	return n && (t.created_at = a), t.modified_at = a, t.modified_by = r, t.modified_by_auth0_id = i, { ...t };
}
function xv(e) {
	let t = { ...e };
	return t.created_at = e.created_at?.toDate(), t.modified_at = e.modified_at?.toDate(), t;
}
function Sv(e) {
	let t = [];
	return e.forEach((e) => {
		let n = e.data();
		n = xv(n), n.id = e.id, t.push(n);
	}), t;
}
async function Cv(e, t, ...n) {
	try {
		let r = await $(e, t), { collectionPath: i, collectionPathSegments: a } = vv(e, t, n);
		return Sv(await op(Kd(r, i, ...a)));
	} catch (e) {
		throw Error(`Error getting elemnts ${X(e)}`);
	}
}
async function wv(e, t, n, ...r) {
	try {
		let i = await $(e, t), { collectionPath: a, collectionPathSegments: o } = vv(e, t, r, n), s = (await ip(qd(i, a, ...o))).data();
		return s = xv(s), s.id = n, s;
	} catch (e) {
		throw Error(`Error getting element with id: ${n} ${X(e)}`);
	}
}
async function Tv(e, t, { collectionFullPath: n, queryConstraints: r }) {
	try {
		let i = await $(e, t), { collectionPath: a, collectionPathSegments: o } = vv(e, t, n);
		return Sv(await op(zf(Kd(i, a, ...o), ...r)));
	} catch (e) {
		throw Error(`Error getting elements using queries ${X(e)}`);
	}
}
async function Ev(e, t, { collectionFullPath: n, queryConstraints: r }) {
	try {
		let i = await $(e, t), { collectionPath: a, collectionPathSegments: o } = vv(e, t, n);
		return (await pp(zf(Kd(i, a, ...o), ...r))).data().count;
	} catch (e) {
		throw Error(`Error getting elements count using queries ${X(e)}`);
	}
}
async function Dv(e, t, r, ...i) {
	try {
		let a = await $(e, t), o = bv(e, r, !0), { collectionPath: s, collectionPathSegments: c } = vv(e, t, i), l = Kd(a, s, ...c), u = n(), d = qd(l, u), f = o;
		return f.id = u, yv(f), await sp(d, f), u;
	} catch (e) {
		throw Error(`Error creating element\n ${X(e)}`);
	}
}
async function Ov(e, t, n, r, ...i) {
	try {
		let a = await $(e, t), o = bv(e, n);
		delete o.id;
		let { collectionPath: s, collectionPathSegments: c } = vv(e, t, i, r), l = o;
		yv(l), await cp(qd(a, s, ...c), l);
	} catch (e) {
		throw Error(`Error updating element with id: ${r} ${X(e)}`);
	}
}
async function kv(e, t, n, r, ...i) {
	try {
		let a = await $(e, t), o = bv(e, {}), s = {
			...n,
			modified_at: o.modified_at,
			modified_by: o.modified_by,
			modified_by_auth0_id: o.modified_by_auth0_id
		}, { collectionPath: c, collectionPathSegments: l } = vv(e, t, i, r), u = s;
		yv(u), await cp(qd(a, c, ...l), u);
	} catch (e) {
		throw Error(`Error updating properties for element with id: ${r} ${X(e)}`);
	}
}
async function Av(e, t, n, ...r) {
	try {
		let i = await $(e, t), { collectionPath: a, collectionPathSegments: o } = vv(e, t, r, n);
		await lp(qd(i, a, ...o));
	} catch (e) {
		throw Error(`Error deleting element with id: ${n} ${X(e)}`);
	}
}
//#endregion
//#region src/plan.service.ts
var jv = /* @__PURE__ */ u({
	createPlan: () => Fv,
	deletePlan: () => Lv,
	getFirebaseToken: () => Bv,
	getPlan: () => Pv,
	getPlans: () => Nv,
	getPlansByCustomGeoboundaryId: () => Vv,
	getPlansByUserId: () => zv,
	getPublicPlans: () => Rv,
	initFirebase: () => Hv,
	updatePlan: () => Iv
});
function Mv(e) {
	let t = JSON.parse(e.package);
	t && (e.status = t.state, t.expirationForAgencyBookingConfirmation ? e.expirationForAgencyBookingConfirmation = t.expirationForAgencyBookingConfirmation : e.expirationForAgencyBookingConfirmation = null);
}
async function Nv(e, t) {
	return await Cv(e, t, Y.Plans);
}
async function Pv(e, t, n) {
	return await wv(e, t, n, Y.Plans);
}
async function Fv(e, t, n) {
	return Mv(n), await Dv(e, t, n, Y.Plans);
}
async function Iv(e, t, n, r) {
	Mv(r), await Ov(e, t, r, n, Y.Plans);
}
async function Lv(e, t, n) {
	await Av(e, t, n, Y.Plans);
}
async function Rv(e, t, n) {
	let r = [J("is_public", "==", !0)];
	return n && (r = [...r, J("agency", "==", n)]), await Tv(e, t, {
		collectionFullPath: [Y.Plans],
		queryConstraints: r
	});
}
async function zv(e, t, n) {
	return await Tv(e, t, {
		collectionFullPath: [Y.Plans],
		queryConstraints: [J("created_by", "==", n)]
	});
}
async function Bv(e, t, n) {
	return await hv(e, t, n);
}
async function Vv(e, t, n) {
	return await Tv(e, t, {
		collectionFullPath: [Y.Plans],
		queryConstraints: [J("custom_geoboundaries", "array-contains", n)]
	});
}
async function Hv(e, t) {
	await $(e, t);
}
//#endregion
//#region src/geocoding.service.ts
var Uv = /* @__PURE__ */ u({ geocoding: () => Gv });
function Wv(e, t) {
	let n = Ke(e, t, m.Geocoding);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for geocoding in shared plans. Check .metadata file 🔴🔴🔴");
	return n;
}
async function Gv(e, t, n, r, i, a, o, s, c) {
	let l = i.length ? `&country=${i}` : "", u = Me(e, t), d = `${n}/v3/lds/geocoding/geocode`;
	if (d += `?address=${encodeURIComponent(r)}`, d += l, d += `&limit=${a}`, d += `&client=${encodeURIComponent(u)}`, !o) {
		let e = { Authorization: `Bearer ${_e.getInstance().getToken()}` }, t = await (await fetch(d, {
			method: "GET",
			headers: e
		})).json();
		if (t[0].error) throw Error(t[0].error);
		return t[0].value;
	}
	try {
		let n = Wv(e, t), r = new URLSearchParams({
			appVersion: e.flavour,
			planId: s,
			geocodingUrl: encodeURIComponent(d),
			password: c
		});
		return n += `?${r.toString()}`, await (await fetch(n, { method: "GET" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${X(e)}`);
	}
}
//#endregion
//#region src/audit.service.ts
var Kv = /* @__PURE__ */ u({ createEvent: () => qv });
async function qv(e, t, n) {
	return await Dv(e, t, n, Y.Audit);
}
//#endregion
//#region src/sharePlan.service.ts
var Jv = /* @__PURE__ */ u({
	createSharePlan: () => Zv,
	getAssetById: () => ey,
	getAssets: () => $v,
	getPlan: () => Qv,
	getSharedPlanContent: () => ty,
	getSharedPlanContentFromPlanId: () => ny,
	isPasswordRequired: () => Xv,
	updateSharedPlanContent: () => ry
});
function Yv(e, t) {
	let n = Ke(e, t, m.SharedPlan);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for managin shared plans. Check .metadata file 🔴🔴🔴");
	return n;
}
async function Xv(e, t, n) {
	let r = new URLSearchParams({
		action: h.PasswordRequired,
		planId: n,
		appVersion: t.getAppVersion()
	}), i = !1, a = !0;
	try {
		let n = Yv(e, t);
		n += `?${r.toString()}`;
		let o = await fetch(n, { method: "GET" });
		o.ok && (i = !0, a = (await o.json()).passwordRequired);
	} catch (e) {
		throw Error(`Cloud function error ${X(e)}`);
	}
	return {
		isActive: i,
		isPasswordRequired: a
	};
}
async function Zv(e, t, n) {
	let r = `Bearer ${_e.getInstance().getToken()}`, i = new URLSearchParams({
		action: h.Share,
		planId: n.planId
	}), a = { expiracyDate: n.expiracyDate };
	n.password && (a.password = n.password);
	let o = n.package;
	o && o.showPrice !== void 0 && (a.showPrice = o.showPrice ? "true" : "false");
	try {
		let n = Yv(e, t);
		return n += `?${i.toString()}`, await (await fetch(n, {
			method: "POST",
			headers: { Authorization: r },
			body: JSON.stringify(a)
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${X(e)}`);
	}
}
async function Qv(e, t, n) {
	let r = new URLSearchParams({
		action: h.Plan,
		planId: n.planId,
		appVersion: t.getAppVersion()
	});
	n.password && r.append("password", n.password);
	try {
		let n = Yv(e, t);
		n += `?${r.toString()}`;
		let i = await fetch(n, { method: "GET" });
		if (i.status >= 400) throw Error(`Cloud function error ${i.statusText}`);
		return await i.json();
	} catch (e) {
		throw Error(`Cloud function error ${X(e)}`);
	}
}
async function $v(e, t, n) {
	let r = new URLSearchParams({
		action: h.Assets,
		planId: n.planId,
		appVersion: t.getAppVersion()
	});
	n.password && r.append("password", n.password), n.assetsOffset !== void 0 && (r.delete("action"), r.append("action", h.AssetsPagination), r.append("assetsOffset", n.assetsOffset.toString()), r.append("token", n.token || ""), r.append("iv", n.iv || ""));
	try {
		let n = Yv(e, t);
		n += `?${r.toString()}`;
		let i = await fetch(n, { method: "GET" }), a = await i.json();
		if (i.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${X(e)}`);
	}
}
async function ey(e, t, n, r) {
	let i = new URLSearchParams({
		action: h.Asset,
		planId: n.planId,
		appVersion: t.getAppVersion(),
		assetId: r
	});
	n.password && i.append("password", n.password);
	try {
		let n = Yv(e, t);
		n += `?${i.toString()}`;
		let r = await fetch(n, { method: "GET" }), a = await r.json();
		if (r.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${X(e)}`);
	}
}
async function ty(e, t, n) {
	return await wv(e, t, n, Y.SharedPlans);
}
async function ny(e, t, n) {
	let r = [J("planId", "==", n)], i = (await Tv(e, t, {
		collectionFullPath: [Y.SharedPlans],
		queryConstraints: r
	}))[0];
	return i ? (i.expiracyDate = i.expiracyDate.toDate(), i.creationDate = i.creationDate.toDate(), i) : null;
}
async function ry(e, t, n, r) {
	await Ov(e, t, r, n, Y.SharedPlans);
}
//#endregion
//#region src/packages.service.ts
var iy = /* @__PURE__ */ u({
	getAllPackagesWithAllProperties: () => ay,
	getPackageAvailability: () => oy,
	getPackageClassificationValues: () => sy
});
async function ay(e, t) {
	let n = x(e, t, e.data_model.packages);
	return await b(`SELECT
    ${e.data_model.packages.columns.map((e) => e.id).join(", ")}
  FROM ${n}
  ORDER BY package ASC`, e, t);
}
async function oy(e, t, n, r, i) {
	let a = (await b(`
    SELECT
      (AVG(availability) * 100) as availability,
    FROM ${x(e, t, e.data_model.packages_availability)}
    WHERE package_id = ${i} and date between '${n}' and '${r}'
  `, e, t))[0].availability;
	return a == null ? (console.warn(`Availability for package ${i} between ${n} and ${r} is null. Behaving as it is available.`), 100) : Math.floor(a) || 0;
}
async function sy(e, t) {
	if (!e.data_model.packages) throw Error("Packages classification is not defined");
	return (await b(`
  SELECT
    ARRAY_AGG(DISTINCT l1 ORDER BY l1) as l1,
    ARRAY_AGG(DISTINCT u_l2 ORDER BY u_l2) as l2,
    ARRAY_AGG(DISTINCT u_l3 ORDER BY u_l3) as l3,
    ARRAY_AGG(DISTINCT u_l4 ORDER BY u_l4) as l4,
  FROM ${x(e, t, e.data_model.packages)} pc,
  UNNEST(pc.l2) as u_l2,
  UNNEST(pc.l3) as u_l3,
  UNNEST(pc.l4) as u_l4
  WHERE l1 IS NOT NULL;
  `, e, t))[0];
}
//#endregion
//#region src/auth0.service.ts
var cy = /* @__PURE__ */ u({
	getAuth0Roles: () => ly,
	getAuth0Users: () => uy
});
async function ly(e, t) {
	let n = Ke(e, t, m.Auth0);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting Auth0 roles. Check .env file 🔴🔴🔴");
	n += "roles";
	let r = `Bearer ${_e.getInstance().getToken()}`, i = await (await fetch(n, {
		method: "GET",
		headers: { Authorization: r }
	})).json();
	if (i.error) throw Error(i.error);
	return i;
}
async function uy(e, t) {
	let n = Ke(e, t, m.Auth0);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting Auth0 users. Check .env file 🔴🔴🔴");
	n += "users-by-role";
	let r = `Bearer ${_e.getInstance().getToken()}`, i = await (await fetch(n, {
		method: "GET",
		headers: { Authorization: r }
	})).json();
	if (i.error) throw Error(i.error);
	return i;
}
//#endregion
//#region src/comment.service.ts
var dy = /* @__PURE__ */ u({
	addAttachmentToComment: () => gy,
	clearAllCommentAttachments: () => _y,
	createComment: () => my,
	getAllAttachments: () => My,
	getAllNewComments: () => jy,
	getCommentAttachments: () => by,
	getComments: () => fy,
	getCommentsCount: () => py,
	getLatestPlanComments: () => Ay,
	markAllPlanCommentsAsNew: () => Oy,
	markAllPlanCommentsAsRead: () => Ty,
	markCommentAsNew: () => Dy,
	markCommentAsRead: () => wy,
	removeCommentAttachments: () => vy,
	updateComment: () => hy
});
async function fy(e, t, n) {
	return await Tv(e, t, {
		collectionFullPath: [Y.Comments],
		queryConstraints: [J("plan_id", "==", n)]
	});
}
async function py(e, t, n) {
	return await Ev(e, t, {
		collectionFullPath: [Y.Comments],
		queryConstraints: [J("plan_id", "==", n)]
	});
}
async function my(e, t, n) {
	n.new = !0, n.newForCreator = !1;
	try {
		return await Dv(e, t, n, Y.Comments);
	} catch (e) {
		let t = `Could not save comment from plan ${n.plan_id}`;
		throw console.error(`${t}`, e), Error(t);
	}
}
async function hy(e, t, n) {
	let r = n.id;
	if (!r) throw Error("Comment id is required, when trying to update a comment");
	return await Ov(e, t, n, r, Y.Comments), r;
}
async function gy(e, t, n, r) {
	let i = await wv(e, t, n, Y.Comments);
	i.attachments ||= [], i.attachments.push(r), await Ov(e, t, i, n, Y.Comments);
}
async function _y(e, t, n) {
	let r = await wv(e, t, n, Y.Comments);
	r.attachments = [], await Ov(e, t, r, n, Y.Comments);
}
async function vy(e, t, n, r) {
	let i = await wv(e, t, n, Y.Comments);
	i.attachments = i.attachments.filter((e) => !r.includes(e.humanName)), await Ov(e, t, i, n, Y.Comments);
}
async function yy(e, t, n) {
	let r = await wv(e, t, n, Y.Comments);
	return r.id = n, r;
}
async function by(e, t, n) {
	return (await yy(e, t, n)).attachments || [];
}
function xy(e, t) {
	return e.created_by === t ? e.newForCreator ?? !1 : e.new ?? !1;
}
function Sy(e, t, n) {
	return e.created_by === t ? e.newForCreator = n : e.new = n, e;
}
async function Cy(e, t, n, r) {
	let i = r.id;
	if (!i) throw Error("Comment id is required, when trying to set a comment as readed");
	xy(r, t) && (Sy(r, t, !1), await Ov(e, n, r, i, Y.Comments));
}
async function wy(e, t, n, r) {
	Cy(e, t, n, await yy(e, n, r));
}
async function Ty(e, t, n, r) {
	let i = await fy(e, n, r);
	for (let r = 0; r < i.length; r++) {
		let a = i[r];
		await Cy(e, t, n, a);
	}
}
async function Ey(e, t, n, r) {
	let i = r.id;
	if (!i) throw Error("Comment id is required, when trying to set a comment as new");
	if (!xy(r, t)) return Sy(r, t, !0), Ov(e, n, r, i, Y.Comments);
}
async function Dy(e, t, n, r) {
	Ey(e, t, n, await yy(e, n, r));
}
async function Oy(e, t, n, r) {
	let i = await fy(e, n, r);
	for (let r = 0; r < i.length; r++) {
		let a = i[r];
		await Ey(e, t, n, a);
	}
}
async function ky(e, t, n, r) {
	let i = [...new Set(n)], a = i.length, o = [], s = r ? "newForCreator" : "new";
	for (let n = 0; n < a; n += 25) {
		let r = i.slice(n, n + 25), a = await Tv(e, t, {
			collectionFullPath: [Y.Comments],
			queryConstraints: [J("plan_id", "in", r), J(s, "==", !0)]
		});
		a.length !== 0 && o.push(...a);
	}
	return o;
}
async function Ay(e, t) {
	return await Tv(e, t, {
		collectionFullPath: [xp.Comments],
		queryConstraints: [Uf("created_at", "desc"), Gf(10)]
	});
}
async function jy(e, t, n, r) {
	let i = n.map((e) => e.planId), [a, o] = await Promise.all([ky(e, t, i, !1), ky(e, t, i, !0)]);
	return o.forEach((e) => {
		a.some((t) => t.id === e.id) || a.push(e);
	}), a.filter((e) => xy(e, r));
}
async function My(e, t, n) {
	return (await Tv(e, t, {
		collectionFullPath: [Y.Comments],
		queryConstraints: [J("plan_id", "==", n)]
	})).flatMap((e) => e.attachments || []);
}
//#endregion
//#region src/client.service.ts
var Ny = /* @__PURE__ */ u({
	createClient: () => Fy,
	getAllClients: () => Py
});
async function Py(e, t) {
	return await Tv(e, t, {
		collectionFullPath: [Y.Clients],
		queryConstraints: []
	});
}
async function Fy(e, t, n) {
	try {
		await Dv(e, t, n, Y.Clients);
	} catch (e) {
		let t = `Could not save client with name ${n.name}`;
		throw console.error(`${t}`, e), Error(t);
	}
}
//#endregion
//#region src/brand.service.ts
var Iy = /* @__PURE__ */ u({
	createBrand: () => Ry,
	getAllBrands: () => Ly
});
async function Ly(e, t, n, r) {
	if (n === r) return await Tv(e, t, {
		collectionFullPath: [Y.Brands],
		queryConstraints: []
	});
	let i = {
		collectionFullPath: [Y.Brands],
		queryConstraints: [J("agency", "==", r)]
	}, a = {
		collectionFullPath: [Y.Brands],
		queryConstraints: [J("agency", "==", n)]
	}, o = [];
	return o.push(Tv(e, t, i)), o.push(Tv(e, t, a)), (await Promise.all(o)).flat();
}
async function Ry(e, t, n) {
	try {
		await Dv(e, t, n, Y.Brands);
	} catch (e) {
		let t = `Could not save brand with name ${n.name}`;
		throw console.error(`${t}`, e), Error(t);
	}
}
//#endregion
//#region src/carto-metric-event.service.ts
var zy = /* @__PURE__ */ u({ sendCartoMetricEvent: () => By });
async function By(e, t, n) {
	let r = _e.getInstance().getToken(), { apiBaseUrl: i } = S(e, t), a = Je(e), o = {
		accessToken: r,
		apiBaseUrl: i
	};
	await fe({
		abortController: new AbortController().signal,
		credentials: o,
		method: ie.Post,
		body: n,
		url: a
	});
}
//#endregion
//#region src/signed-url.service.ts
var Vy = /* @__PURE__ */ u({ getSignedUrlForFile: () => Hy });
async function Hy(e, t, n, r, i, a) {
	let o = Ke(e, t, m.SignedUrls);
	if (!o) throw Error("🔴🔴🔴 No cloud function url define for managing signed urls. Check .env file 🔴🔴🔴");
	let s = new URLSearchParams({
		action: a,
		bucketName: r,
		fileName: n,
		type: i
	}).toString(), c = `Bearer ${_e.getInstance().getToken()}`;
	return (await (await fetch(`${o}?${s}`, {
		method: "GET",
		headers: { Authorization: c }
	})).json()).url;
}
//#endregion
//#region src/helpers/array.helper.ts
function Uy(e) {
	return !e || !Array.isArray(e) ? !1 : e.length > 0;
}
//#endregion
//#region src/packages-browser.service.ts
var Wy = /* @__PURE__ */ u({
	getAllPackages: () => Yy,
	getAllPackagesWithAllProperties: () => qy,
	getPackageAssetsIds: () => Jy
});
function Gy(e, t) {
	return Uy(t) ? `
      EXISTS (
        SELECT 1
        FROM UNNEST(${e}) AS element
        WHERE${Ze({
		columnName: "element",
		ids: t,
		equalityOperator: Ye.EQUALS,
		logicalOperator: Xe.NONE
	})}
      )
    ` : null;
}
function Ky(e) {
	let t = [];
	if (e.digital !== void 0 && t.push(`digital = ${e.digital}`), Uy(e.l1)) {
		let n = Ze({
			columnName: "l1",
			ids: e.l1,
			equalityOperator: Ye.EQUALS,
			logicalOperator: Xe.NONE
		});
		t.push(n);
	}
	t.push(Gy("l2", e.l2)), t.push(Gy("l3", e.l3)), t.push(Gy("l4", e.l4));
	let n = t.filter((e) => e !== null).join(" OR ");
	return n ? ` AND (${n})` : "";
}
async function qy(e, t, n) {
	let r = x(e, t, e.data_model.packages), i = x(e, t, e.data_model.packages_availability), a = x(e, t, e.data_model.assets), o = `
    availability AS (
      SELECT
        package_id,
        NULL as availability,
      FROM ${i}
      group by package_id
    ),
    `, s = n.dateRange;
	s && (o = `
    availability AS (
      SELECT
        package_id,
        (AVG(availability) * 100) as availability,
      FROM ${i}
      WHERE date between '${s[0]}' and '${s[1]}'
      group by package_id
    ),
    `);
	let c = n.priceRange, l = Ky(n.panelType);
	return await b(`
  WITH ${o}
  panels AS (
    SELECT
      package_id, package, panels, gross_price
      FROM ${r}
      WHERE gross_price >= ${c[0]} AND gross_price <= ${c[1]}
      ${l}
  ),
  impressions AS (
    SELECT p.package_id, SUM(a.impressions) as impressions
    FROM ${r} p
    JOIN ${a} a
      ON p.package_id IN UNNEST(a.packages)
    group by p.package_id
  )
  Select
    p.package_id as id,
    a.availability,
    p.package as name,
    p.panels,
    p.gross_price as price,
    i.impressions
  FROM panels p
  LEFT JOIN availability a ON p.package_id = a.package_id
  LEFT JOIN impressions i ON p.package_id = i.package_id
  ORDER BY p.package ASC
  `, e, t);
}
async function Jy(e, t, n) {
	return await b(`
  SELECT id
  FROM ${x(e, t, e.data_model.assets)}
  WHERE EXISTS (
    SELECT 1
    FROM UNNEST(packages) AS p
    WHERE p = ${n}
  )
  `, e, t);
}
async function Yy(e, t) {
	return b(`
  SELECT
    package_id as id,
    package as name,
    gross_price as price,
    contacts as impressions,
    null as availability,
    panels
  FROM ${x(e, t, e.data_model.packages)}
  ORDER BY package ASC`, e, t);
}
//#endregion
//#region src/firestore/firestore.subscriber.ts
async function Xy(e, t, n = 0) {
	let r = iv(t, n);
	return up(e, (e) => {
		console.debug(`⭕️ 👋 Firestore has tell us collection has been updated, waiting ${n}s before running callback`), r(Sv(e));
	});
}
async function Zy(e, t, n) {
	let r = iv(t, n);
	return up(e, (e) => {
		console.debug(`⭕️ 👋 Firestore has tell us document has been updated, waiting ${n}s before running callback`), r(e.data());
	});
}
async function Qy(e, t, n) {
	let { collectionPath: r, collectionPathSegments: i } = vv(e, t, n);
	return Kd(await $(e, t), r, ...i);
}
async function $y(e, t, n, r, i) {
	return Xy(zf(await Qy(e, t, [Y.Comments]), J("plan_id", "==", n)), (e) => i(e), r * 1e3);
}
async function eb(e, t, n, r) {
	return Zy(qd(await $(e, t), `${t.getAppVersion()}_${Y.Subscriptions}`, bp.Comments), r, n * 1e3);
}
async function tb(e, t, n, r) {
	return Zy(qd(await $(e, t), `${t.getAppVersion()}_${Y.Subscriptions}`, bp.Plans), r, n * 1e3);
}
//#endregion
//#region src/helpers/featured-package-lock.helper.ts
var nb = "reorder_lock";
function rb(e, t) {
	return !!(e.isLocked && e.expiresAt && e.expiresAt.getTime() > t);
}
function ib(e, t, n, r = !1) {
	return rb(e, n) ? r && e.heldBy === t : !0;
}
function ab(e, t, n) {
	return e.heldBy === t ? n === void 0 || e.sessionId === n : !1;
}
function ob(e, t, n, r) {
	return rb(e, n) && ab(e, t, r);
}
//#endregion
//#region src/featured-package-lock.service.ts
var sb = /* @__PURE__ */ u({
	acquireLock: () => pb,
	deserializeLock: () => ub,
	getLockStatus: () => gb,
	releaseLock: () => mb,
	renewLock: () => hb
});
function cb(e) {
	if (!e.features.packages.featured_packages) throw Error("Featured packages configuration not found in metadata. Check metadata file to verify featured_packages is correctly set");
	return e.features.packages.featured_packages.lock.expiration_interval;
}
var lb = {
	isLocked: !1,
	heldBy: null,
	sessionId: null,
	acquiredAt: null,
	expiresAt: null,
	lastRenewal: null
};
function ub(e) {
	return e ? {
		isLocked: e.isLocked,
		heldBy: e.heldBy,
		sessionId: e.sessionId ?? null,
		acquiredAt: e.acquiredAt?.toDate() || null,
		expiresAt: e.expiresAt?.toDate() || null,
		lastRenewal: e.lastRenewal?.toDate() || null
	} : { ...lb };
}
function db(e) {
	return {
		isLocked: e.isLocked,
		heldBy: e.heldBy,
		sessionId: e.sessionId,
		acquiredAt: e.acquiredAt ? I.fromDate(e.acquiredAt) : null,
		expiresAt: e.expiresAt ? I.fromDate(e.expiresAt) : null,
		lastRenewal: e.lastRenewal ? I.fromDate(e.lastRenewal) : null
	};
}
async function fb(e, t, n) {
	let r = await $(e, t), { userEmail: i } = _v(e), { collectionPath: a, collectionPathSegments: o } = vv(e, t, [Y.FeaturedPackagesLock], n);
	return {
		db: r,
		lockRef: qd(r, a, ...o),
		userEmail: i
	};
}
async function pb(e, t, n = nb, r = !1, i = null) {
	try {
		let { db: a, lockRef: o, userEmail: s } = await fb(e, t, n), c = cb(e);
		return await vp(a, async (e) => {
			let t = ub((await e.get(o)).data()), n = Date.now();
			if (!ib(t, s, n, r)) return {
				success: !1,
				heldBy: t.heldBy || void 0,
				acquiredAt: t.acquiredAt || void 0
			};
			let a = {
				isLocked: !0,
				heldBy: s,
				sessionId: i,
				acquiredAt: new Date(n),
				expiresAt: new Date(n + c),
				lastRenewal: new Date(n)
			};
			return e.set(o, db(a)), {
				success: !0,
				sessionId: i ?? void 0
			};
		});
	} catch (e) {
		throw console.error("[featured-package-lock.service] Error acquiring lock:", e), Error(`Failed to acquire lock: ${String(e)}`);
	}
}
async function mb(e, t, n = nb, r) {
	try {
		let { db: i, lockRef: a, userEmail: o } = await fb(e, t, n);
		await vp(i, async (e) => {
			let t = await e.get(a), n = ub(t.data());
			t.exists() && ab(n, o, r) && e.delete(a);
		});
	} catch (e) {
		throw console.error("[featured-package-lock.service] Error releasing lock:", e), Error(`Failed to release lock: ${String(e)}`);
	}
}
async function hb(e, t, n = nb, r) {
	try {
		let { db: i, lockRef: a, userEmail: o } = await fb(e, t, n), s = cb(e);
		return await vp(i, async (e) => {
			let t = ub((await e.get(a)).data());
			if (!t.isLocked || !ab(t, o, r)) return !1;
			let n = Date.now(), i = {
				...t,
				expiresAt: new Date(n + s),
				lastRenewal: new Date(n)
			};
			return e.set(a, db(i)), !0;
		});
	} catch (e) {
		return console.error("[featured-package-lock.service] Error renewing lock:", e), !1;
	}
}
async function gb(e, t, n = nb) {
	try {
		let { lockRef: r } = await fb(e, t, n), i = ub((await ip(r)).data());
		return rb(i, Date.now()) ? i : ub(void 0);
	} catch (e) {
		throw console.error("[featured-package-lock.service] Error getting lock status:", e), Error(`Failed to get lock status: ${String(e)}`);
	}
}
//#endregion
//#region src/helpers/featured-package.helper.ts
function _b(e, t) {
	if (!Number.isFinite(e) || Number.isNaN(e)) throw Error(`Invalid ${t}: expected a number, got ${e}`);
	return e;
}
function vb(e) {
	let t = e?.trim() ?? "";
	if (!t) return null;
	if (t.length > 150) throw Error(`Invalid shortDescription: expected at most 150 characters, got ${t.length}`);
	return t;
}
function yb(e) {
	return {
		start: I.fromDate(e.start),
		end: I.fromDate(e.end)
	};
}
function bb(e) {
	return {
		id: e.id,
		order: e.order,
		short_description: vb(e.shortDescription),
		description: e.description,
		name: e.name,
		original_name: e.originalName,
		digital: e.digital,
		available: e.available,
		asset_ids: e.assetIds,
		source_package: e.sourcePackage ?? null,
		use_period: yb(e.usePeriod),
		sales_period: yb(e.salesPeriod),
		price: e.price.price,
		production: e.price.production,
		posting: e.price.posting,
		custom_tags: e.customTags,
		price_details: e.priceDetails,
		purchases: {
			current: _b(e.purchases.current, "purchases.current"),
			max: _b(e.purchases.max, "purchases.max")
		},
		impressions: e.impressions,
		events: e.events,
		created_by: e.created_by,
		image_url: e.imageUrl
	};
}
function xb(e) {
	let t = e.use_period, n = e.sales_period, r = e.purchases;
	return {
		id: e.id,
		order: e.order ?? -1,
		name: e.name,
		shortDescription: e.short_description ?? null,
		description: e.description,
		originalName: e.original_name,
		digital: e.digital,
		available: e.available,
		assetIds: e.asset_ids || [],
		sourcePackage: e.source_package ?? null,
		usePeriod: {
			start: t.start.toDate(),
			end: t.end.toDate()
		},
		salesPeriod: {
			start: n.start.toDate(),
			end: n.end.toDate()
		},
		price: {
			price: e.price,
			production: e.production,
			posting: e.posting
		},
		customTags: e.custom_tags,
		priceDetails: e.price_details,
		purchases: {
			current: _b(r.current, "purchases.current"),
			max: _b(r.max, "purchases.max")
		},
		impressions: e.impressions,
		events: e.events || [],
		created_at: e.created_at,
		modified_at: e.modified_at,
		modified_by: e.modified_by ?? null,
		created_by: e.created_by,
		imageUrl: e.image_url ?? null
	};
}
//#endregion
//#region src/featured-package.service.ts
var Sb = /* @__PURE__ */ u({
	createFeaturedPackage: () => Tb,
	deleteFeaturedPackage: () => Ob,
	getFeaturedPackage: () => wb,
	getFeaturedPackagePurchaseStatus: () => Mb,
	getFeaturedPackages: () => Cb,
	getFeaturedPackagesReadyToPurchase: () => Ab,
	purchaseFeaturedPackage: () => Nb,
	updateFeaturedPackage: () => Eb,
	updateFeaturedPackageAvailability: () => Db,
	updateFeaturedPackagesOrder: () => kb
});
async function Cb(e, t) {
	return (await Cv(e, t, Y.FeaturedPackages)).map(xb);
}
async function wb(e, t, n) {
	return xb(await wv(e, t, n, Y.FeaturedPackages));
}
async function Tb(e, t, n) {
	return await Dv(e, t, bb(n), Y.FeaturedPackages);
}
async function Eb(e, t, n, r) {
	await Ov(e, t, bb(r), n, Y.FeaturedPackages);
}
async function Db(e, t, n, r) {
	await kv(e, t, { available: r }, n, Y.FeaturedPackages);
}
async function Ob(e, t, n) {
	await Av(e, t, n, Y.FeaturedPackages);
}
async function kb(e, t, n) {
	let { userEmail: r } = _v(e), i = await gb(e, t);
	if (!i.isLocked || i.heldBy !== r) throw Error(`Cannot update package order: Lock is not held by current user (${r})`);
	let a = {
		successful: [],
		failed: []
	};
	return await Promise.allSettled(n.map(async (n) => {
		try {
			await kv(e, t, { order: n.order }, n.id, Y.FeaturedPackages), a.successful.push(n.id);
		} catch (e) {
			a.failed.push({
				id: n.id,
				name: n.name,
				error: e instanceof Error ? e.message : String(e)
			});
		}
	})), a;
}
async function Ab(e, t) {
	let n = I.fromDate(/* @__PURE__ */ new Date());
	return (await Tv(e, t, {
		collectionFullPath: [Y.FeaturedPackages],
		queryConstraints: [
			J("available", "==", !0),
			J("sales_period.start", "<=", n),
			J("sales_period.end", ">=", n),
			Uf("order", "asc")
		]
	})).map(xb);
}
function jb(e, t) {
	let n = t.getEnvironmentForMetadata(), r = e.app_config.remote_functions.featured_packages;
	if (!r) throw Error("🔴🔴🔴 No cloud function url defined for featured packages. Check .metadata file 🔴🔴🔴");
	let i = r[n];
	if (!i) throw Error(`🔴🔴🔴 No cloud function url defined for featured packages in ${n} environment. Check .metadata file 🔴🔴🔴`);
	return i;
}
async function Mb(e, t, n) {
	let r = await wb(e, t, n), i = r.available, a = r.purchases.current >= r.purchases.max;
	return {
		canPurchase: i && !a,
		available: i,
		soldOut: a
	};
}
async function Nb(e, t, n, r) {
	let i = _e.getInstance().getToken(), a = jb(e, t), o = {
		action: te.Purchase,
		featuredPackageId: n,
		planId: r
	};
	try {
		let e = await fetch(a, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${i}`,
				"Content-Type": "application/json"
			},
			body: JSON.stringify(o)
		});
		if (!e.ok) {
			let t = await e.text();
			throw Error(t || e.statusText);
		}
		return await e.json();
	} catch (e) {
		throw Error(`Cloud function error: ${X(e)}`);
	}
}
//#endregion
//#region src/helpers/featured-package-edit.helper.ts
function Pb(e) {
	let t = {};
	return e.name !== void 0 && (t.name = e.name), e.shortDescription !== void 0 && (t.short_description = vb(e.shortDescription)), e.description !== void 0 && (t.description = e.description), e.imageUrl !== void 0 && (t.image_url = e.imageUrl), e.available !== void 0 && (t.available = e.available), e.assetIds !== void 0 && (t.asset_ids = e.assetIds), e.sourcePackage !== void 0 && (t.source_package = e.sourcePackage), e.impressions !== void 0 && (t.impressions = _b(e.impressions, "impressions")), e.usePeriod !== void 0 && (t.use_period = yb(e.usePeriod)), e.salesPeriod !== void 0 && (t.sales_period = yb(e.salesPeriod)), e.price !== void 0 && (t.price = _b(e.price.price, "price"), t.production = _b(e.price.production, "production"), t.posting = _b(e.price.posting, "posting")), e.priceDetails !== void 0 && (t.price_details = e.priceDetails), e.maxPurchases !== void 0 && (t["purchases.max"] = _b(e.maxPurchases, "purchases.max")), t;
}
function Fb(e, t = /* @__PURE__ */ new Date()) {
	return {
		name: "edited",
		description: "Package edited",
		createdAt: t.toISOString(),
		createdBy: e
	};
}
var Ib = "FeaturedPackageMaxPurchasesBelowSoldError", Lb = class extends Error {
	constructor(e, t) {
		super(`Max purchases ${e} is below the ${t} already sold`), ge(this, "maxPurchases", void 0), ge(this, "sold", void 0), this.maxPurchases = e, this.sold = t, this.name = Ib;
	}
};
function Rb(e) {
	return e instanceof Error && e.name === Ib;
}
function zb(e, t) {
	if (e < t) throw new Lb(e, t);
}
//#endregion
//#region src/helpers/featured-package-edit-lock.helper.ts
var Bb = "edit_lock_";
function Vb(e) {
	return `${Bb}${e}`;
}
function Hb() {
	let e = Bb.slice(-1), t = String.fromCharCode(e.charCodeAt(0) + 1);
	return {
		start: Bb,
		end: `${Bb.slice(0, -1)}${t}`
	};
}
function Ub(e) {
	return e.startsWith(Bb) && e.slice(10) || null;
}
function Wb(e, t, n) {
	return rb(e, n) && !!e.heldBy && e.heldBy !== t;
}
function Gb(e, t, n) {
	let r = {};
	return Object.entries(e).forEach(([e, i]) => {
		Wb(i, t, n) && (r[e] = i.heldBy);
	}), r;
}
function Kb(e, t, n) {
	let r = null;
	return Object.values(e).forEach((e) => {
		if (!Wb(e, t, n)) return;
		let i = e.expiresAt.getTime();
		(r === null || i < r) && (r = i);
	}), r;
}
function qb(e, t) {
	let n = `projects/${e}/databases/(default)`;
	return {
		url: `https://firestore.googleapis.com/v1/${n}/documents:commit`,
		body: JSON.stringify({ writes: [{
			delete: `${n}/documents/${t}`,
			currentDocument: { exists: !0 }
		}] })
	};
}
function Jb(e, t, n, r) {
	return e ? "renewed" : n - t < r ? "retry" : "lost";
}
var Yb = "FeaturedPackageEditLockLostError", Xb = class extends Error {
	constructor(e) {
		super(`Edit lock for featured package ${e} is not held anymore`), this.name = Yb;
	}
};
function Zb(e) {
	return e instanceof Error && e.name === Yb;
}
//#endregion
//#region src/featured-package-edit.service.ts
var Qb = /* @__PURE__ */ u({
	editFeaturedPackage: () => ex,
	isMaxPurchasesBelowSoldError: () => Rb,
	subscribeToFeaturedPackages: () => $b
});
async function $b(e, t, n, r) {
	let i = await $(e, t), { collectionPath: a, collectionPathSegments: o } = vv(e, t, [Y.FeaturedPackages]);
	return up(Kd(i, a, ...o), (e) => {
		n(Sv(e).map(xb));
	}, r);
}
async function ex(e, t, n, r, i) {
	if (Object.keys(r).length === 0) return;
	let a = await $(e, t), { userEmail: o, userId: s } = _v(e), c = vv(e, t, [Y.FeaturedPackages], n), l = vv(e, t, [Y.FeaturedPackagesLock], Vb(n)), u = qd(a, c.collectionPath, ...c.collectionPathSegments), d = qd(a, l.collectionPath, ...l.collectionPathSegments);
	await vp(a, async (e) => {
		if (!ob(ub((await e.get(d)).data()), o, Date.now(), i)) throw new Xb(n);
		if (r.maxPurchases !== void 0) {
			let t = (await e.get(u)).data()?.purchases;
			zb(r.maxPurchases, t?.current ?? 0);
		}
		e.update(u, {
			...Pb(r),
			events: yp(Fb(o)),
			modified_at: I.now(),
			modified_by: o,
			modified_by_auth0_id: s
		});
	});
}
//#endregion
//#region src/featured-package-edit-lock.service.ts
var tx = /* @__PURE__ */ u({
	acquireEditLock: () => nx,
	getEditLockHolders: () => Gb,
	getNextEditLockExpiry: () => Kb,
	getRenewalOutcome: () => Jb,
	isEditLockLostError: () => Zb,
	isLockOwnedBy: () => ab,
	prepareEditLockUnloadRelease: () => ax,
	releaseEditLock: () => ix,
	releaseEditLockOnUnload: () => ox,
	renewEditLock: () => rx,
	subscribeToEditLocks: () => sx
});
async function nx(e, t, r) {
	return pb(e, t, Vb(r), !0, n());
}
async function rx(e, t, n, r) {
	return hb(e, t, Vb(n), r);
}
async function ix(e, t, n, r) {
	await mb(e, t, Vb(n), r);
}
async function ax(e, t, n) {
	await $(e, t);
	let r = tv(Gr()).currentUser;
	if (!r) throw Error("Not signed in to Firebase");
	let i = await r.getIdToken(), { collectionPath: a, collectionPathSegments: o } = vv(e, t, [Y.FeaturedPackagesLock], Vb(n)), { projectId: s } = qe(e, t);
	return {
		...qb(s, [a, ...o].join("/")),
		idToken: i
	};
}
function ox(e) {
	fetch(e.url, {
		method: "POST",
		keepalive: !0,
		headers: {
			Authorization: `Bearer ${e.idToken}`,
			"Content-Type": "application/json"
		},
		body: e.body
	}).catch(() => void 0);
}
async function sx(e, t, n, r) {
	let i = await $(e, t), { collectionPath: a } = vv(e, t, [Y.FeaturedPackagesLock]), { start: o, end: s } = Hb();
	return up(zf(Kd(i, a), J(of(), ">=", o), J(of(), "<", s)), (e) => {
		let t = {};
		e.docs.forEach((e) => {
			let n = Ub(e.id);
			n && (t[n] = ub(e.data()));
		}), n(t);
	}, r);
}
//#endregion
//#region src/featured-packages-assets.service.ts
var cx = /* @__PURE__ */ u({ getAssetsForFeaturedPackageWizard: () => ux });
function lx(e, t) {
	return `
    SELECT
      id,
      geom,
      internal_panel_id AS internalPanelId,
      impressions,
      TRIM(CONCAT(COALESCE(address, ''), ' ', COALESCE(address2, ''))) AS address,
      is_digital AS isDigital,
      l2_product AS l2Product,
      packages
    FROM ${x(e, t, e.data_model.assets)}
  `;
}
async function ux(e, t) {
	return b(lx(e, t), e, t);
}
//#endregion
export { it as AssetsService, Kv as AuditService, cy as Auth0Service, _e as AuthManager, Iy as BrandService, Pe as CacheManager, zy as CartoMetricEventService, Ny as ClientService, dy as CommentService, tx as FeaturedPackageEditLockService, Qb as FeaturedPackageEditService, sb as FeaturedPackageLockService, Sb as FeaturedPackageService, cx as FeaturedPackagesAssetsService, Ie as FilterOption, Uv as GeocodingService, Wy as PackageBrowserService, iy as PackagesService, jv as PlanService, Jv as SharePlanService, Vy as SignedUrlService, Me as buildSqlClientIdentifier, S as getCartoCredentials, Re as getColunmsIdFromModel, gv as getRoleFromFirebaseToken, Ne as getTablesWithLastUpdate, fv as initializeFirebaseApp, eb as subscribeToComments, $y as subscribeToPlanComments, tb as subscribeToPlans };
